import React, { useState, useEffect, useRef, useContext } from 'react';
import { useResponsiveParams, Text, DataGridGroup, QuantaFormik, useQuantaFormikContext, QuantaForm, Label, Button, NotificationList, Card, Modal, InputGridGroup, Paper, Grid, GridItem, MixedGridGroup, QuantaInput, RadioGroup, DataGrid, QuantaSelect, SearchResultsModal, Wizard, SummaryLayout, HideOnTablet, SlideablePaper } from 'quanta-ui';
import { Layout, ClientService } from './layout.js';
import { c as _slicedToArray, a as _toConsumableArray, b as _objectWithoutProperties, f as _asyncToGenerator, _ as _objectSpread2, d as _extends, i as _typeof, g as _defineProperty } from './_rollupPluginBabelHelpers-fb970440.js';
import { faChevronCircleUp, faChevronCircleDown, faCheck, faSpinner, faDownload, faSave, faPaperclip, faFileMedical, faEdit, faSearch, faInfoCircle, faExclamationCircle, faExclamationTriangle, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery, useLazyQuery } from '@apollo/client';
import { h as GET_BUY_HEALTH_POLICY_VAR_DETAILS, N as GET_GENDER_LIST, T as PAY_PREMIUM_LIST, s as LOB_PRODUCT_LIST, y as SEND_PROPOSAL_PDF, M as GET_DATE_TIME, p as SAVE_QUOTE, r as GET_MEDICAL_QUESTIONS, Z as RELATIONSHIP_WITH_PROPOSER, X as ROLLOVER_COMPANY_LIST, i as CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, R as RENEWAL_MANDATE_DETAILS, J as PROPOSER_DROPDOWN_DETAIL, m as GET_CUSTOMER_TYPE_DOMAIN, k as CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL, _ as DOCUMENT_STATIC_DATA, a4 as PROFILE_DETAILS, a1 as VIEW_DOCUMENT, a3 as INSERT_DOCUMENT_LIST, a2 as UPLOAD_DOCUMENT, x as SAVE_PROPOSAL, o as CHECK_IMD_CONFIG, n as GET_BUSINESS_TYPE, Y as CHARACTER_LIMIT_LIST, a0 as GET_DOCUMENTS_LIST, w as CALCULATE_PREMIUM_FOR_PROPOSAL, z as CUSTOMER_BANK_DETAILS } from './demand-draft-4fa845ea.js';
import { L as Loading } from './loading-c16d3bd3.js';
import { E as Error$1 } from './error-ee5266a9.js';
import { P as Parse } from './CurrencyFormater-d288bc4f.js';
import { M as ModalViewBreakup } from './view-breakup-99284a36.js';
import { Link, useParams } from 'react-router-dom';
import { u as useMutationQuery } from './useMutationQuery-42b53d8d.js';
import { u as useFetchQuery } from './useFetchQuery-56ba5b94.js';
import { resetProposerDetails, updateBuyHealthPolicy, updatePlanPremium } from './proposal/health/state.js';
import moment from 'moment';
import { P as ProposerDetails } from './index-45d02618.js';
import { P as PayPremium } from './pay-premium-health-a36868d1.js';
import { a as ConfigContext } from './ConfigProvider-9522944e.js';
import { P as ProposerCustomerReadOnly } from './proposer-customer-readonly-15cf2aa8.js';
import { I as IconIdle } from './icon-search-idle-a2977e92.js';
import { S as SuccessPage } from './index-e7dcaf02.js';

function InsuranceData(_ref) {
  var _quoteData$cover, _quoteData$location, _quoteData$location$z, _quoteData$location2, _quoteData$location2$, _quoteData$location3, _quoteData$location3$, _plans$find, _plans$find$premium, _dataBuyHealthPolicy$, _dataBuyHealthPolicy$2;

  _ref.lobCode;
      _ref.lobName;
      var productName = _ref.productName;
      _ref.productCode;
      var planName = _ref.planName;
      _ref.planCode;
      _ref.proposalNumber;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showViewBreakup = _useState4[0],
      setShowViewBreakup = _useState4[1];

  var _useQuery = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS),
      buyHealthPolicyLoading = _useQuery.loading,
      errorBuyHealthPolicy = _useQuery.error,
      dataBuyHealthPolicy = _useQuery.data;

  var _useQuery2 = useQuery(GET_GENDER_LIST),
      loadingGenderList = _useQuery2.loading,
      errorGenderList = _useQuery2.error,
      dataGenderList = _useQuery2.data;

  if (dataBuyHealthPolicy) {
    var buyHealthPolicy = dataBuyHealthPolicy === null || dataBuyHealthPolicy === void 0 ? void 0 : dataBuyHealthPolicy.buyHealthPolicy;
    var quoteData = buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quoteData;
    var planData = buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.planData;
    var plans = planData === null || planData === void 0 ? void 0 : planData.plans;
  }

  if (dataGenderList) {
    var genderList = dataGenderList.genderList;
  }

  var repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 4
  });
  var grid_data = [{
    colSpan: 4,
    className: '-mb-8',
    grid_data: [{
      label: /*#__PURE__*/React.createElement("span", {
        className: "text-primary font-bold"
      }, "Plan Name"),
      text: /*#__PURE__*/React.createElement(Text, null, planName)
    }, {
      label: /*#__PURE__*/React.createElement("span", {
        className: "text-primary font-bold"
      }, "Sum Insured"),
      text: /*#__PURE__*/React.createElement(Text, null, Parse(quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$cover = quoteData.cover) === null || _quoteData$cover === void 0 ? void 0 : _quoteData$cover.sum_insured))
    }, {
      label: /*#__PURE__*/React.createElement("span", {
        className: "text-primary font-bold"
      }, "Customer Location"),
      text: /*#__PURE__*/React.createElement(Text, null, [quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$location = quoteData.location) === null || _quoteData$location === void 0 ? void 0 : (_quoteData$location$z = _quoteData$location.zone) === null || _quoteData$location$z === void 0 ? void 0 : _quoteData$location$z.trim(), quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$location2 = quoteData.location) === null || _quoteData$location2 === void 0 ? void 0 : (_quoteData$location2$ = _quoteData$location2.city) === null || _quoteData$location2$ === void 0 ? void 0 : _quoteData$location2$.trim(), quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$location3 = quoteData.location) === null || _quoteData$location3 === void 0 ? void 0 : (_quoteData$location3$ = _quoteData$location3.pincode) === null || _quoteData$location3$ === void 0 ? void 0 : _quoteData$location3$.trim()].filter(function (a) {
        return a;
      }).join(', '))
    }, {
      label: /*#__PURE__*/React.createElement("span", {
        className: "text-primary font-bold"
      }, "Annual Premium (inclusive of all taxes)"),
      text: /*#__PURE__*/React.createElement("div", {
        className: "flex justify-start space-x-2 mt-1"
      }, /*#__PURE__*/React.createElement(Text, {
        type: "larger",
        severity: "info",
        className: "-mt-1"
      }, Parse(plans === null || plans === void 0 ? void 0 : (_plans$find = plans.find(function (p) {
        return p.name === planName;
      })) === null || _plans$find === void 0 ? void 0 : (_plans$find$premium = _plans$find.premium) === null || _plans$find$premium === void 0 ? void 0 : _plans$find$premium.totalPremium)), /*#__PURE__*/React.createElement("span", {
        className: "mt-1.5"
      }, /*#__PURE__*/React.createElement(Text, {
        severity: "action",
        type: "label",
        className: "quanta_link md:mt-1 md:ml-2 cursor-pointer",
        onClick: function onClick(e) {
          setShowViewBreakup(true);
        }
      }, "View Breakup")))
    }]
  }, {
    title: /*#__PURE__*/React.createElement("div", {
      className: "text-secondary text-base cursor-pointer -mb-3",
      onClick: function onClick(_) {
        return setExpanded(!expanded);
      }
    }, expanded ? 'Hide details' : 'Show details', /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: expanded ? faChevronCircleUp : faChevronCircleDown,
      className: "text-secondary ml-2 cursor-pointer"
    })),
    titleType: 'normal',
    repeat: 4,
    grid_data: expanded ? [{
      label: /*#__PURE__*/React.createElement(Text, {
        type: "label",
        className: "font-bold"
      }, "Member"),
      text: buyHealthPolicy.insuredDetails.map(function (insured) {
        return insured.relationship;
      }).join(','),
      colSpan: 1
    }, {
      label: /*#__PURE__*/React.createElement(Text, {
        type: "label",
        className: "font-bold"
      }, "Cover type"),
      text: quoteData.cover.type,
      colSpan: 1
    }, {
      label: /*#__PURE__*/React.createElement(Text, {
        type: "label",
        className: "font-bold"
      }, "Tenure"),
      text: quoteData.cover.tenure,
      colSpan: 1
    }] : []
  }, expanded ? {
    title: 'Base Covers',
    titleType: 'normal',
    repeat: 4,
    className: 'pt-0 pb-2',
    gridClassName: 'space-y-2',
    grid_data: plans && plans.find(function (p) {
      return p.name === planName;
    }).covers.map(function (c) {
      return {
        text: /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row space-x-1 "
        }, /*#__PURE__*/React.createElement("div", {
          className: "text-success"
        }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faCheck
        })), /*#__PURE__*/React.createElement("div", null, c.name))
      };
    })
  } : null].concat(_toConsumableArray(expanded ? plans && plans.find(function (p) {
    return p.name === planName;
  }).packs.map(function (pack) {
    if (pack.addOnCovers.filter(function (add) {
      return add.selected;
    }).length > 0) {
      return {
        title: pack.name,
        titleType: 'normal',
        className: 'pt-0 pb-4',
        gridClassName: 'space-y-2',
        repeat: 4,
        grid_data: pack && pack.addOnCovers.filter(function (add) {
          return add.selected;
        }).map(function (add, idx) {
          return {
            text: /*#__PURE__*/React.createElement("div", {
              key: idx,
              className: "flex flex-row space-x-1"
            }, /*#__PURE__*/React.createElement("div", {
              className: "text-success"
            }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faCheck
            })), /*#__PURE__*/React.createElement("div", null, add.name))
          };
        })
      };
    }

    return null;
  }).filter(function (pack) {
    return pack;
  }) : [])).filter(function (d) {
    return d;
  });
  return buyHealthPolicyLoading || loadingGenderList ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(Loading, {
    customMessage: "Loading Plan Details"
  })) : errorBuyHealthPolicy || errorGenderList ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(Error$1, {
    error: {
      message: "There was an issue fetching the Plan and Cover Details. Please try again after some time..."
    }
  })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DataGridGroup, {
    data: grid_data,
    repeat: repeat,
    textType: "label",
    titleType: "title",
    titleSeverity: "info" // className="w-full"
    ,
    gap: 0.5,
    isSeparatorRequired: false,
    gapY: 0.5,
    spaceY: 2,
    gapX: 0.5,
    nullData: function nullData() {
      return /*#__PURE__*/React.createElement(Text, {
        className: "opacity-40"
      }, "Not Captured");
    }
  }), /*#__PURE__*/React.createElement(ModalViewBreakup, {
    showViewBreakup: showViewBreakup,
    setShowViewBreakup: setShowViewBreakup,
    selectedPlanTypeView: planName,
    productName: productName,
    genderList: genderList,
    REACTIVE_VAR_QUERY: GET_BUY_HEALTH_POLICY_VAR_DETAILS,
    reactive_var_quote: dataBuyHealthPolicy === null || dataBuyHealthPolicy === void 0 ? void 0 : (_dataBuyHealthPolicy$ = dataBuyHealthPolicy.buyHealthPolicy) === null || _dataBuyHealthPolicy$ === void 0 ? void 0 : _dataBuyHealthPolicy$.quoteData,
    reactive_var_plan: dataBuyHealthPolicy === null || dataBuyHealthPolicy === void 0 ? void 0 : (_dataBuyHealthPolicy$2 = dataBuyHealthPolicy.buyHealthPolicy) === null || _dataBuyHealthPolicy$2 === void 0 ? void 0 : _dataBuyHealthPolicy$2.planData,
    title: 'Premium Breakup for Proposal'
  }));
}

var _excluded$9 = ["lobCode", "lobName", "productName", "productCode", "planName", "planCode", "proposalNumber"];
function InsuranceSummary(_ref) {
  var lobCode = _ref.lobCode,
      lobName = _ref.lobName,
      productName = _ref.productName,
      productCode = _ref.productCode,
      planName = _ref.planName,
      planCode = _ref.planCode,
      proposalNumber = _ref.proposalNumber,
      props = _objectWithoutProperties(_ref, _excluded$9);

  useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3
  });

  var validate = function validate(values) {
    var errors = {};
    return errors;
  };

  var InsuranceDetails = function InsuranceDetails(_ref2) {
    var validate = _ref2.validate;

    var _useQuantaFormikConte = useQuantaFormikContext(),
        values = _useQuantaFormikConte.values;
        _useQuantaFormikConte.setFieldValue;

    var AutoSubmitForm = function AutoSubmitForm(_ref3) {
      var validate = _ref3.validate,
          values = _ref3.values;
      useEffect(function () {
        if (values) {
          var errors = validate(values);
          Object.keys(errors).length;
        }
      }, [values]);
      return null;
    };

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaForm, {
      className: "space-y-4 p-4"
    }, /*#__PURE__*/React.createElement(InsuranceData, {
      lobCode: lobCode,
      lobName: lobName,
      productName: productName,
      productCode: productCode,
      planName: planName,
      planCode: planCode,
      proposalNumber: proposalNumber,
      props: props
    }), /*#__PURE__*/React.createElement(AutoSubmitForm, {
      validate: validate,
      values: values
    })));
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuantaFormik, {
    enableReinitialize: true,
    validate: validate
  }, /*#__PURE__*/React.createElement(InsuranceDetails, {
    validate: validate
  })));
}

function InsuranceSummaryMinimized(_ref) {
  _ref.lobCode;
      _ref.lobName;
      _ref.productName;
      _ref.productCode;
      _ref.planName;
      _ref.planCode;
      _ref.proposalNumber;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-neutral h-24 w-32 flex justify-center items-center shadow-t shadow-b p-4"
  }, /*#__PURE__*/React.createElement(Label, {
    text: /*#__PURE__*/React.createElement("span", {
      className: "text-primary font-bold"
    }, "Coverage Details"),
    severity: "info"
  }));
}

var _excluded$8 = ["ppcTestLevel", "memberID", "memberStatus"],
    _excluded2$3 = ["relationship"],
    _excluded3$3 = ["crn", "isNewCustomer", "ciuType", "isCRNVerified"];
function ProposalSummary(_ref) {
  var _lobProductList$find, _buyHealthPolicy$inte, _buyHealthPolicy$inte2, _buyHealthPolicy$inte3, _buyHealthPolicy$inte4, _buyHealthPolicy$inte5, _buyHealthPolicy$inte6, _buyHealthPolicy$inte7, _buyHealthPolicy$inte8, _buyHealthPolicy$inte9, _buyHealthPolicy$inte10, _buyHealthPolicy$inte11, _buyHealthPolicy$inte12, _buyHealthPolicy$inte13, _quoteData$cover, _quoteData$cover2, _plans$find2, _plans$find2$premium, _dataBuyHealthPolicy$;

  var dataBuyHealthPolicy = _ref.data,
      lobCode = _ref.lobCode;
      _ref.lobName;
      var productName = _ref.productName,
      productCode = _ref.productCode,
      planName = _ref.planName,
      planCode = _ref.planCode;
      _ref.proposalNumber;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      alerts = _useState2[0],
      setAlerts = _useState2[1];

  var mutateQuery = useMutationQuery();
  var fetchQuery = useFetchQuery();

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showViewBreakup = _useState4[0],
      setShowViewBreakup = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loadingDownload = _useState6[0],
      setLoadingDownload = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      mounted = _useState8[0],
      setMounted = _useState8[1];

  var repeat = useResponsiveParams({
    for_mobile: 2,
    for_desktop: 2
  });

  var _useQuery = useQuery(GET_GENDER_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loadingGenderList = _useQuery.loading,
      errorGenderList = _useQuery.error,
      dataGenderList = _useQuery.data;

  var _useQuery2 = useQuery(PAY_PREMIUM_LIST, {
    fetchPolicy: 'cache-first'
  }),
      list_loading = _useQuery2.loading,
      error_list = _useQuery2.error,
      ListDetails = _useQuery2.data;

  var _useQuery3 = useQuery(LOB_PRODUCT_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loadingLobList = _useQuery3.loading,
      errorLobList = _useQuery3.error,
      dataLobList = _useQuery3.data;

  useEffect(function () {

    if (dataBuyHealthPolicy && dataGenderList && ListDetails && !mounted) {
      setMounted(true);
    }

    return function () {
    };
  }, [mounted, dataBuyHealthPolicy, dataGenderList, ListDetails]);

  var getBase64Var = function getBase64Var(buyHealthPolicyData, getDateTimeData) {
    var _buyHealthPolicyData$2, _buyHealthPolicyData$3, _buyHealthPolicyData$4, _buyHealthPolicyData$5, _buyHealthPolicyData$6, _buyHealthPolicyData$7, _buyHealthPolicyData$8, _buyHealthPolicyData$9, _buyHealthPolicyData$10, _buyHealthPolicyData$11, _buyHealthPolicyData$12, _buyHealthPolicyData$13, _buyHealthPolicyData$14, _buyHealthPolicyData$15, _buyHealthPolicyData$16, _buyHealthPolicyData$17, _buyHealthPolicyData$18, _buyHealthPolicyData$19, _buyHealthPolicyData$20, _buyHealthPolicyData$21, _buyHealthPolicyData$22, _buyHealthPolicyData$23, _buyHealthPolicyData$24, _buyHealthPolicyData$25, _buyHealthPolicyData$26, _buyHealthPolicyData$27, _buyHealthPolicyData$28, _buyHealthPolicyData$29, _buyHealthPolicyData$30, _getDateTimeData$date, _buyHealthPolicyData$31, _buyHealthPolicyData$32, _buyHealthPolicyData$33, _buyHealthPolicyData$34, _buyHealthPolicyData$35, _buyHealthPolicyData$36, _buyHealthPolicyData$37, _buyHealthPolicyData$38, _buyHealthPolicyData$39, _buyHealthPolicyData$40, _buyHealthPolicyData$41, _buyHealthPolicyData$42, _buyHealthPolicyData$43, _buyHealthPolicyData$44, _buyHealthPolicyData$45, _buyHealthPolicyData$46, _buyHealthPolicyData$47, _buyHealthPolicyData$48, _buyHealthPolicyData$49, _buyHealthPolicyData$50, _buyHealthPolicyData$51;

    var getInsuredDetailsObj = function getInsuredDetailsObj(insuredDetails, nomineeDetails, prevInsuranceDetails, medicalQuestionaire, planData, isHealthDeclarationSelected) {
      var insuredDetailsResponseArr = [];
      insuredDetails.forEach(function (insured) {
        var _prevInsuranceInput$p, _medicalQuestionaireO, _medicalQuestionaireO2, _plans$find, _plans$find$packs;

        insured.ppcTestLevel;
            insured.memberID;
            insured.memberStatus;
            var restInsured = _objectWithoutProperties(insured, _excluded$8);

        var insuredObj = _objectSpread2({}, restInsured);

        var nomineeObj = nomineeDetails === null || nomineeDetails === void 0 ? void 0 : nomineeDetails.find(function (nominee) {
          var _nominee$relationship, _insured$relationship;

          return (nominee === null || nominee === void 0 ? void 0 : (_nominee$relationship = nominee.relationship) === null || _nominee$relationship === void 0 ? void 0 : _nominee$relationship.toLowerCase()) === (insured === null || insured === void 0 ? void 0 : (_insured$relationship = insured.relationship) === null || _insured$relationship === void 0 ? void 0 : _insured$relationship.toLowerCase());
        });

        var relationship = nomineeObj.relationship,
            restNomineeObj = _objectWithoutProperties(nomineeObj, _excluded2$3);

        insuredObj.nomineeDetails = _objectSpread2(_objectSpread2({}, restNomineeObj), {}, {
          insuredRelationship: relationship
        });
        var prevInsuranceInput = prevInsuranceDetails === null || prevInsuranceDetails === void 0 ? void 0 : prevInsuranceDetails.find(function (prevInsured) {
          var _prevInsured$insuredR, _insured$relationship2;

          return (prevInsured === null || prevInsured === void 0 ? void 0 : (_prevInsured$insuredR = prevInsured.insuredRelationship) === null || _prevInsured$insuredR === void 0 ? void 0 : _prevInsured$insuredR.toLowerCase()) === (insured === null || insured === void 0 ? void 0 : (_insured$relationship2 = insured.relationship) === null || _insured$relationship2 === void 0 ? void 0 : _insured$relationship2.toLowerCase());
        });
        insuredObj.prevInsuranceInput = {
          prevInsurerName: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevInsurerName,
          prevPolicyNo: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicyNo,
          prevPolicySI: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicySI,
          prevClaimLodged: (prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : (_prevInsuranceInput$p = prevInsuranceInput.prevClaimLodged) === null || _prevInsuranceInput$p === void 0 ? void 0 : _prevInsuranceInput$p.toLowerCase()) === 'yes' ? true : false,
          claimAmount: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.claimAmount,
          prevPolicyStartDate: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicyStartDate,
          prevPolicyEndDate: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicyEndDate,
          cbAmount: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.cbAmount
        };
        var medicalQuestionaireObj = isHealthDeclarationSelected ? medicalQuestionaire === null || medicalQuestionaire === void 0 ? void 0 : medicalQuestionaire.find(function (m) {
          var _m$relationship, _insured$relationship3;

          return (m === null || m === void 0 ? void 0 : (_m$relationship = m.relationship) === null || _m$relationship === void 0 ? void 0 : _m$relationship.toLowerCase()) === (insured === null || insured === void 0 ? void 0 : (_insured$relationship3 = insured.relationship) === null || _insured$relationship3 === void 0 ? void 0 : _insured$relationship3.toLowerCase());
        }) : {
          relationship: insured === null || insured === void 0 ? void 0 : insured.relationship,
          questions: []
        };

        if (medicalQuestionaireObj && ((_medicalQuestionaireO = medicalQuestionaireObj) === null || _medicalQuestionaireO === void 0 ? void 0 : (_medicalQuestionaireO2 = _medicalQuestionaireO.questions) === null || _medicalQuestionaireO2 === void 0 ? void 0 : _medicalQuestionaireO2.length) > 0) {
          var _medicalQuestionaireO3, _medicalQuestionaireO4, _medicalQuestionaireO5, _medicalQuestionaireO6, _medicalQuestionaireO7, _medicalQuestionaireO8, _medicalQuestionaireO9, _medicalQuestionaireO10;

          medicalQuestionaireObj = _objectSpread2(_objectSpread2({}, medicalQuestionaireObj), {}, {
            questions: (_medicalQuestionaireO3 = medicalQuestionaireObj) === null || _medicalQuestionaireO3 === void 0 ? void 0 : (_medicalQuestionaireO4 = _medicalQuestionaireO3.questions) === null || _medicalQuestionaireO4 === void 0 ? void 0 : _medicalQuestionaireO4.map(function (question) {
              var _question$answer;

              return {
                srNo: question === null || question === void 0 ? void 0 : question.srNo,
                answer: question === null || question === void 0 ? void 0 : (_question$answer = question.answer) === null || _question$answer === void 0 ? void 0 : _question$answer.answerText
              };
            })
          });
          medicalQuestionaireObj = _objectSpread2(_objectSpread2({}, medicalQuestionaireObj), {}, {
            questions: ((_medicalQuestionaireO5 = medicalQuestionaireObj) === null || _medicalQuestionaireO5 === void 0 ? void 0 : (_medicalQuestionaireO6 = _medicalQuestionaireO5.questions) === null || _medicalQuestionaireO6 === void 0 ? void 0 : (_medicalQuestionaireO7 = _medicalQuestionaireO6.find(function (q) {
              var _q$srNo;

              return (q === null || q === void 0 ? void 0 : (_q$srNo = q.srNo) === null || _q$srNo === void 0 ? void 0 : _q$srNo.toLowerCase()) === 'master';
            })) === null || _medicalQuestionaireO7 === void 0 ? void 0 : (_medicalQuestionaireO8 = _medicalQuestionaireO7.answer) === null || _medicalQuestionaireO8 === void 0 ? void 0 : _medicalQuestionaireO8.toLowerCase()) === 'no' ? (_medicalQuestionaireO9 = medicalQuestionaireObj) === null || _medicalQuestionaireO9 === void 0 ? void 0 : (_medicalQuestionaireO10 = _medicalQuestionaireO9.questions) === null || _medicalQuestionaireO10 === void 0 ? void 0 : _medicalQuestionaireO10.filter(function (q) {
              var _q$srNo2;

              return (q === null || q === void 0 ? void 0 : (_q$srNo2 = q.srNo) === null || _q$srNo2 === void 0 ? void 0 : _q$srNo2.toLowerCase()) !== 'master';
            }) : []
          });
        }

        insuredObj.medicalQuestionaire = medicalQuestionaireObj ? medicalQuestionaireObj : {
          relationship: insured === null || insured === void 0 ? void 0 : insured.relationship,
          questions: []
        };
        var plans = planData.plans;
        insuredObj.addOnCovers = plans === null || plans === void 0 ? void 0 : (_plans$find = plans.find(function (p) {
          var _p$name;

          return (p === null || p === void 0 ? void 0 : (_p$name = p.name) === null || _p$name === void 0 ? void 0 : _p$name.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
        })) === null || _plans$find === void 0 ? void 0 : (_plans$find$packs = _plans$find.packs) === null || _plans$find$packs === void 0 ? void 0 : _plans$find$packs.filter(function (pack) {
          var _pack$index;

          return pack === null || pack === void 0 ? void 0 : (_pack$index = pack.index) === null || _pack$index === void 0 ? void 0 : _pack$index.includes(insured === null || insured === void 0 ? void 0 : insured.relationship);
        }).flatMap(function (pack) {
          return pack.addOnCovers.filter(function (addOnCover) {
            return addOnCover.selected;
          });
        });

        if (!insuredObj.addOnCovers) {
          insuredObj.addOnCovers = [];
        }

        insuredDetailsResponseArr.push(insuredObj);
      });
      return insuredDetailsResponseArr;
    };

    var _buyHealthPolicyData$ = buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.proposerDetailsMeta;
        _buyHealthPolicyData$.crn;
        _buyHealthPolicyData$.isNewCustomer;
        _buyHealthPolicyData$.ciuType;
        _buyHealthPolicyData$.isCRNVerified;
        var restProposerMetaData = _objectWithoutProperties(_buyHealthPolicyData$, _excluded3$3);

    return {
      input: {
        proposerDetails: _objectSpread2(_objectSpread2(_objectSpread2({}, restProposerMetaData), buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.proposerDetails), {}, {
          isThinCustomer: false
        }),
        insuredDetails: getInsuredDetailsObj(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.insuredDetails, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.nomineeDetails, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.prevInsuranceDetails, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.medicalQuestionaire, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.planData, (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$2 = buyHealthPolicyData.isHealthDeclarationSelected) === null || _buyHealthPolicyData$2 === void 0 ? void 0 : _buyHealthPolicyData$2.toLowerCase()) === 'yes'),
        plan: {
          name: planName,
          code: planCode,
          covers: (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$3 = buyHealthPolicyData.planData) === null || _buyHealthPolicyData$3 === void 0 ? void 0 : (_buyHealthPolicyData$4 = _buyHealthPolicyData$3.plans) === null || _buyHealthPolicyData$4 === void 0 ? void 0 : (_buyHealthPolicyData$5 = _buyHealthPolicyData$4.find(function (plan) {
            var _plan$name;

            return (plan === null || plan === void 0 ? void 0 : (_plan$name = plan.name) === null || _plan$name === void 0 ? void 0 : _plan$name.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          })) === null || _buyHealthPolicyData$5 === void 0 ? void 0 : (_buyHealthPolicyData$6 = _buyHealthPolicyData$5.covers) === null || _buyHealthPolicyData$6 === void 0 ? void 0 : _buyHealthPolicyData$6.length) > 0 ? buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$7 = buyHealthPolicyData.planData) === null || _buyHealthPolicyData$7 === void 0 ? void 0 : (_buyHealthPolicyData$8 = _buyHealthPolicyData$7.plans) === null || _buyHealthPolicyData$8 === void 0 ? void 0 : (_buyHealthPolicyData$9 = _buyHealthPolicyData$8.find(function (plan) {
            var _plan$name2;

            return (plan === null || plan === void 0 ? void 0 : (_plan$name2 = plan.name) === null || _plan$name2 === void 0 ? void 0 : _plan$name2.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          })) === null || _buyHealthPolicyData$9 === void 0 ? void 0 : _buyHealthPolicyData$9.covers : [],
          packs: (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$10 = buyHealthPolicyData.planData) === null || _buyHealthPolicyData$10 === void 0 ? void 0 : (_buyHealthPolicyData$11 = _buyHealthPolicyData$10.plans) === null || _buyHealthPolicyData$11 === void 0 ? void 0 : (_buyHealthPolicyData$12 = _buyHealthPolicyData$11.find(function (plan) {
            var _plan$name3;

            return (plan === null || plan === void 0 ? void 0 : (_plan$name3 = plan.name) === null || _plan$name3 === void 0 ? void 0 : _plan$name3.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          })) === null || _buyHealthPolicyData$12 === void 0 ? void 0 : (_buyHealthPolicyData$13 = _buyHealthPolicyData$12.packs) === null || _buyHealthPolicyData$13 === void 0 ? void 0 : _buyHealthPolicyData$13.length) > 0 ? buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$14 = buyHealthPolicyData.planData) === null || _buyHealthPolicyData$14 === void 0 ? void 0 : (_buyHealthPolicyData$15 = _buyHealthPolicyData$14.plans) === null || _buyHealthPolicyData$15 === void 0 ? void 0 : (_buyHealthPolicyData$16 = _buyHealthPolicyData$15.find(function (plan) {
            var _plan$name4;

            return (plan === null || plan === void 0 ? void 0 : (_plan$name4 = plan.name) === null || _plan$name4 === void 0 ? void 0 : _plan$name4.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          })) === null || _buyHealthPolicyData$16 === void 0 ? void 0 : _buyHealthPolicyData$16.packs : [],
          premium: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$17 = buyHealthPolicyData.planData) === null || _buyHealthPolicyData$17 === void 0 ? void 0 : (_buyHealthPolicyData$18 = _buyHealthPolicyData$17.plans) === null || _buyHealthPolicyData$18 === void 0 ? void 0 : (_buyHealthPolicyData$19 = _buyHealthPolicyData$18.find(function (plan) {
            var _plan$name5;

            return (plan === null || plan === void 0 ? void 0 : (_plan$name5 = plan.name) === null || _plan$name5 === void 0 ? void 0 : _plan$name5.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          })) === null || _buyHealthPolicyData$19 === void 0 ? void 0 : _buyHealthPolicyData$19.premium
        },
        intermediary: {
          intermediaryCode: buyHealthPolicyData !== null && buyHealthPolicyData !== void 0 && (_buyHealthPolicyData$20 = buyHealthPolicyData.intermediaryDetails) !== null && _buyHealthPolicyData$20 !== void 0 && _buyHealthPolicyData$20.code ? "".concat(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$21 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$21 === void 0 ? void 0 : _buyHealthPolicyData$21.code) : '',
          locationCode: buyHealthPolicyData !== null && buyHealthPolicyData !== void 0 && (_buyHealthPolicyData$22 = buyHealthPolicyData.intermediaryDetails) !== null && _buyHealthPolicyData$22 !== void 0 && _buyHealthPolicyData$22.location ? "".concat(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$23 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$23 === void 0 ? void 0 : _buyHealthPolicyData$23.location) : '',
          fieldUserCode: buyHealthPolicyData !== null && buyHealthPolicyData !== void 0 && (_buyHealthPolicyData$24 = buyHealthPolicyData.intermediaryDetails) !== null && _buyHealthPolicyData$24 !== void 0 && _buyHealthPolicyData$24.fieldUserCode ? "".concat(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$25 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$25 === void 0 ? void 0 : _buyHealthPolicyData$25.fieldUserCode) : ''
        },
        zone: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$26 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$26 === void 0 ? void 0 : (_buyHealthPolicyData$27 = _buyHealthPolicyData$26.location) === null || _buyHealthPolicyData$27 === void 0 ? void 0 : (_buyHealthPolicyData$28 = _buyHealthPolicyData$27.zone) === null || _buyHealthPolicyData$28 === void 0 ? void 0 : _buyHealthPolicyData$28.trim(),
        quotationType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.quotationType,
        sumInsured: parseFloat(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$29 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$29 === void 0 ? void 0 : (_buyHealthPolicyData$30 = _buyHealthPolicyData$29.cover) === null || _buyHealthPolicyData$30 === void 0 ? void 0 : _buyHealthPolicyData$30.sum_insured),
        startDate: getDateTimeData === null || getDateTimeData === void 0 ? void 0 : (_getDateTimeData$date = getDateTimeData.datetimeValue) === null || _getDateTimeData$date === void 0 ? void 0 : _getDateTimeData$date.date,
        startTime: '00:00',
        coverType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$31 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$31 === void 0 ? void 0 : (_buyHealthPolicyData$32 = _buyHealthPolicyData$31.cover) === null || _buyHealthPolicyData$32 === void 0 ? void 0 : _buyHealthPolicyData$32.type,
        tenure: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$33 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$33 === void 0 ? void 0 : (_buyHealthPolicyData$34 = _buyHealthPolicyData$33.cover) === null || _buyHealthPolicyData$34 === void 0 ? void 0 : _buyHealthPolicyData$34.tenure,
        proposalPaymentType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.proposalPaymentType,
        isHealthDeclarationSelected: (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$35 = buyHealthPolicyData.isHealthDeclarationSelected) === null || _buyHealthPolicyData$35 === void 0 ? void 0 : _buyHealthPolicyData$35.toLowerCase()) === 'yes',
        quoteNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.quoteNumber,
        productCode: productCode,
        policyNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$36 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$36 === void 0 ? void 0 : _buyHealthPolicyData$36.policyNumber,
        employeeNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$37 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$37 === void 0 ? void 0 : _buyHealthPolicyData$37.employeeNumber,
        proposerPincode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$38 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$38 === void 0 ? void 0 : (_buyHealthPolicyData$39 = _buyHealthPolicyData$38.location) === null || _buyHealthPolicyData$39 === void 0 ? void 0 : _buyHealthPolicyData$39.pincode,

        /* Renew mandate */
        renewalMandateDetails: {
          renewalPaymentMandate: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$40 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$40 === void 0 ? void 0 : _buyHealthPolicyData$40.renewalPaymentMandate,
          renewalPaymentMandateTakenInNameOf: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$41 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$41 === void 0 ? void 0 : _buyHealthPolicyData$41.renewalPaymentMandateTakenInNameOf,
          termForMandateOpted: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$42 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$42 === void 0 ? void 0 : _buyHealthPolicyData$42.termForMandateOpted,
          typeOfDebit: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$43 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$43 === void 0 ? void 0 : _buyHealthPolicyData$43.typeOfDebit,
          accountNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$44 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$44 === void 0 ? void 0 : _buyHealthPolicyData$44.accountNumber,
          destinationBankName: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$45 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$45 === void 0 ? void 0 : _buyHealthPolicyData$45.destinationBankName,
          destinationIfscCode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$46 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$46 === void 0 ? void 0 : _buyHealthPolicyData$46.destinationIfscCode,
          destinationMicrCode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$47 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$47 === void 0 ? void 0 : _buyHealthPolicyData$47.destinationMicrCode,
          destinationBranchName: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$48 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$48 === void 0 ? void 0 : _buyHealthPolicyData$48.destinationBranchName,
          mandateAmount: parseFloat(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$49 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$49 === void 0 ? void 0 : _buyHealthPolicyData$49.mandateAmount),
          finalCollectionDate: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$50 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$50 === void 0 ? void 0 : _buyHealthPolicyData$50.finalCollectionDate,
          destinationBankAccountType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$51 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$51 === void 0 ? void 0 : _buyHealthPolicyData$51.destinationBankAccountType
        }
      },
      proposalNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.proposalNumber
    };
  };

  if (dataBuyHealthPolicy) {
    var buyHealthPolicy = dataBuyHealthPolicy === null || dataBuyHealthPolicy === void 0 ? void 0 : dataBuyHealthPolicy.buyHealthPolicy;
    var quoteData = buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quoteData;
    var planData = buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.planData;
    var plans = planData === null || planData === void 0 ? void 0 : planData.plans;
  }

  if (dataGenderList) {
    var genderList = dataGenderList.genderList;
  }

  if (ListDetails) {
    var ProposalPaymentTypeList = ListDetails.ProposalPaymentTypeList;
  }

  if (dataLobList) {
    var lobProductList = dataLobList.lobProductList;
  }

  var getDomainData = function getDomainData(domainArr, searchText, searchType, returnType) {
    return domainArr.find(function (d) {
      return d["".concat(searchType)] === searchText;
    }) ? domainArr.find(function (d) {
      return d["".concat(searchType)] === searchText;
    })["".concat(returnType)] : '';
  };

  var grid_data = [{
    grid_data: [buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.quoteNumber ? {
      label: /*#__PURE__*/React.createElement("div", {
        className: "flex justify-start mt-2 mb-0.5"
      }, /*#__PURE__*/React.createElement(Text, {
        type: "label",
        className: "flex justify-end items-end h-full"
      }, "Quotation Number")),
      colSpan: repeat,
      text: /*#__PURE__*/React.createElement(Link, {
        to: "/quote/saved/".concat(lobCode, "/").concat(lobProductList === null || lobProductList === void 0 ? void 0 : (_lobProductList$find = lobProductList.find(function (lpl) {
          var _lpl$lob_code;

          return (lpl === null || lpl === void 0 ? void 0 : (_lpl$lob_code = lpl.lob_code) === null || _lpl$lob_code === void 0 ? void 0 : _lpl$lob_code.toLowerCase()) === (lobCode === null || lobCode === void 0 ? void 0 : lobCode.toLowerCase());
        })) === null || _lobProductList$find === void 0 ? void 0 : _lobProductList$find.lob_name, "/").concat(productCode, "/").concat(productName, "/").concat(buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quoteNumber)
      }, /*#__PURE__*/React.createElement(Text, {
        className: "text-secondary underline"
      }, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quoteNumber))
    } : null, buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.proposalNumber ? {
      label: /*#__PURE__*/React.createElement("span", {
        className: "text-primary"
      }, "Proposal Number"),
      colSpan: repeat,
      text: /*#__PURE__*/React.createElement(Text, null, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber)
    } : null, // buyHealthPolicy?.proposalStatus
    //   ? {
    //       label: (
    //         <span className="text-primary">Proposal Status</span>
    //       ),
    //       text: <Text>{buyHealthPolicy?.proposalStatus}</Text>,
    //       colSpan: repeat,
    //     }
    //   : null,
    {
      label: 'Partner',
      colSpan: repeat,
      text: buyHealthPolicy !== null && buyHealthPolicy !== void 0 && (_buyHealthPolicy$inte = buyHealthPolicy.intermediaryDetails) !== null && _buyHealthPolicy$inte !== void 0 && _buyHealthPolicy$inte.intermediaryName ? /*#__PURE__*/React.createElement(Text, null, "".concat(buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$inte2 = buyHealthPolicy.intermediaryDetails) === null || _buyHealthPolicy$inte2 === void 0 ? void 0 : _buyHealthPolicy$inte2.intermediaryName, "(", "".concat(buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$inte3 = buyHealthPolicy.intermediaryDetails) === null || _buyHealthPolicy$inte3 === void 0 ? void 0 : _buyHealthPolicy$inte3.code), ")")) : buyHealthPolicy !== null && buyHealthPolicy !== void 0 && (_buyHealthPolicy$inte4 = buyHealthPolicy.intermediaryDetails) !== null && _buyHealthPolicy$inte4 !== void 0 && _buyHealthPolicy$inte4.intermediaryCode ? /*#__PURE__*/React.createElement(Text, null, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$inte5 = buyHealthPolicy.intermediaryDetails) === null || _buyHealthPolicy$inte5 === void 0 ? void 0 : _buyHealthPolicy$inte5.intermediaryCode) : /*#__PURE__*/React.createElement(Text, {
        severity: 'neutral'
      }, "Not Captured")
    }, {
      label: 'Branch Office',
      colSpan: repeat,
      text: buyHealthPolicy !== null && buyHealthPolicy !== void 0 && (_buyHealthPolicy$inte6 = buyHealthPolicy.intermediaryDetails) !== null && _buyHealthPolicy$inte6 !== void 0 && _buyHealthPolicy$inte6.branchOfficeName ? /*#__PURE__*/React.createElement(Text, null, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$inte7 = buyHealthPolicy.intermediaryDetails) === null || _buyHealthPolicy$inte7 === void 0 ? void 0 : _buyHealthPolicy$inte7.branchOfficeName) : buyHealthPolicy !== null && buyHealthPolicy !== void 0 && (_buyHealthPolicy$inte8 = buyHealthPolicy.intermediaryDetails) !== null && _buyHealthPolicy$inte8 !== void 0 && _buyHealthPolicy$inte8.location ? /*#__PURE__*/React.createElement(Text, null, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$inte9 = buyHealthPolicy.intermediaryDetails) === null || _buyHealthPolicy$inte9 === void 0 ? void 0 : _buyHealthPolicy$inte9.location) : /*#__PURE__*/React.createElement(Text, {
        severity: 'neutral'
      }, "Not Captured")
    }, {
      label: 'Field User',
      colSpan: repeat,
      text: buyHealthPolicy !== null && buyHealthPolicy !== void 0 && (_buyHealthPolicy$inte10 = buyHealthPolicy.intermediaryDetails) !== null && _buyHealthPolicy$inte10 !== void 0 && _buyHealthPolicy$inte10.fieldUserName ? /*#__PURE__*/React.createElement(Text, null, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$inte11 = buyHealthPolicy.intermediaryDetails) === null || _buyHealthPolicy$inte11 === void 0 ? void 0 : _buyHealthPolicy$inte11.fieldUserName) : buyHealthPolicy !== null && buyHealthPolicy !== void 0 && (_buyHealthPolicy$inte12 = buyHealthPolicy.intermediaryDetails) !== null && _buyHealthPolicy$inte12 !== void 0 && _buyHealthPolicy$inte12.fieldUserCode ? /*#__PURE__*/React.createElement(Text, null, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$inte13 = buyHealthPolicy.intermediaryDetails) === null || _buyHealthPolicy$inte13 === void 0 ? void 0 : _buyHealthPolicy$inte13.fieldUserCode) : /*#__PURE__*/React.createElement(Text, {
        severity: 'neutral'
      }, "Not Captured")
    }, buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.proposalPaymentType ? {
      label: /*#__PURE__*/React.createElement("span", {
        className: "text-primary"
      }, "Proposal Type"),
      text: /*#__PURE__*/React.createElement(React.Fragment, null, ProposalPaymentTypeList && /*#__PURE__*/React.createElement(Text, null, getDomainData(ProposalPaymentTypeList, buyHealthPolicy.proposalPaymentType, 'code', 'value'))),
      colSpan: repeat
    } : null, planName ? {
      label: /*#__PURE__*/React.createElement("span", {
        className: "text-primary"
      }, "Plan Name"),
      text: /*#__PURE__*/React.createElement(Text, null, planName),
      colSpan: repeat
    } : null, quoteData !== null && quoteData !== void 0 && (_quoteData$cover = quoteData.cover) !== null && _quoteData$cover !== void 0 && _quoteData$cover.sum_insured ? {
      label: /*#__PURE__*/React.createElement("span", {
        className: "text-primary"
      }, "Sum Insured"),
      text: /*#__PURE__*/React.createElement(Text, null, Parse(quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$cover2 = quoteData.cover) === null || _quoteData$cover2 === void 0 ? void 0 : _quoteData$cover2.sum_insured))
    } : null, plans !== null && plans !== void 0 && (_plans$find2 = plans.find(function (p) {
      return p.name === planName;
    })) !== null && _plans$find2 !== void 0 && (_plans$find2$premium = _plans$find2.premium) !== null && _plans$find2$premium !== void 0 && _plans$find2$premium.totalPremium ? {
      label: /*#__PURE__*/React.createElement("span", {
        className: "text-primary"
      }, "Annual Premium (inclusive of all taxes)"),
      colSpan: 2,
      text: /*#__PURE__*/React.createElement("div", {
        className: "flex justify-start space-x-2 mt-1"
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Text, {
        type: "larger",
        severity: "info",
        className: "mt-0.5"
      }, Parse(plans.find(function (p) {
        return p.name === planName;
      }).premium.totalPremium))), /*#__PURE__*/React.createElement("span", {
        className: "mt-2.5"
      }, /*#__PURE__*/React.createElement(Text, {
        severity: "action",
        type: "label",
        className: "quanta_link cursor-pointer mt-1",
        onClick: function onClick(_) {
          setShowViewBreakup(true);
        }
      }, "View Breakup")))
    } : null, {
      text: /*#__PURE__*/React.createElement("span", {
        className: "flex flex-col items-end justify-end py-3 w-full h-full"
      }, /*#__PURE__*/React.createElement(Button, {
        flat: true,
        type: 'button',
        disabled: !(dataBuyHealthPolicy !== null && dataBuyHealthPolicy !== void 0 && (_dataBuyHealthPolicy$ = dataBuyHealthPolicy.buyHealthPolicy) !== null && _dataBuyHealthPolicy$ !== void 0 && _dataBuyHealthPolicy$.proposalNumber.length) > 0 || loadingDownload,
        size: "medium",
        className: "w-full",
        onClick: /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_) {
            var getDateTime, _yield$getDateTime, getDateTimeData, proposalPDFBase64String, _yield$proposalPDFBas, dataBase64String, sendProposalPDF, downloadBase64String, byteCharacters, byteNumbers, i, byteArray, file, fileURL;

            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    getDateTime = fetchQuery({
                      query: GET_DATE_TIME
                    });
                    setAlerts([]);
                    setLoadingDownload(true);
                    _context.next = 6;
                    return getDateTime;

                  case 6:
                    _yield$getDateTime = _context.sent;
                    getDateTimeData = _yield$getDateTime.data;
                    proposalPDFBase64String = mutateQuery({
                      mutation: SEND_PROPOSAL_PDF,
                      variables: getBase64Var(buyHealthPolicy, getDateTimeData)
                    });
                    _context.next = 11;
                    return proposalPDFBase64String;

                  case 11:
                    _yield$proposalPDFBas = _context.sent;
                    dataBase64String = _yield$proposalPDFBas.data;
                    sendProposalPDF = dataBase64String.sendProposalPDF;
                    downloadBase64String = sendProposalPDF.base64Pdf;
                    setLoadingDownload(false);
                    byteCharacters = atob(downloadBase64String.toString());
                    byteNumbers = new Array(byteCharacters.length);

                    for (i = 0; i < byteCharacters.length; i++) {
                      byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    byteArray = new Uint8Array(byteNumbers);
                    file = new Blob([byteArray], {
                      type: 'application/pdf;base64'
                    });
                    fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    _context.next = 30;
                    break;

                  case 25:
                    _context.prev = 25;
                    _context.t0 = _context["catch"](0);
                    setAlerts([{
                      id: Date.now(),
                      content: /*#__PURE__*/React.createElement("div", {
                        className: "flex flex-col w-full h-full"
                      }, /*#__PURE__*/React.createElement(Text, {
                        type: "normal"
                      }, _context.t0.message)),
                      type: 'error',
                      timeout: null,
                      disableClose: false
                    }]);
                    setLoadingDownload(false);
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth'
                    });

                  case 30:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 25]]);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }()
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: loadingDownload ? faSpinner : faDownload,
        className: "mr-4",
        spin: loadingDownload,
        size: "lg"
      }), loadingDownload ? 'Downloading...' : 'Download Proposal Form')),
      colSpan: repeat
    }].filter(function (d) {
      return d;
    })
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, list_loading || loadingGenderList || loadingLobList ? /*#__PURE__*/React.createElement(Loading, null) : errorGenderList | error_list || errorLobList ? /*#__PURE__*/React.createElement(Error$1, {
    error: errorGenderList | error_list || errorLobList
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DataGridGroup, {
    data: grid_data,
    repeat: repeat,
    textType: "label",
    titleType: "title",
    titleSeverity: "info",
    className: "w-full",
    gap: 0,
    gapX: 16,
    isSeparatorRequired: false,
    gapY: 2,
    spaceY: 2,
    nullData: function nullData() {
      return /*#__PURE__*/React.createElement(Text, {
        className: "opacity-40"
      }, "Not Captured");
    }
  }), /*#__PURE__*/React.createElement(ModalViewBreakup, {
    showViewBreakup: showViewBreakup,
    setShowViewBreakup: setShowViewBreakup,
    selectedPlanTypeView: planName,
    productName: productName,
    genderList: genderList,
    reactive_var_quote: buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quoteData,
    reactive_var_plan: buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.planData,
    title: 'Premium Breakup for Proposal'
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts
  }))));
}

var _excluded$7 = ["lobCode", "lobName", "productName", "productCode", "planName", "planCode", "proposalNumber"];
function SummaryPanel(_ref) {
  var lobCode = _ref.lobCode,
      lobName = _ref.lobName,
      productName = _ref.productName,
      productCode = _ref.productCode,
      planName = _ref.planName,
      planCode = _ref.planCode,
      proposalNumber = _ref.proposalNumber,
      props = _objectWithoutProperties(_ref, _excluded$7);

  var _useQuery = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  if (loading) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }

  if (error) {
    return /*#__PURE__*/React.createElement(Error$1, null);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-start h-auto sticky top-0"
  }, /*#__PURE__*/React.createElement(Card, {
    className: "h-full xl:h-auto p-0 m-0",
    title: "Proposal"
  }, data && /*#__PURE__*/React.createElement(ProposalSummary, _extends({
    data: data,
    lobCode: lobCode,
    lobName: lobName,
    productName: productName,
    productCode: productCode,
    planName: planName,
    planCode: planCode,
    proposalNumber: proposalNumber
  }, props))));
}

var _excluded$6 = ["goToStep", "proceedToNextStep", "setProceedToNextStep", "setParentAlerts", "setLoadingStep", "setCustomLoadingMessage", "lobCode", "lobName", "productName", "productCode", "planName", "planCode", "proposalNumber"];
function ProposerDetailsHealth(_ref) {
  var _Set, _dataBuyHealthPolicy$, _dataBuyHealthPolicy$2, _dataBuyHealthPolicy$3, _dataBuyHealthPolicy$4, _dataBuyHealthPolicy$5, _dataBuyHealthPolicy$6, _dataBuyHealthPolicy$7, _dataBuyHealthPolicy$8, _previousDataBuyHealt, _previousDataBuyHealt2, _previousDataBuyHealt3, _previousDataBuyHealt4, _previousDataBuyHealt5, _previousDataBuyHealt6, _dataBuyHealthPolicy$9, _dataBuyHealthPolicy$10, _dataBuyHealthPolicy$11, _dataBuyHealthPolicy$12, _dataBuyHealthPolicy$13, _dataBuyHealthPolicy$14, _previousDataBuyHealt7, _previousDataBuyHealt8, _previousDataBuyHealt9, _previousDataBuyHealt10, _previousDataBuyHealt11, _previousDataBuyHealt12, _dataBuyHealthPolicy$15, _dataBuyHealthPolicy$16, _dataBuyHealthPolicy$17, _dataBuyHealthPolicy$18, _dataBuyHealthPolicy$19, _dataBuyHealthPolicy$20, _previousDataBuyHealt13, _previousDataBuyHealt14, _previousDataBuyHealt15, _previousDataBuyHealt16, _previousDataBuyHealt17, _previousDataBuyHealt18, _dataBuyHealthPolicy$21, _dataBuyHealthPolicy$22, _dataBuyHealthPolicy$23, _dataBuyHealthPolicy$24, _dataBuyHealthPolicy$25, _dataBuyHealthPolicy$26, _previousDataBuyHealt19, _previousDataBuyHealt20, _previousDataBuyHealt21, _previousDataBuyHealt22, _previousDataBuyHealt23, _previousDataBuyHealt24;

  var goToStep = _ref.goToStep,
      proceedToNextStep = _ref.proceedToNextStep,
      setProceedToNextStep = _ref.setProceedToNextStep,
      setParentAlerts = _ref.setParentAlerts,
      setLoadingStep = _ref.setLoadingStep,
      setCustomLoadingMessage = _ref.setCustomLoadingMessage;
      _ref.lobCode;
      _ref.lobName;
      _ref.productName;
      _ref.productCode;
      _ref.planName;
      _ref.planCode;
      _ref.proposalNumber;
      var props = _objectWithoutProperties(_ref, _excluded$6);

  var initLoadRef = useRef([]);

  var _useQuery = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: ((_Set = new Set(initLoadRef === null || initLoadRef === void 0 ? void 0 : initLoadRef.current)) === null || _Set === void 0 ? void 0 : _Set.size) >= 1,
    onCompleted: function onCompleted(_) {
      initLoadRef.current = [].concat(_toConsumableArray(initLoadRef.current), [1]);
    }
  }),
      loadingBuyHealthPolicy = _useQuery.loading,
      errorBuyHealthPolicy = _useQuery.error,
      dataBuyHealthPolicy = _useQuery.data,
      previousDataBuyHealthPolicy = _useQuery.previousData;

  var saveQuoteVariables = function saveQuoteVariables(_ref2) {
    var _values$quoteData, _values$quoteData2, _values$quoteData2$lo, _values$quoteData3, _values$quoteData3$lo, _values$quoteData4, _values$quoteData4$lo, _values$quoteData5, _values$quoteData5$lo, _values$quoteData6, _values$quoteData6$lo, _values$quoteData7, _values$quoteData7$lo, _values$quoteData8, _values$quoteData8$lo, _values$quoteData9, _values$quoteData9$lo, _values$intermediaryD, _values$intermediaryD2, _values$intermediaryD3, _values$quoteData10, _values$quoteData11, _values$quoteData11$m, _values$quoteData12, _values$quoteData12$c, _values$quoteData13, _values$quoteData13$c, _values$quoteData14, _values$quoteData14$c, _values$planData, _values$planData$plan, _values$planData$plan2, _values$quoteData15, _values$proposerDetai;

    var lob_code = _ref2.lob_code,
        product_code = _ref2.product_code,
        values = _ref2.values;
    return {
      input: {
        quotationType: values === null || values === void 0 ? void 0 : values.quotationType,
        quoteCreationDate: moment().format('YYYY-MM-DD').toString(),
        customer: values === null || values === void 0 ? void 0 : values.proposerDetails,
        lob: lob_code,
        product: product_code,
        // custCkyc: '123444',
        // panNo: 'BSAPG7676S',
        maternitySelectedCover: values === null || values === void 0 ? void 0 : (_values$quoteData = values.quoteData) === null || _values$quoteData === void 0 ? void 0 : _values$quoteData.maternitySelectedCover,
        location: {
          pinCode: values === null || values === void 0 ? void 0 : (_values$quoteData2 = values.quoteData) === null || _values$quoteData2 === void 0 ? void 0 : (_values$quoteData2$lo = _values$quoteData2.location) === null || _values$quoteData2$lo === void 0 ? void 0 : _values$quoteData2$lo.pincode,
          state: values === null || values === void 0 ? void 0 : (_values$quoteData3 = values.quoteData) === null || _values$quoteData3 === void 0 ? void 0 : (_values$quoteData3$lo = _values$quoteData3.location) === null || _values$quoteData3$lo === void 0 ? void 0 : _values$quoteData3$lo.state,
          stateCode: values === null || values === void 0 ? void 0 : (_values$quoteData4 = values.quoteData) === null || _values$quoteData4 === void 0 ? void 0 : (_values$quoteData4$lo = _values$quoteData4.location) === null || _values$quoteData4$lo === void 0 ? void 0 : _values$quoteData4$lo.stateCode,
          district: values === null || values === void 0 ? void 0 : (_values$quoteData5 = values.quoteData) === null || _values$quoteData5 === void 0 ? void 0 : (_values$quoteData5$lo = _values$quoteData5.location) === null || _values$quoteData5$lo === void 0 ? void 0 : _values$quoteData5$lo.district,
          districtCode: values === null || values === void 0 ? void 0 : (_values$quoteData6 = values.quoteData) === null || _values$quoteData6 === void 0 ? void 0 : (_values$quoteData6$lo = _values$quoteData6.location) === null || _values$quoteData6$lo === void 0 ? void 0 : _values$quoteData6$lo.districtCode,
          city: values === null || values === void 0 ? void 0 : (_values$quoteData7 = values.quoteData) === null || _values$quoteData7 === void 0 ? void 0 : (_values$quoteData7$lo = _values$quoteData7.location) === null || _values$quoteData7$lo === void 0 ? void 0 : _values$quoteData7$lo.city,
          cityCode: values === null || values === void 0 ? void 0 : (_values$quoteData8 = values.quoteData) === null || _values$quoteData8 === void 0 ? void 0 : (_values$quoteData8$lo = _values$quoteData8.location) === null || _values$quoteData8$lo === void 0 ? void 0 : _values$quoteData8$lo.cityCode,
          zone: values === null || values === void 0 ? void 0 : (_values$quoteData9 = values.quoteData) === null || _values$quoteData9 === void 0 ? void 0 : (_values$quoteData9$lo = _values$quoteData9.location) === null || _values$quoteData9$lo === void 0 ? void 0 : _values$quoteData9$lo.zone
        },
        intermediary: {
          intermediaryCode: values === null || values === void 0 ? void 0 : (_values$intermediaryD = values.intermediaryDetails) === null || _values$intermediaryD === void 0 ? void 0 : _values$intermediaryD.code,
          locationCode: values === null || values === void 0 ? void 0 : (_values$intermediaryD2 = values.intermediaryDetails) === null || _values$intermediaryD2 === void 0 ? void 0 : _values$intermediaryD2.location,
          fieldUserCode: values === null || values === void 0 ? void 0 : (_values$intermediaryD3 = values.intermediaryDetails) === null || _values$intermediaryD3 === void 0 ? void 0 : _values$intermediaryD3.fieldUserCode
        },
        members: values === null || values === void 0 ? void 0 : (_values$quoteData10 = values.quoteData) === null || _values$quoteData10 === void 0 ? void 0 : _values$quoteData10.members.filter(function (mem) {
          return mem === null || mem === void 0 ? void 0 : mem.selected;
        }).map(function (member) {
          var _member$age;

          return {
            relationship: member === null || member === void 0 ? void 0 : member.relationship,
            gender: member === null || member === void 0 ? void 0 : member.gender,
            dob: member === null || member === void 0 ? void 0 : member.dob,
            age: member === null || member === void 0 ? void 0 : (_member$age = member.age) === null || _member$age === void 0 ? void 0 : _member$age.toString(),
            maternitySelected: member !== null && member !== void 0 && member.maternitySelected ? member === null || member === void 0 ? void 0 : member.maternitySelected : false
          };
        }),
        maternityMembers: values === null || values === void 0 ? void 0 : (_values$quoteData11 = values.quoteData) === null || _values$quoteData11 === void 0 ? void 0 : (_values$quoteData11$m = _values$quoteData11.maternityMembers) === null || _values$quoteData11$m === void 0 ? void 0 : _values$quoteData11$m.map(function (plan) {
          var _plan$members;

          return {
            planName: plan === null || plan === void 0 ? void 0 : plan.planName,
            members: (_plan$members = plan.members) === null || _plan$members === void 0 ? void 0 : _plan$members.map(function (mem) {
              var _mem$age;

              return {
                relationship: mem.relationship,
                gender: mem.gender,
                dob: mem.dob,
                age: (_mem$age = mem.age) === null || _mem$age === void 0 ? void 0 : _mem$age.toString(),
                maternitySelected: mem.maternitySelected
              };
            })
          };
        }),
        cover: {
          type: values === null || values === void 0 ? void 0 : (_values$quoteData12 = values.quoteData) === null || _values$quoteData12 === void 0 ? void 0 : (_values$quoteData12$c = _values$quoteData12.cover) === null || _values$quoteData12$c === void 0 ? void 0 : _values$quoteData12$c.type,
          sumInsured: parseInt(values === null || values === void 0 ? void 0 : (_values$quoteData13 = values.quoteData) === null || _values$quoteData13 === void 0 ? void 0 : (_values$quoteData13$c = _values$quoteData13.cover) === null || _values$quoteData13$c === void 0 ? void 0 : _values$quoteData13$c.sum_insured),
          tenure: values === null || values === void 0 ? void 0 : (_values$quoteData14 = values.quoteData) === null || _values$quoteData14 === void 0 ? void 0 : (_values$quoteData14$c = _values$quoteData14.cover) === null || _values$quoteData14$c === void 0 ? void 0 : _values$quoteData14$c.tenure
        },
        plans: values === null || values === void 0 ? void 0 : (_values$planData = values.planData) === null || _values$planData === void 0 ? void 0 : (_values$planData$plan = _values$planData.plans) === null || _values$planData$plan === void 0 ? void 0 : (_values$planData$plan2 = _values$planData$plan.filter(function (plan) {
          return plan === null || plan === void 0 ? void 0 : plan.isSelected;
        })) === null || _values$planData$plan2 === void 0 ? void 0 : _values$planData$plan2.map(function (plan) {
          var _plan$covers, _plan$packs, _plan$premium, _plan$premium2, _plan$premium3, _plan$premium4, _plan$premium5, _plan$premium6, _plan$premium7, _plan$premium7$loadin, _plan$premium8, _plan$premium8$discou, _plan$premium9, _plan$premium9$breaku;

          return {
            name: plan === null || plan === void 0 ? void 0 : plan.name,
            code: plan === null || plan === void 0 ? void 0 : plan.code,
            covers: plan === null || plan === void 0 ? void 0 : (_plan$covers = plan.covers) === null || _plan$covers === void 0 ? void 0 : _plan$covers.map(function (cover) {
              return {
                name: cover === null || cover === void 0 ? void 0 : cover.name,
                index: cover === null || cover === void 0 ? void 0 : cover.index
              };
            }),
            packs: plan === null || plan === void 0 ? void 0 : (_plan$packs = plan.packs) === null || _plan$packs === void 0 ? void 0 : _plan$packs.map(function (pack) {
              var _pack$addOnCovers;

              return {
                name: pack === null || pack === void 0 ? void 0 : pack.name,
                index: pack === null || pack === void 0 ? void 0 : pack.index,
                addOnCovers: pack === null || pack === void 0 ? void 0 : (_pack$addOnCovers = pack.addOnCovers) === null || _pack$addOnCovers === void 0 ? void 0 : _pack$addOnCovers.map(function (addOn) {
                  return {
                    name: addOn === null || addOn === void 0 ? void 0 : addOn.name,
                    index: addOn === null || addOn === void 0 ? void 0 : addOn.index,
                    selected: addOn === null || addOn === void 0 ? void 0 : addOn.selected
                  };
                })
              };
            }),
            premium: {
              basePremium: plan === null || plan === void 0 ? void 0 : (_plan$premium = plan.premium) === null || _plan$premium === void 0 ? void 0 : _plan$premium.basePremium,
              loadingDiscount: plan === null || plan === void 0 ? void 0 : (_plan$premium2 = plan.premium) === null || _plan$premium2 === void 0 ? void 0 : _plan$premium2.loadingDiscount,
              netPremium: plan === null || plan === void 0 ? void 0 : (_plan$premium3 = plan.premium) === null || _plan$premium3 === void 0 ? void 0 : _plan$premium3.netPremium,
              gst: plan === null || plan === void 0 ? void 0 : (_plan$premium4 = plan.premium) === null || _plan$premium4 === void 0 ? void 0 : _plan$premium4.gst,
              stampDuty: plan === null || plan === void 0 ? void 0 : (_plan$premium5 = plan.premium) === null || _plan$premium5 === void 0 ? void 0 : _plan$premium5.stampDuty,
              totalPremium: plan === null || plan === void 0 ? void 0 : (_plan$premium6 = plan.premium) === null || _plan$premium6 === void 0 ? void 0 : _plan$premium6.totalPremium,
              loading: plan === null || plan === void 0 ? void 0 : (_plan$premium7 = plan.premium) === null || _plan$premium7 === void 0 ? void 0 : (_plan$premium7$loadin = _plan$premium7.loading) === null || _plan$premium7$loadin === void 0 ? void 0 : _plan$premium7$loadin.map(function (loading) {
                return {
                  name: loading === null || loading === void 0 ? void 0 : loading.name,
                  amount: loading === null || loading === void 0 ? void 0 : loading.amount
                };
              }),
              discount: plan === null || plan === void 0 ? void 0 : (_plan$premium8 = plan.premium) === null || _plan$premium8 === void 0 ? void 0 : (_plan$premium8$discou = _plan$premium8.discount) === null || _plan$premium8$discou === void 0 ? void 0 : _plan$premium8$discou.map(function (discount) {
                return {
                  name: discount === null || discount === void 0 ? void 0 : discount.name,
                  amount: discount === null || discount === void 0 ? void 0 : discount.amount
                };
              }),
              breakup: plan === null || plan === void 0 ? void 0 : (_plan$premium9 = plan.premium) === null || _plan$premium9 === void 0 ? void 0 : (_plan$premium9$breaku = _plan$premium9.breakup) === null || _plan$premium9$breaku === void 0 ? void 0 : _plan$premium9$breaku.map(function (brkup) {
                return {
                  relationship: brkup === null || brkup === void 0 ? void 0 : brkup.relationship,
                  gender: brkup === null || brkup === void 0 ? void 0 : brkup.gender,
                  age: brkup === null || brkup === void 0 ? void 0 : brkup.age,
                  premium: brkup === null || brkup === void 0 ? void 0 : brkup.premium
                };
              })
            }
          };
        }),
        existingPolicyNumber: values === null || values === void 0 ? void 0 : (_values$quoteData15 = values.quoteData) === null || _values$quoteData15 === void 0 ? void 0 : _values$quoteData15.existingPolicyNumber,
        isExistingEmployee: values !== null && values !== void 0 && (_values$proposerDetai = values.proposerDetails) !== null && _values$proposerDetai !== void 0 && _values$proposerDetai.employeeNumber ? true : false
      }
    };
  };

  var proposerDOB = dataBuyHealthPolicy === null || dataBuyHealthPolicy === void 0 ? void 0 : (_dataBuyHealthPolicy$ = dataBuyHealthPolicy.buyHealthPolicy) === null || _dataBuyHealthPolicy$ === void 0 ? void 0 : (_dataBuyHealthPolicy$2 = _dataBuyHealthPolicy$.quoteData) === null || _dataBuyHealthPolicy$2 === void 0 ? void 0 : _dataBuyHealthPolicy$2.members.filter(function (mem) {
    return mem === null || mem === void 0 ? void 0 : mem.selected;
  }).map(function (member) {
    var _member$age2;

    return {
      relationship: member === null || member === void 0 ? void 0 : member.relationship,
      gender: member === null || member === void 0 ? void 0 : member.gender,
      dob: member === null || member === void 0 ? void 0 : member.dob,
      age: member === null || member === void 0 ? void 0 : (_member$age2 = member.age) === null || _member$age2 === void 0 ? void 0 : _member$age2.toString()
    };
  }).find(function (data) {
    return data.relationship === 'Self';
  }); // console.log("proposerDoD--------------------->",proposerDOB)

  return /*#__PURE__*/React.createElement(React.Fragment, null, !loadingBuyHealthPolicy && !errorBuyHealthPolicy && /*#__PURE__*/React.createElement(ProposerDetails, _objectSpread2({
    REACTIVE_VAR_QUERY: GET_BUY_HEALTH_POLICY_VAR_DETAILS,
    SAVE_QUOTE_QUERY: SAVE_QUOTE,
    goToStep: goToStep,
    proceedToNextStep: proceedToNextStep,
    resetProposerDetails: resetProposerDetails,
    saveQuoteVariables: saveQuoteVariables,
    setCustomLoadingMessage: setCustomLoadingMessage,
    setLoadingStep: setLoadingStep,
    setParentAlerts: setParentAlerts,
    setProceedToNextStep: setProceedToNextStep,
    updateReactiveVar: updateBuyHealthPolicy,
    preDob: proposerDOB ? proposerDOB.dob : "",
    prePermPincode: dataBuyHealthPolicy !== null && dataBuyHealthPolicy !== void 0 && (_dataBuyHealthPolicy$3 = dataBuyHealthPolicy.buyHealthPolicy) !== null && _dataBuyHealthPolicy$3 !== void 0 && (_dataBuyHealthPolicy$4 = _dataBuyHealthPolicy$3.quoteData) !== null && _dataBuyHealthPolicy$4 !== void 0 && (_dataBuyHealthPolicy$5 = _dataBuyHealthPolicy$4.location) !== null && _dataBuyHealthPolicy$5 !== void 0 && _dataBuyHealthPolicy$5.pincode ? dataBuyHealthPolicy === null || dataBuyHealthPolicy === void 0 ? void 0 : (_dataBuyHealthPolicy$6 = dataBuyHealthPolicy.buyHealthPolicy) === null || _dataBuyHealthPolicy$6 === void 0 ? void 0 : (_dataBuyHealthPolicy$7 = _dataBuyHealthPolicy$6.quoteData) === null || _dataBuyHealthPolicy$7 === void 0 ? void 0 : (_dataBuyHealthPolicy$8 = _dataBuyHealthPolicy$7.location) === null || _dataBuyHealthPolicy$8 === void 0 ? void 0 : _dataBuyHealthPolicy$8.pincode : previousDataBuyHealthPolicy !== null && previousDataBuyHealthPolicy !== void 0 && (_previousDataBuyHealt = previousDataBuyHealthPolicy.buyHealthPolicy) !== null && _previousDataBuyHealt !== void 0 && (_previousDataBuyHealt2 = _previousDataBuyHealt.quoteData) !== null && _previousDataBuyHealt2 !== void 0 && (_previousDataBuyHealt3 = _previousDataBuyHealt2.location) !== null && _previousDataBuyHealt3 !== void 0 && _previousDataBuyHealt3.pincode ? previousDataBuyHealthPolicy === null || previousDataBuyHealthPolicy === void 0 ? void 0 : (_previousDataBuyHealt4 = previousDataBuyHealthPolicy.buyHealthPolicy) === null || _previousDataBuyHealt4 === void 0 ? void 0 : (_previousDataBuyHealt5 = _previousDataBuyHealt4.quoteData) === null || _previousDataBuyHealt5 === void 0 ? void 0 : (_previousDataBuyHealt6 = _previousDataBuyHealt5.location) === null || _previousDataBuyHealt6 === void 0 ? void 0 : _previousDataBuyHealt6.pincode : '',
    prePermDistrict: dataBuyHealthPolicy !== null && dataBuyHealthPolicy !== void 0 && (_dataBuyHealthPolicy$9 = dataBuyHealthPolicy.buyHealthPolicy) !== null && _dataBuyHealthPolicy$9 !== void 0 && (_dataBuyHealthPolicy$10 = _dataBuyHealthPolicy$9.quoteData) !== null && _dataBuyHealthPolicy$10 !== void 0 && (_dataBuyHealthPolicy$11 = _dataBuyHealthPolicy$10.location) !== null && _dataBuyHealthPolicy$11 !== void 0 && _dataBuyHealthPolicy$11.district ? dataBuyHealthPolicy === null || dataBuyHealthPolicy === void 0 ? void 0 : (_dataBuyHealthPolicy$12 = dataBuyHealthPolicy.buyHealthPolicy) === null || _dataBuyHealthPolicy$12 === void 0 ? void 0 : (_dataBuyHealthPolicy$13 = _dataBuyHealthPolicy$12.quoteData) === null || _dataBuyHealthPolicy$13 === void 0 ? void 0 : (_dataBuyHealthPolicy$14 = _dataBuyHealthPolicy$13.location) === null || _dataBuyHealthPolicy$14 === void 0 ? void 0 : _dataBuyHealthPolicy$14.district : previousDataBuyHealthPolicy !== null && previousDataBuyHealthPolicy !== void 0 && (_previousDataBuyHealt7 = previousDataBuyHealthPolicy.buyHealthPolicy) !== null && _previousDataBuyHealt7 !== void 0 && (_previousDataBuyHealt8 = _previousDataBuyHealt7.quoteData) !== null && _previousDataBuyHealt8 !== void 0 && (_previousDataBuyHealt9 = _previousDataBuyHealt8.location) !== null && _previousDataBuyHealt9 !== void 0 && _previousDataBuyHealt9.district ? previousDataBuyHealthPolicy === null || previousDataBuyHealthPolicy === void 0 ? void 0 : (_previousDataBuyHealt10 = previousDataBuyHealthPolicy.buyHealthPolicy) === null || _previousDataBuyHealt10 === void 0 ? void 0 : (_previousDataBuyHealt11 = _previousDataBuyHealt10.quoteData) === null || _previousDataBuyHealt11 === void 0 ? void 0 : (_previousDataBuyHealt12 = _previousDataBuyHealt11.location) === null || _previousDataBuyHealt12 === void 0 ? void 0 : _previousDataBuyHealt12.district : '',
    prePermState: dataBuyHealthPolicy !== null && dataBuyHealthPolicy !== void 0 && (_dataBuyHealthPolicy$15 = dataBuyHealthPolicy.buyHealthPolicy) !== null && _dataBuyHealthPolicy$15 !== void 0 && (_dataBuyHealthPolicy$16 = _dataBuyHealthPolicy$15.quoteData) !== null && _dataBuyHealthPolicy$16 !== void 0 && (_dataBuyHealthPolicy$17 = _dataBuyHealthPolicy$16.location) !== null && _dataBuyHealthPolicy$17 !== void 0 && _dataBuyHealthPolicy$17.state ? dataBuyHealthPolicy === null || dataBuyHealthPolicy === void 0 ? void 0 : (_dataBuyHealthPolicy$18 = dataBuyHealthPolicy.buyHealthPolicy) === null || _dataBuyHealthPolicy$18 === void 0 ? void 0 : (_dataBuyHealthPolicy$19 = _dataBuyHealthPolicy$18.quoteData) === null || _dataBuyHealthPolicy$19 === void 0 ? void 0 : (_dataBuyHealthPolicy$20 = _dataBuyHealthPolicy$19.location) === null || _dataBuyHealthPolicy$20 === void 0 ? void 0 : _dataBuyHealthPolicy$20.state : previousDataBuyHealthPolicy !== null && previousDataBuyHealthPolicy !== void 0 && (_previousDataBuyHealt13 = previousDataBuyHealthPolicy.buyHealthPolicy) !== null && _previousDataBuyHealt13 !== void 0 && (_previousDataBuyHealt14 = _previousDataBuyHealt13.quoteData) !== null && _previousDataBuyHealt14 !== void 0 && (_previousDataBuyHealt15 = _previousDataBuyHealt14.location) !== null && _previousDataBuyHealt15 !== void 0 && _previousDataBuyHealt15.state ? previousDataBuyHealthPolicy === null || previousDataBuyHealthPolicy === void 0 ? void 0 : (_previousDataBuyHealt16 = previousDataBuyHealthPolicy.buyHealthPolicy) === null || _previousDataBuyHealt16 === void 0 ? void 0 : (_previousDataBuyHealt17 = _previousDataBuyHealt16.quoteData) === null || _previousDataBuyHealt17 === void 0 ? void 0 : (_previousDataBuyHealt18 = _previousDataBuyHealt17.location) === null || _previousDataBuyHealt18 === void 0 ? void 0 : _previousDataBuyHealt18.state : '',
    prePermCityTownVillage: dataBuyHealthPolicy !== null && dataBuyHealthPolicy !== void 0 && (_dataBuyHealthPolicy$21 = dataBuyHealthPolicy.buyHealthPolicy) !== null && _dataBuyHealthPolicy$21 !== void 0 && (_dataBuyHealthPolicy$22 = _dataBuyHealthPolicy$21.quoteData) !== null && _dataBuyHealthPolicy$22 !== void 0 && (_dataBuyHealthPolicy$23 = _dataBuyHealthPolicy$22.location) !== null && _dataBuyHealthPolicy$23 !== void 0 && _dataBuyHealthPolicy$23.city ? dataBuyHealthPolicy === null || dataBuyHealthPolicy === void 0 ? void 0 : (_dataBuyHealthPolicy$24 = dataBuyHealthPolicy.buyHealthPolicy) === null || _dataBuyHealthPolicy$24 === void 0 ? void 0 : (_dataBuyHealthPolicy$25 = _dataBuyHealthPolicy$24.quoteData) === null || _dataBuyHealthPolicy$25 === void 0 ? void 0 : (_dataBuyHealthPolicy$26 = _dataBuyHealthPolicy$25.location) === null || _dataBuyHealthPolicy$26 === void 0 ? void 0 : _dataBuyHealthPolicy$26.city : previousDataBuyHealthPolicy !== null && previousDataBuyHealthPolicy !== void 0 && (_previousDataBuyHealt19 = previousDataBuyHealthPolicy.buyHealthPolicy) !== null && _previousDataBuyHealt19 !== void 0 && (_previousDataBuyHealt20 = _previousDataBuyHealt19.quoteData) !== null && _previousDataBuyHealt20 !== void 0 && (_previousDataBuyHealt21 = _previousDataBuyHealt20.location) !== null && _previousDataBuyHealt21 !== void 0 && _previousDataBuyHealt21.city ? previousDataBuyHealthPolicy === null || previousDataBuyHealthPolicy === void 0 ? void 0 : (_previousDataBuyHealt22 = previousDataBuyHealthPolicy.buyHealthPolicy) === null || _previousDataBuyHealt22 === void 0 ? void 0 : (_previousDataBuyHealt23 = _previousDataBuyHealt22.quoteData) === null || _previousDataBuyHealt23 === void 0 ? void 0 : (_previousDataBuyHealt24 = _previousDataBuyHealt23.location) === null || _previousDataBuyHealt24 === void 0 ? void 0 : _previousDataBuyHealt24.city : ''
  }, props)));
}

var _excluded$5 = ["answerText"];
function ModalMedicalQuestionaire(_ref) {
  var productCode = _ref.productCode,
      questions = _ref.questions,
      medicalQuestionaireDisplay = _ref.medicalQuestionaireDisplay,
      setMedicalQuestionaireDisplay = _ref.setMedicalQuestionaireDisplay,
      readOnlyMode = _ref.readOnlyMode;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalDisplay = _useState2[0],
      setModalDisplay = _useState2[1];

  var _useState3 = useState('Kotak'),
      _useState4 = _slicedToArray(_useState3, 1);
      _useState4[0];

  var _useState5 = useState('Random Address'),
      _useState6 = _slicedToArray(_useState5, 1);
      _useState6[0];

  var _useQuery = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first'
  }),
      loadingBuyPolicy = _useQuery.loading,
      errorBuyPolicy = _useQuery.error,
      dataBuyPolicy = _useQuery.data;

  var masterQuestion = questions === null || questions === void 0 ? void 0 : questions.find(function (q) {
    var _q$srNo;

    return (q === null || q === void 0 ? void 0 : (_q$srNo = q.srNo) === null || _q$srNo === void 0 ? void 0 : _q$srNo.toLowerCase()) === 'master';
  });

  if (loadingBuyPolicy) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Loading, {
      customMessage: 'Fetching medical questions'
    }));
  }

  if (errorBuyPolicy) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Error$1, {
      error: errorBuyPolicy
    }));
  }

  var buyHealthPolicy = dataBuyPolicy.buyHealthPolicy;
  var nomineeDetails = buyHealthPolicy.nomineeDetails,
      medicalQuestionaire = buyHealthPolicy.medicalQuestionaire;
  useEffect(function () {
    var timer = setTimeout(function () {
      setModalDisplay(medicalQuestionaireDisplay);
    }, 150);
    return function () {
      return clearTimeout(timer);
    };
  }, [medicalQuestionaireDisplay, setModalDisplay]);

  var onModalClose = function onModalClose() {
    setModalDisplay(false);
    setMedicalQuestionaireDisplay(false);
    document.body.classList.remove('overflow-y-hidden');
  };

  var getInitialObjectFromReactiveVar = function getInitialObjectFromReactiveVar() {
    var initObj = {};
    medicalQuestionaire.forEach(function (m) {
      initObj["".concat(m.relationship)] = {};
      m.questions.forEach(function (q) {
        var _q$answer = q.answer,
            answerText = _q$answer.answerText,
            restAnswer = _objectWithoutProperties(_q$answer, _excluded$5);

        initObj["".concat(m.relationship)][q.srNo] = {
          checkboxAnswer: restAnswer.checkboxAnswer,
          textareaAnswer: answerText === '' ? '' : restAnswer.textareaAnswer
        };
      });
    });
    return initObj;
  };

  var getInitObject = function getInitObject() {
    if (medicalQuestionaire.length === 0) {
      var initObj = {};
      var questionObj = {};
      questions.forEach(function (medicalQuestionaire) {
        var _medicalQuestionaire$;

        questionObj["".concat(medicalQuestionaire.srNo)] = {
          checkboxAnswer: (medicalQuestionaire === null || medicalQuestionaire === void 0 ? void 0 : (_medicalQuestionaire$ = medicalQuestionaire.srNo) === null || _medicalQuestionaire$ === void 0 ? void 0 : _medicalQuestionaire$.toLowerCase()) === 'master' ? !(masterQuestion !== null && masterQuestion !== void 0 && masterQuestion.condToChild) ? 'Yes' : 'No' : 'No',
          textareaAnswer: ''
        };
      });
      nomineeDetails.forEach(function (nominee) {
        initObj["".concat(nominee.relationship)] = questionObj;
      });
      return initObj;
    }

    return getInitialObjectFromReactiveVar();
  };

  var getResponseObj = function getResponseObj(values) {
    var responseObj = [];
    nomineeDetails.forEach(function (nominee) {
      responseObj.push({
        relationship: nominee.relationship,
        questions: Object.keys(values["".concat(nominee.relationship)]).map(function (k) {
          var answerText = '';
          var question = questions.find(function (question) {
            return question.srNo === k;
          });

          if (question) {
            if (!question.isParent) {
              var parentQuestion = questions.find(function (q) {
                return q.childQuesNo.find(function (c) {
                  return c.toLowerCase() === question.srNo.toLowerCase();
                });
              });

              if (parentQuestion && (values["".concat(nominee.relationship)]["".concat(parentQuestion.srNo)].checkboxAnswer === 'Yes' && !parentQuestion.condToChild || values["".concat(nominee.relationship)]["".concat(parentQuestion.srNo)].checkboxAnswer === 'No' && parentQuestion.condToChild)) {
                answerText = '';
              } else {
                answerText = question.isChkTxtReq && values["".concat(nominee.relationship)][k].checkboxAnswer === 'Yes' ? values["".concat(nominee.relationship)][k].textareaAnswer : question.isChkTxtReq && values["".concat(nominee.relationship)][k].checkboxAnswer === 'No' ? values["".concat(nominee.relationship)][k].checkboxAnswer : question.isChkReq ? values["".concat(nominee.relationship)][k].checkboxAnswer : values["".concat(nominee.relationship)][k].textareaAnswer;
              }
            } else {
              answerText = question.isChkTxtReq && values["".concat(nominee.relationship)][k].checkboxAnswer === 'Yes' ? values["".concat(nominee.relationship)][k].textareaAnswer : question.isChkTxtReq && values["".concat(nominee.relationship)][k].checkboxAnswer === 'No' ? values["".concat(nominee.relationship)][k].checkboxAnswer : question.isChkReq ? values["".concat(nominee.relationship)][k].checkboxAnswer : values["".concat(nominee.relationship)][k].textareaAnswer;
            }
          } else {
            answerText = values["".concat(nominee.relationship)][k].checkboxAnswer;
          }

          return {
            srNo: k,
            answer: {
              checkboxAnswer: values["".concat(nominee.relationship)][k].checkboxAnswer,
              answerText: answerText,
              textareaAnswer: values["".concat(nominee.relationship)][k].textareaAnswer
            }
          };
        })
      });
    });
    return responseObj;
  };

  var initialValues = getInitObject();

  var validate = function validate(values) {
    var errors = {};

    var _loop = function _loop(i) {
      var _values$$MASTER, _values$$MASTER$check, _values$$MASTER$check2;

      var member = Object.keys(values)[i];
      var masterQuestion = questions === null || questions === void 0 ? void 0 : questions.find(function (question) {
        var _question$srNo, _question$srNo$toStri;

        return (question === null || question === void 0 ? void 0 : (_question$srNo = question.srNo) === null || _question$srNo === void 0 ? void 0 : (_question$srNo$toStri = _question$srNo.toString()) === null || _question$srNo$toStri === void 0 ? void 0 : _question$srNo$toStri.toLowerCase()) === 'master';
      });

      if (((_values$$MASTER = values["".concat(member)]['MASTER']) === null || _values$$MASTER === void 0 ? void 0 : (_values$$MASTER$check = _values$$MASTER.checkboxAnswer) === null || _values$$MASTER$check === void 0 ? void 0 : (_values$$MASTER$check2 = _values$$MASTER$check.toString()) === null || _values$$MASTER$check2 === void 0 ? void 0 : _values$$MASTER$check2.toLowerCase()) === 'no') {
        var _questions$filter, _questions$filter2;

        if (!(questions !== null && questions !== void 0 && (_questions$filter = questions.filter(function (question) {
          var _masterQuestion$child;

          return masterQuestion === null || masterQuestion === void 0 ? void 0 : (_masterQuestion$child = masterQuestion.childQuesNo) === null || _masterQuestion$child === void 0 ? void 0 : _masterQuestion$child.includes(question === null || question === void 0 ? void 0 : question.srNo);
        })) !== null && _questions$filter !== void 0 && _questions$filter.find(function (question) {
          var _values$$, _values$$2, _values$$2$checkboxAn, _values$$2$checkboxAn2, _values$$3, _values$$3$checkboxAn, _values$$3$checkboxAn2, _values$$4, _values$$4$toString;

          return (question === null || question === void 0 ? void 0 : question.condToChild) === null && (((_values$$ = values["".concat(member)]["".concat(question === null || question === void 0 ? void 0 : question.srNo)]) === null || _values$$ === void 0 ? void 0 : _values$$.textareaAnswer) || ((_values$$2 = values["".concat(member)]["".concat(question === null || question === void 0 ? void 0 : question.srNo)]) === null || _values$$2 === void 0 ? void 0 : (_values$$2$checkboxAn = _values$$2.checkboxAnswer) === null || _values$$2$checkboxAn === void 0 ? void 0 : (_values$$2$checkboxAn2 = _values$$2$checkboxAn.toString()) === null || _values$$2$checkboxAn2 === void 0 ? void 0 : _values$$2$checkboxAn2.toLowerCase()) === 'yes') || (question === null || question === void 0 ? void 0 : question.condToChild) && ((_values$$3 = values["".concat(member)]["".concat(question === null || question === void 0 ? void 0 : question.srNo)]) === null || _values$$3 === void 0 ? void 0 : (_values$$3$checkboxAn = _values$$3.checkboxAnswer) === null || _values$$3$checkboxAn === void 0 ? void 0 : (_values$$3$checkboxAn2 = _values$$3$checkboxAn.toString()) === null || _values$$3$checkboxAn2 === void 0 ? void 0 : _values$$3$checkboxAn2.toLowerCase()) === 'yes' || (question === null || question === void 0 ? void 0 : question.condToChild) === false && ((_values$$4 = values["".concat(member)]["".concat(question === null || question === void 0 ? void 0 : question.srNo)]) === null || _values$$4 === void 0 ? void 0 : (_values$$4$toString = _values$$4.toString()) === null || _values$$4$toString === void 0 ? void 0 : _values$$4$toString.toLowerCase()) === 'no';
        }))) {
          errors.masterQuestion = "* Medical Questionaire has to be filled for members";
        } else {
          errors = {};
          return {
            v: errors
          };
        }

        questions === null || questions === void 0 ? void 0 : (_questions$filter2 = questions.filter(function (question) {
          var _question$srNo2, _question$srNo2$toStr, _values$$5, _values$$5$checkboxAn, _values$$5$checkboxAn2, _values$$6, _values$$6$checkboxAn, _values$$6$checkboxAn2;

          return (question === null || question === void 0 ? void 0 : (_question$srNo2 = question.srNo) === null || _question$srNo2 === void 0 ? void 0 : (_question$srNo2$toStr = _question$srNo2.toString()) === null || _question$srNo2$toStr === void 0 ? void 0 : _question$srNo2$toStr.toLowerCase()) !== 'master' && (question === null || question === void 0 ? void 0 : question.isParent) && ((question === null || question === void 0 ? void 0 : question.condToChild) === true && ((_values$$5 = values["".concat(member)]["".concat(question === null || question === void 0 ? void 0 : question.srNo)]) === null || _values$$5 === void 0 ? void 0 : (_values$$5$checkboxAn = _values$$5.checkboxAnswer) === null || _values$$5$checkboxAn === void 0 ? void 0 : (_values$$5$checkboxAn2 = _values$$5$checkboxAn.toString()) === null || _values$$5$checkboxAn2 === void 0 ? void 0 : _values$$5$checkboxAn2.toLowerCase()) === 'yes' || (question === null || question === void 0 ? void 0 : question.condToChild) === false && ((_values$$6 = values["".concat(member)]["".concat(question === null || question === void 0 ? void 0 : question.srNo)]) === null || _values$$6 === void 0 ? void 0 : (_values$$6$checkboxAn = _values$$6.checkboxAnswer) === null || _values$$6$checkboxAn === void 0 ? void 0 : (_values$$6$checkboxAn2 = _values$$6$checkboxAn.toString()) === null || _values$$6$checkboxAn2 === void 0 ? void 0 : _values$$6$checkboxAn2.toLowerCase()) === 'no');
        })) === null || _questions$filter2 === void 0 ? void 0 : _questions$filter2.forEach(function (question) {
          var _question$childQuesNo;

          question === null || question === void 0 ? void 0 : (_question$childQuesNo = question.childQuesNo) === null || _question$childQuesNo === void 0 ? void 0 : _question$childQuesNo.forEach(function (childQuestion) {
            var _values$$7, _values$$7$checkboxAn, _values$$7$checkboxAn2, _values$$8;

            if (((_values$$7 = values["".concat(member)]["".concat(childQuestion)]) === null || _values$$7 === void 0 ? void 0 : (_values$$7$checkboxAn = _values$$7.checkboxAnswer) === null || _values$$7$checkboxAn === void 0 ? void 0 : (_values$$7$checkboxAn2 = _values$$7$checkboxAn.toString()) === null || _values$$7$checkboxAn2 === void 0 ? void 0 : _values$$7$checkboxAn2.toLowerCase()) === 'no' && !((_values$$8 = values["".concat(member)]["".concat(childQuestion)]) !== null && _values$$8 !== void 0 && _values$$8.textareaAnswer)) {
              if (!errors["".concat(member)]) {
                errors = _objectSpread2(_objectSpread2({}, errors), {}, _defineProperty({}, "".concat(member), {}));
              }

              if (childQuestion !== null && childQuestion !== void 0 && childQuestion.isChkReq) {
                errors["".concat(member)]["".concat(childQuestion)] = {
                  checkboxAnswer: "* Required"
                };
              } else {
                errors["".concat(member)]["".concat(childQuestion)] = {
                  textareaAnswer: "* Required"
                };
              }
            }
          });
        });
      }
    };

    for (var i = 0; i < ((_Object$keys = Object.keys(values)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length); i++) {
      var _Object$keys;

      var _ret = _loop(i);

      if (_typeof(_ret) === "object") return _ret.v;
    }

    return errors;
  };

  var MedicalQuestions = function MedicalQuestions(_ref2) {
    var _validate, _validate2, _Object$keys2;

    var validate = _ref2.validate;

    var _useQuantaFormikConte = useQuantaFormikContext(),
        values = _useQuantaFormikConte.values;

    var repeat = useResponsiveParams({
      for_mobile: 1,
      for_desktop: 1
    }); //console.log("nomineedetails",nomineeDetails)

    var questionData = nomineeDetails ? nomineeDetails.map(function (m) {
      var _questions$find, _questions$filter3;

      return {
        title: "".concat(m.relationship),
        size: 'medium',
        grid_data: values["".concat(m.relationship)]['MASTER'].checkboxAnswer === '' || values["".concat(m.relationship)]['MASTER'].checkboxAnswer === (!(masterQuestion !== null && masterQuestion !== void 0 && masterQuestion.condToChild) ? '' : 'No') ? [{
          type: 'radiogroup',
          label: /*#__PURE__*/React.createElement(Text, null, masterQuestion === null || masterQuestion === void 0 ? void 0 : masterQuestion.label),
          name: "".concat(m.relationship, ".").concat((_questions$find = questions.find(function (q) {
            var _q$srNo2;

            return (q === null || q === void 0 ? void 0 : (_q$srNo2 = q.srNo) === null || _q$srNo2 === void 0 ? void 0 : _q$srNo2.toLowerCase()) === 'master';
          })) === null || _questions$find === void 0 ? void 0 : _questions$find.srNo, ".checkboxAnswer"),
          disabledGlobal: readOnlyMode,
          flow: 'row',
          className: 'items-baseline justify-between',
          data: [{
            label: 'Yes',
            value: 'Yes'
          }, {
            label: 'No',
            value: 'No'
          }]
        }] : [{
          type: 'radiogroup',
          label: /*#__PURE__*/React.createElement(Text, null, masterQuestion === null || masterQuestion === void 0 ? void 0 : masterQuestion.label),
          name: "".concat(m.relationship, ".").concat(masterQuestion === null || masterQuestion === void 0 ? void 0 : masterQuestion.srNo, ".checkboxAnswer"),
          disabledGlobal: readOnlyMode,
          flow: 'row',
          className: 'items-baseline justify-between',
          data: [{
            label: 'Yes',
            value: 'Yes'
          }, {
            label: 'No',
            value: 'No'
          }]
        }].concat(_toConsumableArray(questions === null || questions === void 0 ? void 0 : (_questions$filter3 = questions.filter(function (q) {
          var _q$srNo3;

          return (q === null || q === void 0 ? void 0 : (_q$srNo3 = q.srNo) === null || _q$srNo3 === void 0 ? void 0 : _q$srNo3.toLowerCase()) !== 'master';
        })) === null || _questions$filter3 === void 0 ? void 0 : _questions$filter3.flatMap(function (q) {
          var _values$$q$srNo;

          if (!q.isParent) {
            var _values$$9, _values$$10;

            var parentQuestion = questions === null || questions === void 0 ? void 0 : questions.find(function (question) {
              var _question$childQuesNo2;

              return question === null || question === void 0 ? void 0 : (_question$childQuesNo2 = question.childQuesNo) === null || _question$childQuesNo2 === void 0 ? void 0 : _question$childQuesNo2.find(function (c) {
                return c.toLowerCase() === q.srNo.toLowerCase();
              });
            });

            if (parentQuestion && (((_values$$9 = values["".concat(m.relationship)]["".concat(parentQuestion.srNo)]) === null || _values$$9 === void 0 ? void 0 : _values$$9.checkboxAnswer) === 'Yes' && !parentQuestion.condToChild || ((_values$$10 = values["".concat(m.relationship)]["".concat(parentQuestion.srNo)]) === null || _values$$10 === void 0 ? void 0 : _values$$10.checkboxAnswer) === 'No' && parentQuestion !== null && parentQuestion !== void 0 && parentQuestion.condToChild)) {
              return null;
            }
          }

          if (q !== null && q !== void 0 && q.isChkTxtReq && ((_values$$q$srNo = values["".concat(m.relationship)][q.srNo]) === null || _values$$q$srNo === void 0 ? void 0 : _values$$q$srNo.checkboxAnswer) === 'Yes') {
            return [{
              type: 'radiogroup',
              label: /*#__PURE__*/React.createElement(Text, null, q === null || q === void 0 ? void 0 : q.label),
              name: "".concat(m === null || m === void 0 ? void 0 : m.relationship, ".").concat(q === null || q === void 0 ? void 0 : q.srNo, ".checkboxAnswer"),
              disabledGlobal: readOnlyMode,
              flow: 'row',
              className: 'items-baseline justify-between',
              data: [{
                label: 'Yes',
                value: 'Yes'
              }, {
                label: 'No',
                value: 'No'
              }]
            }, {
              type: 'textarea',
              name: "".concat(m === null || m === void 0 ? void 0 : m.relationship, ".").concat(q === null || q === void 0 ? void 0 : q.srNo, ".textareaAnswer"),
              disabled: readOnlyMode,
              flow: 'col',
              rows: 1,
              maxLength: 100
            }];
          }

          if (!q.isChkReq) {
            return {
              type: 'textarea',
              label: /*#__PURE__*/React.createElement(Text, null, q === null || q === void 0 ? void 0 : q.label, " (max 100 characters)"),
              name: "".concat(m === null || m === void 0 ? void 0 : m.relationship, ".").concat(q === null || q === void 0 ? void 0 : q.srNo, ".textareaAnswer"),
              disabled: readOnlyMode,
              flow: 'col',
              rows: 1,
              maxLength: 100
            };
          }

          return {
            type: 'radiogroup',
            label: /*#__PURE__*/React.createElement(Text, null, q === null || q === void 0 ? void 0 : q.label),
            name: "".concat(m === null || m === void 0 ? void 0 : m.relationship, ".").concat(q === null || q === void 0 ? void 0 : q.srNo, ".checkboxAnswer"),
            disabledGlobal: readOnlyMode,
            flow: 'row',
            className: 'items-baseline justify-between',
            data: [{
              label: 'Yes',
              value: 'Yes'
            }, {
              label: 'No',
              value: 'No'
            }]
          };
        }).filter(function (q) {
          return q;
        })))
      };
    }) : [];
    var disclaimerInformation = [{
      title: /*#__PURE__*/React.createElement("span", {
        className: "text-black font-bold"
      }, "Disclaimer/ Privacy Policy"),
      grid_data: [{
        colSpan: 1,
        text: /*#__PURE__*/React.createElement(Text, {
          type: "label",
          className: "text-base text-black"
        }, "Insurance is the subject matter of solicitation. The advertisement contains only an indication of cover offered . For more details on risk factors, terms, conditions and exclusions , please read the sales brochures carefully before concluding a sale. Trade logo displayed above belongs to Kotak Mahindra Bank Ltd. and Zurich Insurance Company Ltd, Switzerland and is used by Zurich Kotak General Insurance Company (India) Limited under license.  CIN: U66000MH2014PLC260291. IRDAI Reg. No.152. Registered & Corporate Office: 401, 4th Floor, Silver Metropolis, Jai Coach Compound, Off Western Express Highway, Goregaon (East), Mumbai- 400063. Maharashtra, India.")
      }]
    }];
    var other_props = {
      flow: 'cols',
      repeat: repeat,
      gapX: 6,
      gapY: 3,
      gap: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true
    }; //console.log("beforspli----------->",questionData)

    if (productCode === '2885' || productCode === '2877') {
      questionData = questionData.map(function (q) {
        return {
          title: q.title,
          size: q.size,
          grid_data: q.grid_data.filter(function (g, idx) {
            return idx !== 0;
          })
        };
      });
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaForm, {
      className: "space-y-4"
    }, /*#__PURE__*/React.createElement(InputGridGroup, _objectSpread2({
      data: questionData
    }, other_props)), /*#__PURE__*/React.createElement(DataGridGroup, {
      data: disclaimerInformation,
      repeat: 1,
      textType: "label",
      titleType: "title",
      titleSeverity: "info",
      nullData: function nullData() {
        return /*#__PURE__*/React.createElement(Text, {
          severity: "neutral"
        }, "Not Captured");
      }
    }), ((_validate = validate(values)) === null || _validate === void 0 ? void 0 : _validate.masterQuestion) && /*#__PURE__*/React.createElement(Text, {
      className: "flex space-y-2",
      severity: 'error'
    }, (_validate2 = validate(values)) === null || _validate2 === void 0 ? void 0 : _validate2.masterQuestion), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end pb-12"
    }, /*#__PURE__*/React.createElement(Button, {
      type: 'button',
      flat: false,
      onClick: function onClick(_) {
        updateBuyHealthPolicy({
          medicalQuestionaire: getResponseObj(values)
        });
        onModalClose();
      },
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSave,
        className: "mx-2 w-32"
      }),
      disabled: readOnlyMode || (Object === null || Object === void 0 ? void 0 : (_Object$keys2 = Object.keys(validate(values))) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0
    }, "Save"))));
  };

  return /*#__PURE__*/React.createElement(Modal, {
    display: modalDisplay,
    size: "full",
    title: 'Medical Questionaire',
    className: "min-h-screen flex flex-col justify-start",
    direction: "down",
    onClose: onModalClose
  }, /*#__PURE__*/React.createElement(QuantaFormik, {
    enableReinitialize: true,
    initialValues: initialValues,
    validate: validate
  }, /*#__PURE__*/React.createElement(MedicalQuestions, {
    validate: validate
  })));
}

var _excluded$4 = ["goToStep", "proceedToNextStep", "setProceedToNextStep", "currentStepFunctions", "setCurrentStepFunctions", "setParentAlerts", "setLoadingStep", "setCustomLoadingMessage", "lobCode", "lobName", "productName", "productCode", "planName", "planCode", "proposalNumber", "renderExpandedCards", "alerts"],
    _excluded2$2 = ["ppcTestLevel", "memberID", "memberStatus"],
    _excluded3$2 = ["relationship"],
    _excluded4$1 = ["isNewCustomer", "isCRNVerified"];
function ReviewConfirmDetails(_ref) {
  var _plans$find, _plans$find$premium, _prembuyHealthPolicy$, _prembuyHealthPolicy$2, _dataPaymentType$Prop2, _value$, _value$$userMyDetail;

  var goToStep = _ref.goToStep,
      proceedToNextStep = _ref.proceedToNextStep,
      setProceedToNextStep = _ref.setProceedToNextStep;
      _ref.currentStepFunctions;
      _ref.setCurrentStepFunctions;
      var setParentAlerts = _ref.setParentAlerts,
      setLoadingStep = _ref.setLoadingStep,
      setCustomLoadingMessage = _ref.setCustomLoadingMessage;
      _ref.lobCode;
      _ref.lobName;
      _ref.productName;
      var productCode = _ref.productCode,
      planName = _ref.planName,
      planCode = _ref.planCode,
      proposalNumber = _ref.proposalNumber,
      renderExpandedCards = _ref.renderExpandedCards,
      alerts = _ref.alerts,
      props = _objectWithoutProperties(_ref, _excluded$4);

  var fetchQuery = useFetchQuery();
  var mutateQuery = useMutationQuery();

  var _useContext = useContext(ConfigContext);
      _useContext.branding;

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      viewDocIdx = _useState2[0],
      setViewDocIdx = _useState2[1];

  var uploadDocRef = useRef([]);
  var screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop'
  });
  var params = useParams();
  var plan_name = planName ? planName : params === null || params === void 0 ? void 0 : params.plan_name;
  planCode ? planCode : params === null || params === void 0 ? void 0 : params.plan_code; //console.log('review and cnfirm page',plan_name)

  var _useQuery = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  if (data) {
    var prembuyHealthPolicy = data === null || data === void 0 ? void 0 : data.buyHealthPolicy;
    prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : prembuyHealthPolicy.quoteData;
    var premplanData = prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : prembuyHealthPolicy.planData;
    var plans = premplanData === null || premplanData === void 0 ? void 0 : premplanData.plans;
  }

  var Prem_data;
  Prem_data = plans === null || plans === void 0 ? void 0 : (_plans$find = plans.find(function (p) {
    return p.name === plan_name;
  })) === null || _plans$find === void 0 ? void 0 : (_plans$find$premium = _plans$find.premium) === null || _plans$find$premium === void 0 ? void 0 : _plans$find$premium.totalPremium;
  var prem_feature;

  if (!prembuyHealthPolicy.proposerDetails.panNumber) {
    if (Prem_data >= 50000) {
      // //console.log('activate push once')
      prem_feature = 1;
    }
  }

  var rev_manamount;
  rev_manamount = (prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : (_prembuyHealthPolicy$ = prembuyHealthPolicy.renewalMandateDetails) === null || _prembuyHealthPolicy$ === void 0 ? void 0 : (_prembuyHealthPolicy$2 = _prembuyHealthPolicy$.renewalPaymentMandate) === null || _prembuyHealthPolicy$2 === void 0 ? void 0 : _prembuyHealthPolicy$2.toString()) === 'true' ? 1.5 * Prem_data : '';

  var _useQuery2 = useQuery(GET_DATE_TIME),
      dateTimeLoading = _useQuery2.loading,
      errorTimeLoading = _useQuery2.error,
      dateTimeData = _useQuery2.data;

  var _useQuery3 = useQuery(GET_MEDICAL_QUESTIONS, {
    variables: {
      input: {
        productCode: productCode
      }
    },
    fetchPolicy: 'cache-first'
  }),
      loadingQuestions = _useQuery3.loading,
      errorQuestions = _useQuery3.error,
      dataQuestions = _useQuery3.data;

  var _useQuery4 = useQuery(RELATIONSHIP_WITH_PROPOSER, {
    fetchPolicy: 'cache-first'
  });
      _useQuery4.loading;
      _useQuery4.error;
      var datarelationshipwithproposer = _useQuery4.data;

  var _useQuery5 = useQuery(ROLLOVER_COMPANY_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loadingRollOverCompanyList = _useQuery5.loading,
      errorRollOverCompanyList = _useQuery5.error,
      dataRollOverCompanyList = _useQuery5.data;

  var _useQuery6 = useQuery(CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first'
  }),
      dropDownLoadingCustomer = _useQuery6.loading,
      dropDownDetails = _useQuery6.data;

  var _useQuery7 = useQuery(RENEWAL_MANDATE_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode: productCode
    }
  }),
      renewDropDownLoadingCustomer = _useQuery7.loading,
      renewDropDownErrorCustomer = _useQuery7.error,
      renewMandateDropDownDetails = _useQuery7.data;

  var _useQuery8 = useQuery(PROPOSER_DROPDOWN_DETAIL, {
    variables: {
      productCode: productCode
    },
    fetchPolicy: 'cache-first'
  }),
      loadingProposerDetail = _useQuery8.loading,
      errorProposerDetail = _useQuery8.error,
      dataProposerDetail = _useQuery8.data;

  var _useQuery9 = useQuery(PAY_PREMIUM_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loadingPaymentType = _useQuery9.loading,
      errorPaymentType = _useQuery9.error,
      dataPaymentType = _useQuery9.data;

  var _useQuery10 = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first'
  }),
      loadingCustTypeDomain = _useQuery10.loading,
      errorCustTypeDomain = _useQuery10.error,
      dataCustTypeDomain = _useQuery10.data;

  var _useQuery11 = useQuery(CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first'
  }),
      dropDownLoadingOrganisation = _useQuery11.loading,
      dropDownErrorOrganisation = _useQuery11.error,
      dropDownDetailsOrganisation = _useQuery11.data;

  var _useQuery12 = useQuery(DOCUMENT_STATIC_DATA, {
    fetchPolicy: 'cache-and-network'
  }),
      loadingDocumentExtensions = _useQuery12.loading,
      errorDocumentExtensions = _useQuery12.error;
      _useQuery12.data;

  var _useQuery13 = useQuery(PROFILE_DETAILS, {
    fetchPolicy: 'network-only'
  }),
      loadingProfile = _useQuery13.loading;
      _useQuery13.error;
      var dataProfileData = _useQuery13.data;

  var repeat = useResponsiveParams({
    for_mobile: 2,
    for_desktop: 3
  });

  var validate = function validate(values) {
    return {};
  };

  var getDomainData = function getDomainData(domainArr, searchText, searchType, returnType) {
    return domainArr.find(function (d) {
      var _d$, _d$$toString, _searchText$toString;

      return ((_d$ = d["".concat(searchType)]) === null || _d$ === void 0 ? void 0 : (_d$$toString = _d$.toString()) === null || _d$$toString === void 0 ? void 0 : _d$$toString.toLowerCase()) === (searchText === null || searchText === void 0 ? void 0 : (_searchText$toString = searchText.toString()) === null || _searchText$toString === void 0 ? void 0 : _searchText$toString.toLowerCase());
    }) ? domainArr.find(function (d) {
      var _d$2, _d$2$toString, _searchText$toString2;

      return ((_d$2 = d["".concat(searchType)]) === null || _d$2 === void 0 ? void 0 : (_d$2$toString = _d$2.toString()) === null || _d$2$toString === void 0 ? void 0 : _d$2$toString.toLowerCase()) === (searchText === null || searchText === void 0 ? void 0 : (_searchText$toString2 = searchText.toString()) === null || _searchText$toString2 === void 0 ? void 0 : _searchText$toString2.toLowerCase());
    })["".concat(returnType)] : searchText === null || searchText === undefined ? '' : "".concat(searchText);
  };

  var _useLazyQuery = useLazyQuery(VIEW_DOCUMENT, {
    fetchPolicy: 'network-only',
    onError: function onError(error) {
      setParentAlerts([{
        id: Date.now() + Math.random(),
        header: 'Error fetching document',
        content: /*#__PURE__*/React.createElement(Text, null, error === null || error === void 0 ? void 0 : error.message),
        type: 'error',
        timeout: null,
        disableClose: false
      }]);
      uploadDocRef.current = [];
    },
    onCompleted: function onCompleted(data) {
      var _ref2, _ref2$find;

      var viewDocument = data.viewDocument;
      var base64String = viewDocument.base64String,
          documentExtension = viewDocument.documentExtension,
          documentFileName = viewDocument.documentFileName;
      /**Solution 1 (downloads doc* files and views other file types) */
      // let byteCharacters = window.atob(
      //   base64String
      //     ?.toString()
      //     ?.split(';')
      //     ?.pop()
      //     ?.split(',')
      //     ?.pop(),
      // );
      // let byteNumbers = new Array(byteCharacters.length);
      // for (let i = 0; i < byteCharacters.length; i++) {
      //   byteNumbers[i] = byteCharacters.charCodeAt(i);
      // }
      // let byteArray = new Uint8Array(byteNumbers);
      // let file = new Blob([byteArray], {
      //   type: `${base64String
      //     ?.toString()
      //     ?.split(';')[0]
      //     ?.split(':')
      //     ?.pop()};base64`,
      // });
      // let fileURL = URL.createObjectURL(file);
      // if (
      //   documentExtensions
      //     ?.find(
      //       (extension) =>
      //         extension?.code?.toString()?.toLowerCase() ===
      //         documentExtension?.toString()?.toLowerCase(),
      //     )
      //     ?.value?.toString()
      //     ?.startsWith('doc')
      // ) {
      //   const downloadLink = document.createElement('a');
      //   const fileName = `${documentFileName}.${
      //     documentExtensions?.find(
      //       (extension) =>
      //         extension?.code?.toString()?.toLowerCase() ===
      //         documentExtension?.toString()?.toLowerCase(),
      //     )?.value
      //   }`;
      //   downloadLink.href = base64String;
      //   downloadLink.download = fileName;
      //   downloadLink.click();
      // } else {
      //   window.open(fileURL);
      // }

      /**Solution 2 (downloads all file types) */

      /**Solution 1 (downloads doc* files and views other file types) */
      // let byteCharacters = window.atob(
      //   base64String
      //     ?.toString()
      //     ?.split(';')
      //     ?.pop()
      //     ?.split(',')
      //     ?.pop(),
      // );
      // let byteNumbers = new Array(byteCharacters.length);
      // for (let i = 0; i < byteCharacters.length; i++) {
      //   byteNumbers[i] = byteCharacters.charCodeAt(i);
      // }
      // let byteArray = new Uint8Array(byteNumbers);
      // let file = new Blob([byteArray], {
      //   type: `${base64String
      //     ?.toString()
      //     ?.split(';')[0]
      //     ?.split(':')
      //     ?.pop()};base64`,
      // });
      // let fileURL = URL.createObjectURL(file);
      // if (
      //   documentExtensions
      //     ?.find(
      //       (extension) =>
      //         extension?.code?.toString()?.toLowerCase() ===
      //         documentExtension?.toString()?.toLowerCase(),
      //     )
      //     ?.value?.toString()
      //     ?.startsWith('doc')
      // ) {
      //   const downloadLink = document.createElement('a');
      //   const fileName = `${documentFileName}.${
      //     documentExtensions?.find(
      //       (extension) =>
      //         extension?.code?.toString()?.toLowerCase() ===
      //         documentExtension?.toString()?.toLowerCase(),
      //     )?.value
      //   }`;
      //   downloadLink.href = base64String;
      //   downloadLink.download = fileName;
      //   downloadLink.click();
      // } else {
      //   window.open(fileURL);
      // }

      /**Solution 2 (downloads all file types) */
      var downloadLink = document.createElement('a');
      var fileName = "".concat(documentFileName, ".").concat( //documentExtensions
      (_ref2 = [{
        code: '1',
        value: 'pdf'
      }, {
        code: '2',
        value: 'jpg'
      }, {
        code: '3',
        value: 'jpeg'
      }, {
        code: '4',
        value: 'png'
      }, {
        code: '5',
        value: 'doc'
      }, {
        code: '6',
        value: 'docx'
      }, {
        code: '7',
        value: 'msg'
      }]) === null || _ref2 === void 0 ? void 0 : (_ref2$find = _ref2.find(function (extension) {
        var _extension$code, _extension$code$toStr, _documentExtension$to;

        return (extension === null || extension === void 0 ? void 0 : (_extension$code = extension.code) === null || _extension$code === void 0 ? void 0 : (_extension$code$toStr = _extension$code.toString()) === null || _extension$code$toStr === void 0 ? void 0 : _extension$code$toStr.toLowerCase()) === (documentExtension === null || documentExtension === void 0 ? void 0 : (_documentExtension$to = documentExtension.toString()) === null || _documentExtension$to === void 0 ? void 0 : _documentExtension$to.toLowerCase());
      })) === null || _ref2$find === void 0 ? void 0 : _ref2$find.value);
      downloadLink.href = base64String;
      downloadLink.download = fileName;
      downloadLink.click();
    }
  }),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      viewDocument = _useLazyQuery2[0],
      loadingDocument = _useLazyQuery2[1].loading;

  var ReviewForm = function ReviewForm(_ref3) {
    var _renderExpandedCards$, _renderExpandedCards$2, _renderExpandedCards$5, _renderExpandedCards$6, _renderExpandedCards$9, _renderExpandedCards$10, _renderExpandedCards$13, _renderExpandedCards$14, _renderExpandedCards$17, _renderExpandedCards$18, _renderExpandedCards$21, _renderExpandedCards$22;

    _ref3.validate;

    var _useState3 = useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        medicalQuestionaireDisplay = _useState4[0],
        setMedicalQuestionaireDisplay = _useState4[1]; // const ReviewProposerForm = () => {
    //   const data = [
    //     proposerDetailsMeta.isNewCustomer === false
    //       ? {
    //           grid_data: [
    //             {
    //               label: 'Customer Number',
    //               text: proposerDetails.id,
    //             },
    //             {
    //               label: 'CRN',
    //               text: proposerDetailsMeta?.crn,
    //             },
    //           ],
    //         }
    //       : null,
    //     proposerDetails?.customerType ===
    //     getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //       ? {
    //           title: <Text type="normal">Personal Details</Text>,
    //           grid_data: [
    //             {
    //               label: 'Title',
    //               text: (
    //                 <Text
    //                   className={
    //                     proposerDetails?.title ? '' : 'opacity-40'
    //                   }
    //                   type={'normal'}
    //                 >
    //                   {proposerDetails.title
    //                     ? getDomainData(
    //                         salutationList,
    //                         proposerDetails?.title,
    //                         'code',
    //                         'value',
    //                       )
    //                     : 'Not Captured'}
    //                 </Text>
    //               ),
    //             },
    //             {
    //               label: 'Gender',
    //               text: (
    //                 <Text
    //                   className={
    //                     proposerDetails?.gender ? '' : 'opacity-40'
    //                   }
    //                   type={'normal'}
    //                 >
    //                   {proposerDetails.gender
    //                     ? getDomainData(
    //                         genderList,
    //                         proposerDetails?.gender,
    //                         'code',
    //                         'value',
    //                       )
    //                     : 'Not Captured'}
    //                 </Text>
    //               ),
    //             },
    //             {
    //               label: 'Date of Birth',
    //               text: proposerDetails.proposerDOB,
    //             },
    //             {
    //               label: 'First Name',
    //               text: proposerDetails.firstName,
    //             },
    //             {
    //               label: 'Middle Name',
    //               text: proposerDetails.middleName,
    //             },
    //             {
    //               label: 'Last Name',
    //               text: proposerDetails.lastName,
    //             },
    //             {
    //               label: 'Marital Status',
    //               text: (
    //                 <Text
    //                   className={
    //                     proposerDetails?.maritalStatus
    //                       ? ''
    //                       : 'opacity-40'
    //                   }
    //                   type={'normal'}
    //                 >
    //                   {proposerDetails.maritalStatus
    //                     ? getDomainData(
    //                         maritalStatusList,
    //                         proposerDetails?.maritalStatus,
    //                         'code',
    //                         'value',
    //                       )
    //                     : 'Not Captured'}
    //                 </Text>
    //               ),
    //             },
    //             {
    //               label: 'Nationality',
    //               text: (
    //                 <Text
    //                   className={
    //                     proposerDetails?.nationality
    //                       ? ''
    //                       : 'opacity-40'
    //                   }
    //                   type={'normal'}
    //                 >
    //                   {proposerDetails.nationality
    //                     ? getDomainData(
    //                         nationalityList,
    //                         proposerDetails?.nationality,
    //                         'code',
    //                         'value',
    //                       )
    //                     : 'Not Captured'}
    //                 </Text>
    //               ),
    //             },
    //           ],
    //         }
    //       : {
    //           title: <Text type="normal">Organisation Details</Text>,
    //           grid_data: [
    //             {
    //               label: 'Organisation Name',
    //               text: proposerDetails.orgName,
    //             },
    //             {
    //               label: 'Organisation Type ',
    //               text: getDomainData(
    //                 organisationList,
    //                 proposerDetails?.orgType,
    //                 'code',
    //                 'value',
    //               ),
    //             },
    //             {
    //               label: 'Contact Person Name',
    //               text: proposerDetails.contactName,
    //             },
    //           ],
    //         },
    //     proposerDetails.customerType ===
    //     getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //       ? {
    //           title: (
    //             <Text type="normal">Identification Details</Text>
    //           ),
    //           grid_type: 'data',
    //           grid_data: [
    //             {
    //               label: 'ID Proof Type',
    //               text: (
    //                 <Text
    //                   className={
    //                     proposerDetails?.idProofType
    //                       ? ''
    //                       : 'opacity-40'
    //                   }
    //                   type={'normal'}
    //                 >
    //                   {proposerDetails.idProofType
    //                     ? getDomainData(
    //                         idProofTypeList,
    //                         proposerDetails?.idProofType,
    //                         'code',
    //                         'value',
    //                       )
    //                     : 'Not Captured'}
    //                 </Text>
    //               ),
    //             },
    //             {
    //               label: 'ID Proof Number',
    //               text: proposerDetails?.idProofNumber
    //                 ?.toString()
    //                 ?.toUpperCase(),
    //             },
    //           ],
    //         }
    //       : {
    //           title: (
    //             <Text type="normal">Tax Identification Details</Text>
    //           ),
    //           grid_type: 'data',
    //           grid_data: [
    //             {
    //               label: 'Registration Number',
    //               text: proposerDetails.regNumber,
    //             },
    //             {
    //               label: 'TAN Number',
    //               text: proposerDetails.tanNumber?.toUpperCase(),
    //             },
    //             {
    //               label: 'GST Number',
    //               text: proposerDetails.gstNumber?.toUpperCase(),
    //             },
    //           ],
    //         },
    //     proposerDetails.customerType ===
    //     getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //       ? {
    //           title: <Text type="normal">Internal Employee</Text>,
    //           grid_type: 'data',
    //           grid_data: [
    //             {
    //               label: 'Employee Number',
    //               text: proposerDetails?.employeeNumber
    //                 ?.toString()
    //                 ?.toUpperCase(),
    //             },
    //           ],
    //         }
    //       : null,
    //     proposerDetails.customerType ===
    //     getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //       ? {
    //           title: (
    //             <Text type="normal">Tax Identification Details</Text>
    //           ),
    //           grid_type: 'data',
    //           grid_data: [
    //             {
    //               label: 'PAN Card Number',
    //               text: proposerDetails?.panNumber
    //                 ?.toString()
    //                 ?.toUpperCase(),
    //             },
    //             {
    //               label: 'GST Number',
    //               text: proposerDetails.gstNumber?.toUpperCase(),
    //             },
    //           ],
    //         }
    //       : null,
    //     {
    //       grid_type: 'data',
    //       grid_data: [
    //         {
    //           label: 'Permanent Address',
    //           colSpan: repeat,
    //           text: [
    //             proposerDetails?.permAddressLine1?.trim(),
    //             proposerDetails?.permAddressLine2?.trim(),
    //             proposerDetails?.permAddressLine3?.trim(),
    //             proposerDetails?.permLandmark?.trim(),
    //             proposerDetails?.permCityTownVillage?.trim(),
    //             proposerDetails?.permDistrict?.trim(),
    //             proposerDetails?.permState?.trim(),
    //             proposerDetails?.permPincode,
    //           ]
    //             .filter((a) => a)
    //             .join(','),
    //         },
    //         {
    //           label: 'Communication Address',
    //           colSpan: repeat,
    //           text: [
    //             proposerDetails?.commAddressLine1?.trim(),
    //             proposerDetails?.commAddressLine2?.trim(),
    //             proposerDetails?.commAddressLine3?.trim(),
    //             proposerDetails?.commLandmark?.trim(),
    //             proposerDetails?.commCityTownVillage?.trim(),
    //             proposerDetails?.commDistrict?.trim(),
    //             proposerDetails?.commState?.trim(),
    //             proposerDetails?.commPincode,
    //           ]
    //             .filter((a) => a)
    //             .join(','),
    //         },
    //       ].filter((d) => d),
    //     },
    //     proposerDetails.customerType ===
    //     getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //       ? {
    //           title: <Text type="normal">Contact Details</Text>,
    //           grid_type: 'data',
    //           grid_data: [
    //             {
    //               label: 'Mobile Number',
    //               text: proposerDetails.mobileNo,
    //             },
    //             {
    //               label: 'Email Id',
    //               text: proposerDetails.emailID,
    //             },
    //           ].filter((d) => d),
    //         }
    //       : {
    //           title: <Text type="normal">Contact Details</Text>,
    //           grid_type: 'data',
    //           grid_data: [
    //             {
    //               label: 'Telephone Number',
    //               text: proposerDetails.phoneNo,
    //             },
    //             {
    //               label: 'Organisation Mobile Number',
    //               text: proposerDetails.mobileNo,
    //             },
    //             {
    //               label: 'FAX Number',
    //               text: proposerDetails.faxNo,
    //             },
    //             {
    //               label: 'Alternative Telephone Number',
    //               text: proposerDetails.altPhoneNo,
    //             },
    //             {
    //               label: 'Alternative Mobile Number',
    //               text: proposerDetails.altMobileNo,
    //             },
    //             {
    //               label: 'Organisation Email Id',
    //               text: proposerDetails.emailID,
    //             },
    //             !buyHealthPolicy.proposalNumber
    //               ? {
    //                   colSpan: repeat,
    //                   label: <div className="mt-4"></div>,
    //                   text: (
    //                     <Text
    //                       severity="action"
    //                       className="hover:underline cursor-pointer"
    //                       onClick={(_) => {
    //                         goToStep(0);
    //                         window.scrollTo({
    //                           top: 0,
    //                           behavior: 'smooth',
    //                         });
    //                       }}
    //                     >
    //                       <FontAwesomeIcon
    //                         icon={faEdit}
    //                         className="mr-1"
    //                       />
    //                       <span className="font-bold">
    //                         Edit Details
    //                       </span>
    //                     </Text>
    //                   ),
    //                 }
    //               : null,
    //           ].filter((d) => d),
    //         },
    //   ].filter((d) => d);
    //   const other_props = {
    //     flow: 'cols',
    //     repeat,
    //     gapX: 6,
    //     gapY: 0,
    //     spaceY: 2,
    //     size: 'full',
    //     titleSeverity: 'info',
    //     textType: 'normal',
    //     useExpandablePaper: false,
    //   };
    //   return (
    //     <DataGridGroup
    //       {...{ data, ...other_props }}
    //       nullData={() => (
    //         <Text className="opacity-40">Not Captured</Text>
    //       )}
    //     />
    //   );
    // };


    var RenewMandateReviewForm = function RenewMandateReviewForm(_ref4) {
      var _PRD_RenewalPaymentMa, _PRD_RenewalPaymentMa2, _PRD_RenewalPaymentMa3;

      var renewalMandateDetails = _ref4.renewalMandateDetails;
      var grid_data = [{
        label: /*#__PURE__*/React.createElement(Text, {
          type: "label"
        }, "Do you want to set up a renewal payment mandate in the name of", ' ', renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.renewalPaymentMandateTakenInNameOf ? renewalMandateDetails === null || renewalMandateDetails === void 0 ? void 0 : renewalMandateDetails.renewalPaymentMandateTakenInNameOf : PRD_RenewalPaymentMandateTakenInTheNameOf ? (_PRD_RenewalPaymentMa = PRD_RenewalPaymentMandateTakenInTheNameOf[0]) === null || _PRD_RenewalPaymentMa === void 0 ? void 0 : (_PRD_RenewalPaymentMa2 = _PRD_RenewalPaymentMa.value) === null || _PRD_RenewalPaymentMa2 === void 0 ? void 0 : (_PRD_RenewalPaymentMa3 = _PRD_RenewalPaymentMa2.toString()) === null || _PRD_RenewalPaymentMa3 === void 0 ? void 0 : _PRD_RenewalPaymentMa3.toLowerCase() : '', "?"),
        text: renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.renewalPaymentMandate ? 'Yes' : 'No'
      }, // {
      //   label: 'Term for Mandate - Opted (Times)',
      //   text: getDomainData(
      //     PRD_TermForMandate,
      //     renewalMandateDetails?.termForMandateOpted,
      //     'code',
      //     'value',
      //   ),
      // },
      // {
      //   label: 'Type of Debit',
      //   text: (
      //     <Text
      //       className={
      //         renewalMandateDetails?.typeOfDebit ? '' : 'opacity-40'
      //       }
      //       type={'normal'}
      //     >
      //       {renewalMandateDetails.typeOfDebit
      //         ? getDomainData(
      //             typeOfDebit,
      //             renewalMandateDetails?.typeOfDebit,
      //             'code',
      //             'value',
      //           )
      //         : 'Not Captured'}
      //     </Text>
      //   ),
      // },
      // {
      //   label:
      //     'Destination Bank Account Number/ Legal Account Number',
      //   text: renewalMandateDetails?.accountNumber,
      // },
      // {
      //   label: 'Direct Debit/  NACH - Destination Bank Name',
      //   text: renewalMandateDetails?.destinationBankName,
      // },
      // {
      //   label: 'Destination Bank IFSC code',
      //   text: renewalMandateDetails?.destinationIfscCode,
      // },
      // {
      //   label: 'Destination Bank MICR code',
      //   text: renewalMandateDetails?.destinationMicrCode,
      // },
      // {
      //   label: 'Branch Name',
      //   text: renewalMandateDetails?.destinationBranchName,
      // },
      // {
      //   label: 'Mandate Amount',
      //   text: Parse(
      //     renewalMandateDetails?.mandateAmount,
      //     true,
      //     false,
      //     branding,
      //   ),
      // },
      // {
      //   label: 'Final Collection Date',
      //   text: renewalMandateDetails?.finalCollectionDate,
      // },
      // {
      //   label: 'Destination Bank Account Type',
      //   text: (
      //     <Text
      //       className={
      //         renewalMandateDetails?.destinationBankAccountType
      //           ? ''
      //           : 'opacity-40'
      //       }
      //       type={'normal'}
      //     >
      //       {renewalMandateDetails?.destinationBankAccountType
      //         ? getDomainData(
      //             destinationBankAccountType,
      //             renewalMandateDetails?.destinationBankAccountType,
      //             'code',
      //             'value',
      //           )
      //         : 'Not Captured'}
      //     </Text>
      //   ),
      // },
      !buyHealthPolicy.proposalNumber ? {
        colSpan: repeat,
        label: /*#__PURE__*/React.createElement("div", {
          className: "mt-4"
        }),
        text: /*#__PURE__*/React.createElement(Text, {
          severity: "action",
          className: "hover:underline cursor-pointer",
          onClick: function onClick(_) {
            goToStep(2);
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faEdit,
          className: "mr-1"
        }), /*#__PURE__*/React.createElement("span", {
          className: "font-bold"
        }, "Edit Details"))
      } : null].filter(function (d) {
        return d;
      });
      return /*#__PURE__*/React.createElement(DataGrid, {
        data: grid_data,
        flow: "cols",
        repeat: repeat,
        gapX: 6,
        textType: "normal",
        gapY: 0,
        spaceY: 2,
        nullData: function nullData() {
          return /*#__PURE__*/React.createElement(Text, {
            className: "opacity-40"
          }, "Not Captured");
        }
      });
    };

    var ReviewInsuredMembersForm = function ReviewInsuredMembersForm(_ref5) {
      var insuredDetails = _ref5.insuredDetails;
      var data = insuredDetails ? insuredDetails.map(function (m, _) {
        return {
          title: /*#__PURE__*/React.createElement(Text, {
            type: "normal"
          }, m.relationship, m !== null && m !== void 0 && m.memberStatus ? " (".concat(m === null || m === void 0 ? void 0 : m.memberStatus, ")") : ''),
          grid_data: [{
            label: 'Title',
            text: m.title
          }, {
            label: 'Gender',
            text: /*#__PURE__*/React.createElement(Text, {
              className: m !== null && m !== void 0 && m.gender ? '' : 'opacity-40',
              type: 'normal'
            }, m.gender ? getDomainData(genderList, m === null || m === void 0 ? void 0 : m.gender, 'code', 'value') : 'Not Captured')
          }, {
            label: 'Date of Birth',
            text: m.dob
          }, {
            label: 'First Name',
            text: m.firstName
          }, {
            label: 'Middle Name',
            text: m.middleName
          }, {
            label: 'Last Name',
            text: m.lastName
          }, {
            label: 'Marital Status',
            text: /*#__PURE__*/React.createElement(Text, {
              className: m !== null && m !== void 0 && m.maritalStatus ? '' : 'opacity-40',
              type: 'normal'
            }, m.maritalStatus ? getDomainData(maritalStatusList, m === null || m === void 0 ? void 0 : m.maritalStatus, 'code', 'value') : '')
          }, {
            label: 'Height',
            text: m.height ? "".concat(m.height, " cm(s)") : ''
          }, {
            label: 'Weight',
            text: m.weight ? "".concat(m.weight, " Kg(s)") : ''
          }, {
            label: 'Occupation',
            text: /*#__PURE__*/React.createElement(Text, {
              className: m !== null && m !== void 0 && m.occupation ? '' : 'opacity-40',
              type: 'normal'
            }, m.occupation ? getDomainData(PRD_OccupationList, m === null || m === void 0 ? void 0 : m.occupation, 'code', 'value') : 'Not Captured')
          }, m.relationship === 'Co-applicant' ? {
            label: 'Insured Relationship with Proposer',
            text: /*#__PURE__*/React.createElement(Text, {
              className: m !== null && m !== void 0 && m.insuredrelationshipwithproposer ? '' : 'opacity-40',
              type: 'normal'
            }, m.insuredrelationshipwithproposer ? getDomainData(relationshipwithproposer, m === null || m === void 0 ? void 0 : m.insuredrelationshipwithproposer, 'code', 'value') : 'Not Captured')
          } : null, {
            label: 'If Other Occupation',
            text: m.otherOccupation
          }, {
            label: 'Pre-Existing Disease waiting period',
            text: /*#__PURE__*/React.createElement(Text, {
              className: m !== null && m !== void 0 && m.pedWaitingPeriod ? '' : 'opacity-40',
              type: 'normal'
            }, m.pedWaitingPeriod ? getDomainData(PRD_PreExistDiseaseWaitPeriod, m === null || m === void 0 ? void 0 : m.pedWaitingPeriod, 'code', 'value') : 'Not Captured')
          }, // {
          //   label: 'Cumulative Bonus(in %)',
          //   text:
          //     m?.cbBonusPct !== null &&
          //     m?.cbBonusPct !== undefined &&
          //     m?.cbBonusPct !== null
          //       ? `${getDomainData(
          //           PRD_CumulativeBonus,
          //           m?.cbBonusPct,
          //           'code',
          //           'value',
          //         )}`
          //       : '',
          // },
          m !== null && m !== void 0 && m.ppcTestLevel ? {
            label: 'PPC Test Level',
            text: m.ppcTestLevel
          } : null, {
            label: 'Portability Required?',
            text: m.isPortabilityRequired ? 'Yes' : 'No'
          }, !buyHealthPolicy.proposalNumber ? {
            colSpan: repeat,
            label: /*#__PURE__*/React.createElement("div", {
              className: "mt-4"
            }),
            text: /*#__PURE__*/React.createElement(Text, {
              severity: "action",
              className: "hover:underline cursor-pointer",
              onClick: function onClick(_) {
                goToStep(1);
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
              }
            }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faEdit,
              className: "mr-1"
            }), /*#__PURE__*/React.createElement("span", {
              className: "font-bold"
            }, "Edit Details"))
          } : null].filter(function (d) {
            return d;
          })
        };
      }) : [];
      var other_props = {
        flow: 'cols',
        repeat: repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false
      };
      return /*#__PURE__*/React.createElement(DataGridGroup, _extends({}, _objectSpread2({
        data: data
      }, other_props), {
        nullData: function nullData() {
          return /*#__PURE__*/React.createElement(Text, {
            className: "opacity-40"
          }, "Not Captured");
        }
      }));
    };

    var ReviewNomineeForm = function ReviewNomineeForm(_ref6) {
      var nomineeDetails = _ref6.nomineeDetails;
      var data = nomineeDetails ? nomineeDetails.map(function (m) {
        return {
          title: /*#__PURE__*/React.createElement(Text, {
            type: "normal"
          }, m.relationship),
          grid_data: [{
            label: 'Name',
            text: m.name
          }, {
            label: 'Date of Birth',
            text: m.dob
          }, {
            label: 'Relationship with Member',
            text: /*#__PURE__*/React.createElement(Text, {
              className: m !== null && m !== void 0 && m.relationshipWithInsured ? '' : 'opacity-40',
              type: 'normal'
            }, m.relationshipWithInsured ? getDomainData(PRD_NomiRelationWithMemb, m === null || m === void 0 ? void 0 : m.relationshipWithInsured, 'code', 'value') : 'Not Captured')
          }, {
            label: 'Name of Appointee(in case of Minor)',
            text: m.nameOfAppointee
          }, {
            label: 'Relationship with Nominee',
            text: /*#__PURE__*/React.createElement(Text, {
              className: m !== null && m !== void 0 && m.relationshipWithAppointee ? '' : 'opacity-40'
            }, m.relationshipWithAppointee ? getDomainData(PRD_ApointRelationWithMinNomi, m === null || m === void 0 ? void 0 : m.relationshipWithAppointee, 'code', 'value') : 'Not Captured')
          }, !buyHealthPolicy.proposalNumber ? {
            colSpan: repeat,
            label: /*#__PURE__*/React.createElement("div", {
              className: "mt-4"
            }),
            text: /*#__PURE__*/React.createElement(Text, {
              severity: "action",
              className: "hover:underline cursor-pointer",
              onClick: function onClick(_) {
                goToStep(2);
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
              }
            }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faEdit,
              className: "mr-1"
            }), /*#__PURE__*/React.createElement("span", {
              className: "font-bold"
            }, "Edit Details"))
          } : null].filter(function (d) {
            return d;
          })
        };
      }) : [];
      var other_props = {
        flow: 'cols',
        repeat: repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false
      };
      return /*#__PURE__*/React.createElement(DataGridGroup, _extends({}, _objectSpread2({
        data: data
      }, other_props), {
        nullData: function nullData() {
          return /*#__PURE__*/React.createElement(Text, {
            className: "opacity-40"
          }, "Not Captured");
        }
      }));
    };

    var ReviewPreviousInsuranceForm = function ReviewPreviousInsuranceForm(_ref7) {
      var prevInsuranceDetails = _ref7.prevInsuranceDetails;
      var data = prevInsuranceDetails ? prevInsuranceDetails.map(function (prevInsured) {
        return {
          title: /*#__PURE__*/React.createElement(Text, {
            type: "normal"
          }, prevInsured.insuredRelationship, " - Previous Insurance Policy ", '&', " Claims"),
          grid_data: [{
            label: 'Previous Insurer Name',
            text: getDomainData(rolloverCompanyList, prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevInsurerName, 'code', 'value')
          }, {
            label: 'Previous Policy Number',
            text: prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevPolicyNo
          }, {
            label: 'Policy Start Date',
            text: prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevPolicyStartDate
          }, {
            label: 'Policy End Date',
            text: prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevPolicyEndDate
          }, {
            label: 'Sum Insured',
            text: prevInsured !== null && prevInsured !== void 0 && prevInsured.prevPolicySI ? Parse(prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevPolicySI) : ''
          }, {
            label: 'Claims lodged in the past policy?',
            text: prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevClaimLodged
          }, {
            label: 'Claim Amount',
            text: prevInsured !== null && prevInsured !== void 0 && prevInsured.claimAmount ? Parse(prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.claimAmount) : ''
          }, {
            label: 'Cumulative Bonus Amount',
            text: (prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.cbAmount) !== null && (prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.cbAmount) !== undefined && (prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.cbAmount) !== '' ? Parse(prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.cbAmount) : ''
          }, !buyHealthPolicy.proposalNumber ? {
            colSpan: repeat,
            label: /*#__PURE__*/React.createElement("div", {
              className: "mt-4"
            }),
            text: /*#__PURE__*/React.createElement(Text, {
              severity: "action",
              className: "hover:underline cursor-pointer",
              onClick: function onClick(_) {
                goToStep(2);
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
              }
            }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faEdit,
              className: "mr-1"
            }), /*#__PURE__*/React.createElement("span", {
              className: "font-bold"
            }, "Edit Details"))
          } : null].filter(function (d) {
            return d;
          })
        };
      }) : [];
      var other_props = {
        flow: 'cols',
        repeat: repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false
      };
      return /*#__PURE__*/React.createElement(DataGridGroup, _extends({}, _objectSpread2({
        data: data
      }, other_props), {
        nullData: function nullData() {
          return /*#__PURE__*/React.createElement(Text, {
            className: "opacity-40"
          }, "Not Captured");
        }
      }));
    };

    var ReviewPortablityDetailsForm = function ReviewPortablityDetailsForm(_ref8) {
      var portabilityDetails = _ref8.portabilityDetails;
      var data = portabilityDetails ? portabilityDetails.map(function (portability) {
        return {
          title: /*#__PURE__*/React.createElement(Text, {
            type: "normal"
          }, portability.insuredRelationship),
          grid_data: [{
            label: 'Member ID',
            text: portability.memberId
          }, {
            label: 'Insured Name',
            text: portability.memberName
          }, {
            label: 'Sum Insuured (including Cumulative Bonus, if any)',
            text: (portability === null || portability === void 0 ? void 0 : portability.sumInsuredIncCumBonusifany) !== '' && (portability === null || portability === void 0 ? void 0 : portability.sumInsuredIncCumBonusifany) !== null && (portability === null || portability === void 0 ? void 0 : portability.sumInsuredIncCumBonusifany) !== undefined ? Parse(portability.sumInsuredIncCumBonusifany) : ''
          }, {
            label: '30 Days Waiting Period',
            text: portability.thirtyDaysWaitingPeriod
          }, {
            label: '2 Years Waiting Period',
            text: portability.twoYearsWaitingPeriod
          }, {
            label: 'PED (4 Years) Waiting Period',
            text: portability.ped4YearsWaitingPeriod
          }].filter(function (d) {
            return d;
          })
        };
      }) : [];
      var other_props = {
        flow: 'cols',
        repeat: repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false
      };
      return /*#__PURE__*/React.createElement(DataGridGroup, _extends({}, _objectSpread2({
        data: data
      }, other_props), {
        nullData: function nullData() {
          return /*#__PURE__*/React.createElement(Text, {
            className: "opacity-40"
          }, "Not Captured");
        }
      }));
    };

    var HealthDeclarationForm = function HealthDeclarationForm() {
      var data = [{
        title: /*#__PURE__*/React.createElement("span", {
          className: "flex flex-col space-y-4"
        }, /*#__PURE__*/React.createElement(Text, {
          type: "large"
        }, "Health Declaration"), /*#__PURE__*/React.createElement(Text, {
          type: "label",
          className: "text-base text-black"
        }, "Any of the Insured member/s has medical condition or in not in good health?")),
        grid_data: [{
          type: 'render',
          component: function component() {
            return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RadioGroup, {
              selected: isHealthDeclarationSelected,
              disabled: true,
              data: [{
                label: 'Yes',
                value: 'Yes'
              }, {
                label: 'No',
                value: 'No'
              }]
            }));
          }
        }]
      }];
      var other_props = {
        flow: 'cols',
        repeat: repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        useExpandablePaper: false
      };
      return /*#__PURE__*/React.createElement(InputGridGroup, _objectSpread2({
        data: data
      }, other_props));
    };

    var uploadDocsData = [{
      grid_type: 'data',
      grid_data: [{
        label: '',
        colSpan: repeat,
        className: 'my-4',
        text: documentsPreloaded && (documentsPreloaded === null || documentsPreloaded === void 0 ? void 0 : documentsPreloaded.length) > 0 ? documentsPreloaded === null || documentsPreloaded === void 0 ? void 0 : documentsPreloaded.map(function (doc, documentIdx) {
          var _screenType$toString, _doc$documentName, _doc$documentName$toS, _ref9, _ref9$find, _screenType$toString2;

          // console.log("2050 doc : ",doc);
          return /*#__PURE__*/React.createElement(Paper, {
            key: documentIdx,
            className: "my-4 ".concat(documentIdx === 0 ? '-mt-1' : '', " bg-neutral border border-neutral-darker p-4 rounded")
          }, /*#__PURE__*/React.createElement(Grid, {
            repeat: repeat,
            gap: 0,
            gapX: 0,
            gapY: 0
          }, /*#__PURE__*/React.createElement(GridItem, {
            colSpan: (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString = screenType.toString()) === null || _screenType$toString === void 0 ? void 0 : _screenType$toString.toLowerCase()) === 'mobile' ? 1 : 2
          }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faPaperclip,
            size: "1x",
            className: "mr-3"
          })), /*#__PURE__*/React.createElement(Text, {
            severity: 'info',
            className: 'font-semibold'
          }, doc !== null && doc !== void 0 && doc.documentDescription && (doc === null || doc === void 0 ? void 0 : (_doc$documentName = doc.documentName) === null || _doc$documentName === void 0 ? void 0 : (_doc$documentName$toS = _doc$documentName.toString()) === null || _doc$documentName$toS === void 0 ? void 0 : _doc$documentName$toS.toLowerCase()) === 'others' ? doc === null || doc === void 0 ? void 0 : doc.documentDescription : doc === null || doc === void 0 ? void 0 : doc.documentName), /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col ml-7',
            severity: 'neutral-darker',
            type: 'label'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex items-center flex-wrap'
          }, /*#__PURE__*/React.createElement(Text, {
            type: 'label'
          }, "File Name:\xA0"), /*#__PURE__*/React.createElement(Text, {
            type: 'label',
            className: 'break-normal'
          }, "".concat(doc === null || doc === void 0 ? void 0 : doc.documentFileName, ".").concat( //documentExtensions
          (_ref9 = [{
            code: '1',
            value: 'pdf'
          }, {
            code: '2',
            value: 'jpg'
          }, {
            code: '3',
            value: 'jpeg'
          }, {
            code: '4',
            value: 'png'
          }, {
            code: '5',
            value: 'doc'
          }, {
            code: '6',
            value: 'docx'
          }, {
            code: '7',
            value: 'msg'
          }]) === null || _ref9 === void 0 ? void 0 : (_ref9$find = _ref9.find(function (extension) {
            var _extension$code2, _extension$code2$toSt, _doc$documentExtensio, _doc$documentExtensio2;

            return (extension === null || extension === void 0 ? void 0 : (_extension$code2 = extension.code) === null || _extension$code2 === void 0 ? void 0 : (_extension$code2$toSt = _extension$code2.toString()) === null || _extension$code2$toSt === void 0 ? void 0 : _extension$code2$toSt.toLowerCase()) === (doc === null || doc === void 0 ? void 0 : (_doc$documentExtensio = doc.documentExtension) === null || _doc$documentExtensio === void 0 ? void 0 : (_doc$documentExtensio2 = _doc$documentExtensio.toString()) === null || _doc$documentExtensio2 === void 0 ? void 0 : _doc$documentExtensio2.toLowerCase());
          })) === null || _ref9$find === void 0 ? void 0 : _ref9$find.value)))), /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col ml-7',
            severity: 'neutral-darker',
            type: 'label'
          }, "File Size:\xA0", doc === null || doc === void 0 ? void 0 : doc.documentSize, " KB"))), /*#__PURE__*/React.createElement(GridItem, {
            colSpan: (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString2 = screenType.toString()) === null || _screenType$toString2 === void 0 ? void 0 : _screenType$toString2.toLowerCase()) === 'mobile' ? repeat : 1,
            className: 'flex flex-col justify-center items-end'
          }, /*#__PURE__*/React.createElement(Text, {
            className: "flex justify-end items-center"
          }, /*#__PURE__*/React.createElement(Button, {
            size: 'small',
            type: 'button',
            flat: true,
            className: "w-full md:w-56 md:pr-4 max-h-10 -ml-0.5",
            iconPre: loadingDocument && documentIdx === viewDocIdx ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faSpinner,
              spin: true
            }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faDownload
            }),
            onClick: function onClick(_) {
              setViewDocIdx(documentIdx);

              if (buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.proposalNumber) {
                var _buyHealthPolicy$prop, _buyHealthPolicy$prop2;

                viewDocument({
                  variables: {
                    input: {
                      viewDocumentFor: {
                        customerID: buyHealthPolicy !== null && buyHealthPolicy !== void 0 && (_buyHealthPolicy$prop = buyHealthPolicy.proposerDetails) !== null && _buyHealthPolicy$prop !== void 0 && _buyHealthPolicy$prop.id ? buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop2 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop2 === void 0 ? void 0 : _buyHealthPolicy$prop2.id : '',
                        policyID: buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.policyNumber ? buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.policyNumber : '',
                        proposalNumber: buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.proposalNumber ? buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber : ''
                      },
                      // customerID:
                      //   values?.selectedCustomer
                      //     ?.cust_number,
                      documentDetails: {
                        documentID: doc === null || doc === void 0 ? void 0 : doc.documentID,
                        documentName: doc === null || doc === void 0 ? void 0 : doc.documentName,
                        documentFileName: doc === null || doc === void 0 ? void 0 : doc.documentFileName,
                        documentExtension: doc === null || doc === void 0 ? void 0 : doc.documentExtension,
                        documentSize: doc === null || doc === void 0 ? void 0 : doc.documentSize,
                        documentDescription: doc === null || doc === void 0 ? void 0 : doc.documentDescription
                      }
                    }
                  }
                });
              } else {
                var _ref10, _ref10$find;

                var downloadLink = document.createElement('a');
                var fileName = "".concat(doc === null || doc === void 0 ? void 0 : doc.documentFileName, ".").concat( //documentExtensions
                (_ref10 = [{
                  code: '1',
                  value: 'pdf'
                }, {
                  code: '2',
                  value: 'jpg'
                }, {
                  code: '3',
                  value: 'jpeg'
                }, {
                  code: '4',
                  value: 'png'
                }, {
                  code: '5',
                  value: 'doc'
                }, {
                  code: '6',
                  value: 'docx'
                }, {
                  code: '7',
                  value: 'msg'
                }]) === null || _ref10 === void 0 ? void 0 : (_ref10$find = _ref10.find(function (extension) {
                  var _extension$code3, _extension$code3$toSt, _doc$documentExtensio3, _doc$documentExtensio4;

                  return (extension === null || extension === void 0 ? void 0 : (_extension$code3 = extension.code) === null || _extension$code3 === void 0 ? void 0 : (_extension$code3$toSt = _extension$code3.toString()) === null || _extension$code3$toSt === void 0 ? void 0 : _extension$code3$toSt.toLowerCase()) === (doc === null || doc === void 0 ? void 0 : (_doc$documentExtensio3 = doc.documentExtension) === null || _doc$documentExtensio3 === void 0 ? void 0 : (_doc$documentExtensio4 = _doc$documentExtensio3.toString()) === null || _doc$documentExtensio4 === void 0 ? void 0 : _doc$documentExtensio4.toLowerCase());
                })) === null || _ref10$find === void 0 ? void 0 : _ref10$find.value);
                downloadLink.href = doc.documentBase64String;
                downloadLink.download = fileName;
                downloadLink.click();
              }
            } // iconPre={<FontAwesomeIcon icon={faDownload} />}

          }, loadingDocument && documentIdx === viewDocIdx ? 'Downloading...' : 'Download', ' ')))));
        }) : []
      }]
    }];
    var otherPropsForCards = {
      flow: 'cols',
      textType: 'normal',
      repeat: repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      titleType: 'normal',
      useExpandablePaper: false,
      useGlobalExpandablePaper: true,
      globalTitleSeverity: 'info',
      globalTitleType: 'large',
      nullData: function nullData() {
        return /*#__PURE__*/React.createElement(Text, {
          severity: "neutral"
        }, "Not Captured");
      }
    };

    var TitlePart = function TitlePart() {
      var _dataPaymentType$Prop, _buyHealthPolicy$poli, _buyHealthPolicy$poli2, _dateTimeData$datetim, _buyHealthPolicy$quot, _buyHealthPolicy$quot2, _buyHealthPolicy$poli3, _buyHealthPolicy$poli4, _buyHealthPolicy$prop3;

      var data = [{
        title: 'Business Type',
        grid_data: [{
          type: 'render',
          component: function component() {
            return /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faCheck,
              className: "mr-2 text-success"
            }), quotationType);
          }
        }]
      }, {
        title: 'Proposal Type',
        grid_data: [{
          type: 'radiogroup',
          name: 'proposalPaymentType',
          disabledGlobal: buyHealthPolicy.proposalNumber.length > 0,
          data: dataPaymentType ? (_dataPaymentType$Prop = dataPaymentType.ProposalPaymentTypeList) === null || _dataPaymentType$Prop === void 0 ? void 0 : _dataPaymentType$Prop.map(function (paymentMethod) {
            return {
              label: paymentMethod.value ? paymentMethod.value : '',
              value: paymentMethod.code ? paymentMethod.code : ''
            };
          }) : []
        }]
      }, {
        title: 'Review Proposal',
        grid_type: 'data',
        grid_data: [{
          label: 'Policy Start Date',
          name: 'startDate',
          text: buyHealthPolicy !== null && buyHealthPolicy !== void 0 && (_buyHealthPolicy$poli = buyHealthPolicy.policy) !== null && _buyHealthPolicy$poli !== void 0 && _buyHealthPolicy$poli.startDate ? buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$poli2 = buyHealthPolicy.policy) === null || _buyHealthPolicy$poli2 === void 0 ? void 0 : _buyHealthPolicy$poli2.startDate : dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim = dateTimeData.datetimeValue) === null || _dateTimeData$datetim === void 0 ? void 0 : _dateTimeData$datetim.date
        }, {
          label: 'Tenure',
          text: buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$quot = buyHealthPolicy.quoteData) === null || _buyHealthPolicy$quot === void 0 ? void 0 : (_buyHealthPolicy$quot2 = _buyHealthPolicy$quot.cover) === null || _buyHealthPolicy$quot2 === void 0 ? void 0 : _buyHealthPolicy$quot2.tenure
        }, buyHealthPolicy !== null && buyHealthPolicy !== void 0 && (_buyHealthPolicy$poli3 = buyHealthPolicy.policy) !== null && _buyHealthPolicy$poli3 !== void 0 && _buyHealthPolicy$poli3.endDate ? {
          label: 'Policy End Date',
          name: 'endDate',
          text: buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$poli4 = buyHealthPolicy.policy) === null || _buyHealthPolicy$poli4 === void 0 ? void 0 : _buyHealthPolicy$poli4.endDate
        } : null, {
          label: 'Lead Generator',
          colSpan: 1,
          text: /*#__PURE__*/React.createElement("div", {
            className: 'mt-1'
          }, /*#__PURE__*/React.createElement(QuantaInput, {
            type: 'text',
            size: 'full',
            name: 'leadGenerator',
            disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop3 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop3 === void 0 ? void 0 : _buyHealthPolicy$prop3.length) > 0
          }))
        }].filter(function (d) {
          return d;
        })
      }];
      var other_props = {
        flow: 'cols',
        repeat: repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false
      };
      return /*#__PURE__*/React.createElement(MixedGridGroup, _objectSpread2({
        data: data
      }, other_props));
    };

    var RenewMandate = function RenewMandate() {
      var data = [{
        grid_type: 'data',
        grid_data: [{
          text: /*#__PURE__*/React.createElement(RenewMandateReviewForm, {
            renewalMandateDetails: renewalMandateDetails
          }),
          colSpan: repeat
        }]
      }];
      var other_props = {
        flow: 'cols',
        textType: 'normal',
        repeat: repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        useExpandablePaper: false
      };
      return /*#__PURE__*/React.createElement(MixedGridGroup, _objectSpread2({
        data: data
      }, other_props));
    };

    var data = [// {
    //   title: <Text type="large">Proposer Customer</Text>,
    //   grid_type: 'data',
    //   grid_data: [
    //     {
    //       text: <ReviewProposerForm />,
    //       colSpan: repeat,
    //     },
    //   ],
    // },
    {
      title: /*#__PURE__*/React.createElement(Text, {
        type: "large"
      }, "Insured Members Details"),
      grid_type: 'data',
      expanded: renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$ = renderExpandedCards.current) === null || _renderExpandedCards$ === void 0 ? void 0 : (_renderExpandedCards$2 = _renderExpandedCards$.find(function (card) {
        var _card$cardName, _card$cardName$toStri;

        return (card === null || card === void 0 ? void 0 : (_card$cardName = card.cardName) === null || _card$cardName === void 0 ? void 0 : (_card$cardName$toStri = _card$cardName.toString()) === null || _card$cardName$toStri === void 0 ? void 0 : _card$cardName$toStri.toLowerCase()) === 'insured members details';
      })) === null || _renderExpandedCards$2 === void 0 ? void 0 : _renderExpandedCards$2.flag,
      isToggleEnabled: true,
      setExpandedCards: function setExpandedCards(expanded) {
        var _renderExpandedCards$3, _renderExpandedCards$4;

        renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$3 = renderExpandedCards.current) === null || _renderExpandedCards$3 === void 0 ? void 0 : _renderExpandedCards$3.filter(function (card) {
          var _card$cardName2, _card$cardName2$toStr;

          return (card === null || card === void 0 ? void 0 : (_card$cardName2 = card.cardName) === null || _card$cardName2 === void 0 ? void 0 : (_card$cardName2$toStr = _card$cardName2.toString()) === null || _card$cardName2$toStr === void 0 ? void 0 : _card$cardName2$toStr.toLowerCase()) !== 'insured members details';
        })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$4 = renderExpandedCards.current) === null || _renderExpandedCards$4 === void 0 ? void 0 : _renderExpandedCards$4.find(function (card) {
          var _card$cardName3, _card$cardName3$toStr;

          return (card === null || card === void 0 ? void 0 : (_card$cardName3 = card.cardName) === null || _card$cardName3 === void 0 ? void 0 : (_card$cardName3$toStr = _card$cardName3.toString()) === null || _card$cardName3$toStr === void 0 ? void 0 : _card$cardName3$toStr.toLowerCase()) === 'insured members details';
        })), {}, {
          flag: expanded
        })]);
      },
      grid_data: [{
        text: /*#__PURE__*/React.createElement(ReviewInsuredMembersForm, {
          insuredDetails: insuredDetails
        }),
        colSpan: repeat
      }]
    }, {
      title: /*#__PURE__*/React.createElement(Text, {
        type: "large"
      }, "Nominee Details"),
      grid_type: 'data',
      expanded: renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$5 = renderExpandedCards.current) === null || _renderExpandedCards$5 === void 0 ? void 0 : (_renderExpandedCards$6 = _renderExpandedCards$5.find(function (card) {
        var _card$cardName4, _card$cardName4$toStr;

        return (card === null || card === void 0 ? void 0 : (_card$cardName4 = card.cardName) === null || _card$cardName4 === void 0 ? void 0 : (_card$cardName4$toStr = _card$cardName4.toString()) === null || _card$cardName4$toStr === void 0 ? void 0 : _card$cardName4$toStr.toLowerCase()) === 'nominee details';
      })) === null || _renderExpandedCards$6 === void 0 ? void 0 : _renderExpandedCards$6.flag,
      isToggleEnabled: true,
      setExpandedCards: function setExpandedCards(expanded) {
        var _renderExpandedCards$7, _renderExpandedCards$8;

        renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$7 = renderExpandedCards.current) === null || _renderExpandedCards$7 === void 0 ? void 0 : _renderExpandedCards$7.filter(function (card) {
          var _card$cardName5, _card$cardName5$toStr;

          return (card === null || card === void 0 ? void 0 : (_card$cardName5 = card.cardName) === null || _card$cardName5 === void 0 ? void 0 : (_card$cardName5$toStr = _card$cardName5.toString()) === null || _card$cardName5$toStr === void 0 ? void 0 : _card$cardName5$toStr.toLowerCase()) !== 'nominee details';
        })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$8 = renderExpandedCards.current) === null || _renderExpandedCards$8 === void 0 ? void 0 : _renderExpandedCards$8.find(function (card) {
          var _card$cardName6, _card$cardName6$toStr;

          return (card === null || card === void 0 ? void 0 : (_card$cardName6 = card.cardName) === null || _card$cardName6 === void 0 ? void 0 : (_card$cardName6$toStr = _card$cardName6.toString()) === null || _card$cardName6$toStr === void 0 ? void 0 : _card$cardName6$toStr.toLowerCase()) === 'nominee details';
        })), {}, {
          flag: expanded
        })]);
      },
      grid_data: [{
        text: /*#__PURE__*/React.createElement(ReviewNomineeForm, {
          nomineeDetails: nomineeDetails
        }),
        colSpan: repeat
      }]
    }, prevInsuranceDetails && prevInsuranceDetails.length > 0 ? {
      title: /*#__PURE__*/React.createElement(Text, {
        type: "large"
      }, "Previous Insurance Details"),
      grid_type: 'data',
      expanded: renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$9 = renderExpandedCards.current) === null || _renderExpandedCards$9 === void 0 ? void 0 : (_renderExpandedCards$10 = _renderExpandedCards$9.find(function (card) {
        var _card$cardName7, _card$cardName7$toStr;

        return (card === null || card === void 0 ? void 0 : (_card$cardName7 = card.cardName) === null || _card$cardName7 === void 0 ? void 0 : (_card$cardName7$toStr = _card$cardName7.toString()) === null || _card$cardName7$toStr === void 0 ? void 0 : _card$cardName7$toStr.toLowerCase()) === 'previous insurance details';
      })) === null || _renderExpandedCards$10 === void 0 ? void 0 : _renderExpandedCards$10.flag,
      isToggleEnabled: true,
      setExpandedCards: function setExpandedCards(expanded) {
        var _renderExpandedCards$11, _renderExpandedCards$12;

        renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$11 = renderExpandedCards.current) === null || _renderExpandedCards$11 === void 0 ? void 0 : _renderExpandedCards$11.filter(function (card) {
          var _card$cardName8, _card$cardName8$toStr;

          return (card === null || card === void 0 ? void 0 : (_card$cardName8 = card.cardName) === null || _card$cardName8 === void 0 ? void 0 : (_card$cardName8$toStr = _card$cardName8.toString()) === null || _card$cardName8$toStr === void 0 ? void 0 : _card$cardName8$toStr.toLowerCase()) !== 'previous insurance details';
        })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$12 = renderExpandedCards.current) === null || _renderExpandedCards$12 === void 0 ? void 0 : _renderExpandedCards$12.find(function (card) {
          var _card$cardName9, _card$cardName9$toStr;

          return (card === null || card === void 0 ? void 0 : (_card$cardName9 = card.cardName) === null || _card$cardName9 === void 0 ? void 0 : (_card$cardName9$toStr = _card$cardName9.toString()) === null || _card$cardName9$toStr === void 0 ? void 0 : _card$cardName9$toStr.toLowerCase()) === 'previous insurance details';
        })), {}, {
          flag: expanded
        })]);
      },
      grid_data: [{
        text: /*#__PURE__*/React.createElement(ReviewPreviousInsuranceForm, {
          prevInsuranceDetails: prevInsuranceDetails
        }),
        colSpan: repeat
      }]
    } : null, proposalNumber && portabilityDetails && portabilityDetails.length > 0 ? {
      title: /*#__PURE__*/React.createElement(Text, {
        type: "large"
      }, "Underwriting Assessment"),
      grid_type: 'data',
      expanded: renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$13 = renderExpandedCards.current) === null || _renderExpandedCards$13 === void 0 ? void 0 : (_renderExpandedCards$14 = _renderExpandedCards$13.find(function (card) {
        var _card$cardName10, _card$cardName10$toSt;

        return (card === null || card === void 0 ? void 0 : (_card$cardName10 = card.cardName) === null || _card$cardName10 === void 0 ? void 0 : (_card$cardName10$toSt = _card$cardName10.toString()) === null || _card$cardName10$toSt === void 0 ? void 0 : _card$cardName10$toSt.toLowerCase()) === 'underwriting assessment';
      })) === null || _renderExpandedCards$14 === void 0 ? void 0 : _renderExpandedCards$14.flag,
      isToggleEnabled: true,
      setExpandedCards: function setExpandedCards(expanded) {
        var _renderExpandedCards$15, _renderExpandedCards$16;

        renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$15 = renderExpandedCards.current) === null || _renderExpandedCards$15 === void 0 ? void 0 : _renderExpandedCards$15.filter(function (card) {
          var _card$cardName11, _card$cardName11$toSt;

          return (card === null || card === void 0 ? void 0 : (_card$cardName11 = card.cardName) === null || _card$cardName11 === void 0 ? void 0 : (_card$cardName11$toSt = _card$cardName11.toString()) === null || _card$cardName11$toSt === void 0 ? void 0 : _card$cardName11$toSt.toLowerCase()) !== 'underwriting assessment';
        })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$16 = renderExpandedCards.current) === null || _renderExpandedCards$16 === void 0 ? void 0 : _renderExpandedCards$16.find(function (card) {
          var _card$cardName12, _card$cardName12$toSt;

          return (card === null || card === void 0 ? void 0 : (_card$cardName12 = card.cardName) === null || _card$cardName12 === void 0 ? void 0 : (_card$cardName12$toSt = _card$cardName12.toString()) === null || _card$cardName12$toSt === void 0 ? void 0 : _card$cardName12$toSt.toLowerCase()) === 'underwriting assessment';
        })), {}, {
          flag: expanded
        })]);
      },
      grid_data: [{
        text: /*#__PURE__*/React.createElement(ReviewPortablityDetailsForm, {
          portabilityDetails: portabilityDetails
        }),
        colSpan: repeat
      }]
    } : null, productCode.toString() !== '2885' ? {
      title: /*#__PURE__*/React.createElement(Text, {
        type: "large"
      }, "Renewal Mandate Details"),
      grid_type: 'data',
      expanded: renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$17 = renderExpandedCards.current) === null || _renderExpandedCards$17 === void 0 ? void 0 : (_renderExpandedCards$18 = _renderExpandedCards$17.find(function (card) {
        var _card$cardName13, _card$cardName13$toSt;

        return (card === null || card === void 0 ? void 0 : (_card$cardName13 = card.cardName) === null || _card$cardName13 === void 0 ? void 0 : (_card$cardName13$toSt = _card$cardName13.toString()) === null || _card$cardName13$toSt === void 0 ? void 0 : _card$cardName13$toSt.toLowerCase()) === 'renewal mandate details';
      })) === null || _renderExpandedCards$18 === void 0 ? void 0 : _renderExpandedCards$18.flag,
      isToggleEnabled: true,
      setExpandedCards: function setExpandedCards(expanded) {
        var _renderExpandedCards$19, _renderExpandedCards$20;

        renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$19 = renderExpandedCards.current) === null || _renderExpandedCards$19 === void 0 ? void 0 : _renderExpandedCards$19.filter(function (card) {
          var _card$cardName14, _card$cardName14$toSt;

          return (card === null || card === void 0 ? void 0 : (_card$cardName14 = card.cardName) === null || _card$cardName14 === void 0 ? void 0 : (_card$cardName14$toSt = _card$cardName14.toString()) === null || _card$cardName14$toSt === void 0 ? void 0 : _card$cardName14$toSt.toLowerCase()) !== 'renewal mandate details';
        })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$20 = renderExpandedCards.current) === null || _renderExpandedCards$20 === void 0 ? void 0 : _renderExpandedCards$20.find(function (card) {
          var _card$cardName15, _card$cardName15$toSt;

          return (card === null || card === void 0 ? void 0 : (_card$cardName15 = card.cardName) === null || _card$cardName15 === void 0 ? void 0 : (_card$cardName15$toSt = _card$cardName15.toString()) === null || _card$cardName15$toSt === void 0 ? void 0 : _card$cardName15$toSt.toLowerCase()) === 'renewal mandate details';
        })), {}, {
          flag: expanded
        })]);
      },
      grid_data: [{
        text: /*#__PURE__*/React.createElement(RenewMandate, {
          renewalMandateDetails: renewalMandateDetails
        }),
        colSpan: repeat
      }]
    } : null].filter(function (d) {
      return d;
    });
    var other_props = {
      flow: 'cols',
      textType: 'normal',
      repeat: repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaForm, {
      className: "space-y-2"
    }, /*#__PURE__*/React.createElement(TitlePart, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ProposerCustomerReadOnly, {
      reactiveVarData: buyHealthPolicy,
      goToStep: goToStep,
      renderExpandedCards: renderExpandedCards
    })), /*#__PURE__*/React.createElement(MixedGridGroup, _objectSpread2({
      data: data
    }, other_props)), documentsPreloaded && (documentsPreloaded === null || documentsPreloaded === void 0 ? void 0 : documentsPreloaded.length) > 0 //&& documentsPreloaded[0]?.documentBase64String
    //&& documentsPreloaded[0]?.documentBase64String?.length > 0
    &&
    /*#__PURE__*/
    React.createElement(MixedGridGroup, _objectSpread2(_objectSpread2({
      data: uploadDocsData
    }, otherPropsForCards), {}, {
      globalTitle: 'Uploaded Documents',
      expanded: renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$21 = renderExpandedCards.current) === null || _renderExpandedCards$21 === void 0 ? void 0 : (_renderExpandedCards$22 = _renderExpandedCards$21.find(function (card) {
        var _card$cardName16, _card$cardName16$toSt;

        return (card === null || card === void 0 ? void 0 : (_card$cardName16 = card.cardName) === null || _card$cardName16 === void 0 ? void 0 : (_card$cardName16$toSt = _card$cardName16.toString()) === null || _card$cardName16$toSt === void 0 ? void 0 : _card$cardName16$toSt.toLowerCase()) === 'uploaded document';
      })) === null || _renderExpandedCards$22 === void 0 ? void 0 : _renderExpandedCards$22.flag,
      isToggleEnabled: true,
      setExpandedCards: function setExpandedCards(expanded) {
        var _renderExpandedCards$23, _renderExpandedCards$24;

        renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$23 = renderExpandedCards.current) === null || _renderExpandedCards$23 === void 0 ? void 0 : _renderExpandedCards$23.filter(function (card) {
          var _card$cardName17, _card$cardName17$toSt;

          return (card === null || card === void 0 ? void 0 : (_card$cardName17 = card.cardName) === null || _card$cardName17 === void 0 ? void 0 : (_card$cardName17$toSt = _card$cardName17.toString()) === null || _card$cardName17$toSt === void 0 ? void 0 : _card$cardName17$toSt.toLowerCase()) !== 'uploaded document';
        })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$24 = renderExpandedCards.current) === null || _renderExpandedCards$24 === void 0 ? void 0 : _renderExpandedCards$24.find(function (card) {
          var _card$cardName18, _card$cardName18$toSt;

          return (card === null || card === void 0 ? void 0 : (_card$cardName18 = card.cardName) === null || _card$cardName18 === void 0 ? void 0 : (_card$cardName18$toSt = _card$cardName18.toString()) === null || _card$cardName18$toSt === void 0 ? void 0 : _card$cardName18$toSt.toLowerCase()) === 'uploaded document';
        })), {}, {
          flag: expanded
        })]);
      }
    })), /*#__PURE__*/React.createElement(HealthDeclarationForm, null), /*#__PURE__*/React.createElement(Button, {
      type: "button",
      disabled: (isHealthDeclarationSelected === null || isHealthDeclarationSelected === void 0 ? void 0 : isHealthDeclarationSelected.toLowerCase()) === 'no',
      flat: true,
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faFileMedical,
        className: (isHealthDeclarationSelected === null || isHealthDeclarationSelected === void 0 ? void 0 : isHealthDeclarationSelected.toLowerCase()) === 'no' ? 'mr-1' : 'ml-2 mr-1'
      }),
      onClick: function onClick(_) {
        return setMedicalQuestionaireDisplay(true);
      }
    }, ' ', "Medical Questionaire")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalMedicalQuestionaire, {
      productCode: productCode,
      medicalQuestionaireDisplay: medicalQuestionaireDisplay,
      setMedicalQuestionaireDisplay: setMedicalQuestionaireDisplay,
      questions: productQuestionList,
      readOnlyMode: true
    })));
  };

  if (loading || dropDownLoadingCustomer || loadingCustTypeDomain || dateTimeLoading || loadingPaymentType || loadingQuestions || loadingRollOverCompanyList || loadingProposerDetail || renewDropDownLoadingCustomer || dropDownLoadingOrganisation || loadingDocumentExtensions || loadingProfile) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  if (error || errorCustTypeDomain || errorTimeLoading || errorPaymentType || errorQuestions || errorRollOverCompanyList || errorProposerDetail || dropDownErrorOrganisation || renewDropDownErrorCustomer || errorDocumentExtensions) {
    return /*#__PURE__*/React.createElement(Error, {
      error: error || errorCustTypeDomain || errorTimeLoading || errorPaymentType || errorQuestions || errorRollOverCompanyList || errorProposerDetail || dropDownErrorOrganisation || renewDropDownErrorCustomer || errorDocumentExtensions
    });
  }

  var productQuestionList = dataQuestions.productQuestionList;
  var buyHealthPolicy = data.buyHealthPolicy;
  var rolloverCompanyList = dataRollOverCompanyList.rolloverCompanyList;
  buyHealthPolicy.proposerDetails;
      buyHealthPolicy.proposerDetailsMeta;
      var insuredDetails = buyHealthPolicy.insuredDetails,
      nomineeDetails = buyHealthPolicy.nomineeDetails,
      prevInsuranceDetails = buyHealthPolicy.prevInsuranceDetails,
      renewalMandateDetails = buyHealthPolicy.renewalMandateDetails,
      portabilityDetails = buyHealthPolicy.portabilityDetails,
      isHealthDeclarationSelected = buyHealthPolicy.isHealthDeclarationSelected,
      quotationType = buyHealthPolicy.quotationType,
      documentDetails = buyHealthPolicy.documentDetails;
  dropDownDetails.idProofTypeList;
      var maritalStatusList = dropDownDetails.maritalStatusList;
      dropDownDetails.nationalityList;
      var genderList = dropDownDetails.genderList;
      dropDownDetails.salutationList;
  var relationshipwithproposer = datarelationshipwithproposer.relationshipwithproposer;
  renewMandateDropDownDetails.typeOfDebit;
      renewMandateDropDownDetails.PRD_TermForMandate;
      renewMandateDropDownDetails.destinationBankAccountType;
      var PRD_RenewalPaymentMandateTakenInTheNameOf = renewMandateDropDownDetails.PRD_RenewalPaymentMandateTakenInTheNameOf;
  var PRD_PreExistDiseaseWaitPeriod = dataProposerDetail.PRD_PreExistDiseaseWaitPeriod,
      PRD_OccupationList = dataProposerDetail.PRD_OccupationList;
      dataProposerDetail.PRD_CumulativeBonus;
      var PRD_NomiRelationWithMemb = dataProposerDetail.PRD_NomiRelationWithMemb,
      PRD_ApointRelationWithMinNomi = dataProposerDetail.PRD_ApointRelationWithMinNomi;
  dataCustTypeDomain.customerTypeList;
  var initialValues = {
    proposalPaymentType: buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.proposalPaymentType ? buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalPaymentType : dataPaymentType === null || dataPaymentType === void 0 ? void 0 : (_dataPaymentType$Prop2 = dataPaymentType.ProposalPaymentTypeList[0]) === null || _dataPaymentType$Prop2 === void 0 ? void 0 : _dataPaymentType$Prop2.code,
    leadGenerator: buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.leadGenerator ? buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.leadGenerator : ''
  };
  dropDownDetailsOrganisation.organisationList;
  var obj = {
    dataProfileData: dataProfileData
  };
  var value = Object.values(obj);
  var mapUserId = value === null || value === void 0 ? void 0 : (_value$ = value[0]) === null || _value$ === void 0 ? void 0 : (_value$$userMyDetail = _value$.userMyDetail) === null || _value$$userMyDetail === void 0 ? void 0 : _value$$userMyDetail.userId;
  var documentsPreloaded = documentDetails && (documentDetails === null || documentDetails === void 0 ? void 0 : documentDetails.length) > 0 ? documentDetails : null; //null ;//data?.getDocumentsForCustomer;

  var saveProposalVariables = function saveProposalVariables(buyHealthPolicyData, getDateTimeData, values) {
    var _buyHealthPolicyData$2, _buyHealthPolicyData$3, _buyHealthPolicyData$4, _buyHealthPolicyData$5, _buyHealthPolicyData$6, _buyHealthPolicyData$7, _buyHealthPolicyData$8, _buyHealthPolicyData$9, _buyHealthPolicyData$10, _buyHealthPolicyData$11, _buyHealthPolicyData$12, _buyHealthPolicyData$13, _buyHealthPolicyData$14, _buyHealthPolicyData$15, _buyHealthPolicyData$16, _buyHealthPolicyData$17, _buyHealthPolicy$poli5, _getDateTimeData$date, _buyHealthPolicyData$18, _buyHealthPolicyData$19, _buyHealthPolicyData$20, _buyHealthPolicyData$21, _buyHealthPolicyData$22, _buyHealthPolicy$quot3, _buyHealthPolicy$quot4, _buyHealthPolicyData$23, _buyHealthPolicyData$24, _buyHealthPolicyData$25, _buyHealthPolicyData$26, _buyHealthPolicyData$27, _buyHealthPolicyData$28, _buyHealthPolicyData$29, _buyHealthPolicyData$30, _buyHealthPolicyData$31, _buyHealthPolicyData$32, _buyHealthPolicyData$33, _buyHealthPolicyData$34, _buyHealthPolicyData$35, _buyHealthPolicyData$36;

    var getInsuredDetailsObj = function getInsuredDetailsObj(insuredDetails, nomineeDetails, prevInsuranceDetails, medicalQuestionaire, planData, isHealthDeclarationSelected) {
      var insuredDetailsResponseArr = [];
      insuredDetails.forEach(function (insured) {
        var _prevInsuranceInput$p, _medicalQuestionaireO, _medicalQuestionaireO2, _plans$find2, _plans$find2$packs;

        insured.ppcTestLevel;
            insured.memberID;
            insured.memberStatus;
            var restInsured = _objectWithoutProperties(insured, _excluded2$2);

        var insuredObj = _objectSpread2({}, restInsured);

        var nomineeObj = nomineeDetails === null || nomineeDetails === void 0 ? void 0 : nomineeDetails.find(function (nominee) {
          var _nominee$relationship, _insured$relationship;

          return (nominee === null || nominee === void 0 ? void 0 : (_nominee$relationship = nominee.relationship) === null || _nominee$relationship === void 0 ? void 0 : _nominee$relationship.toLowerCase()) === (insured === null || insured === void 0 ? void 0 : (_insured$relationship = insured.relationship) === null || _insured$relationship === void 0 ? void 0 : _insured$relationship.toLowerCase());
        });

        var relationship = nomineeObj.relationship,
            restNomineeObj = _objectWithoutProperties(nomineeObj, _excluded3$2);

        insuredObj.nomineeDetails = _objectSpread2(_objectSpread2({}, restNomineeObj), {}, {
          insuredRelationship: relationship
        });
        var prevInsuranceInput = prevInsuranceDetails === null || prevInsuranceDetails === void 0 ? void 0 : prevInsuranceDetails.find(function (prevInsured) {
          var _prevInsured$insuredR, _insured$relationship2;

          return (prevInsured === null || prevInsured === void 0 ? void 0 : (_prevInsured$insuredR = prevInsured.insuredRelationship) === null || _prevInsured$insuredR === void 0 ? void 0 : _prevInsured$insuredR.toLowerCase()) === (insured === null || insured === void 0 ? void 0 : (_insured$relationship2 = insured.relationship) === null || _insured$relationship2 === void 0 ? void 0 : _insured$relationship2.toLowerCase());
        });
        insuredObj.prevInsuranceInput = {
          prevInsurerName: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevInsurerName,
          prevPolicyNo: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicyNo,
          prevPolicySI: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicySI,
          prevClaimLodged: (prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : (_prevInsuranceInput$p = prevInsuranceInput.prevClaimLodged) === null || _prevInsuranceInput$p === void 0 ? void 0 : _prevInsuranceInput$p.toLowerCase()) === 'yes' ? true : false,
          claimAmount: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.claimAmount,
          prevPolicyStartDate: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicyStartDate,
          prevPolicyEndDate: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicyEndDate,
          cbAmount: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.cbAmount
        };
        var medicalQuestionaireObj = isHealthDeclarationSelected ? medicalQuestionaire === null || medicalQuestionaire === void 0 ? void 0 : medicalQuestionaire.find(function (m) {
          var _m$relationship, _insured$relationship3;

          return (m === null || m === void 0 ? void 0 : (_m$relationship = m.relationship) === null || _m$relationship === void 0 ? void 0 : _m$relationship.toLowerCase()) === (insured === null || insured === void 0 ? void 0 : (_insured$relationship3 = insured.relationship) === null || _insured$relationship3 === void 0 ? void 0 : _insured$relationship3.toLowerCase());
        }) : {
          relationship: insured === null || insured === void 0 ? void 0 : insured.relationship,
          questions: []
        };

        if (medicalQuestionaireObj && ((_medicalQuestionaireO = medicalQuestionaireObj) === null || _medicalQuestionaireO === void 0 ? void 0 : (_medicalQuestionaireO2 = _medicalQuestionaireO.questions) === null || _medicalQuestionaireO2 === void 0 ? void 0 : _medicalQuestionaireO2.length) > 0) {
          var _medicalQuestionaireO3, _medicalQuestionaireO4, _medicalQuestionaireO5, _medicalQuestionaireO6, _medicalQuestionaireO7, _medicalQuestionaireO8, _medicalQuestionaireO9, _medicalQuestionaireO10;

          medicalQuestionaireObj = _objectSpread2(_objectSpread2({}, medicalQuestionaireObj), {}, {
            questions: (_medicalQuestionaireO3 = medicalQuestionaireObj) === null || _medicalQuestionaireO3 === void 0 ? void 0 : (_medicalQuestionaireO4 = _medicalQuestionaireO3.questions) === null || _medicalQuestionaireO4 === void 0 ? void 0 : _medicalQuestionaireO4.map(function (question) {
              var _question$answer;

              return {
                srNo: question === null || question === void 0 ? void 0 : question.srNo,
                answer: question === null || question === void 0 ? void 0 : (_question$answer = question.answer) === null || _question$answer === void 0 ? void 0 : _question$answer.answerText
              };
            })
          });
          medicalQuestionaireObj = _objectSpread2(_objectSpread2({}, medicalQuestionaireObj), {}, {
            questions: ((_medicalQuestionaireO5 = medicalQuestionaireObj) === null || _medicalQuestionaireO5 === void 0 ? void 0 : (_medicalQuestionaireO6 = _medicalQuestionaireO5.questions) === null || _medicalQuestionaireO6 === void 0 ? void 0 : (_medicalQuestionaireO7 = _medicalQuestionaireO6.find(function (q) {
              var _q$srNo;

              return (q === null || q === void 0 ? void 0 : (_q$srNo = q.srNo) === null || _q$srNo === void 0 ? void 0 : _q$srNo.toLowerCase()) === 'master';
            })) === null || _medicalQuestionaireO7 === void 0 ? void 0 : (_medicalQuestionaireO8 = _medicalQuestionaireO7.answer) === null || _medicalQuestionaireO8 === void 0 ? void 0 : _medicalQuestionaireO8.toLowerCase()) !== 'ye' ? (_medicalQuestionaireO9 = medicalQuestionaireObj) === null || _medicalQuestionaireO9 === void 0 ? void 0 : (_medicalQuestionaireO10 = _medicalQuestionaireO9.questions) === null || _medicalQuestionaireO10 === void 0 ? void 0 : _medicalQuestionaireO10.filter(function (q) {
              var _q$srNo2;

              return (q === null || q === void 0 ? void 0 : (_q$srNo2 = q.srNo) === null || _q$srNo2 === void 0 ? void 0 : _q$srNo2.toLowerCase()) !== '';
            }) : []
          });
        }

        insuredObj.medicalQuestionaire = medicalQuestionaireObj ? medicalQuestionaireObj : {
          relationship: insured === null || insured === void 0 ? void 0 : insured.relationship,
          questions: []
        };
        var plans = planData.plans;
        insuredObj.addOnCovers = plans === null || plans === void 0 ? void 0 : (_plans$find2 = plans.find(function (p) {
          var _p$name;

          return (p === null || p === void 0 ? void 0 : (_p$name = p.name) === null || _p$name === void 0 ? void 0 : _p$name.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
        })) === null || _plans$find2 === void 0 ? void 0 : (_plans$find2$packs = _plans$find2.packs) === null || _plans$find2$packs === void 0 ? void 0 : _plans$find2$packs.filter(function (pack) {
          var _pack$index;

          return pack === null || pack === void 0 ? void 0 : (_pack$index = pack.index) === null || _pack$index === void 0 ? void 0 : _pack$index.includes(insured === null || insured === void 0 ? void 0 : insured.relationship);
        }).flatMap(function (pack) {
          return pack.addOnCovers.filter(function (addOnCover) {
            return addOnCover.selected;
          });
        });

        if (!insuredObj.addOnCovers) {
          insuredObj.addOnCovers = [];
        }

        insuredDetailsResponseArr.push(insuredObj);
      });
      return insuredDetailsResponseArr;
    };

    var _buyHealthPolicyData$ = buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.proposerDetailsMeta;
        _buyHealthPolicyData$.isNewCustomer;
        var isCRNVerified = _buyHealthPolicyData$.isCRNVerified,
        restProposerMetaData = _objectWithoutProperties(_buyHealthPolicyData$, _excluded4$1);

    return {
      input: {
        proposerDetails: _objectSpread2(_objectSpread2(_objectSpread2({}, restProposerMetaData), buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.proposerDetails), {}, {
          isThinCustomer: false,
          isCRNVerified: isCRNVerified === null ? false : isCRNVerified === "" ? false : isCRNVerified
        }),
        insuredDetails: getInsuredDetailsObj(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.insuredDetails, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.nomineeDetails, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.prevInsuranceDetails, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.medicalQuestionaire, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.planData, (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$2 = buyHealthPolicyData.isHealthDeclarationSelected) === null || _buyHealthPolicyData$2 === void 0 ? void 0 : _buyHealthPolicyData$2.toLowerCase()) === 'yes' || (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$3 = buyHealthPolicyData.isHealthDeclarationSelected) === null || _buyHealthPolicyData$3 === void 0 ? void 0 : _buyHealthPolicyData$3.toLowerCase()) === 'no'),
        plan: {
          name: planName,
          code: planCode,
          premium: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$4 = buyHealthPolicyData.planData) === null || _buyHealthPolicyData$4 === void 0 ? void 0 : (_buyHealthPolicyData$5 = _buyHealthPolicyData$4.plans) === null || _buyHealthPolicyData$5 === void 0 ? void 0 : (_buyHealthPolicyData$6 = _buyHealthPolicyData$5.find(function (plan) {
            var _plan$name;

            return (plan === null || plan === void 0 ? void 0 : (_plan$name = plan.name) === null || _plan$name === void 0 ? void 0 : _plan$name.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          })) === null || _buyHealthPolicyData$6 === void 0 ? void 0 : _buyHealthPolicyData$6.premium
        },
        intermediary: {
          intermediaryCode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$7 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$7 === void 0 ? void 0 : _buyHealthPolicyData$7.code,
          locationCode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$8 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$8 === void 0 ? void 0 : _buyHealthPolicyData$8.location,
          fieldUserCode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$9 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$9 === void 0 ? void 0 : _buyHealthPolicyData$9.fieldUserCode,
          fieldUserName: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$10 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$10 === void 0 ? void 0 : _buyHealthPolicyData$10.fieldUserName,
          fieldUserLocation: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$11 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$11 === void 0 ? void 0 : _buyHealthPolicyData$11.fieldUserLocation
        },
        zone: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$12 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$12 === void 0 ? void 0 : (_buyHealthPolicyData$13 = _buyHealthPolicyData$12.location) === null || _buyHealthPolicyData$13 === void 0 ? void 0 : (_buyHealthPolicyData$14 = _buyHealthPolicyData$13.zone) === null || _buyHealthPolicyData$14 === void 0 ? void 0 : _buyHealthPolicyData$14.trim(),
        quotationType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.quotationType,
        UserId: mapUserId ? mapUserId : '',
        sumInsured: parseFloat(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$15 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$15 === void 0 ? void 0 : (_buyHealthPolicyData$16 = _buyHealthPolicyData$15.cover) === null || _buyHealthPolicyData$16 === void 0 ? void 0 : _buyHealthPolicyData$16.sum_insured),
        startDate: (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$17 = buyHealthPolicyData.quotationType) === null || _buyHealthPolicyData$17 === void 0 ? void 0 : _buyHealthPolicyData$17.toLowerCase()) === 'roll over' ? buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$poli5 = buyHealthPolicy.policy) === null || _buyHealthPolicy$poli5 === void 0 ? void 0 : _buyHealthPolicy$poli5.startDate : getDateTimeData === null || getDateTimeData === void 0 ? void 0 : (_getDateTimeData$date = getDateTimeData.datetimeValue) === null || _getDateTimeData$date === void 0 ? void 0 : _getDateTimeData$date.date,
        startTime: '00:00',
        coverType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$18 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$18 === void 0 ? void 0 : (_buyHealthPolicyData$19 = _buyHealthPolicyData$18.cover) === null || _buyHealthPolicyData$19 === void 0 ? void 0 : _buyHealthPolicyData$19.type,
        tenure: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$20 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$20 === void 0 ? void 0 : (_buyHealthPolicyData$21 = _buyHealthPolicyData$20.cover) === null || _buyHealthPolicyData$21 === void 0 ? void 0 : _buyHealthPolicyData$21.tenure,
        proposalPaymentType: values === null || values === void 0 ? void 0 : values.proposalPaymentType,
        leadGenerator: values === null || values === void 0 ? void 0 : values.leadGenerator,

        /*SA CR P2_169A*/
        isHealthDeclarationSelected: (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$22 = buyHealthPolicyData.isHealthDeclarationSelected) === null || _buyHealthPolicyData$22 === void 0 ? void 0 : _buyHealthPolicyData$22.toLowerCase()) === 'yes',
        // || buyHealthPolicyData?.isHealthDeclarationSelected?.toLowerCase() ==='no',
        quoteNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.quoteNumber,
        productCode: productCode,
        existingPolicyNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.existingPolicyNumber,
        isExistingEmployee: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$quot3 = buyHealthPolicy.quoteData) === null || _buyHealthPolicy$quot3 === void 0 ? void 0 : (_buyHealthPolicy$quot4 = _buyHealthPolicy$quot3.isExistingEmployee) === null || _buyHealthPolicy$quot4 === void 0 ? void 0 : _buyHealthPolicy$quot4.toLowerCase()) === 'yes' ? true : false,
        employeeNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$23 = buyHealthPolicyData.proposerDetails) === null || _buyHealthPolicyData$23 === void 0 ? void 0 : _buyHealthPolicyData$23.employeeNumber,
        proposerPincode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$24 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$24 === void 0 ? void 0 : (_buyHealthPolicyData$25 = _buyHealthPolicyData$24.location) === null || _buyHealthPolicyData$25 === void 0 ? void 0 : _buyHealthPolicyData$25.pincode,

        /* Renew mandate */
        renewalMandateDetails: {
          renewalPaymentMandate: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$26 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$26 === void 0 ? void 0 : _buyHealthPolicyData$26.renewalPaymentMandate,
          renewalPaymentMandateTakenInNameOf: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$27 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$27 === void 0 ? void 0 : _buyHealthPolicyData$27.renewalPaymentMandateTakenInNameOf,
          termForMandateOpted: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$28 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$28 === void 0 ? void 0 : _buyHealthPolicyData$28.termForMandateOpted,
          typeOfDebit: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$29 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$29 === void 0 ? void 0 : _buyHealthPolicyData$29.typeOfDebit,
          accountNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$30 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$30 === void 0 ? void 0 : _buyHealthPolicyData$30.accountNumber,
          destinationBankName: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$31 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$31 === void 0 ? void 0 : _buyHealthPolicyData$31.destinationBankName,
          destinationIfscCode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$32 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$32 === void 0 ? void 0 : _buyHealthPolicyData$32.destinationIfscCode,
          destinationMicrCode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$33 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$33 === void 0 ? void 0 : _buyHealthPolicyData$33.destinationMicrCode,
          destinationBranchName: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$34 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$34 === void 0 ? void 0 : _buyHealthPolicyData$34.destinationBranchName,
          mandateAmount: parseFloat(rev_manamount // buyHealthPolicyData?.renewalMandateDetails?.mandateAmount,
          ),
          finalCollectionDate: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$35 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$35 === void 0 ? void 0 : _buyHealthPolicyData$35.finalCollectionDate,
          destinationBankAccountType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$36 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$36 === void 0 ? void 0 : _buyHealthPolicyData$36.destinationBankAccountType
        }
      }
    };
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
      var _buyHealthPolicy$inte, _dataImdCongig$checkC, _data$saveProposal, _data$saveProposal7, _data$saveProposal8, _data$saveProposal9, _buyHealthPolicy$poli6, _buyHealthPolicy$poli7, _getDateTimeData$date2, _data$saveProposal10, _getDateTimeData$date3, getDateTime, _yield$getDateTime, getDateTimeData, ImdConfigQuery, _yield$ImdConfigQuery, dataImdCongig, variables, doSaveProposal, _yield$doSaveProposal, _data, _data$saveProposal2, _data$saveProposal3, _data$saveProposal4, _data$saveProposal5, _data$saveProposal6, _documentsPreloaded$, _documentsPreloaded$2, _documentsPreloaded$3, _data$saveProposal11, _data$saveProposal12, _uploadDocdata$upload, _uploadDocdata$upload2, _uploadDocdata$upload3, _documentsPreloaded$m, _data$saveProposal13, _data$saveProposal14, _documentsPreloaded$m2, uploadDocument, _yield$uploadDocument, uploadDocdata, _uploadDocdata$upload4, _uploadDocdata$upload5, insertDocListQuery, _error$message;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(prem_feature === 1)) {
                _context.next = 7;
                break;
              }

              setParentAlerts([{
                header: 'Error',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, "PanCard Number is Mandatory for premium amount greater than 50000"),
                type: 'error',
                timeout: null,
                disableClose: false
              }]);
              setLoadingStep(false);
              goToStep(0);
              return _context.abrupt("return", false);

            case 7:
              if (buyHealthPolicy.proposalNumber) {
                _context.next = 82;
                break;
              }

              _context.prev = 8;
              setParentAlerts([]);
              getDateTime = fetchQuery({
                query: GET_DATE_TIME
              });
              _context.next = 13;
              return getDateTime;

            case 13:
              _yield$getDateTime = _context.sent;
              getDateTimeData = _yield$getDateTime.data;

              /*SA Divya  CR P2_169A  : Check IMD Config*/
              ImdConfigQuery = fetchQuery({
                query: CHECK_IMD_CONFIG,
                fetchPolicy: 'cache-first',
                variables: {
                  intermediaryCode: buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$inte = buyHealthPolicy.intermediaryDetails) === null || _buyHealthPolicy$inte === void 0 ? void 0 : _buyHealthPolicy$inte.code
                }
              });
              setLoadingStep(true);
              _context.next = 19;
              return ImdConfigQuery;

            case 19:
              _yield$ImdConfigQuery = _context.sent;
              dataImdCongig = _yield$ImdConfigQuery.data;
              setLoadingStep(false);

              if (!(dataImdCongig !== null && dataImdCongig !== void 0 && (_dataImdCongig$checkC = dataImdCongig.checkConfigImd) !== null && _dataImdCongig$checkC !== void 0 && _dataImdCongig$checkC.isConfiguredIMD && !(values !== null && values !== void 0 && values.leadGenerator))) {
                _context.next = 25;
                break;
              }

              setParentAlerts([{
                header: 'Unable to Proceed',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, "Lead generator is Mandatory. \n                  Please enter the Lead generator before Proceeding"),
                type: 'warning',
                timeout: null,
                disableClose: false
              }]);
              return _context.abrupt("return", false);

            case 25:
              /*EA Divya CR P2_169A  : Check IMD Config*/

              variables = saveProposalVariables(buyHealthPolicy, getDateTimeData, values);
              doSaveProposal = mutateQuery({
                mutation: SAVE_PROPOSAL,
                variables: variables
              });
              setCustomLoadingMessage('Saving Proposal');
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
              setLoadingStep(true);
              _context.next = 33;
              return doSaveProposal;

            case 33:
              _yield$doSaveProposal = _context.sent;
              _data = _yield$doSaveProposal.data;
              setLoadingStep(false);

              if (_data !== null && _data !== void 0 && (_data$saveProposal = _data.saveProposal) !== null && _data$saveProposal !== void 0 && _data$saveProposal.warningMsg) {
                setParentAlerts([].concat(_toConsumableArray(alerts), [{
                  header: 'Proposal Saved Successfully',
                  content: /*#__PURE__*/React.createElement("div", {
                    className: "flex flex-col w-full h-full"
                  }, /*#__PURE__*/React.createElement(Text, {
                    type: "normal"
                  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
                    icon: faCheck,
                    className: "text-success"
                  }), ' ', "Proposal Number:", ' ', _data === null || _data === void 0 ? void 0 : (_data$saveProposal2 = _data.saveProposal) === null || _data$saveProposal2 === void 0 ? void 0 : _data$saveProposal2.proposalNumber)),
                  type: 'success',
                  timeout: null,
                  disableClose: false
                }, {
                  content: /*#__PURE__*/React.createElement(Text, {
                    type: "normal"
                  }, _data === null || _data === void 0 ? void 0 : (_data$saveProposal3 = _data.saveProposal) === null || _data$saveProposal3 === void 0 ? void 0 : _data$saveProposal3.warningMsg),
                  type: 'warning',
                  timeout: null,
                  disableClose: false
                }]));
              } else {
                if ((_data === null || _data === void 0 ? void 0 : (_data$saveProposal4 = _data.saveProposal) === null || _data$saveProposal4 === void 0 ? void 0 : _data$saveProposal4.isApplicableForPayment) === false && ((productCode === null || productCode === void 0 ? void 0 : productCode.toString()) === '2883' || (productCode === null || productCode === void 0 ? void 0 : productCode.toString()) === '2880' || (productCode === null || productCode === void 0 ? void 0 : productCode.toString()) === '2877' || (productCode === null || productCode === void 0 ? void 0 : productCode.toString()) === '2885')) {
                  setParentAlerts([].concat(_toConsumableArray(alerts), [{
                    header: 'Medical/Underwriting Approval',
                    id: Date.now(),
                    content: /*#__PURE__*/React.createElement("div", {
                      className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                    }, /*#__PURE__*/React.createElement("span", null, 'Your case needs Medical/Underwriting approval. Until then, only the Digital Link is available for payment (includes - ASBA Payment)')),
                    type: 'warning',
                    timeout: 100000000,
                    disableClose: true
                  }, {
                    header: 'Proposal Saved Successfully',
                    content: /*#__PURE__*/React.createElement("div", {
                      className: "flex flex-col w-full h-full"
                    }, /*#__PURE__*/React.createElement(Text, {
                      type: "normal"
                    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
                      icon: faCheck,
                      className: "text-success"
                    }), ' ', "Proposal Number:", ' ', _data === null || _data === void 0 ? void 0 : (_data$saveProposal5 = _data.saveProposal) === null || _data$saveProposal5 === void 0 ? void 0 : _data$saveProposal5.proposalNumber)),
                    type: 'success',
                    timeout: null,
                    disableClose: false
                  }]));
                } else {
                  setParentAlerts([].concat(_toConsumableArray(alerts), [{
                    header: 'Proposal Saved Successfully',
                    content: /*#__PURE__*/React.createElement("div", {
                      className: "flex flex-col w-full h-full"
                    }, /*#__PURE__*/React.createElement(Text, {
                      type: "normal"
                    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
                      icon: faCheck,
                      className: "text-success"
                    }), ' ', "Proposal Number:", ' ', _data === null || _data === void 0 ? void 0 : (_data$saveProposal6 = _data.saveProposal) === null || _data$saveProposal6 === void 0 ? void 0 : _data$saveProposal6.proposalNumber)),
                    type: 'success',
                    timeout: null,
                    disableClose: false
                  }]));
                }
              }

              updateBuyHealthPolicy({
                proposalNumber: _data.saveProposal.proposalNumber,
                proposalStatus: _data.saveProposal.proposalStatus,
                proposalPaymentType: values.proposalPaymentType,
                leadGenerator: values.leadGenerator,
                isProposalApplicableForPayment: (_data === null || _data === void 0 ? void 0 : (_data$saveProposal7 = _data.saveProposal) === null || _data$saveProposal7 === void 0 ? void 0 : _data$saveProposal7.isApplicableForPayment) === null || (_data === null || _data === void 0 ? void 0 : (_data$saveProposal8 = _data.saveProposal) === null || _data$saveProposal8 === void 0 ? void 0 : _data$saveProposal8.isApplicableForPayment) === undefined || _data !== null && _data !== void 0 && (_data$saveProposal9 = _data.saveProposal) !== null && _data$saveProposal9 !== void 0 && _data$saveProposal9.isApplicableForPayment ? true : false,
                policy: {
                  startDate: buyHealthPolicy !== null && buyHealthPolicy !== void 0 && (_buyHealthPolicy$poli6 = buyHealthPolicy.policy) !== null && _buyHealthPolicy$poli6 !== void 0 && _buyHealthPolicy$poli6.startDate ? buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$poli7 = buyHealthPolicy.policy) === null || _buyHealthPolicy$poli7 === void 0 ? void 0 : _buyHealthPolicy$poli7.startDate : getDateTimeData === null || getDateTimeData === void 0 ? void 0 : (_getDateTimeData$date2 = getDateTimeData.datetimeValue) === null || _getDateTimeData$date2 === void 0 ? void 0 : _getDateTimeData$date2.date,
                  endDate: _data === null || _data === void 0 ? void 0 : (_data$saveProposal10 = _data.saveProposal) === null || _data$saveProposal10 === void 0 ? void 0 : _data$saveProposal10.proposalEndDate,
                  time: getDateTimeData === null || getDateTimeData === void 0 ? void 0 : (_getDateTimeData$date3 = getDateTimeData.datetimeValue) === null || _getDateTimeData$date3 === void 0 ? void 0 : _getDateTimeData$date3.time
                },
                proposerDetails: {
                  id: _data.saveProposal.customerID
                }
              });
              updatePlanPremium(planName, _data.saveProposal.premium);

              if (!(_data.saveProposal.proposalNumber && (productCode === null || productCode === void 0 ? void 0 : productCode.toString()) === '2883')) {
                _context.next = 69;
                break;
              }

              _context.prev = 40;

              if (!(documentsPreloaded && (documentsPreloaded === null || documentsPreloaded === void 0 ? void 0 : documentsPreloaded.length) > 0 && (_documentsPreloaded$ = documentsPreloaded[0]) !== null && _documentsPreloaded$ !== void 0 && _documentsPreloaded$.documentBase64String && ((_documentsPreloaded$2 = documentsPreloaded[0]) === null || _documentsPreloaded$2 === void 0 ? void 0 : (_documentsPreloaded$3 = _documentsPreloaded$2.documentBase64String) === null || _documentsPreloaded$3 === void 0 ? void 0 : _documentsPreloaded$3.length) > 0)) {
                _context.next = 60;
                break;
              }

              // console.log("2968 : inside if");
              // console.log("2969 .data.saveProposal. :",data.saveProposal);
              // console.log("2970. data.saveProposal.proposalNumber",data.saveProposal.proposalNumber);
              uploadDocument = mutateQuery({
                mutation: UPLOAD_DOCUMENT,
                variables: {
                  input: {
                    uploadDocumentFor: {
                      proposalNumber: _data.saveProposal.proposalNumber ? _data.saveProposal.proposalNumber : "",
                      customerID: (_data$saveProposal11 = _data.saveProposal) !== null && _data$saveProposal11 !== void 0 && _data$saveProposal11.customerID ? (_data$saveProposal12 = _data.saveProposal) === null || _data$saveProposal12 === void 0 ? void 0 : _data$saveProposal12.customerID : ''
                    },
                    documents: documentsPreloaded === null || documentsPreloaded === void 0 ? void 0 : documentsPreloaded.map(function (document) {
                      return {
                        documentName: document === null || document === void 0 ? void 0 : document.documentName,
                        documentFileName: document === null || document === void 0 ? void 0 : document.documentFileName,
                        documentExtension: document === null || document === void 0 ? void 0 : document.documentExtension,
                        documentSize: document === null || document === void 0 ? void 0 : document.documentSize,
                        documentBase64String: document === null || document === void 0 ? void 0 : document.documentBase64String,
                        documentDescription: document === null || document === void 0 ? void 0 : document.documentDescription
                      };
                    })
                  }
                }
              }); // uploadDocuments({ });

              setCustomLoadingMessage('Uploading Documents');
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
              setLoadingStep(true);
              _context.next = 48;
              return uploadDocument;

            case 48:
              _yield$uploadDocument = _context.sent;
              uploadDocdata = _yield$uploadDocument.data;
              setLoadingStep(false); //console.log("30004 : uploadDocdata :",uploadDocdata?.uploadDocuments);

              if (uploadDocdata !== null && uploadDocdata !== void 0 && (_uploadDocdata$upload = uploadDocdata.uploadDocuments) !== null && _uploadDocdata$upload !== void 0 && _uploadDocdata$upload.failedDocDtls && (uploadDocdata === null || uploadDocdata === void 0 ? void 0 : (_uploadDocdata$upload2 = uploadDocdata.uploadDocuments) === null || _uploadDocdata$upload2 === void 0 ? void 0 : (_uploadDocdata$upload3 = _uploadDocdata$upload2.failedDocDtls) === null || _uploadDocdata$upload3 === void 0 ? void 0 : _uploadDocdata$upload3.length) > 0) {
                uploadDocdata === null || uploadDocdata === void 0 ? void 0 : (_uploadDocdata$upload4 = uploadDocdata.uploadDocuments) === null || _uploadDocdata$upload4 === void 0 ? void 0 : (_uploadDocdata$upload5 = _uploadDocdata$upload4.failedDocDtls) === null || _uploadDocdata$upload5 === void 0 ? void 0 : _uploadDocdata$upload5.forEach(function (e) {
                  setParentAlerts([].concat(_toConsumableArray(alerts), [{
                    id: Date.now(),
                    header: 'Failed Upload Document Detials',
                    content: /*#__PURE__*/React.createElement("div", {
                      className: "flex flex-col w-full h-full"
                    }, /*#__PURE__*/React.createElement(Text, {
                      type: "normal"
                    }, "".concat(e === null || e === void 0 ? void 0 : e.documentFileName, " ~\n                                        ").concat(e === null || e === void 0 ? void 0 : e.ErrorMsg))),
                    type: 'warning',
                    timeout: null,
                    disableClose: false
                  }]));
                });
              }

              updateBuyHealthPolicy({
                documentDetails: documentsPreloaded === null || documentsPreloaded === void 0 ? void 0 : (_documentsPreloaded$m = documentsPreloaded.map(function (doc) {
                  var _uploadDocdata$upload6;

                  if (uploadDocdata !== null && uploadDocdata !== void 0 && (_uploadDocdata$upload6 = uploadDocdata.uploadDocuments) !== null && _uploadDocdata$upload6 !== void 0 && _uploadDocdata$upload6.documentDetails.find(function (e) {
                    var _e$documentFileName, _doc$documentFileName;

                    return (e === null || e === void 0 ? void 0 : (_e$documentFileName = e.documentFileName) === null || _e$documentFileName === void 0 ? void 0 : _e$documentFileName.toLowerCase()) === (doc === null || doc === void 0 ? void 0 : (_doc$documentFileName = doc.documentFileName) === null || _doc$documentFileName === void 0 ? void 0 : _doc$documentFileName.toLowerCase());
                  })) {
                    var _uploadDocdata$upload7, _uploadDocdata$upload8, _uploadDocdata$upload9, _uploadDocdata$upload10;

                    return {
                      documentID: uploadDocdata !== null && uploadDocdata !== void 0 && (_uploadDocdata$upload7 = uploadDocdata.uploadDocuments) !== null && _uploadDocdata$upload7 !== void 0 && _uploadDocdata$upload7.documentDetails.find(function (e) {
                        var _e$documentFileName2, _doc$documentFileName2;

                        return (e === null || e === void 0 ? void 0 : (_e$documentFileName2 = e.documentFileName) === null || _e$documentFileName2 === void 0 ? void 0 : _e$documentFileName2.toLowerCase()) === (doc === null || doc === void 0 ? void 0 : (_doc$documentFileName2 = doc.documentFileName) === null || _doc$documentFileName2 === void 0 ? void 0 : _doc$documentFileName2.toLowerCase());
                      }) ? uploadDocdata === null || uploadDocdata === void 0 ? void 0 : (_uploadDocdata$upload8 = uploadDocdata.uploadDocuments) === null || _uploadDocdata$upload8 === void 0 ? void 0 : (_uploadDocdata$upload9 = _uploadDocdata$upload8.documentDetails) === null || _uploadDocdata$upload9 === void 0 ? void 0 : (_uploadDocdata$upload10 = _uploadDocdata$upload9.find(function (e) {
                        var _e$documentFileName3, _doc$documentFileName3;

                        return (e === null || e === void 0 ? void 0 : (_e$documentFileName3 = e.documentFileName) === null || _e$documentFileName3 === void 0 ? void 0 : _e$documentFileName3.toLowerCase()) === (doc === null || doc === void 0 ? void 0 : (_doc$documentFileName3 = doc.documentFileName) === null || _doc$documentFileName3 === void 0 ? void 0 : _doc$documentFileName3.toLowerCase());
                      })) === null || _uploadDocdata$upload10 === void 0 ? void 0 : _uploadDocdata$upload10.documentID : '',
                      documentDescription: doc === null || doc === void 0 ? void 0 : doc.documentDescription,
                      documentName: doc === null || doc === void 0 ? void 0 : doc.documentName,
                      documentFileName: doc === null || doc === void 0 ? void 0 : doc.documentFileName,
                      documentExtension: doc === null || doc === void 0 ? void 0 : doc.documentExtension,
                      documentSize: doc === null || doc === void 0 ? void 0 : doc.documentSize,
                      documentBase64String: doc === null || doc === void 0 ? void 0 : doc.documentBase64String
                    };
                  }
                })) === null || _documentsPreloaded$m === void 0 ? void 0 : _documentsPreloaded$m.filter(function (e) {
                  return e;
                })
              });
              insertDocListQuery = fetchQuery({
                query: INSERT_DOCUMENT_LIST,
                variables: {
                  input: {
                    proposalNumber: _data.saveProposal.proposalNumber ? _data.saveProposal.proposalNumber : "",
                    customerNumber: (_data$saveProposal13 = _data.saveProposal) !== null && _data$saveProposal13 !== void 0 && _data$saveProposal13.customerID ? (_data$saveProposal14 = _data.saveProposal) === null || _data$saveProposal14 === void 0 ? void 0 : _data$saveProposal14.customerID : '',
                    productCode: productCode,
                    documentList: documentsPreloaded === null || documentsPreloaded === void 0 ? void 0 : (_documentsPreloaded$m2 = documentsPreloaded.map(function (doc) {
                      var _uploadDocdata$upload11;

                      if (uploadDocdata !== null && uploadDocdata !== void 0 && (_uploadDocdata$upload11 = uploadDocdata.uploadDocuments) !== null && _uploadDocdata$upload11 !== void 0 && _uploadDocdata$upload11.documentDetails.find(function (e) {
                        var _e$documentFileName4, _doc$documentFileName4;

                        return (e === null || e === void 0 ? void 0 : (_e$documentFileName4 = e.documentFileName) === null || _e$documentFileName4 === void 0 ? void 0 : _e$documentFileName4.toLowerCase()) === (doc === null || doc === void 0 ? void 0 : (_doc$documentFileName4 = doc.documentFileName) === null || _doc$documentFileName4 === void 0 ? void 0 : _doc$documentFileName4.toLowerCase());
                      })) {
                        var _uploadDocdata$upload12, _uploadDocdata$upload13, _uploadDocdata$upload14, _uploadDocdata$upload15;

                        return {
                          documentID: uploadDocdata !== null && uploadDocdata !== void 0 && (_uploadDocdata$upload12 = uploadDocdata.uploadDocuments) !== null && _uploadDocdata$upload12 !== void 0 && _uploadDocdata$upload12.documentDetails.find(function (e) {
                            var _e$documentFileName5, _doc$documentFileName5;

                            return (e === null || e === void 0 ? void 0 : (_e$documentFileName5 = e.documentFileName) === null || _e$documentFileName5 === void 0 ? void 0 : _e$documentFileName5.toLowerCase()) === (doc === null || doc === void 0 ? void 0 : (_doc$documentFileName5 = doc.documentFileName) === null || _doc$documentFileName5 === void 0 ? void 0 : _doc$documentFileName5.toLowerCase());
                          }) ? uploadDocdata === null || uploadDocdata === void 0 ? void 0 : (_uploadDocdata$upload13 = uploadDocdata.uploadDocuments) === null || _uploadDocdata$upload13 === void 0 ? void 0 : (_uploadDocdata$upload14 = _uploadDocdata$upload13.documentDetails) === null || _uploadDocdata$upload14 === void 0 ? void 0 : (_uploadDocdata$upload15 = _uploadDocdata$upload14.find(function (e) {
                            var _e$documentFileName6, _doc$documentFileName6;

                            return (e === null || e === void 0 ? void 0 : (_e$documentFileName6 = e.documentFileName) === null || _e$documentFileName6 === void 0 ? void 0 : _e$documentFileName6.toLowerCase()) === (doc === null || doc === void 0 ? void 0 : (_doc$documentFileName6 = doc.documentFileName) === null || _doc$documentFileName6 === void 0 ? void 0 : _doc$documentFileName6.toLowerCase());
                          })) === null || _uploadDocdata$upload15 === void 0 ? void 0 : _uploadDocdata$upload15.documentID : '',
                          documentDescription: doc === null || doc === void 0 ? void 0 : doc.documentDescription,
                          documentName: doc === null || doc === void 0 ? void 0 : doc.documentName,
                          documentFileName: doc === null || doc === void 0 ? void 0 : doc.documentFileName,
                          documentExtension: doc === null || doc === void 0 ? void 0 : doc.documentExtension,
                          documentSize: doc === null || doc === void 0 ? void 0 : doc.documentSize
                        };
                      }
                    })) === null || _documentsPreloaded$m2 === void 0 ? void 0 : _documentsPreloaded$m2.filter(function (e) {
                      return e;
                    })
                  }
                }
              });
              setLoadingStep(true);
              _context.next = 57;
              return insertDocListQuery;

            case 57:
              setLoadingStep(false);

            case 60:
              _context.next = 69;
              break;

            case 62:
              _context.prev = 62;
              _context.t0 = _context["catch"](40);
              setLoadingStep(false);
              setCustomLoadingMessage(null);

              if (_context.t0 !== null && _context.t0 !== void 0 && _context.t0.message) {
                if ((_error$message = _context.t0.message) !== null && _error$message !== void 0 && _error$message.includes("Unexpected token")) {
                  _context.t0.message = 'Please try again after sometime';
                }
              }

              setParentAlerts([].concat(_toConsumableArray(alerts), [{
                id: Date.now(),
                header: 'Error in Upload Document',
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-col w-full h-full"
                }, /*#__PURE__*/React.createElement(Text, {
                  type: "normal"
                }, _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message)),
                type: 'error',
                timeout: null,
                disableClose: false
              }]));
              return _context.abrupt("return", false);

            case 69:
              setProceedToNextStep([].concat(_toConsumableArray(proceedToNextStep.slice(0, 3)), [true], _toConsumableArray(proceedToNextStep.slice(3))));
              return _context.abrupt("return", true);

            case 73:
              _context.prev = 73;
              _context.t1 = _context["catch"](8);
              updateBuyHealthPolicy({
                proposalPaymentType: values.proposalPaymentType,
                leadGenerator: values.leadGenerator
              }); //Unexpected Token

              if (_context.t1 !== null && _context.t1 !== void 0 && _context.t1.message) {
                if (_context.t1.message.includes("Unexpected token")) {
                  _context.t1.message = 'Please try again after sometime';
                }
              } //Unexpected Token


              setParentAlerts([_objectSpread2(_objectSpread2({}, alerts), {}, {
                header: 'Error',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, _context.t1.message),
                type: 'error',
                timeout: null,
                disableClose: false
              })]);
              setLoadingStep(false);
              return _context.abrupt("return", false);

            case 80:
              _context.next = 86;
              break;

            case 82:
              setParentAlerts([]);
              setProceedToNextStep([].concat(_toConsumableArray(proceedToNextStep.slice(0, 3)), [true], _toConsumableArray(proceedToNextStep.slice(4))));
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
              return _context.abrupt("return", true);

            case 86:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 73], [40, 62]]);
    }));

    return function onSubmit(_x) {
      return _ref11.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuantaFormik, {
    innerRef: props.forwardedRef,
    enableReinitialize: true,
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit,
    validator: function validator() {
      return {};
    }
  }, /*#__PURE__*/React.createElement(ReviewForm, {
    validate: validate
  })));
}

var _excluded$3 = ["proceedToNextStep", "setProceedToNextStep", "setParentAlerts", "setDisableProcced", "setLoadingStep", "setCustomLoadingMessage", "lobCode", "lobName", "productName", "productCode", "planName", "planCode", "proposalNumber", "renderExpandedCards"],
    _excluded2$1 = ["prevInsuranceDetails"],
    _excluded3$1 = ["prevInsuranceDetails"],
    _excluded4 = ["ppcTestLevel", "memberID", "memberStatus"],
    _excluded5 = ["relationship"],
    _excluded6 = ["isNewCustomer", "isCRNVerified"],
    _excluded7 = ["warningMsg"],
    _excluded8 = ["warningMsg"];
function NomineeDetails(_ref) {
  var _plans$find, _plans$find$premium, _buyHealthPolicy$prop14;

  var proceedToNextStep = _ref.proceedToNextStep,
      setProceedToNextStep = _ref.setProceedToNextStep,
      setParentAlerts = _ref.setParentAlerts,
      setDisableProcced = _ref.setDisableProcced,
      setLoadingStep = _ref.setLoadingStep,
      setCustomLoadingMessage = _ref.setCustomLoadingMessage;
      _ref.lobCode;
      _ref.lobName;
      _ref.productName;
      var productCode = _ref.productCode,
      planName = _ref.planName,
      planCode = _ref.planCode;
      _ref.proposalNumber;
      var renderExpandedCards = _ref.renderExpandedCards,
      props = _objectWithoutProperties(_ref, _excluded$3);

  var fetchQuery = useFetchQuery();
  var screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop'
  });
  var uploadDocRef = useRef([]);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      alerts = _useState2[0],
      setAlerts = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      medicalQuestionaireDisplay = _useState4[0],
      setMedicalQuestionaireDisplay = _useState4[1];

  var params = useParams();
  var plan_name = planName ? planName : params === null || params === void 0 ? void 0 : params.plan_name;
  planCode ? planCode : params === null || params === void 0 ? void 0 : params.plan_code;
  var repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3
  });
  var policy_Start_Date_min = '';

  var _useQuery = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first'
  }),
      loadingBuyPolicy = _useQuery.loading,
      errorBuyPolicy = _useQuery.error,
      dataBuyPolicy = _useQuery.data;

  if (dataBuyPolicy) {
    var prembuyHealthPolicy = dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : dataBuyPolicy.buyHealthPolicy;
    prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : prembuyHealthPolicy.quoteData;
    var premplanData = prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : prembuyHealthPolicy.planData;
    var plans = premplanData === null || premplanData === void 0 ? void 0 : premplanData.plans;
  }

  var Prem_data;
  Prem_data = plans === null || plans === void 0 ? void 0 : (_plans$find = plans.find(function (p) {
    return p.name === plan_name;
  })) === null || _plans$find === void 0 ? void 0 : (_plans$find$premium = _plans$find.premium) === null || _plans$find$premium === void 0 ? void 0 : _plans$find$premium.totalPremium; ////console.log('nominee details premium data',prembuyHealthPolicy.renewalMandateDetails.renewalPaymentMandate)

  var manamount;
  manamount = productCode.toString() !== '2885' ? 1.5 * Prem_data : ''; //console.log('manmount data----',manamount)

  var _useState5 = useState(manamount),
      _useState6 = _slicedToArray(_useState5, 2),
      renew_man_amount = _useState6[0],
      setrenew_man_amount = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2);
      _useState8[0];
      _useState8[1];

  var _useQuery2 = useQuery(PROPOSER_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode: productCode
    }
  }),
      loading = _useQuery2.loading,
      dropDownDetails = _useQuery2.data;

  var _useQuery3 = useQuery(ROLLOVER_COMPANY_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loadingRollOverCompanyList = _useQuery3.loading,
      errorRollOverCompanyList = _useQuery3.error,
      dataRollOverCompanyList = _useQuery3.data;

  var _useQuery4 = useQuery(RENEWAL_MANDATE_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode: productCode
    },
    onError: function onError(err) {
      setAlerts([{
        header: 'No dropdown details',
        id: 1,
        content: /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row flex-wrap space-y-2 w-full h-full"
        }, /*#__PURE__*/React.createElement("span", null, err.message)),
        type: 'error',
        timeout: null,
        disableClose: false
      }]);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }),
      loadingRenewalMandateData = _useQuery4.loading,
      renewalMandateData = _useQuery4.data;

  var _useQuery5 = useQuery(GET_BUSINESS_TYPE, {
    fetchPolicy: 'cache-first'
  }),
      loadingBusinessType = _useQuery5.loading,
      errorBusinessType = _useQuery5.error,
      dataBusinessType = _useQuery5.data;

  var _useQuery6 = useQuery(GET_MEDICAL_QUESTIONS, {
    variables: {
      input: {
        productCode: productCode
      }
    },
    fetchPolicy: 'cache-first'
  }),
      loadingQuestions = _useQuery6.loading,
      errorQuestions = _useQuery6.error,
      dataQuestions = _useQuery6.data;

  var _useQuery7 = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loadingNameLimit = _useQuery7.loading,
      errorNameLimit = _useQuery7.error,
      dataNameLimit = _useQuery7.data;

  var _useQuery8 = useQuery(DOCUMENT_STATIC_DATA, {
    fetchPolicy: 'cache-first'
  }),
      loadingDocumentExtensions = _useQuery8.loading,
      errorDocumentExtensions = _useQuery8.error,
      dataDocumentExtensions = _useQuery8.data;

  var _useQuery9 = useQuery(GET_DOCUMENTS_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loadingDocumentList = _useQuery9.loading,
      errorDocumentList = _useQuery9.error,
      dataDocumentList = _useQuery9.data;

  if (loadingBuyPolicy || loading || loadingQuestions || loadingRollOverCompanyList || loadingBusinessType || loadingRenewalMandateData || loadingNameLimit || loadingDocumentExtensions || loadingDocumentList) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Loading, {
      customMessage: 'Fetching nominee details'
    }));
  }

  if (errorBuyPolicy || errorQuestions || errorRollOverCompanyList || errorBusinessType || errorNameLimit || errorDocumentExtensions || errorDocumentList) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Error$1, {
      error: errorBuyPolicy || errorQuestions || errorRollOverCompanyList || errorBusinessType || errorNameLimit || errorDocumentList
    }));
  }

  var buyHealthPolicy = dataBuyPolicy.buyHealthPolicy;
  var businessTypeList = dataBusinessType.businessTypeList;
  var rolloverCompanyList = dataRollOverCompanyList.rolloverCompanyList;
  var nomineeDetails = buyHealthPolicy.nomineeDetails,
      prevInsuranceDetails = buyHealthPolicy.prevInsuranceDetails,
      renewalMandateDetails = buyHealthPolicy.renewalMandateDetails;
      buyHealthPolicy.documentDetails;
  var PRD_NomiRelationWithMemb = dropDownDetails.PRD_NomiRelationWithMemb,
      PRD_ApointRelationWithMinNomi = dropDownDetails.PRD_ApointRelationWithMinNomi;
  renewalMandateData.PRD_TermForMandate;
      var PRD_RenewalPaymentMandateTakenInTheNameOf = renewalMandateData.PRD_RenewalPaymentMandateTakenInTheNameOf;
      renewalMandateData.typeOfDebit;
      var destinationBankAccountType = renewalMandateData.destinationBankAccountType;
  var productQuestionList = dataQuestions.productQuestionList;
  var characterLimitList = dataNameLimit.characterLimitList;
  var documentExtensions = dataDocumentExtensions.documentExtensions,
      docFileSizeLimit = dataDocumentExtensions.docFileSizeLimit,
      docDescCharacterLimit = dataDocumentExtensions.docDescCharacterLimit;
  var documentList = dataDocumentList.documentList;
  var MINOR_THRESHOLD_AGE = 18;

  var getDomainData = function getDomainData(domainArr, searchText, searchType, returnType) {
    return domainArr.find(function (d) {
      return d["".concat(searchType)] === searchText;
    }) ? domainArr.find(function (d) {
      return d["".concat(searchType)] === searchText;
    })["".concat(returnType)] : '';
  };

  var getInitObject = function getInitObject() {
    var _destinationBankAccou, _buyHealthPolicy$docu;

    var initObj = {};
    nomineeDetails.forEach(function (nominee) {
      var prevInsured = prevInsuranceDetails === null || prevInsuranceDetails === void 0 ? void 0 : prevInsuranceDetails.find(function (prevInsured) {
        var _prevInsured$insuredR, _nominee$relationship;

        return (prevInsured === null || prevInsured === void 0 ? void 0 : (_prevInsured$insuredR = prevInsured.insuredRelationship) === null || _prevInsured$insuredR === void 0 ? void 0 : _prevInsured$insuredR.toLowerCase()) === (nominee === null || nominee === void 0 ? void 0 : (_nominee$relationship = nominee.relationship) === null || _nominee$relationship === void 0 ? void 0 : _nominee$relationship.toLowerCase());
      });
      initObj[nominee.relationship] = {
        name: nominee.name ? nominee.name : '',
        dob: nominee.dob ? nominee.dob : '',
        relationshipWithInsured: nominee.relationshipWithInsured ? nominee.relationshipWithInsured : '',
        relationshipWithAppointee: nominee.relationshipWithAppointee ? nominee.relationshipWithAppointee : '',
        nameOfAppointee: nominee.nameOfAppointee ? nominee.nameOfAppointee : '',
        prevInsuranceDetails: {
          prevInsurerName: (prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevInsurerName) !== undefined ? prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevInsurerName : '',
          prevPolicyNo: (prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevPolicyNo) !== undefined ? prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevPolicyNo : '',
          prevPolicyStartDate: (prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevPolicyStartDate) !== undefined ? prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevPolicyStartDate : '',
          prevPolicyEndDate: (prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevPolicyEndDate) !== undefined ? prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevPolicyEndDate : '',
          prevPolicySI: (prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevPolicySI) !== undefined ? prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevPolicySI : '',
          prevClaimLodged: (prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevClaimLodged) !== undefined ? prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.prevClaimLodged : '',
          claimAmount: (prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.claimAmount) !== undefined ? prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.claimAmount : '',
          cbAmount: (prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.cbAmount) !== undefined ? prevInsured === null || prevInsured === void 0 ? void 0 : prevInsured.cbAmount : '',
          insuredRelationship: nominee !== null && nominee !== void 0 && nominee.relationship ? nominee === null || nominee === void 0 ? void 0 : nominee.relationship : ''
        }
      };
    });
    initObj.sameNomineeForAllInsured = buyHealthPolicy.sameNomineeForAllInsured;
    initObj.isHealthDeclarationSelected = buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.isHealthDeclarationSelected ? buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.isHealthDeclarationSelected : 'No';
    initObj.renewalPaymentMandate = false, // renewalMandateDetails?.renewalPaymentMandate === false
    //   ? renewalMandateDetails?.renewalPaymentMandate
    //  : buyHealthPolicy?.quoteData?.cover?.tenure?.toLowerCase() =="1 year" ||buyHealthPolicy?.quoteData?.cover?.tenure?.toString() =="1"
    //  ? true
    // //  : buyHealthPolicy?.quoteData?.cover?.tenure?.toString() =="1"
    // //  ? true
    //   :false;
    initObj.renewalPaymentMandateTakenInNameOf = renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.renewalPaymentMandateTakenInNameOf ? renewalMandateDetails === null || renewalMandateDetails === void 0 ? void 0 : renewalMandateDetails.renewalPaymentMandateTakenInNameOf : PRD_RenewalPaymentMandateTakenInTheNameOf.length > 0 ? PRD_RenewalPaymentMandateTakenInTheNameOf[0].code : '';
    initObj.termForMandateOpted = renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.termForMandateOpted ? renewalMandateDetails === null || renewalMandateDetails === void 0 ? void 0 : renewalMandateDetails.termForMandateOpted : '';
    initObj.typeOfDebit = renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.typeOfDebit ? renewalMandateDetails === null || renewalMandateDetails === void 0 ? void 0 : renewalMandateDetails.typeOfDebit : '';
    initObj.accountNumber = renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.accountNumber ? renewalMandateDetails === null || renewalMandateDetails === void 0 ? void 0 : renewalMandateDetails.accountNumber : '';
    initObj.destinationBankName = renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.destinationBankName ? renewalMandateDetails === null || renewalMandateDetails === void 0 ? void 0 : renewalMandateDetails.destinationBankName : '';
    initObj.destinationIfscCode = renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.destinationIfscCode ? renewalMandateDetails === null || renewalMandateDetails === void 0 ? void 0 : renewalMandateDetails.destinationIfscCode : '';
    initObj.destinationMicrCode = renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.destinationMicrCode ? renewalMandateDetails === null || renewalMandateDetails === void 0 ? void 0 : renewalMandateDetails.destinationMicrCode : '';
    initObj.destinationBranchName = renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.destinationBranchName ? renewalMandateDetails === null || renewalMandateDetails === void 0 ? void 0 : renewalMandateDetails.destinationBranchName : '';
    initObj.mandateAmount = renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.mandateAmount ? renewalMandateDetails === null || renewalMandateDetails === void 0 ? void 0 : renewalMandateDetails.mandateAmount : '';
    initObj.finalCollectionDate = renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.finalCollectionDate ? renewalMandateDetails === null || renewalMandateDetails === void 0 ? void 0 : renewalMandateDetails.finalCollectionDate : '';
    initObj.destinationBankAccountType = renewalMandateDetails !== null && renewalMandateDetails !== void 0 && renewalMandateDetails.destinationBankAccountType ? renewalMandateDetails === null || renewalMandateDetails === void 0 ? void 0 : renewalMandateDetails.destinationBankAccountType : destinationBankAccountType ? (_destinationBankAccou = destinationBankAccountType[0]) === null || _destinationBankAccou === void 0 ? void 0 : _destinationBankAccou.code : '';
    initObj.documentDetails = buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.documentDetails && (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$docu = buyHealthPolicy.documentDetails) === null || _buyHealthPolicy$docu === void 0 ? void 0 : _buyHealthPolicy$docu.length) > 0 ? buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.documentDetails : [{
      documentDescription: '',
      documentName: '',
      documentNameValue: '',
      documentFileName: '',
      documentExtension: '',
      documentSize: null,
      dragging: false,
      dragCounter: 0,
      documentBase64String: ''
    }];
    return initObj;
  };

  var initialValues = getInitObject();

  var validate = function validate(values) {
    var _values$documentDetai;

    var errors = {};
    var dcount = 0;
    var pcount = 0;
    var error_count = 0;
    errors.documentDetails = values === null || values === void 0 ? void 0 : (_values$documentDetai = values.documentDetails) === null || _values$documentDetai === void 0 ? void 0 : _values$documentDetai.map(function (_) {
      return {};
    });
    var firstNameValue = characterLimitList === null || characterLimitList === void 0 ? void 0 : characterLimitList.find(function (characterLimit) {
      return characterLimit.code.toLowerCase() === 'first name';
    });
    nomineeDetails.forEach(function (nominee) {
      errors["".concat(nominee.relationship)] = {};
      errors["".concat(nominee.relationship)].prevInsuranceDetails = {};

      if (!values["".concat(nominee.relationship)].name) {
        errors["".concat(nominee.relationship)].name = '* Required';
      } else if (!values["".concat(nominee.relationship)].name.match(/^[a-zA-Z ]*$/)) {
        errors["".concat(nominee.relationship)].name = '* Name can be alphabets only';
      } else if (values["".concat(nominee.relationship)].name.length > firstNameValue.value) {
        errors["".concat(nominee.relationship)].name = "* Name cannot be greater than ".concat(firstNameValue.value, " characters");
      }

      if (!values["".concat(nominee.relationship)].dob) {
        errors["".concat(nominee.relationship)].dob = '* Required';
      }

      if (values["".concat(nominee.relationship)].dob) {
        if (moment(values["".concat(nominee.relationship)].dob, 'DD/MM/YYYY').isAfter()) {
          errors["".concat(nominee.relationship)].dob = '* Date of Birth cannot be a future date';
        }
      }

      if (!values["".concat(nominee.relationship)].relationshipWithInsured) {
        errors["".concat(nominee.relationship)].relationshipWithInsured = '* Required';
      }

      if (values["".concat(nominee.relationship)].dob && moment(new Date(), 'DD/MM/YYYY').diff(moment(values["".concat(nominee.relationship)].dob, 'DD/MM/YYYY'), 'years') < MINOR_THRESHOLD_AGE) {
        if (!values["".concat(nominee.relationship)].nameOfAppointee) {
          errors["".concat(nominee.relationship)].nameOfAppointee = '* Required';
        } else if (!values["".concat(nominee.relationship)].nameOfAppointee.match(/^[a-zA-Z ]*$/)) {
          errors["".concat(nominee.relationship)].nameOfAppointee = '* Name can be alphabets only';
        } else if (values["".concat(nominee.relationship)].nameOfAppointee.length > firstNameValue.value) {
          errors["".concat(nominee.relationship)].nameOfAppointee = "* Name cannot be greater than ".concat(firstNameValue.value, " characters");
        }

        if (!values["".concat(nominee.relationship)].relationshipWithAppointee) {
          errors["".concat(nominee.relationship)].relationshipWithAppointee = '* Required';
        }
      }

      if (values["".concat(nominee.relationship)].prevInsuranceDetails.prevInsurerName !== '') {
        dcount = dcount + 1;
      }

      pcount = pcount + 1;
      /**Validations for previous insurance details */
    }); //console.log('dcount data',dcount)

    if ((buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quotationType.toLowerCase()) !== 'new business') {
      if (dcount === 0) {
        ////console.log('inside dcount data if',dcount)
        nomineeDetails.forEach(function (nominee) {
          errors["".concat(nominee.relationship)].prevInsuranceDetails = {};
          errors["".concat(nominee.relationship)].prevInsuranceDetails.prevInsurerName = '* For Roll Over atleast 1 Previous insurance details is Required';
        });
      }
    }

    nomineeDetails.forEach(function (nominee) {
      if (dcount >= 1) {
        errors["".concat(nominee.relationship)].prevInsuranceDetails = {};

        if (values["".concat(nominee.relationship)].prevInsuranceDetails.prevInsurerName !== '') {
          var _getDomainData, _values$$prevInsuranc3, _values$$prevInsuranc4, _values$$prevInsuranc5, _values$$prevInsuranc6, _values$$prevInsuranc7, _values$$prevInsuranc8, _values$$prevInsuranc9;

          if (((_getDomainData = getDomainData(businessTypeList, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quotationType, 'code', 'value')) === null || _getDomainData === void 0 ? void 0 : _getDomainData.toLowerCase()) !== 'new business' || Object.keys(values["".concat(nominee.relationship)].prevInsuranceDetails).find(function (k) {
            return (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'prevclaimlodged' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'insuredrelationship' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'cbpct' && values["".concat(nominee.relationship)].prevInsuranceDetails[k];
          })) {
            var _values$, _values$$prevInsuranc, _values$2, _values$2$prevInsuran, _values$2$prevInsuran2, _values$3, _values$3$prevInsuran, _values$4, _values$4$prevInsuran, _moment, _values$5, _values$5$prevInsuran, _values$6, _values$6$prevInsuran, _values$7, _values$7$prevInsuran, _values$8, _values$8$prevInsuran, _values$9, _values$9$prevInsuran, _moment2, _values$10, _values$10$prevInsura, _values$11, _values$11$prevInsura, _values$$prevInsuranc2;

            if (!values["".concat(nominee.relationship)].prevInsuranceDetails.prevInsurerName) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevInsurerName = '* Required';
            }

            if (values["".concat(nominee.relationship)].prevInsuranceDetails.prevInsurerName && !getDomainData(rolloverCompanyList, values["".concat(nominee.relationship)].prevInsuranceDetails.prevInsurerName, 'code', 'value')) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevInsurerName = '* Invalid Insurer';
            }

            if (!values["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicyNo) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicyNo = '* Required';
            }

            if ((_values$ = values["".concat(nominee === null || nominee === void 0 ? void 0 : nominee.relationship)]) !== null && _values$ !== void 0 && (_values$$prevInsuranc = _values$.prevInsuranceDetails) !== null && _values$$prevInsuranc !== void 0 && _values$$prevInsuranc.prevPolicyNo && !((_values$2 = values["".concat(nominee === null || nominee === void 0 ? void 0 : nominee.relationship)]) !== null && _values$2 !== void 0 && (_values$2$prevInsuran = _values$2.prevInsuranceDetails) !== null && _values$2$prevInsuran !== void 0 && (_values$2$prevInsuran2 = _values$2$prevInsuran.prevPolicyNo) !== null && _values$2$prevInsuran2 !== void 0 && _values$2$prevInsuran2.match(/^[a-zA-Z0-9]+$/))) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicyNo = '* Policy Number can be alphanumeric only';
            }

            if (!values["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicyStartDate) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicyStartDate = '* Required';
            }

            if (moment((_values$3 = values["".concat(nominee.relationship)]) === null || _values$3 === void 0 ? void 0 : (_values$3$prevInsuran = _values$3.prevInsuranceDetails) === null || _values$3$prevInsuran === void 0 ? void 0 : _values$3$prevInsuran.prevPolicyStartDate, 'DD/MM/YYYY').isAfter()) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicyStartDate = '* Cannot accept future date';
            } else if ((_values$4 = values["".concat(nominee.relationship)]) !== null && _values$4 !== void 0 && (_values$4$prevInsuran = _values$4.prevInsuranceDetails) !== null && _values$4$prevInsuran !== void 0 && _values$4$prevInsuran.prevPolicyEndDate && (_moment = moment((_values$5 = values["".concat(nominee.relationship)]) === null || _values$5 === void 0 ? void 0 : (_values$5$prevInsuran = _values$5.prevInsuranceDetails) === null || _values$5$prevInsuran === void 0 ? void 0 : _values$5$prevInsuran.prevPolicyStartDate, 'DD/MM/YYYY')) !== null && _moment !== void 0 && _moment.isAfter(moment((_values$6 = values["".concat(nominee.relationship)]) === null || _values$6 === void 0 ? void 0 : (_values$6$prevInsuran = _values$6.prevInsuranceDetails) === null || _values$6$prevInsuran === void 0 ? void 0 : _values$6$prevInsuran.prevPolicyEndDate, 'DD/MM/YYYY'))) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicyStartDate = '* Policy Start date cannot be greater than the Expiry date';
            }

            var days = new Date();
            days.setDate(days.getDate() + 44); // console.log("days",days)

            if (moment((_values$7 = values["".concat(nominee.relationship)]) === null || _values$7 === void 0 ? void 0 : (_values$7$prevInsuran = _values$7.prevInsuranceDetails) === null || _values$7$prevInsuran === void 0 ? void 0 : _values$7$prevInsuran.prevPolicyEndDate, 'DD/MM/YYYY') > days // .isAfter()
            // >days
            ) {
                errors["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicyEndDate = '* Policy Expiry date cannot be more than 45days from current date';
              }

            if (moment((_values$8 = values["".concat(nominee.relationship)]) === null || _values$8 === void 0 ? void 0 : (_values$8$prevInsuran = _values$8.prevInsuranceDetails) === null || _values$8$prevInsuran === void 0 ? void 0 : _values$8$prevInsuran.prevPolicyEndDate, 'DD/MM/YYYY').isBefore(moment(), 'dates')) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicyEndDate = '* Previous insurance policy end date cannot be less than current date';
            }

            if (!values["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicyEndDate) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicyEndDate = '* Required';
            } else if ((_values$9 = values["".concat(nominee.relationship)]) !== null && _values$9 !== void 0 && (_values$9$prevInsuran = _values$9.prevInsuranceDetails) !== null && _values$9$prevInsuran !== void 0 && _values$9$prevInsuran.prevPolicyStartDate && (_moment2 = moment((_values$10 = values["".concat(nominee.relationship)]) === null || _values$10 === void 0 ? void 0 : (_values$10$prevInsura = _values$10.prevInsuranceDetails) === null || _values$10$prevInsura === void 0 ? void 0 : _values$10$prevInsura.prevPolicyEndDate, 'DD/MM/YYYY')) !== null && _moment2 !== void 0 && _moment2.isBefore(moment((_values$11 = values["".concat(nominee.relationship)]) === null || _values$11 === void 0 ? void 0 : (_values$11$prevInsura = _values$11.prevInsuranceDetails) === null || _values$11$prevInsura === void 0 ? void 0 : _values$11$prevInsura.prevPolicyStartDate, 'DD/MM/YYYY'))) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicyEndDate = '* Policy Expiry date cannot be less than the Start date';
            }

            if (!values["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicySI) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicySI = '* Required';
            }

            if ((_values$$prevInsuranc2 = values["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicySI) !== null && _values$$prevInsuranc2 !== void 0 && _values$$prevInsuranc2.toString().startsWith('0')) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevPolicySI = '* Sum Insured cannot be equal to or start with 0';
            }

            if (!values["".concat(nominee.relationship)].prevInsuranceDetails.prevClaimLodged) {
              errors["".concat(nominee.relationship)].prevInsuranceDetails.prevClaimLodged = '* Required';
            }
          }

          if (((_values$$prevInsuranc3 = values["".concat(nominee.relationship)].prevInsuranceDetails.prevClaimLodged) === null || _values$$prevInsuranc3 === void 0 ? void 0 : _values$$prevInsuranc3.toLowerCase()) === 'yes' && !values["".concat(nominee.relationship)].prevInsuranceDetails.claimAmount) {
            errors["".concat(nominee.relationship)].prevInsuranceDetails.claimAmount = '* Required';
          }

          if (((_values$$prevInsuranc4 = values["".concat(nominee.relationship)].prevInsuranceDetails.prevClaimLodged) === null || _values$$prevInsuranc4 === void 0 ? void 0 : _values$$prevInsuranc4.toLowerCase()) === 'yes' && (_values$$prevInsuranc5 = values["".concat(nominee.relationship)].prevInsuranceDetails.claimAmount) !== null && _values$$prevInsuranc5 !== void 0 && (_values$$prevInsuranc6 = _values$$prevInsuranc5.toString()) !== null && _values$$prevInsuranc6 !== void 0 && _values$$prevInsuranc6.startsWith('0')) {
            errors["".concat(nominee.relationship)].prevInsuranceDetails.claimAmount = '* Claim Amount cannot be equal to or start with 0';
          } // if (
          //   values[
          //     `${nominee.relationship}`
          //   ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
          //     'yes' &&
          //   !values[`${nominee.relationship}`].prevInsuranceDetails
          //     .cbAmount
          // ) {
          //   errors[
          //     `${nominee.relationship}`
          //   ].prevInsuranceDetails.cbAmount = '* Required';
          // }


          if (((_values$$prevInsuranc7 = values["".concat(nominee.relationship)].prevInsuranceDetails.prevClaimLodged) === null || _values$$prevInsuranc7 === void 0 ? void 0 : _values$$prevInsuranc7.toLowerCase()) === 'yes' && (_values$$prevInsuranc8 = values["".concat(nominee.relationship)].prevInsuranceDetails.cbAmount) !== null && _values$$prevInsuranc8 !== void 0 && (_values$$prevInsuranc9 = _values$$prevInsuranc8.toString()) !== null && _values$$prevInsuranc9 !== void 0 && _values$$prevInsuranc9.startsWith('0')) {
            errors["".concat(nominee.relationship)].prevInsuranceDetails.cbAmount = '* Cumulative Bonus Amt cannot be equal to or start with 0';
          }
        }
      }
    });

    if (buyHealthPolicy.quotationType.toString() === 'Roll Over') {
      for (var i = 0; i <= pcount - 1; i++) {
        if (buyHealthPolicy.insuredDetails[i].isPortabilityRequired.toString() === 'true') {
          var _values$buyHealthPoli, _values$buyHealthPoli2, _values$buyHealthPoli3, _values$buyHealthPoli4, _values$buyHealthPoli5;

          //console.log('i port value--',buyHealthPolicy.insuredDetails[i].isPortabilityRequired.toString())
          if (values[buyHealthPolicy.insuredDetails[i].relationship].prevInsuranceDetails.prevInsurerName === '') {
            errors[buyHealthPolicy.insuredDetails[i].relationship].prevInsuranceDetails.prevInsurerName = '* portablity checked against this member kindly fill his/her previous insurance details';
          }

          if (!values[buyHealthPolicy.insuredDetails[i].relationship].prevInsuranceDetails.prevPolicyNo) {
            errors[buyHealthPolicy.insuredDetails[i].relationship].prevInsuranceDetails.prevPolicyNo = '* Required';
          }

          if ((_values$buyHealthPoli = values[buyHealthPolicy.insuredDetails[i].relationship]) !== null && _values$buyHealthPoli !== void 0 && (_values$buyHealthPoli2 = _values$buyHealthPoli.prevInsuranceDetails) !== null && _values$buyHealthPoli2 !== void 0 && _values$buyHealthPoli2.prevPolicyNo && !((_values$buyHealthPoli3 = values[buyHealthPolicy.insuredDetails[i].relationship]) !== null && _values$buyHealthPoli3 !== void 0 && (_values$buyHealthPoli4 = _values$buyHealthPoli3.prevInsuranceDetails) !== null && _values$buyHealthPoli4 !== void 0 && (_values$buyHealthPoli5 = _values$buyHealthPoli4.prevPolicyNo) !== null && _values$buyHealthPoli5 !== void 0 && _values$buyHealthPoli5.match(/^[a-zA-Z0-9]+$/))) {
            errors[buyHealthPolicy.insuredDetails[i].relationship].prevInsuranceDetails.prevPolicyNo = '* Policy Number can be alphanumeric only';
          }
        }
      }
    } // let error_count = 0;


    nomineeDetails.forEach(function (nominee) {
      if (errors["".concat(nominee.relationship)].prevInsuranceDetails) {
        var _errors$ = errors["".concat(nominee.relationship)],
            _prevInsuranceDetails = _errors$.prevInsuranceDetails,
            errorsObj = _objectWithoutProperties(_errors$, _excluded2$1);

        error_count += Object.keys(errorsObj).length + Object.keys(_prevInsuranceDetails).length;
      } else {
        error_count += Object.keys(errors["".concat(nominee.relationship)]).length;
      }
    });

    if (productCode.toString() === '2883') {
      for (var _i = 0; _i < (values === null || values === void 0 ? void 0 : (_values$documentDetai2 = values.documentDetails) === null || _values$documentDetai2 === void 0 ? void 0 : _values$documentDetai2.length); _i++) {
        var _values$documentDetai2, _values$documentDetai3, _values$documentDetai4, _values$documentDetai5, _values$documentDetai6, _values$documentDetai7, _values$documentDetai8, _values$documentDetai9, _values$documentDetai10, _values$documentDetai11, _values$documentDetai12, _values$documentDetai13, _values$documentDetai14;

        if (!(values !== null && values !== void 0 && (_values$documentDetai3 = values.documentDetails[_i]) !== null && _values$documentDetai3 !== void 0 && _values$documentDetai3.documentName) && buyHealthPolicy.quotationType.toString() === 'Roll Over') {
          errors.documentDetails[_i].documentName = '* Required';
          error_count += 1;
        }

        if ((values === null || values === void 0 ? void 0 : (_values$documentDetai4 = values.documentDetails[_i]) === null || _values$documentDetai4 === void 0 ? void 0 : (_values$documentDetai5 = _values$documentDetai4.documentNameValue) === null || _values$documentDetai5 === void 0 ? void 0 : (_values$documentDetai6 = _values$documentDetai5.toString()) === null || _values$documentDetai6 === void 0 ? void 0 : (_values$documentDetai7 = _values$documentDetai6.toLowerCase()) === null || _values$documentDetai7 === void 0 ? void 0 : _values$documentDetai7.trim()) === 'others' && !(values !== null && values !== void 0 && (_values$documentDetai8 = values.documentDetails[_i]) !== null && _values$documentDetai8 !== void 0 && _values$documentDetai8.documentDescription)) {
          errors.documentDetails[_i].documentDescription = '* Required';
          error_count += 1;
        }

        if (values !== null && values !== void 0 && (_values$documentDetai9 = values.documentDetails[_i]) !== null && _values$documentDetai9 !== void 0 && _values$documentDetai9.documentDescription && !(values !== null && values !== void 0 && (_values$documentDetai10 = values.documentDetails[_i]) !== null && _values$documentDetai10 !== void 0 && (_values$documentDetai11 = _values$documentDetai10.documentDescription) !== null && _values$documentDetai11 !== void 0 && _values$documentDetai11.match(/^[a-zA-Z ]*$/))) {
          errors.documentDetails[_i].documentDescription = "* Can only contain alphabets";
          error_count += 1;
        }

        if (values !== null && values !== void 0 && (_values$documentDetai12 = values.documentDetails[_i]) !== null && _values$documentDetai12 !== void 0 && _values$documentDetai12.documentDescription && (values === null || values === void 0 ? void 0 : (_values$documentDetai13 = values.documentDetails[_i]) === null || _values$documentDetai13 === void 0 ? void 0 : (_values$documentDetai14 = _values$documentDetai13.documentDescription) === null || _values$documentDetai14 === void 0 ? void 0 : _values$documentDetai14.length) > parseInt(docDescCharacterLimit === null || docDescCharacterLimit === void 0 ? void 0 : docDescCharacterLimit.code)) {
          errors.documentDetails[_i].documentDescription = "* Can be of maximum ".concat(docDescCharacterLimit === null || docDescCharacterLimit === void 0 ? void 0 : docDescCharacterLimit.value, " characters");
          error_count += 1;
        }
      }
    }

    if (error_count === 0) {
      errors = {};
    }
    /* Validations for Renew Mandate */

    /*if (values.renewalPaymentMandate === true) {
      if (!values.termForMandateOpted) {
        errors.termForMandateOpted = '* Required';
      }
      if (!values.typeOfDebit) {
        errors.typeOfDebit = '* Required';
      }
      if (!values.accountNumber) {
        errors.accountNumber = '* Required';
      }
      if (
        getDomainData(
          typeOfDebit,
          values.typeOfDebit,
          'code',
          'value',
        )?.toLowerCase() === 'nach'
      ) {
        if (!values.destinationIfscCode) {
          errors.destinationIfscCode = '* Required';
        }
        if (
          values?.destinationIfscCode &&
          !values?.destinationIfscCode.match(/^[a-zA-Z0-9\s]+$/)
        ) {
          errors.destinationIfscCode =
            '* IFSC Code cannot contain special characters';
        }
        if (
          values.destinationIfscCode &&
          (!values.destinationBankName ||
            !values.destinationBranchName) &&
          values?.destinationIfscCode.match(/^[a-zA-Z0-9]+$/)
        ) {
          errors.destinationIfscCode =
            '* Click the Search icon to fetch Bank Name and Branch Name';
        }
        if (
          values?.destinationMicrCode &&
          !values?.destinationMicrCode.match(/^[a-zA-Z0-9]+$/)
        ) {
          errors.destinationMicrCode =
            '* MICR Code cannot contain special characters';
        }
        if (!values.destinationBankAccountType) {
          errors.destinationBankAccountType = '* Required';
        }
      }
      if (!values.mandateAmount) {
        errors.mandateAmount = '* Required';
      }
    }*/


    return errors;
  };

  var NomineeForm = function NomineeForm(_ref2) {
    var _renderExpandedCards$, _renderExpandedCards$2, _buyHealthPolicy$quot, _buyHealthPolicy$quot2, _buyHealthPolicy$quot3, _buyHealthPolicy$quot4, _buyHealthPolicy$quot5, _PRD_RenewalPaymentMa, _ref4, _getDomainData10, _values$documentDetai36, _values$documentDetai37, _values$documentDetai38;

    _ref2.validate;
        _ref2.productQuestionList;
        _ref2.medicalQuestionaireOpenMode;

    var _useQuantaFormikConte = useQuantaFormikContext(),
        values = _useQuantaFormikConte.values,
        setFieldValue = _useQuantaFormikConte.setFieldValue;

    var _useState9 = useState(false),
        _useState10 = _slicedToArray(_useState9, 2),
        ifscModalDisplay = _useState10[0],
        showIfscModal = _useState10[1];

    var _useState11 = useState(false),
        _useState12 = _slicedToArray(_useState11, 2),
        loadingIfscCodeData = _useState12[0],
        setLoadingIfscCodeData = _useState12[1];

    var _useState13 = useState([]),
        _useState14 = _slicedToArray(_useState13, 2),
        ifscCodeOutput = _useState14[0],
        setIfscCodeOutput = _useState14[1];

    var _useState15 = useState(null),
        _useState16 = _slicedToArray(_useState15, 2),
        bankMetaMessage = _useState16[0],
        setBankMetaMessage = _useState16[1];

    var _useState17 = useState(false),
        _useState18 = _slicedToArray(_useState17, 2);
        _useState18[0];
        _useState18[1];

    var _useState19 = useState(''),
        _useState20 = _slicedToArray(_useState19, 2),
        searchStringIfsc = _useState20[0];
        _useState20[1];

    var _useState21 = useState(null),
        _useState22 = _slicedToArray(_useState21, 2),
        onDataUpdate = _useState22[0];
        _useState22[1];

    var _useContext = useContext(ConfigContext),
        branding = _useContext.branding;

    var _useState23 = useState(false),
        _useState24 = _slicedToArray(_useState23, 2),
        loadingFinalCollectionDate = _useState24[0];
        _useState24[1];

    var _useState25 = useState(false),
        _useState26 = _slicedToArray(_useState25, 2),
        loadingDefaultBankName = _useState26[0];
        _useState26[1];

    var _useState27 = useState({
      ifsc: ''
    }),
        _useState28 = _slicedToArray(_useState27, 2),
        errors = _useState28[0],
        setErrors = _useState28[1];

    var _useState29 = useState([]),
        _useState30 = _slicedToArray(_useState29, 2),
        alerts = _useState30[0],
        setAlerts = _useState30[1];

    var _useState31 = useState(''),
        _useState32 = _slicedToArray(_useState31, 2),
        customWarningMsg = _useState32[0],
        setCustomWarningMsg = _useState32[1];

    var colSpanParams = useResponsiveParams({
      for_mobile: {
        searchString: 8,
        button: 2
      },
      for_desktop: {
        searchString: 4,
        button: 1
      }
    });
    var changeInputType = useResponsiveParams({
      for_mobile: 'input-lookup',
      for_desktop: 'text'
    });
    useEffect(function () {
      var isMounted = false;
      return function () {
        return isMounted;
      };
    }, [medicalQuestionaireDisplay]);
    useEffect(function () {
      if (buyHealthPolicy.quotationType.toString() === 'Roll Over' && productCode.toString() === '2883') {
        setDisableProcced(true);
      }

      if (productCode.toString() === '2883') {
        var _values$documentDetai20, _values$documentDetai21, _values$documentDetai22, _values$documentDetai23, _values$documentDetai24, _values$documentDetai25, _values$documentDetai26, _values$documentDetai27, _values$documentDetai28, _values$documentDetai29, _values$documentDetai30, _values$documentDetai31, _values$documentDetai32, _values$documentDetai33, _values$documentDetai34, _values$documentDetai35;

        for (var i = 0; i < (values === null || values === void 0 ? void 0 : (_values$documentDetai15 = values.documentDetails) === null || _values$documentDetai15 === void 0 ? void 0 : _values$documentDetai15.length); i++) {
          var _values$documentDetai15, _values$documentDetai16, _values$documentDetai17, _values$documentDetai18;

          if (values !== null && values !== void 0 && (_values$documentDetai16 = values.documentDetails[i]) !== null && _values$documentDetai16 !== void 0 && _values$documentDetai16.documentName && (values === null || values === void 0 ? void 0 : (_values$documentDetai17 = values.documentDetails[i]) === null || _values$documentDetai17 === void 0 ? void 0 : (_values$documentDetai18 = _values$documentDetai17.documentBase64String) === null || _values$documentDetai18 === void 0 ? void 0 : _values$documentDetai18.length) === 0) {
            var _values$documentDetai19;

            setCustomWarningMsg("Provide Input File for ".concat(values === null || values === void 0 ? void 0 : (_values$documentDetai19 = values.documentDetails[i]) === null || _values$documentDetai19 === void 0 ? void 0 : _values$documentDetai19.documentName));
          } else {
            setCustomWarningMsg('');
          }
        }

        if (buyHealthPolicy.quotationType.toString() === 'Roll Over' && productCode.toString() === '2883' && values !== null && values !== void 0 && (_values$documentDetai20 = values.documentDetails) !== null && _values$documentDetai20 !== void 0 && _values$documentDetai20.find(function (e) {
          var _e$documentName;

          return (e === null || e === void 0 ? void 0 : (_e$documentName = e.documentName) === null || _e$documentName === void 0 ? void 0 : _e$documentName.toLowerCase()) === 'previous policy document';
        }) && (values === null || values === void 0 ? void 0 : (_values$documentDetai21 = values.documentDetails) === null || _values$documentDetai21 === void 0 ? void 0 : (_values$documentDetai22 = _values$documentDetai21.find(function (e) {
          var _e$documentName2;

          return (e === null || e === void 0 ? void 0 : (_e$documentName2 = e.documentName) === null || _e$documentName2 === void 0 ? void 0 : _e$documentName2.toLowerCase()) === 'previous policy document';
        })) === null || _values$documentDetai22 === void 0 ? void 0 : (_values$documentDetai23 = _values$documentDetai22.documentBase64String) === null || _values$documentDetai23 === void 0 ? void 0 : _values$documentDetai23.length) > 0 && values !== null && values !== void 0 && (_values$documentDetai24 = values.documentDetails) !== null && _values$documentDetai24 !== void 0 && _values$documentDetai24.find(function (e) {
          var _e$documentName3;

          return (e === null || e === void 0 ? void 0 : (_e$documentName3 = e.documentName) === null || _e$documentName3 === void 0 ? void 0 : _e$documentName3.toLowerCase()) === 'approval mail';
        }) && (values === null || values === void 0 ? void 0 : (_values$documentDetai25 = values.documentDetails) === null || _values$documentDetai25 === void 0 ? void 0 : (_values$documentDetai26 = _values$documentDetai25.find(function (e) {
          var _e$documentName4;

          return (e === null || e === void 0 ? void 0 : (_e$documentName4 = e.documentName) === null || _e$documentName4 === void 0 ? void 0 : _e$documentName4.toLowerCase()) === 'approval mail';
        })) === null || _values$documentDetai26 === void 0 ? void 0 : (_values$documentDetai27 = _values$documentDetai26.documentBase64String) === null || _values$documentDetai27 === void 0 ? void 0 : _values$documentDetai27.length) > 0 && values !== null && values !== void 0 && (_values$documentDetai28 = values.documentDetails) !== null && _values$documentDetai28 !== void 0 && _values$documentDetai28.find(function (e) {
          var _e$documentName5;

          return (e === null || e === void 0 ? void 0 : (_e$documentName5 = e.documentName) === null || _e$documentName5 === void 0 ? void 0 : _e$documentName5.toLowerCase()) === 'renewal notice';
        }) && (values === null || values === void 0 ? void 0 : (_values$documentDetai29 = values.documentDetails) === null || _values$documentDetai29 === void 0 ? void 0 : (_values$documentDetai30 = _values$documentDetai29.find(function (e) {
          var _e$documentName6;

          return (e === null || e === void 0 ? void 0 : (_e$documentName6 = e.documentName) === null || _e$documentName6 === void 0 ? void 0 : _e$documentName6.toLowerCase()) === 'renewal notice';
        })) === null || _values$documentDetai30 === void 0 ? void 0 : (_values$documentDetai31 = _values$documentDetai30.documentBase64String) === null || _values$documentDetai31 === void 0 ? void 0 : _values$documentDetai31.length) > 0 && values !== null && values !== void 0 && (_values$documentDetai32 = values.documentDetails) !== null && _values$documentDetai32 !== void 0 && _values$documentDetai32.find(function (e) {
          var _e$documentName7;

          return (e === null || e === void 0 ? void 0 : (_e$documentName7 = e.documentName) === null || _e$documentName7 === void 0 ? void 0 : _e$documentName7.toLowerCase()) === 'portability form';
        }) && (values === null || values === void 0 ? void 0 : (_values$documentDetai33 = values.documentDetails) === null || _values$documentDetai33 === void 0 ? void 0 : (_values$documentDetai34 = _values$documentDetai33.find(function (e) {
          var _e$documentName8;

          return (e === null || e === void 0 ? void 0 : (_e$documentName8 = e.documentName) === null || _e$documentName8 === void 0 ? void 0 : _e$documentName8.toLowerCase()) === 'portability form';
        })) === null || _values$documentDetai34 === void 0 ? void 0 : (_values$documentDetai35 = _values$documentDetai34.documentBase64String) === null || _values$documentDetai35 === void 0 ? void 0 : _values$documentDetai35.length) > 0) {
          setDisableProcced(false);
        }
      }
    }, [values === null || values === void 0 ? void 0 : values.documentDetails]);

    var onIfscSearch = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val, setFieldValue) {
        var _val$toString;

        var _data$_bankInfo_meta, ifscLookupQuery, _yield$ifscLookupQuer, _data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!((val === null || val === void 0 ? void 0 : (_val$toString = val.toString()) === null || _val$toString === void 0 ? void 0 : _val$toString.length) > 0)) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 1;
                setIfscCodeOutput([]);
                ifscLookupQuery = fetchQuery({
                  query: CUSTOMER_BANK_DETAILS,
                  variables: {
                    filter: {
                      ifscCode: val === null || val === void 0 ? void 0 : val.toString()
                    }
                  }
                });
                setLoadingIfscCodeData(true);
                _context.next = 7;
                return ifscLookupQuery;

              case 7:
                _yield$ifscLookupQuer = _context.sent;
                _data = _yield$ifscLookupQuer.data;
                setLoadingIfscCodeData(false);
                setIfscCodeOutput(_data === null || _data === void 0 ? void 0 : _data.bankInfo);
                setBankMetaMessage(_data === null || _data === void 0 ? void 0 : (_data$_bankInfo_meta = _data._bankInfo_meta) === null || _data$_bankInfo_meta === void 0 ? void 0 : _data$_bankInfo_meta.metaMessage);
                _context.next = 20;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](1);
                setErrors(_objectSpread2(_objectSpread2({}, errors), {}, {
                  ifsc: _context.t0.message
                }));
                setLoadingIfscCodeData(false);
                setIfscCodeOutput([]);
                setBankMetaMessage(null);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 14]]);
      }));

      return function onIfscSearch(_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    var searchInput = {
      flow: 'cols',
      repeat: 5,
      data: changeInputType === 'text' ? [{
        type: 'text',
        name: 'searchString',
        size: 'full',
        colSpan: colSpanParams.searchString
      }, {
        type: 'submit',
        size: 'full',
        colSpan: colSpanParams.button,
        iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faSearch
        }),
        children: 'Search'
      }] : [{
        type: 'input-lookup',
        name: 'searchString',
        size: 'full',
        colSpan: colSpanParams.searchString,
        onLookup: onIfscSearch
      }],
      initialValues: {
        searchString: searchStringIfsc
      },
      validate: function validate(values) {
        var errors = {};
        if (!values.searchString) errors.searchString = '* Required';
        return errors;
      },
      onSearch: function () {
        var _onSearch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(values) {
          var queryOutput, _yield$queryOutput, _data2;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  setIfscCodeOutput([]);
                  queryOutput = fetchQuery({
                    query: CUSTOMER_BANK_DETAILS,
                    variables: {
                      filter: {
                        ifscCode: values.searchString
                      }
                    }
                  });
                  setLoadingIfscCodeData(true);
                  _context2.next = 6;
                  return queryOutput;

                case 6:
                  _yield$queryOutput = _context2.sent;
                  _data2 = _yield$queryOutput.data;
                  setLoadingIfscCodeData(false);
                  setIfscCodeOutput(_data2.bankInfo);
                  setBankMetaMessage(_data2._bankInfo_meta.metaMessage);
                  _context2.next = 19;
                  break;

                case 13:
                  _context2.prev = 13;
                  _context2.t0 = _context2["catch"](0);
                  setErrors(_objectSpread2(_objectSpread2({}, errors), {}, {
                    ifsc: _context2.t0.message
                  }));
                  setLoadingIfscCodeData(false);
                  setIfscCodeOutput([]);
                  setBankMetaMessage(null);

                case 19:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 13]]);
        }));

        function onSearch(_x3) {
          return _onSearch.apply(this, arguments);
        }

        return onSearch;
      }()
    };
    var searchResults = {
      data: ifscCodeOutput,
      onIdle: function onIdle() {
        if (loadingIfscCodeData) {
          return /*#__PURE__*/React.createElement(Loading, null);
        } else if (searchStringIfsc === '') {
          return /*#__PURE__*/React.createElement(IconIdle, null);
        }

        return undefined;
      },
      columns: [{
        Header: 'IFSC Code',
        accessor: 'ifsc_code'
      }, {
        Header: 'Bank Name',
        accessor: 'name'
      }, {
        Header: 'Branch Name',
        accessor: 'branch_name'
      }],
      list: ifscCodeOutput.map(function (data) {
        return {
          title: "".concat(data.ifsc_code),
          subtitle: "".concat(data.branch_name),
          onClick: function onClick() {
            onDataUpdate(data);
            showIfscModal(false);
            document.body.classList.remove('overflow-y-hidden');
          }
        };
      }),
      sortBy: {
        id: 'ifsc_code',
        desc: false
      }
    };

    var onClose = function onClose() {
      showIfscModal(false);
    };

    var onNoResultsFound = function onNoResultsFound() {
      return errors.ifsc;
    };

    var onMessage = function onMessage() {
      return bankMetaMessage && bankMetaMessage.type && bankMetaMessage.message && /*#__PURE__*/React.createElement(Text, {
        severity: bankMetaMessage.type,
        className: "space-x-1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex flex-row"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: bankMetaMessage.type === 'info' ? faExclamationCircle : bankMetaMessage.type === 'warning' ? faExclamationTriangle : faTimesCircle,
        className: "mr-1 text-".concat(bankMetaMessage.type)
      })), /*#__PURE__*/React.createElement("div", null, bankMetaMessage.message)));
    };

    var paginationInput = {
      offset: 0,
      PAGE_SIZE: 4
    };
    var healthDeclarationData = [{
      title: /*#__PURE__*/React.createElement("span", {
        className: "flex flex-col space-y-3 mt-6"
      }, /*#__PURE__*/React.createElement(Text, {
        severity: "info",
        type: "title"
      }, "Health Declaration"), /*#__PURE__*/React.createElement(Text, {
        type: "label",
        className: "text-base text-black"
      }, "Any of the Insured member/s has medical condition or in not in good health?")),
      grid_data: [{
        type: 'radiogroup',
        disabledGlobal: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0,
        name: 'isHealthDeclarationSelected',
        data: [{
          label: 'Yes',
          value: 'Yes'
        }, {
          label: 'No',
          value: 'No'
        }]
      }]
    }];
    var renewalMandateDetails = [//////console.log('product_code',product_code),
    productCode.toString() !== '2885' ? {
      title: /*#__PURE__*/React.createElement(Text, {
        severity: "info",
        type: "large"
      }, "Renewal Mandate"),
      expanded: renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$ = renderExpandedCards.current) === null || _renderExpandedCards$ === void 0 ? void 0 : (_renderExpandedCards$2 = _renderExpandedCards$.find(function (card) {
        var _card$cardName, _card$cardName$toStri;

        return (card === null || card === void 0 ? void 0 : (_card$cardName = card.cardName) === null || _card$cardName === void 0 ? void 0 : (_card$cardName$toStri = _card$cardName.toString()) === null || _card$cardName$toStri === void 0 ? void 0 : _card$cardName$toStri.toLowerCase()) === "renewal mandate";
      })) === null || _renderExpandedCards$2 === void 0 ? void 0 : _renderExpandedCards$2.flag,
      isToggleEnabled: true,
      setExpandedCards: function setExpandedCards(expanded) {
        var _renderExpandedCards$3, _renderExpandedCards$4;

        renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$3 = renderExpandedCards.current) === null || _renderExpandedCards$3 === void 0 ? void 0 : _renderExpandedCards$3.filter(function (card) {
          var _card$cardName2, _card$cardName2$toStr;

          return (card === null || card === void 0 ? void 0 : (_card$cardName2 = card.cardName) === null || _card$cardName2 === void 0 ? void 0 : (_card$cardName2$toStr = _card$cardName2.toString()) === null || _card$cardName2$toStr === void 0 ? void 0 : _card$cardName2$toStr.toLowerCase()) !== "renewal mandate";
        })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$4 = renderExpandedCards.current) === null || _renderExpandedCards$4 === void 0 ? void 0 : _renderExpandedCards$4.find(function (card) {
          var _card$cardName3, _card$cardName3$toStr;

          return (card === null || card === void 0 ? void 0 : (_card$cardName3 = card.cardName) === null || _card$cardName3 === void 0 ? void 0 : (_card$cardName3$toStr = _card$cardName3.toString()) === null || _card$cardName3$toStr === void 0 ? void 0 : _card$cardName3$toStr.toLowerCase()) === "renewal mandate";
        })), {}, {
          flag: expanded
        })]);
      },
      grid_data: loadingDefaultBankName ? [{
        type: 'render',
        colSpan: repeat,
        component: function component() {
          return /*#__PURE__*/React.createElement("div", {
            className: "flex items-center justify-center"
          }, /*#__PURE__*/React.createElement(Loading, {
            customMessage: 'Fetching Bank Name'
          }));
        }
      }] : loadingFinalCollectionDate ? [{
        type: 'render',
        colSpan: repeat,
        component: function component() {
          return /*#__PURE__*/React.createElement("div", {
            className: "flex items-center justify-center"
          }, /*#__PURE__*/React.createElement(Loading, {
            customMessage: 'Fetching final collection date'
          }));
        }
      }] : [(_ref4 = {
        type: 'checkbox',
        name: 'renewalPaymentMandate',
        // checked:buyHealthPolicy?.quoteData?.cover.tenure?.toString() =='1 Year'||buyHealthPolicy?.quoteData?.cover?.tenure?.toString() =="1",
        disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$quot = buyHealthPolicy.quoteData) === null || _buyHealthPolicy$quot === void 0 ? void 0 : (_buyHealthPolicy$quot2 = _buyHealthPolicy$quot.cover.tenure) === null || _buyHealthPolicy$quot2 === void 0 ? void 0 : _buyHealthPolicy$quot2.toString()) !== '1 Year' && (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$quot3 = buyHealthPolicy.quoteData) === null || _buyHealthPolicy$quot3 === void 0 ? void 0 : (_buyHealthPolicy$quot4 = _buyHealthPolicy$quot3.cover) === null || _buyHealthPolicy$quot4 === void 0 ? void 0 : (_buyHealthPolicy$quot5 = _buyHealthPolicy$quot4.tenure) === null || _buyHealthPolicy$quot5 === void 0 ? void 0 : _buyHealthPolicy$quot5.toString()) != "1",
        label: /*#__PURE__*/React.createElement(Text, null, "Do you want to set up a renewal payment mandate in the name of", ' ', (_PRD_RenewalPaymentMa = PRD_RenewalPaymentMandateTakenInTheNameOf[0]) === null || _PRD_RenewalPaymentMa === void 0 ? void 0 : _PRD_RenewalPaymentMa.value, "?")
      }, _defineProperty(_ref4, "disabled", true), _defineProperty(_ref4, "colSpan", repeat), _defineProperty(_ref4, "onDataChange", function onDataChange(val, setFieldValue) {
        //console.log('checkbox mandate data',val)
        if (val === true) setrenew_man_amount(manamount);else setrenew_man_amount('');
      }), _ref4), null, null, null, null, null, null, null, null, null, null].filter(function (d) {
        return d;
      })
    } : null];
    var prevInsuredDetailsData = nomineeDetails ? nomineeDetails === null || nomineeDetails === void 0 ? void 0 : nomineeDetails.map(function (nominee) {
      var _getDomainData3, _renderExpandedCards$5, _renderExpandedCards$6, _buyHealthPolicy$prop, _getDomainData4, _buyHealthPolicy$prop2, _getDomainData5, _buyHealthPolicy$prop3, _getDomainData6, _buyHealthPolicy$prop4, _getDomainData7, _buyHealthPolicy$prop5, _getDomainData8, _buyHealthPolicy$prop6, _getDomainData9, _buyHealthPolicy$prop7, _values$$prevInsuranc10, _buyHealthPolicy$prop8, _values$$prevInsuranc11, _buyHealthPolicy$prop9, _values$$prevInsuranc12, _values$$prevInsuranc13, _buyHealthPolicy$prop10, _buyHealthPolicy$prop11, _buyHealthPolicy$prop12;

      return {
        title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
          severity: "info",
          type: "large"
        }, nominee.relationship, "-Previous Insurance Policy and Claims", ' '), (((_getDomainData3 = getDomainData(businessTypeList, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quotationType, 'code', 'value')) === null || _getDomainData3 === void 0 ? void 0 : _getDomainData3.toLowerCase()) !== 'new business' || Object.keys(values["".concat(nominee.relationship)].prevInsuranceDetails).find(function (k) {
          return (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'prevclaimlodged' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'insuredrelationship' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'cbpct' && values["".concat(nominee.relationship)].prevInsuranceDetails[k];
        })) && /*#__PURE__*/React.createElement(Text, {
          severity: "error",
          type: "title"
        }, "*")),
        size: 'medium',
        expanded: renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$5 = renderExpandedCards.current) === null || _renderExpandedCards$5 === void 0 ? void 0 : (_renderExpandedCards$6 = _renderExpandedCards$5.find(function (card) {
          var _card$cardName4, _card$cardName4$toStr, _nominee$relationship2, _nominee$relationship3;

          return (card === null || card === void 0 ? void 0 : (_card$cardName4 = card.cardName) === null || _card$cardName4 === void 0 ? void 0 : (_card$cardName4$toStr = _card$cardName4.toString()) === null || _card$cardName4$toStr === void 0 ? void 0 : _card$cardName4$toStr.toLowerCase()) === "".concat(nominee === null || nominee === void 0 ? void 0 : (_nominee$relationship2 = nominee.relationship) === null || _nominee$relationship2 === void 0 ? void 0 : (_nominee$relationship3 = _nominee$relationship2.toString()) === null || _nominee$relationship3 === void 0 ? void 0 : _nominee$relationship3.toLowerCase(), " prev insured");
        })) === null || _renderExpandedCards$6 === void 0 ? void 0 : _renderExpandedCards$6.flag,
        isToggleEnabled: true,
        setExpandedCards: function setExpandedCards(expanded) {
          var _renderExpandedCards$7, _renderExpandedCards$8;

          renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$7 = renderExpandedCards.current) === null || _renderExpandedCards$7 === void 0 ? void 0 : _renderExpandedCards$7.filter(function (card) {
            var _card$cardName5, _card$cardName5$toStr, _nominee$relationship4, _nominee$relationship5;

            return (card === null || card === void 0 ? void 0 : (_card$cardName5 = card.cardName) === null || _card$cardName5 === void 0 ? void 0 : (_card$cardName5$toStr = _card$cardName5.toString()) === null || _card$cardName5$toStr === void 0 ? void 0 : _card$cardName5$toStr.toLowerCase()) !== "".concat(nominee === null || nominee === void 0 ? void 0 : (_nominee$relationship4 = nominee.relationship) === null || _nominee$relationship4 === void 0 ? void 0 : (_nominee$relationship5 = _nominee$relationship4.toString()) === null || _nominee$relationship5 === void 0 ? void 0 : _nominee$relationship5.toLowerCase(), " prev insured");
          })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$8 = renderExpandedCards.current) === null || _renderExpandedCards$8 === void 0 ? void 0 : _renderExpandedCards$8.find(function (card) {
            var _card$cardName6, _card$cardName6$toStr, _nominee$relationship6, _nominee$relationship7;

            return (card === null || card === void 0 ? void 0 : (_card$cardName6 = card.cardName) === null || _card$cardName6 === void 0 ? void 0 : (_card$cardName6$toStr = _card$cardName6.toString()) === null || _card$cardName6$toStr === void 0 ? void 0 : _card$cardName6$toStr.toLowerCase()) === "".concat(nominee === null || nominee === void 0 ? void 0 : (_nominee$relationship6 = nominee.relationship) === null || _nominee$relationship6 === void 0 ? void 0 : (_nominee$relationship7 = _nominee$relationship6.toString()) === null || _nominee$relationship7 === void 0 ? void 0 : _nominee$relationship7.toLowerCase(), " prev insured");
          })), {}, {
            flag: expanded
          })]);
        },
        grid_data: [{
          type: 'select',
          searchable: true,
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop === void 0 ? void 0 : _buyHealthPolicy$prop.length) > 0,
          label: /*#__PURE__*/React.createElement("div", null, "Previous Insurer Name", ' ', ((_getDomainData4 = getDomainData(businessTypeList, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quotationType, 'code', 'value')) === null || _getDomainData4 === void 0 ? void 0 : _getDomainData4.toLowerCase()) !== 'new business' || Object.keys(values["".concat(nominee.relationship)].prevInsuranceDetails).find(function (k) {
            return (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'prevclaimlodged' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'insuredrelationship' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'cbpct' && values["".concat(nominee.relationship)].prevInsuranceDetails[k];
          }) ? /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*") : /*#__PURE__*/React.createElement(Text, null)),
          name: "".concat(nominee.relationship, ".prevInsuranceDetails.prevInsurerName"),
          data: rolloverCompanyList && (rolloverCompanyList === null || rolloverCompanyList === void 0 ? void 0 : rolloverCompanyList.length) > 0 ? rolloverCompanyList === null || rolloverCompanyList === void 0 ? void 0 : rolloverCompanyList.map(function (company) {
            return {
              label: company.value ? company.value : '',
              value: company.code ? company.code : ''
            };
          }) : []
        }, {
          type: 'text',
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop2 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop2 === void 0 ? void 0 : _buyHealthPolicy$prop2.length) > 0,
          label: /*#__PURE__*/React.createElement("div", null, "Previous Policy Number", ' ', ((_getDomainData5 = getDomainData(businessTypeList, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quotationType, 'code', 'value')) === null || _getDomainData5 === void 0 ? void 0 : _getDomainData5.toLowerCase()) !== 'new business' || Object.keys(values["".concat(nominee.relationship)].prevInsuranceDetails).find(function (k) {
            return (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'prevclaimlodged' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'insuredrelationship' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'cbpct' && values["".concat(nominee.relationship)].prevInsuranceDetails[k];
          }) ? /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*") : /*#__PURE__*/React.createElement(Text, null)),
          name: "".concat(nominee.relationship, ".prevInsuranceDetails.prevPolicyNo")
        }, {
          type: 'number',
          min: 0,
          onKeyDown: function onKeyDown(evt) {
            return (evt.key === 'e' || evt.key === '-') && evt.preventDefault();
          },
          iconPre: branding.currency,
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop3 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop3 === void 0 ? void 0 : _buyHealthPolicy$prop3.length) > 0,
          className: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 ? "border-neutral-dark" : "",
          label: /*#__PURE__*/React.createElement("div", null, "Sum Insured", ' ', ((_getDomainData6 = getDomainData(businessTypeList, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quotationType, 'code', 'value')) === null || _getDomainData6 === void 0 ? void 0 : _getDomainData6.toLowerCase()) !== 'new business' || Object.keys(values["".concat(nominee.relationship)].prevInsuranceDetails).find(function (k) {
            return (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'prevclaimlodged' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'insuredrelationship' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'cbpct' && values["".concat(nominee.relationship)].prevInsuranceDetails[k];
          }) ? /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*") : /*#__PURE__*/React.createElement(Text, null)),
          name: "".concat(nominee.relationship, ".prevInsuranceDetails.prevPolicySI")
        }, {
          type: 'date',
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop4 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop4 === void 0 ? void 0 : _buyHealthPolicy$prop4.length) > 0,
          label: /*#__PURE__*/React.createElement("div", null, "Policy Start Date", ' ', ((_getDomainData7 = getDomainData(businessTypeList, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quotationType, 'code', 'value')) === null || _getDomainData7 === void 0 ? void 0 : _getDomainData7.toLowerCase()) !== 'new business' || Object.keys(values["".concat(nominee.relationship)].prevInsuranceDetails).find(function (k) {
            return (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'prevclaimlodged' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'insuredrelationship' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'cbpct' && values["".concat(nominee.relationship)].prevInsuranceDetails[k];
          }) ? /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*") : /*#__PURE__*/React.createElement(Text, null)),
          name: "".concat(nominee.relationship, ".prevInsuranceDetails.prevPolicyStartDate")
        }, {
          type: 'date',
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop5 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop5 === void 0 ? void 0 : _buyHealthPolicy$prop5.length) > 0,
          label: /*#__PURE__*/React.createElement("div", null, "Policy Expiry Date", ' ', ((_getDomainData8 = getDomainData(businessTypeList, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quotationType, 'code', 'value')) === null || _getDomainData8 === void 0 ? void 0 : _getDomainData8.toLowerCase()) !== 'new business' || Object.keys(values["".concat(nominee.relationship)].prevInsuranceDetails).find(function (k) {
            return (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'prevclaimlodged' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'insuredrelationship' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'cbpct' && values["".concat(nominee.relationship)].prevInsuranceDetails[k];
          }) ? /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*") : /*#__PURE__*/React.createElement(Text, null)),
          name: "".concat(nominee.relationship, ".prevInsuranceDetails.prevPolicyEndDate"),
          onDataChange: function onDataChange(val, setFieldValue) {
            setFieldValue("".concat(nominee.relationship, ".prevInsuranceDetails.prevPolicyStartDate"), moment(val, "DD/MM/YYYY").subtract(1, 'year').add(1, 'days').format('DD/MM/YYYY'));
          }
        }, {
          type: 'select',
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop6 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop6 === void 0 ? void 0 : _buyHealthPolicy$prop6.length) > 0,
          label: /*#__PURE__*/React.createElement("div", null, "Claims lodged in past policy?", ' ', ((_getDomainData9 = getDomainData(businessTypeList, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quotationType, 'code', 'value')) === null || _getDomainData9 === void 0 ? void 0 : _getDomainData9.toLowerCase()) !== 'new business' || Object.keys(values["".concat(nominee.relationship)].prevInsuranceDetails).find(function (k) {
            return (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'prevclaimlodged' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'insuredrelationship' && (k === null || k === void 0 ? void 0 : k.toLowerCase()) !== 'cbpct' && values["".concat(nominee.relationship)].prevInsuranceDetails[k];
          }) ? /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*") : /*#__PURE__*/React.createElement(Text, null)),
          name: "".concat(nominee.relationship, ".prevInsuranceDetails.prevClaimLodged"),
          data: [{
            label: 'Yes',
            value: 'Yes'
          }, {
            label: 'No',
            value: 'No'
          }],
          onDataChange: function onDataChange(val, setFieldValue) {
            if ((val === null || val === void 0 ? void 0 : val.toLowerCase()) !== 'yes') {
              setFieldValue("".concat(nominee.relationship, ".prevInsuranceDetails.claimAmount"), '');
              setFieldValue("".concat(nominee.relationship, ".prevInsuranceDetails.cbAmount"), '');
            }
          }
        }, {
          type: 'number',
          min: 0,
          name: "".concat(nominee.relationship, ".prevInsuranceDetails.claimAmount"),
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop7 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop7 === void 0 ? void 0 : _buyHealthPolicy$prop7.length) > 0 || !(((_values$$prevInsuranc10 = values["".concat(nominee.relationship)].prevInsuranceDetails.prevClaimLodged) === null || _values$$prevInsuranc10 === void 0 ? void 0 : _values$$prevInsuranc10.toLowerCase()) === 'yes'),
          onKeyDown: function onKeyDown(evt) {
            return (evt.key === 'e' || evt.key === '-') && evt.preventDefault();
          },
          iconPre: /*#__PURE__*/React.createElement(Text, {
            severity: "".concat((buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop8 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop8 === void 0 ? void 0 : _buyHealthPolicy$prop8.length) > 0 || !(((_values$$prevInsuranc11 = values["".concat(nominee.relationship)].prevInsuranceDetails.prevClaimLodged) === null || _values$$prevInsuranc11 === void 0 ? void 0 : _values$$prevInsuranc11.toLowerCase()) === 'yes') ? 'neutral' : 'info')
          }, branding.currency),
          onDataChange: function onDataChange(val, setFieldValue) {
            var _values$12, _values$12$prevInsura;

            if (!val && !((_values$12 = values["".concat(nominee.relationship)]) !== null && _values$12 !== void 0 && (_values$12$prevInsura = _values$12.prevInsuranceDetails) !== null && _values$12$prevInsura !== void 0 && _values$12$prevInsura.cbAmount)) {
              setFieldValue("".concat(nominee.relationship, ".prevInsuranceDetails.prevClaimLodged"), '');
            } else {
              var _values$13, _values$13$prevInsura;

              if (!((_values$13 = values["".concat(nominee.relationship)]) !== null && _values$13 !== void 0 && (_values$13$prevInsura = _values$13.prevInsuranceDetails) !== null && _values$13$prevInsura !== void 0 && _values$13$prevInsura.prevClaimLodged)) {
                setFieldValue("".concat(nominee.relationship, ".prevInsuranceDetails.prevClaimLodged"), 'YES');
              }
            }
          },
          className: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop9 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop9 === void 0 ? void 0 : _buyHealthPolicy$prop9.length) > 0 || !(((_values$$prevInsuranc12 = values["".concat(nominee.relationship)].prevInsuranceDetails.prevClaimLodged) === null || _values$$prevInsuranc12 === void 0 ? void 0 : _values$$prevInsuranc12.toLowerCase()) === 'yes') ? "border-neutral-dark" : "",
          label: /*#__PURE__*/React.createElement("div", null, "Claim Amount", ' ', ((_values$$prevInsuranc13 = values["".concat(nominee.relationship)].prevInsuranceDetails.prevClaimLodged) === null || _values$$prevInsuranc13 === void 0 ? void 0 : _values$$prevInsuranc13.toLowerCase()) === 'yes' ? /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*") : /*#__PURE__*/React.createElement(Text, null))
        }, {
          type: 'number',
          min: 0,
          name: "".concat(nominee.relationship, ".prevInsuranceDetails.cbAmount"),
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop10 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop10 === void 0 ? void 0 : _buyHealthPolicy$prop10.length) > 0,
          // !(
          //   values[
          //     `${nominee.relationship}`
          //   ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
          //   'yes'
          // ),
          onKeyDown: function onKeyDown(evt) {
            return (evt.key === 'e' || evt.key === '-') && evt.preventDefault();
          },
          iconPre: /*#__PURE__*/React.createElement(Text, {
            severity: "".concat((buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop11 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop11 === void 0 ? void 0 : _buyHealthPolicy$prop11.length) > 0 // !(
            //   values[
            //     `${nominee.relationship}`
            //   ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
            //   'yes'
            // )
            ? 'neutral' : 'info')
          }, branding.currency),
          onDataChange: function onDataChange(val, setFieldValue) {// if (
            //   !val &&
            //   !values[`${nominee.relationship}`]
            //     ?.prevInsuranceDetails?.claimAmount
            // ) {
            //   setFieldValue(
            //     `${nominee.relationship}.prevInsuranceDetails.prevClaimLodged`,
            //     '',
            //   );
            // } else {
            //   if (
            //     !values[`${nominee.relationship}`]
            //       ?.prevInsuranceDetails?.prevClaimLodged
            //   ) {
            //     setFieldValue(
            //       `${nominee.relationship}.prevInsuranceDetails.prevClaimLodged`,
            //       'YES',
            //     );
            //   }
            // }
          },
          className: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop12 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop12 === void 0 ? void 0 : _buyHealthPolicy$prop12.length) > 0 // !(
          //   values[
          //     `${nominee.relationship}`
          //   ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
          //   'yes'
          // )
          ? "border-neutral-dark" : "",
          label: /*#__PURE__*/React.createElement("div", null, "Cummulative Bonus Amount", ' ')
        }]
      };
    }) : [];
    var otherPropsWithoutExpanded = {
      flow: 'cols',
      repeat: repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: false
    };
    var data = nomineeDetails ? nomineeDetails.map(function (m, idx) {
      var _renderExpandedCards$9, _renderExpandedCards$10;

      return {
        title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
          severity: "info",
          type: "large"
        }, m.relationship, "-Nominee", ' '), /*#__PURE__*/React.createElement(Text, {
          severity: "error",
          type: "title"
        }, "*")),
        size: 'medium',
        expanded: renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$9 = renderExpandedCards.current) === null || _renderExpandedCards$9 === void 0 ? void 0 : (_renderExpandedCards$10 = _renderExpandedCards$9.find(function (card) {
          var _card$cardName7, _card$cardName7$toStr, _m$relationship, _m$relationship$toStr;

          return (card === null || card === void 0 ? void 0 : (_card$cardName7 = card.cardName) === null || _card$cardName7 === void 0 ? void 0 : (_card$cardName7$toStr = _card$cardName7.toString()) === null || _card$cardName7$toStr === void 0 ? void 0 : _card$cardName7$toStr.toLowerCase()) === "".concat(m === null || m === void 0 ? void 0 : (_m$relationship = m.relationship) === null || _m$relationship === void 0 ? void 0 : (_m$relationship$toStr = _m$relationship.toString()) === null || _m$relationship$toStr === void 0 ? void 0 : _m$relationship$toStr.toLowerCase(), " nominee");
        })) === null || _renderExpandedCards$10 === void 0 ? void 0 : _renderExpandedCards$10.flag,
        isToggleEnabled: true,
        setExpandedCards: function setExpandedCards(expanded) {
          var _renderExpandedCards$11, _renderExpandedCards$12;

          renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$11 = renderExpandedCards.current) === null || _renderExpandedCards$11 === void 0 ? void 0 : _renderExpandedCards$11.filter(function (card) {
            var _card$cardName8, _card$cardName8$toStr, _m$relationship2, _m$relationship2$toSt;

            return (card === null || card === void 0 ? void 0 : (_card$cardName8 = card.cardName) === null || _card$cardName8 === void 0 ? void 0 : (_card$cardName8$toStr = _card$cardName8.toString()) === null || _card$cardName8$toStr === void 0 ? void 0 : _card$cardName8$toStr.toLowerCase()) !== "".concat(m === null || m === void 0 ? void 0 : (_m$relationship2 = m.relationship) === null || _m$relationship2 === void 0 ? void 0 : (_m$relationship2$toSt = _m$relationship2.toString()) === null || _m$relationship2$toSt === void 0 ? void 0 : _m$relationship2$toSt.toLowerCase(), " nominee");
          })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$12 = renderExpandedCards.current) === null || _renderExpandedCards$12 === void 0 ? void 0 : _renderExpandedCards$12.find(function (card) {
            var _card$cardName9, _card$cardName9$toStr, _m$relationship3, _m$relationship3$toSt;

            return (card === null || card === void 0 ? void 0 : (_card$cardName9 = card.cardName) === null || _card$cardName9 === void 0 ? void 0 : (_card$cardName9$toStr = _card$cardName9.toString()) === null || _card$cardName9$toStr === void 0 ? void 0 : _card$cardName9$toStr.toLowerCase()) === "".concat(m === null || m === void 0 ? void 0 : (_m$relationship3 = m.relationship) === null || _m$relationship3 === void 0 ? void 0 : (_m$relationship3$toSt = _m$relationship3.toString()) === null || _m$relationship3$toSt === void 0 ? void 0 : _m$relationship3$toSt.toLowerCase(), " nominee");
          })), {}, {
            flag: expanded
          })]);
        },
        grid_data: [{
          type: 'text',
          label: /*#__PURE__*/React.createElement("div", null, "Name ", /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")),
          name: "".concat(m.relationship, ".name"),
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 || values.sameNomineeForAllInsured && idx > 0,
          onDataChange: function onDataChange(val, setFieldValue) {
            setFieldValue("".concat(m.relationship, ".dob"), moment().subtract(18, 'years').format('DD/MM/YYYY').toString());

            if (values.sameNomineeForAllInsured && idx === 0) {
              nomineeDetails.filter(function (nominee) {
                return nominee.relationship.toLowerCase() !== m.relationship.toLowerCase();
              }).forEach(function (nominee) {
                setFieldValue("".concat(nominee.relationship, ".name"), val);
              });
            }
          },
          onKeyDown: function onKeyDown(evt) {
            var _evt$target, _evt$target$value, _evt$target$value$toS, _evt$target2, _evt$target2$value, _evt$target2$value$to;

            if (evt !== null && evt !== void 0 && (_evt$target = evt.target) !== null && _evt$target !== void 0 && (_evt$target$value = _evt$target.value) !== null && _evt$target$value !== void 0 && (_evt$target$value$toS = _evt$target$value.toString()) !== null && _evt$target$value$toS !== void 0 && _evt$target$value$toS.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target2 = evt.target) === null || _evt$target2 === void 0 ? void 0 : (_evt$target2$value = _evt$target2.value) === null || _evt$target2$value === void 0 ? void 0 : (_evt$target2$value$to = _evt$target2$value.toString()) === null || _evt$target2$value$to === void 0 ? void 0 : _evt$target2$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
              evt.preventDefault();
            }
          }
        }, {
          type: 'date',
          label: /*#__PURE__*/React.createElement("div", null, "Date of Birth ", /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")),
          name: "".concat(m.relationship, ".dob"),
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 || values.sameNomineeForAllInsured && idx > 0,
          onDataChange: function onDataChange(val, setFieldValue) {
            if (moment(new Date(), 'DD/MM/YYYY').diff(moment(val, 'DD/MM/YYYY'), 'years') >= MINOR_THRESHOLD_AGE) {
              setFieldValue("".concat(m.relationship, ".nameOfAppointee"), '');
              setFieldValue("".concat(m.relationship, ".relationshipWithAppointee"), '');
            }

            if (values.sameNomineeForAllInsured && idx === 0) {
              nomineeDetails.filter(function (nominee) {
                return nominee.relationship.toLowerCase() !== m.relationship.toLowerCase();
              }).forEach(function (nominee) {
                setFieldValue("".concat(nominee.relationship, ".dob"), val);

                if (moment(new Date(), 'DD/MM/YYYY').diff(moment(val, 'DD/MM/YYYY'), 'years') >= MINOR_THRESHOLD_AGE) {
                  setFieldValue("".concat(nominee.relationship, ".nameOfAppointee"), '');
                  setFieldValue("".concat(nominee.relationship, ".relationshipWithAppointee"), '');
                }
              });
            }
          }
        }, {
          type: 'select',
          label: /*#__PURE__*/React.createElement("div", null, "Relationship with Member", ' ', /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")),
          data: PRD_NomiRelationWithMemb ? _toConsumableArray(PRD_NomiRelationWithMemb.map(function (relationshipWithMember) {
            return {
              label: relationshipWithMember.value ? relationshipWithMember.value : '',
              value: relationshipWithMember.code ? relationshipWithMember.code : ''
            };
          })) : [],
          name: "".concat(m.relationship, ".relationshipWithInsured"),
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0
        }, {
          type: 'text',
          label: 'Name of Appointee (in case of Minor)',
          name: "".concat(m.relationship, ".nameOfAppointee"),
          onDataChange: function onDataChange(val, setFieldValue) {
            if (values.sameNomineeForAllInsured && idx === 0) {
              nomineeDetails.filter(function (nominee) {
                return nominee.relationship.toLowerCase() !== m.relationship.toLowerCase();
              }).forEach(function (nominee) {
                setFieldValue("".concat(nominee.relationship, ".nameOfAppointee"), val);
              });
            }
          },
          onKeyDown: function onKeyDown(evt) {
            var _evt$target3, _evt$target3$value, _evt$target3$value$to, _evt$target4, _evt$target4$value, _evt$target4$value$to;

            if (evt !== null && evt !== void 0 && (_evt$target3 = evt.target) !== null && _evt$target3 !== void 0 && (_evt$target3$value = _evt$target3.value) !== null && _evt$target3$value !== void 0 && (_evt$target3$value$to = _evt$target3$value.toString()) !== null && _evt$target3$value$to !== void 0 && _evt$target3$value$to.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target4 = evt.target) === null || _evt$target4 === void 0 ? void 0 : (_evt$target4$value = _evt$target4.value) === null || _evt$target4$value === void 0 ? void 0 : (_evt$target4$value$to = _evt$target4$value.toString()) === null || _evt$target4$value$to === void 0 ? void 0 : _evt$target4$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
              evt.preventDefault();
            }
          },
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 || moment(new Date(), 'DD/MM/YYYY').diff(moment(values["".concat(m.relationship)].dob, 'DD/MM/YYYY'), 'years') >= MINOR_THRESHOLD_AGE || values.sameNomineeForAllInsured && idx > 0
        }, {
          type: 'select',
          label: 'Relationship with Nominee',
          searchable: true,
          data: PRD_ApointRelationWithMinNomi ? _toConsumableArray(PRD_ApointRelationWithMinNomi.map(function (relationshipWithAppointee) {
            return {
              label: relationshipWithAppointee.value ? relationshipWithAppointee.value : '',
              value: relationshipWithAppointee.code ? relationshipWithAppointee.code : ''
            };
          })) : [],
          name: "".concat(m.relationship, ".relationshipWithAppointee"),
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 || moment(new Date(), 'DD/MM/YYYY').diff(moment(values["".concat(m.relationship)].dob, 'DD/MM/YYYY'), 'years') >= MINOR_THRESHOLD_AGE
        }, idx === 0 && nomineeDetails.length > 1 ? {
          type: 'checkbox',
          name: 'sameNomineeForAllInsured',
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0,
          label: 'Same Nominee for all members?',
          colSpan: repeat,
          onDataChange: function onDataChange(val, setFieldValue) {
            if (val) {
              nomineeDetails.filter(function (nominee) {
                var _m$relationship4;

                return nominee.relationship.toLowerCase() !== ((_m$relationship4 = m.relationship) === null || _m$relationship4 === void 0 ? void 0 : _m$relationship4.toLowerCase());
              }).forEach(function (nominee) {
                setFieldValue("".concat(nominee.relationship, ".name"), values["".concat(m.relationship)].name);
                setFieldValue("".concat(nominee.relationship, ".dob"), values["".concat(m.relationship)].dob);
                setFieldValue("".concat(nominee.relationship, ".nameOfAppointee"), values["".concat(m.relationship)].nameOfAppointee);
              });
            } else {
              nomineeDetails.filter(function (nominee) {
                var _m$relationship5;

                return nominee.relationship.toLowerCase() !== ((_m$relationship5 = m.relationship) === null || _m$relationship5 === void 0 ? void 0 : _m$relationship5.toLowerCase());
              }).forEach(function (nominee) {
                setFieldValue("".concat(nominee.relationship, ".name"), '');
                setFieldValue("".concat(nominee.relationship, ".dob"), '');
                setFieldValue("".concat(nominee.relationship, ".nameOfAppointee"), '');
              });
            }
          }
        } : null].filter(function (d) {
          return d;
        })
      };
    }) : [];
    var uploadDocumentsData = [!(buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.proposalNumber) ? {
      // title: (
      //   <Text type='title' severity={'info'} className={'text-lg'} >
      //     Upload Documents
      //   </Text>
      // ),
      grid_data: [{
        type: 'render',
        colSpan: repeat,
        component: function component() {
          var _dataDocumentExtensio, _dataDocumentExtensio2, _dataDocumentExtensio3;

          return /*#__PURE__*/React.createElement(Text, {
            severity: 'info',
            className: 'flex space-x-2 items-center my-2'
          }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faInfoCircle
          })), /*#__PURE__*/React.createElement(Text, null, "We support", ' ', /*#__PURE__*/React.createElement(Text, {
            className: 'font-semibold'
          }, dataDocumentExtensions === null || dataDocumentExtensions === void 0 ? void 0 : (_dataDocumentExtensio = dataDocumentExtensions.documentExtensions) === null || _dataDocumentExtensio === void 0 ? void 0 : (_dataDocumentExtensio2 = _dataDocumentExtensio.map(function (extension) {
            return extension === null || extension === void 0 ? void 0 : extension.value;
          })) === null || _dataDocumentExtensio2 === void 0 ? void 0 : _dataDocumentExtensio2.join(', ')), ' ', "formats for your documents to upload.You can upload upto", ' ', /*#__PURE__*/React.createElement(Text, {
            className: 'font-semibold'
          }, dataDocumentExtensions === null || dataDocumentExtensions === void 0 ? void 0 : (_dataDocumentExtensio3 = dataDocumentExtensions.docFileSizeLimit) === null || _dataDocumentExtensio3 === void 0 ? void 0 : _dataDocumentExtensio3.value), ' ', "maximum size for a single file", ' '));
        }
      }, ((_getDomainData10 = getDomainData(businessTypeList, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quotationType, 'code', 'value')) === null || _getDomainData10 === void 0 ? void 0 : _getDomainData10.toLowerCase()) === 'roll over' ? {
        type: 'render',
        colSpan: repeat,
        component: function component() {
          return /*#__PURE__*/React.createElement(Text, {
            severity: 'warning',
            className: 'flex space-x-2 items-center my-2'
          }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faExclamationCircle
          })), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Text, {
            className: 'font-semibold'
          }, "Previous Policy Document, Renewal Notice, Approval Mail and Portability form"), ' ', "is mandatory for Roll over."));
        }
      } : null].concat(_toConsumableArray(values !== null && values !== void 0 && values.documentDetails && (values === null || values === void 0 ? void 0 : (_values$documentDetai36 = values.documentDetails) === null || _values$documentDetai36 === void 0 ? void 0 : _values$documentDetai36.length) > 0 ? values === null || values === void 0 ? void 0 : (_values$documentDetai37 = values.documentDetails) === null || _values$documentDetai37 === void 0 ? void 0 : (_values$documentDetai38 = _values$documentDetai37.map(function (_, idx) {
        return {
          type: 'render',
          colSpan: repeat,
          component: function component() {
            var _screenType$toString, _screenType$toString2, _buyHealthPolicy$addi, _buyHealthPolicy$addi2, _buyHealthPolicy$addi3, _buyHealthPolicy$addi4, _buyHealthPolicy$addi5, _buyHealthPolicy$addi6, _values$documentDetai39, _values$documentDetai40, _values$documentDetai41, _values$documentDetai42, _buyHealthPolicy$addi7, _buyHealthPolicy$addi8, _buyHealthPolicy$addi9, _buyHealthPolicy$addi10, _buyHealthPolicy$addi11, _buyHealthPolicy$addi12, _screenType$toString3, _values$documentDetai49, _values$documentDetai50, _values$documentDetai51, _values$documentDetai52, _documentExtensions$f2, _values$documentDetai56, _screenType$toString4, _values$documentDetai57, _values$documentDetai58, _screenType$toString5, _screenType$toString6, _values$documentDetai59, _screenType$toString7, _screenType$toString8, _buyHealthPolicy$addi13, _buyHealthPolicy$addi14, _buyHealthPolicy$addi15, _buyHealthPolicy$addi16, _buyHealthPolicy$addi17, _buyHealthPolicy$addi18, _values$documentDetai63, _documentExtensions$m, _values$documentDetai65, _values$documentDetai66, _screenType$toString9, _screenType$toString10, _screenType$toString11, _values$documentDetai67, _screenType$toString12, _buyHealthPolicy$addi19, _buyHealthPolicy$addi20, _buyHealthPolicy$addi21, _buyHealthPolicy$addi22, _buyHealthPolicy$addi23, _buyHealthPolicy$addi24, _buyHealthPolicy$addi25, _buyHealthPolicy$addi26, _buyHealthPolicy$addi27, _buyHealthPolicy$addi28, _buyHealthPolicy$addi29, _buyHealthPolicy$addi30, _buyHealthPolicy$addi31, _buyHealthPolicy$addi32, _buyHealthPolicy$addi33, _screenType$toString13;

            return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, {
              className: "bg-neutral-light shadow-md rounded border border-neutral p-4 flex flex-".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString = screenType.toString()) === null || _screenType$toString === void 0 ? void 0 : _screenType$toString.toLowerCase()) === 'mobile' ? 'col space-y-6' : 'row space-x-6')
            }, /*#__PURE__*/React.createElement(Text, {
              className: (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString2 = screenType.toString()) === null || _screenType$toString2 === void 0 ? void 0 : _screenType$toString2.toLowerCase()) === 'mobile' ? 'w-full' : 'flex flex-col w-1/3'
            }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(QuantaSelect, {
              name: "documentDetails[".concat(idx, "].documentName"),
              size: 'full',
              disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi === void 0 ? void 0 : (_buyHealthPolicy$addi2 = _buyHealthPolicy$addi.status) === null || _buyHealthPolicy$addi2 === void 0 ? void 0 : (_buyHealthPolicy$addi3 = _buyHealthPolicy$addi2.toString()) === null || _buyHealthPolicy$addi3 === void 0 ? void 0 : _buyHealthPolicy$addi3.toLowerCase()) === 'quote saved' || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi4 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi4 === void 0 ? void 0 : (_buyHealthPolicy$addi5 = _buyHealthPolicy$addi4.status) === null || _buyHealthPolicy$addi5 === void 0 ? void 0 : (_buyHealthPolicy$addi6 = _buyHealthPolicy$addi5.toString()) === null || _buyHealthPolicy$addi6 === void 0 ? void 0 : _buyHealthPolicy$addi6.toLowerCase()) === 'converted to proposal',
              label: /*#__PURE__*/React.createElement(Text, {
                type: 'label'
              }, "Document Type", ' ', /*#__PURE__*/React.createElement(Text, {
                severity: 'error'
              })),
              onDataChange: function onDataChange(val, _) {
                var _documentList$find;

                setFieldValue("documentDetails[".concat(idx, "].documentNameValue"), documentList === null || documentList === void 0 ? void 0 : (_documentList$find = documentList.find(function (document) {
                  var _document$code, _document$code$toStri, _val$toString4;

                  return (document === null || document === void 0 ? void 0 : (_document$code = document.code) === null || _document$code === void 0 ? void 0 : (_document$code$toStri = _document$code.toString()) === null || _document$code$toStri === void 0 ? void 0 : _document$code$toStri.toLowerCase()) === (val === null || val === void 0 ? void 0 : (_val$toString4 = val.toString()) === null || _val$toString4 === void 0 ? void 0 : _val$toString4.toLowerCase());
                })) === null || _documentList$find === void 0 ? void 0 : _documentList$find.value);
              },
              data: documentList && (documentList === null || documentList === void 0 ? void 0 : documentList.length) > 0 ? documentList === null || documentList === void 0 ? void 0 : documentList.map(function (document) {
                return {
                  label: document !== null && document !== void 0 && document.value ? "".concat(document === null || document === void 0 ? void 0 : document.value) : '',
                  value: document !== null && document !== void 0 && document.code ? "".concat(document === null || document === void 0 ? void 0 : document.code) : ''
                };
              }) : []
            })), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(QuantaInput, {
              name: "documentDetails[".concat(idx, "].documentDescription"),
              size: 'full',
              label: /*#__PURE__*/React.createElement(Text, {
                type: 'label'
              }, "Description", ' ', /*#__PURE__*/React.createElement(Text, {
                severity: 'error'
              }, (values === null || values === void 0 ? void 0 : (_values$documentDetai39 = values.documentDetails[idx]) === null || _values$documentDetai39 === void 0 ? void 0 : (_values$documentDetai40 = _values$documentDetai39.documentNameValue) === null || _values$documentDetai40 === void 0 ? void 0 : (_values$documentDetai41 = _values$documentDetai40.toString()) === null || _values$documentDetai41 === void 0 ? void 0 : (_values$documentDetai42 = _values$documentDetai41.toLowerCase()) === null || _values$documentDetai42 === void 0 ? void 0 : _values$documentDetai42.trim()) === 'others' ? '*' : '')),
              disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi7 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi7 === void 0 ? void 0 : (_buyHealthPolicy$addi8 = _buyHealthPolicy$addi7.status) === null || _buyHealthPolicy$addi8 === void 0 ? void 0 : (_buyHealthPolicy$addi9 = _buyHealthPolicy$addi8.toString()) === null || _buyHealthPolicy$addi9 === void 0 ? void 0 : _buyHealthPolicy$addi9.toLowerCase()) === 'quote saved' || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi10 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi10 === void 0 ? void 0 : (_buyHealthPolicy$addi11 = _buyHealthPolicy$addi10.status) === null || _buyHealthPolicy$addi11 === void 0 ? void 0 : (_buyHealthPolicy$addi12 = _buyHealthPolicy$addi11.toString()) === null || _buyHealthPolicy$addi12 === void 0 ? void 0 : _buyHealthPolicy$addi12.toLowerCase()) === 'converted to proposal',
              placeholder: 'Type description if others',
              onKeyDown: function onKeyDown(evt) {
                var _evt$target5, _evt$target5$value, _evt$target5$value$to, _evt$target6, _evt$target6$value, _evt$target6$value$to;

                if (evt !== null && evt !== void 0 && (_evt$target5 = evt.target) !== null && _evt$target5 !== void 0 && (_evt$target5$value = _evt$target5.value) !== null && _evt$target5$value !== void 0 && (_evt$target5$value$to = _evt$target5$value.toString()) !== null && _evt$target5$value$to !== void 0 && _evt$target5$value$to.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target6 = evt.target) === null || _evt$target6 === void 0 ? void 0 : (_evt$target6$value = _evt$target6.value) === null || _evt$target6$value === void 0 ? void 0 : (_evt$target6$value$to = _evt$target6$value.toString()) === null || _evt$target6$value$to === void 0 ? void 0 : _evt$target6$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
                  evt.preventDefault();
                }
              }
            }))), /*#__PURE__*/React.createElement("span", {
              onDragEnter: function onDragEnter(evt) {
                var _values$documentDetai43;

                evt.preventDefault();
                evt.stopPropagation();

                if (values !== null && values !== void 0 && (_values$documentDetai43 = values.documentDetails[idx]) !== null && _values$documentDetai43 !== void 0 && _values$documentDetai43.documentName) {
                  var _values$documentDetai44, _evt$dataTransfer, _evt$dataTransfer$ite;

                  setFieldValue("documentDetails[".concat(idx, "].dragCounter"), (values === null || values === void 0 ? void 0 : (_values$documentDetai44 = values.documentDetails[idx]) === null || _values$documentDetai44 === void 0 ? void 0 : _values$documentDetai44.dragCounter) + 1);

                  if ((evt === null || evt === void 0 ? void 0 : (_evt$dataTransfer = evt.dataTransfer) === null || _evt$dataTransfer === void 0 ? void 0 : (_evt$dataTransfer$ite = _evt$dataTransfer.items) === null || _evt$dataTransfer$ite === void 0 ? void 0 : _evt$dataTransfer$ite.length) > 0) {
                    setFieldValue("documentDetails[".concat(idx, "].dragging"), true);
                  }
                }
              },
              onDragLeave: function onDragLeave(evt) {
                var _values$documentDetai45;

                evt.preventDefault();
                evt.stopPropagation();

                if (values !== null && values !== void 0 && (_values$documentDetai45 = values.documentDetails[idx]) !== null && _values$documentDetai45 !== void 0 && _values$documentDetai45.documentName) {
                  var _values$documentDetai46, _values$documentDetai47;

                  if ((values === null || values === void 0 ? void 0 : (_values$documentDetai46 = values.documentDetails[idx]) === null || _values$documentDetai46 === void 0 ? void 0 : _values$documentDetai46.dragCounter) === 1) {
                    setFieldValue("documentDetails[".concat(idx, "].dragging"), false);
                  }

                  setFieldValue("documentDetails[".concat(idx, "].dragCounter"), (values === null || values === void 0 ? void 0 : (_values$documentDetai47 = values.documentDetails[idx]) === null || _values$documentDetai47 === void 0 ? void 0 : _values$documentDetai47.dragCounter) - 1);
                }
              },
              onDragOver: function onDragOver(evt) {
                evt.preventDefault();
                evt.stopPropagation();
              },
              onDrop: function onDrop(evt) {
                var _values$documentDetai48, _evt$dataTransfer2, _evt$dataTransfer2$fi;

                evt.preventDefault();
                evt.stopPropagation();

                if (values !== null && values !== void 0 && (_values$documentDetai48 = values.documentDetails[idx]) !== null && _values$documentDetai48 !== void 0 && _values$documentDetai48.documentName && (evt === null || evt === void 0 ? void 0 : (_evt$dataTransfer2 = evt.dataTransfer) === null || _evt$dataTransfer2 === void 0 ? void 0 : (_evt$dataTransfer2$fi = _evt$dataTransfer2.files) === null || _evt$dataTransfer2$fi === void 0 ? void 0 : _evt$dataTransfer2$fi.length) > 0) {
                  if (documentExtensions !== null && documentExtensions !== void 0 && documentExtensions.find(function (extension) {
                    var _extension$value, _extension$value$toSt, _evt$dataTransfer3, _evt$dataTransfer3$fi, _evt$dataTransfer3$fi2, _evt$dataTransfer3$fi3, _evt$dataTransfer3$fi4;

                    return (extension === null || extension === void 0 ? void 0 : (_extension$value = extension.value) === null || _extension$value === void 0 ? void 0 : (_extension$value$toSt = _extension$value.toString()) === null || _extension$value$toSt === void 0 ? void 0 : _extension$value$toSt.toLowerCase()) === (evt === null || evt === void 0 ? void 0 : (_evt$dataTransfer3 = evt.dataTransfer) === null || _evt$dataTransfer3 === void 0 ? void 0 : (_evt$dataTransfer3$fi = _evt$dataTransfer3.files[0]) === null || _evt$dataTransfer3$fi === void 0 ? void 0 : (_evt$dataTransfer3$fi2 = _evt$dataTransfer3$fi.name) === null || _evt$dataTransfer3$fi2 === void 0 ? void 0 : (_evt$dataTransfer3$fi3 = _evt$dataTransfer3$fi2.split('.').pop()) === null || _evt$dataTransfer3$fi3 === void 0 ? void 0 : (_evt$dataTransfer3$fi4 = _evt$dataTransfer3$fi3.toString()) === null || _evt$dataTransfer3$fi4 === void 0 ? void 0 : _evt$dataTransfer3$fi4.toLowerCase());
                  })) {
                    var _evt$dataTransfer4;

                    var reader = new FileReader();
                    var file = evt === null || evt === void 0 ? void 0 : (_evt$dataTransfer4 = evt.dataTransfer) === null || _evt$dataTransfer4 === void 0 ? void 0 : _evt$dataTransfer4.files[0];

                    if ((file === null || file === void 0 ? void 0 : file.size) / 1024 <= parseFloat(docFileSizeLimit === null || docFileSizeLimit === void 0 ? void 0 : docFileSizeLimit.code)) {
                      var _documentExtensions$f, _parseFloat, _parseFloat2, _file$name2, _uploadDocRef$current;

                      setFieldValue("documentDetails[".concat(idx, "].documentExtension"), documentExtensions === null || documentExtensions === void 0 ? void 0 : (_documentExtensions$f = documentExtensions.find(function (extension) {
                        var _extension$value2, _extension$value2$toS, _file$name, _file$name$split$pop, _file$name$split$pop$;

                        return (extension === null || extension === void 0 ? void 0 : (_extension$value2 = extension.value) === null || _extension$value2 === void 0 ? void 0 : (_extension$value2$toS = _extension$value2.toString()) === null || _extension$value2$toS === void 0 ? void 0 : _extension$value2$toS.toLowerCase()) === (file === null || file === void 0 ? void 0 : (_file$name = file.name) === null || _file$name === void 0 ? void 0 : (_file$name$split$pop = _file$name.split('.').pop()) === null || _file$name$split$pop === void 0 ? void 0 : (_file$name$split$pop$ = _file$name$split$pop.toString()) === null || _file$name$split$pop$ === void 0 ? void 0 : _file$name$split$pop$.toLowerCase());
                      })) === null || _documentExtensions$f === void 0 ? void 0 : _documentExtensions$f.code);
                      setFieldValue("documentDetails[".concat(idx, "].documentSize"), parseFloat((_parseFloat = parseFloat((file === null || file === void 0 ? void 0 : file.size) / 1024)) === null || _parseFloat === void 0 ? void 0 : _parseFloat.toFixed(2)));
                      setFieldValue("documentDetails[".concat(idx, "].documentSizeinKB"), "".concat(parseFloat((_parseFloat2 = parseFloat((file === null || file === void 0 ? void 0 : file.size) / 1024)) === null || _parseFloat2 === void 0 ? void 0 : _parseFloat2.toFixed(2)), " Kb"));
                      setFieldValue("documentDetails[".concat(idx, "].documentFileName"), file === null || file === void 0 ? void 0 : (_file$name2 = file.name) === null || _file$name2 === void 0 ? void 0 : _file$name2.split('.')[0]);
                      setFieldValue("documentDetails[".concat(idx, "].documentFileNameWithExtension"), file === null || file === void 0 ? void 0 : file.name);
                      reader.readAsDataURL(file);

                      reader.onload = function () {
                        setFieldValue("documentDetails[".concat(idx, "].documentBase64String"), reader.result);
                      }; //evt.dataTransfer.clearData();


                      //evt.dataTransfer.clearData();
                      setFieldValue("documentDetails[".concat(idx, "].dragCounter"), 0);
                      setFieldValue("documentDetails[".concat(idx, "].dragging"), false);
                      uploadDocRef.current = _toConsumableArray(uploadDocRef === null || uploadDocRef === void 0 ? void 0 : (_uploadDocRef$current = uploadDocRef.current) === null || _uploadDocRef$current === void 0 ? void 0 : _uploadDocRef$current.filter(function (ref) {
                        var _ref$id;

                        return parseInt(ref === null || ref === void 0 ? void 0 : (_ref$id = ref.id) === null || _ref$id === void 0 ? void 0 : _ref$id.toString()) !== idx;
                      }));
                    } else {
                      setAlerts([{
                        id: Date.now(),
                        header: 'Error fetching document',
                        content: /*#__PURE__*/React.createElement(Text, null, "File size is larger than", ' ', docFileSizeLimit === null || docFileSizeLimit === void 0 ? void 0 : docFileSizeLimit.value),
                        type: 'error',
                        timeout: 4000,
                        disableClose: false
                      }]);
                      setFieldValue("documentDetails[".concat(idx, "].dragCounter"), 0);
                      setFieldValue("documentDetails[".concat(idx, "].dragging"), false);
                      uploadDocRef.current = [];
                    }
                  } else {
                    var _uploadDocRef$current2;

                    //evt.dataTransfer.clearData();
                    setFieldValue("documentDetails[".concat(idx, "].dragCounter"), 0);
                    setFieldValue("documentDetails[".concat(idx, "].dragging"), false);
                    setAlerts([{
                      id: Date.now(),
                      content: /*#__PURE__*/React.createElement(Text, null, "Input file Format is not supported"),
                      type: 'error',
                      disableClose: false,
                      timeout: 4000
                    }].concat(_toConsumableArray(alerts)));
                    uploadDocRef.current = _toConsumableArray(uploadDocRef === null || uploadDocRef === void 0 ? void 0 : (_uploadDocRef$current2 = uploadDocRef.current) === null || _uploadDocRef$current2 === void 0 ? void 0 : _uploadDocRef$current2.filter(function (ref) {
                      var _ref$id2;

                      return parseInt(ref === null || ref === void 0 ? void 0 : (_ref$id2 = ref.id) === null || _ref$id2 === void 0 ? void 0 : _ref$id2.toString()) !== idx;
                    }));
                  }
                }
              },
              className: "w-full my-1 border-2 border-dotted border-secondary justify-center flex flex-col ".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString3 = screenType.toString()) === null || _screenType$toString3 === void 0 ? void 0 : _screenType$toString3.toLowerCase()) === 'mobile' ? 'flex-wrap' : '', " p-4")
            }, /*#__PURE__*/React.createElement(Text, {
              className: values !== null && values !== void 0 && (_values$documentDetai49 = values.documentDetails[idx]) !== null && _values$documentDetai49 !== void 0 && _values$documentDetai49.dragging ? 'text-2xl text-neutral-darker flex justify-center' : ''
            }, values !== null && values !== void 0 && (_values$documentDetai50 = values.documentDetails[idx]) !== null && _values$documentDetai50 !== void 0 && _values$documentDetai50.dragging ? 'Drop here' : values !== null && values !== void 0 && (_values$documentDetai51 = values.documentDetails[idx]) !== null && _values$documentDetai51 !== void 0 && _values$documentDetai51.documentFileName ? /*#__PURE__*/React.createElement(Text, {
              className: 'flex flex-col'
            }, /*#__PURE__*/React.createElement(Text, {
              className: 'flex flex-wrap'
            }, /*#__PURE__*/React.createElement(Text, null, "File Name:\xA0"), /*#__PURE__*/React.createElement(Text, {
              severity: 'info',
              className: 'font-semibold break-normal'
            }, "".concat(values === null || values === void 0 ? void 0 : (_values$documentDetai52 = values.documentDetails[idx]) === null || _values$documentDetai52 === void 0 ? void 0 : _values$documentDetai52.documentFileName, ".").concat(documentExtensions === null || documentExtensions === void 0 ? void 0 : (_documentExtensions$f2 = documentExtensions.find(function (extension) {
              var _extension$code, _extension$code$toStr, _values$documentDetai53, _values$documentDetai54, _values$documentDetai55;

              return (extension === null || extension === void 0 ? void 0 : (_extension$code = extension.code) === null || _extension$code === void 0 ? void 0 : (_extension$code$toStr = _extension$code.toString()) === null || _extension$code$toStr === void 0 ? void 0 : _extension$code$toStr.toLowerCase()) === (values === null || values === void 0 ? void 0 : (_values$documentDetai53 = values.documentDetails[idx]) === null || _values$documentDetai53 === void 0 ? void 0 : (_values$documentDetai54 = _values$documentDetai53.documentExtension) === null || _values$documentDetai54 === void 0 ? void 0 : (_values$documentDetai55 = _values$documentDetai54.toString()) === null || _values$documentDetai55 === void 0 ? void 0 : _values$documentDetai55.toLowerCase());
            })) === null || _documentExtensions$f2 === void 0 ? void 0 : _documentExtensions$f2.value))), /*#__PURE__*/React.createElement(Text, null, "File Size:\xA0", /*#__PURE__*/React.createElement(Text, {
              className: 'font-semibold'
            }, "".concat(values === null || values === void 0 ? void 0 : (_values$documentDetai56 = values.documentDetails[idx]) === null || _values$documentDetai56 === void 0 ? void 0 : _values$documentDetai56.documentSize), ' ', "KB"))) : "".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString4 = screenType.toString()) === null || _screenType$toString4 === void 0 ? void 0 : _screenType$toString4.toLowerCase()) !== 'desktop' ? 'Click the browse button to select a file' : "Drag and drop your document here to\n                                  upload. Alternatively you can browse\n                                  the file by clicking the button")), !(values !== null && values !== void 0 && (_values$documentDetai57 = values.documentDetails[idx]) !== null && _values$documentDetai57 !== void 0 && _values$documentDetai57.dragging) && !(values !== null && values !== void 0 && (_values$documentDetai58 = values.documentDetails[idx]) !== null && _values$documentDetai58 !== void 0 && _values$documentDetai58.documentFileName) ? /*#__PURE__*/React.createElement(Text, {
              className: "flex ".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString5 = screenType.toString()) === null || _screenType$toString5 === void 0 ? void 0 : _screenType$toString5.toLowerCase()) === 'mobile' ? 'flex-col space-y-2' : 'space-x-2', " justify-end ").concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString6 = screenType.toString()) === null || _screenType$toString6 === void 0 ? void 0 : _screenType$toString6.toLowerCase()) === 'mobile' ? 'w-full mt-4' : '')
            }, (values === null || values === void 0 ? void 0 : (_values$documentDetai59 = values.documentDetails) === null || _values$documentDetai59 === void 0 ? void 0 : _values$documentDetai59.length) > 1 && /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Button, {
              size: 'small',
              flat: true,
              className: "h-10 w-24 w-".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString7 = screenType.toString()) === null || _screenType$toString7 === void 0 ? void 0 : _screenType$toString7.toLowerCase()) === 'mobile' ? 'full' : '24'),
              onClick: function onClick(_) {
                var _values$documentDetai60;

                if ((values === null || values === void 0 ? void 0 : (_values$documentDetai60 = values.documentDetails) === null || _values$documentDetai60 === void 0 ? void 0 : _values$documentDetai60.length) > 1) {
                  var _values$documentDetai61, _values$documentDetai62, _uploadDocRef$current3;

                  setFieldValue("documentDetails", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : (_values$documentDetai61 = values.documentDetails) === null || _values$documentDetai61 === void 0 ? void 0 : _values$documentDetai61.slice(0, idx)), _toConsumableArray(values === null || values === void 0 ? void 0 : (_values$documentDetai62 = values.documentDetails) === null || _values$documentDetai62 === void 0 ? void 0 : _values$documentDetai62.slice(idx + 1))));
                  uploadDocRef.current = _toConsumableArray(uploadDocRef === null || uploadDocRef === void 0 ? void 0 : (_uploadDocRef$current3 = uploadDocRef.current) === null || _uploadDocRef$current3 === void 0 ? void 0 : _uploadDocRef$current3.filter(function (ref) {
                    var _ref$id3;

                    return parseInt(ref === null || ref === void 0 ? void 0 : (_ref$id3 = ref.id) === null || _ref$id3 === void 0 ? void 0 : _ref$id3.toString()) !== idx;
                  }));
                }
              }
            }, "Cancel")), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Button, {
              size: 'small',
              type: 'button',
              flat: false,
              className: "h-10 w-24 w-".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString8 = screenType.toString()) === null || _screenType$toString8 === void 0 ? void 0 : _screenType$toString8.toLowerCase()) === 'mobile' ? 'full' : '24'),
              disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi13 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi13 === void 0 ? void 0 : (_buyHealthPolicy$addi14 = _buyHealthPolicy$addi13.status) === null || _buyHealthPolicy$addi14 === void 0 ? void 0 : (_buyHealthPolicy$addi15 = _buyHealthPolicy$addi14.toString()) === null || _buyHealthPolicy$addi15 === void 0 ? void 0 : _buyHealthPolicy$addi15.toLowerCase()) === 'quote saved' || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi16 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi16 === void 0 ? void 0 : (_buyHealthPolicy$addi17 = _buyHealthPolicy$addi16.status) === null || _buyHealthPolicy$addi17 === void 0 ? void 0 : (_buyHealthPolicy$addi18 = _buyHealthPolicy$addi17.toString()) === null || _buyHealthPolicy$addi18 === void 0 ? void 0 : _buyHealthPolicy$addi18.toLowerCase()) === 'converted to proposal' || !(values !== null && values !== void 0 && (_values$documentDetai63 = values.documentDetails[idx]) !== null && _values$documentDetai63 !== void 0 && _values$documentDetai63.documentName) ? true : false,
              onClick: function onClick(_) {
                var _uploadDocRef$current4, _uploadDocRef$current5;

                uploadDocRef === null || uploadDocRef === void 0 ? void 0 : (_uploadDocRef$current4 = uploadDocRef.current) === null || _uploadDocRef$current4 === void 0 ? void 0 : (_uploadDocRef$current5 = _uploadDocRef$current4.find(function (ref) {
                  var _ref$id4;

                  return parseInt(ref === null || ref === void 0 ? void 0 : (_ref$id4 = ref.id) === null || _ref$id4 === void 0 ? void 0 : _ref$id4.toString()) === idx;
                })) === null || _uploadDocRef$current5 === void 0 ? void 0 : _uploadDocRef$current5.click();
              }
            }, "Browse", /*#__PURE__*/React.createElement("input", {
              key: idx,
              id: idx,
              ref: function ref(_ref5) {
                var _values$documentDetai64, _uploadDocRef$current6;

                if (values !== null && values !== void 0 && (_values$documentDetai64 = values.documentDetails[idx]) !== null && _values$documentDetai64 !== void 0 && _values$documentDetai64.documentName && !(uploadDocRef !== null && uploadDocRef !== void 0 && (_uploadDocRef$current6 = uploadDocRef.current) !== null && _uploadDocRef$current6 !== void 0 && _uploadDocRef$current6.find(function (r) {
                  return (r === null || r === void 0 ? void 0 : r.id) === (_ref5 === null || _ref5 === void 0 ? void 0 : _ref5.id);
                })) && _ref5) {
                  var _uploadDocRef$current7;

                  uploadDocRef === null || uploadDocRef === void 0 ? void 0 : (_uploadDocRef$current7 = uploadDocRef.current) === null || _uploadDocRef$current7 === void 0 ? void 0 : _uploadDocRef$current7.push(_ref5);
                }
              },
              className: "hidden",
              type: "file",
              accept: "".concat(documentExtensions === null || documentExtensions === void 0 ? void 0 : (_documentExtensions$m = documentExtensions.map(function (extension) {
                return ".".concat(extension === null || extension === void 0 ? void 0 : extension.value);
              })) === null || _documentExtensions$m === void 0 ? void 0 : _documentExtensions$m.join(',')) // disabled={
              //   !values?.documentDetails[idx]
              //     ?.documentName
              //     ? true
              //     : false
              // }
              ,
              // disabled={
              //   !values?.documentDetails[idx]
              //     ?.documentName
              //     ? true
              //     : false
              // }
              onChange: function onChange(evt) {
                var _evt$target7, _evt$target7$files;

                if ((evt === null || evt === void 0 ? void 0 : (_evt$target7 = evt.target) === null || _evt$target7 === void 0 ? void 0 : (_evt$target7$files = _evt$target7.files) === null || _evt$target7$files === void 0 ? void 0 : _evt$target7$files.length) > 0) {
                  var _evt$target8;

                  var reader = new FileReader();
                  var file = evt === null || evt === void 0 ? void 0 : (_evt$target8 = evt.target) === null || _evt$target8 === void 0 ? void 0 : _evt$target8.files[0];

                  if ((file === null || file === void 0 ? void 0 : file.size) / 1024 <= parseFloat(docFileSizeLimit === null || docFileSizeLimit === void 0 ? void 0 : docFileSizeLimit.code)) {
                    var _documentExtensions$f3, _parseFloat3, _parseFloat4, _file$name4, _uploadDocRef$current8;

                    setFieldValue("documentDetails[".concat(idx, "].documentExtension"), documentExtensions === null || documentExtensions === void 0 ? void 0 : (_documentExtensions$f3 = documentExtensions.find(function (extension) {
                      var _extension$value3, _extension$value3$toS, _file$name3, _file$name3$split$pop, _file$name3$split$pop2;

                      return (extension === null || extension === void 0 ? void 0 : (_extension$value3 = extension.value) === null || _extension$value3 === void 0 ? void 0 : (_extension$value3$toS = _extension$value3.toString()) === null || _extension$value3$toS === void 0 ? void 0 : _extension$value3$toS.toLowerCase()) === (file === null || file === void 0 ? void 0 : (_file$name3 = file.name) === null || _file$name3 === void 0 ? void 0 : (_file$name3$split$pop = _file$name3.split('.').pop()) === null || _file$name3$split$pop === void 0 ? void 0 : (_file$name3$split$pop2 = _file$name3$split$pop.toString()) === null || _file$name3$split$pop2 === void 0 ? void 0 : _file$name3$split$pop2.toLowerCase());
                    })) === null || _documentExtensions$f3 === void 0 ? void 0 : _documentExtensions$f3.code);
                    setFieldValue("documentDetails[".concat(idx, "].documentSize"), parseFloat((_parseFloat3 = parseFloat((file === null || file === void 0 ? void 0 : file.size) / 1024)) === null || _parseFloat3 === void 0 ? void 0 : _parseFloat3.toFixed(2)));
                    setFieldValue("documentDetails[".concat(idx, "].documentSizeinKB"), "".concat(parseFloat((_parseFloat4 = parseFloat((file === null || file === void 0 ? void 0 : file.size) / 1024)) === null || _parseFloat4 === void 0 ? void 0 : _parseFloat4.toFixed(2)), " Kb"));
                    setFieldValue("documentDetails[".concat(idx, "].documentFileName"), file === null || file === void 0 ? void 0 : (_file$name4 = file.name) === null || _file$name4 === void 0 ? void 0 : _file$name4.split('.')[0]);
                    setFieldValue("documentDetails[".concat(idx, "].documentFileNameWithExtension"), file === null || file === void 0 ? void 0 : file.name);
                    reader.readAsDataURL(file);

                    reader.onload = function () {
                      setFieldValue("documentDetails[".concat(idx, "].documentBase64String"), reader.result);
                    };

                    setFieldValue("documentDetails[".concat(idx, "].dragCounter"), 0);
                    uploadDocRef.current = _toConsumableArray(uploadDocRef === null || uploadDocRef === void 0 ? void 0 : (_uploadDocRef$current8 = uploadDocRef.current) === null || _uploadDocRef$current8 === void 0 ? void 0 : _uploadDocRef$current8.filter(function (ref) {
                      var _ref$id5;

                      return parseInt(ref === null || ref === void 0 ? void 0 : (_ref$id5 = ref.id) === null || _ref$id5 === void 0 ? void 0 : _ref$id5.toString()) !== idx;
                    }));
                  } else {
                    setAlerts([{
                      id: Date.now(),
                      header: 'Error fetching document',
                      content: /*#__PURE__*/React.createElement(Text, null, "File size is larger than", ' ', docFileSizeLimit === null || docFileSizeLimit === void 0 ? void 0 : docFileSizeLimit.value),
                      type: 'error',
                      timeout: 4000,
                      disableClose: false
                    }]);
                    uploadDocRef.current = [];
                  }
                }

                evt.target.value = '';
              }
            })))) : values !== null && values !== void 0 && (_values$documentDetai65 = values.documentDetails[idx]) !== null && _values$documentDetai65 !== void 0 && _values$documentDetai65.documentFileName && !(values !== null && values !== void 0 && (_values$documentDetai66 = values.documentDetails[idx]) !== null && _values$documentDetai66 !== void 0 && _values$documentDetai66.dragging) ? /*#__PURE__*/React.createElement(Text, {
              className: (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString9 = screenType.toString()) === null || _screenType$toString9 === void 0 ? void 0 : _screenType$toString9.toLowerCase()) === 'mobile' ? 'w-full mt-4' : '',
              severity: 'action'
            }, /*#__PURE__*/React.createElement(Text, {
              className: "flex ".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString10 = screenType.toString()) === null || _screenType$toString10 === void 0 ? void 0 : _screenType$toString10.toLowerCase()) === 'mobile' ? 'flex-col space-y-2' : 'space-x-2', " justify-end ").concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString11 = screenType.toString()) === null || _screenType$toString11 === void 0 ? void 0 : _screenType$toString11.toLowerCase()) === 'mobile' ? 'w-full mt-4' : '')
            }, (values === null || values === void 0 ? void 0 : (_values$documentDetai67 = values.documentDetails) === null || _values$documentDetai67 === void 0 ? void 0 : _values$documentDetai67.length) > 1 && /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Button, {
              size: 'small',
              flat: true,
              className: "h-10 w-24 w-".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString12 = screenType.toString()) === null || _screenType$toString12 === void 0 ? void 0 : _screenType$toString12.toLowerCase()) === 'mobile' ? 'full' : '24'),
              onClick: function onClick(_) {
                var _values$documentDetai68;

                if ((values === null || values === void 0 ? void 0 : (_values$documentDetai68 = values.documentDetails) === null || _values$documentDetai68 === void 0 ? void 0 : _values$documentDetai68.length) > 1) {
                  var _values$documentDetai69, _values$documentDetai70, _uploadDocRef$current9;

                  setFieldValue("documentDetails", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : (_values$documentDetai69 = values.documentDetails) === null || _values$documentDetai69 === void 0 ? void 0 : _values$documentDetai69.slice(0, idx)), _toConsumableArray(values === null || values === void 0 ? void 0 : (_values$documentDetai70 = values.documentDetails) === null || _values$documentDetai70 === void 0 ? void 0 : _values$documentDetai70.slice(idx + 1))));
                  uploadDocRef.current = _toConsumableArray(uploadDocRef === null || uploadDocRef === void 0 ? void 0 : (_uploadDocRef$current9 = uploadDocRef.current) === null || _uploadDocRef$current9 === void 0 ? void 0 : _uploadDocRef$current9.filter(function (ref) {
                    var _ref$id6;

                    return parseInt(ref === null || ref === void 0 ? void 0 : (_ref$id6 = ref.id) === null || _ref$id6 === void 0 ? void 0 : _ref$id6.toString()) !== idx;
                  }));
                }
              }
            }, "Cancel")), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Button, {
              disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi19 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi19 === void 0 ? void 0 : (_buyHealthPolicy$addi20 = _buyHealthPolicy$addi19.status) === null || _buyHealthPolicy$addi20 === void 0 ? void 0 : (_buyHealthPolicy$addi21 = _buyHealthPolicy$addi20.toString()) === null || _buyHealthPolicy$addi21 === void 0 ? void 0 : _buyHealthPolicy$addi21.toLowerCase()) === 'quote saved' || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi22 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi22 === void 0 ? void 0 : (_buyHealthPolicy$addi23 = _buyHealthPolicy$addi22.status) === null || _buyHealthPolicy$addi23 === void 0 ? void 0 : (_buyHealthPolicy$addi24 = _buyHealthPolicy$addi23.toString()) === null || _buyHealthPolicy$addi24 === void 0 ? void 0 : _buyHealthPolicy$addi24.toLowerCase()) === 'pending uw approval' || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi25 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi25 === void 0 ? void 0 : (_buyHealthPolicy$addi26 = _buyHealthPolicy$addi25.status) === null || _buyHealthPolicy$addi26 === void 0 ? void 0 : (_buyHealthPolicy$addi27 = _buyHealthPolicy$addi26.toString()) === null || _buyHealthPolicy$addi27 === void 0 ? void 0 : _buyHealthPolicy$addi27.toLowerCase()) === 'underwriter rejected' || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi28 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi28 === void 0 ? void 0 : (_buyHealthPolicy$addi29 = _buyHealthPolicy$addi28.status) === null || _buyHealthPolicy$addi29 === void 0 ? void 0 : (_buyHealthPolicy$addi30 = _buyHealthPolicy$addi29.toString()) === null || _buyHealthPolicy$addi30 === void 0 ? void 0 : _buyHealthPolicy$addi30.toLowerCase()) === 'underwriter approved' || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi31 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi31 === void 0 ? void 0 : (_buyHealthPolicy$addi32 = _buyHealthPolicy$addi31.status) === null || _buyHealthPolicy$addi32 === void 0 ? void 0 : (_buyHealthPolicy$addi33 = _buyHealthPolicy$addi32.toString()) === null || _buyHealthPolicy$addi33 === void 0 ? void 0 : _buyHealthPolicy$addi33.toLowerCase()) === 'converted to proposal',
              size: 'small',
              flat: true,
              className: "h-10 w-24 w-".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString13 = screenType.toString()) === null || _screenType$toString13 === void 0 ? void 0 : _screenType$toString13.toLowerCase()) === 'mobile' ? 'full' : '24'),
              onClick: function onClick(_) {
                setFieldValue("documentDetails[".concat(idx, "].documentFileName"), '');
                setFieldValue("documentDetails[".concat(idx, "].documentFileNameWithExtension"), '');
                setFieldValue("documentDetails[".concat(idx, "].documentExtension"), '');
                setFieldValue("documentDetails[".concat(idx, "].documentSize"), null);
                setFieldValue("documentDetails[".concat(idx, "].documentSizeinKB"), '');
                setFieldValue("documentDetails[".concat(idx, "].dragging"), false);
                setFieldValue("documentDetails[".concat(idx, "].dragCounter"), 0);
                setFieldValue("documentDetails[".concat(idx, "].documentBase64String"), '');
              }
            }, "Delete")))) : null)));
          }
        };
      })) === null || _values$documentDetai38 === void 0 ? void 0 : _values$documentDetai38.filter(function (d) {
        return d;
      }) : []), [{
        type: 'render',
        colSpan: repeat,
        component: function component() {
          var _screenType$toString14, _buyHealthPolicy$addi34, _buyHealthPolicy$addi35, _buyHealthPolicy$addi36, _buyHealthPolicy$addi37, _buyHealthPolicy$addi38, _buyHealthPolicy$addi39, _buyHealthPolicy$addi40, _buyHealthPolicy$addi41, _buyHealthPolicy$addi42, _buyHealthPolicy$addi43, _buyHealthPolicy$addi44, _buyHealthPolicy$addi45, _buyHealthPolicy$addi46, _buyHealthPolicy$addi47, _buyHealthPolicy$addi48;

          return /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col w-full space-y-2'
          }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Button, {
            flat: true,
            size: 'small',
            className: (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString14 = screenType.toString()) === null || _screenType$toString14 === void 0 ? void 0 : _screenType$toString14.toLowerCase()) === 'mobile' ? 'w-full h-10' : 'h-10',
            disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi34 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi34 === void 0 ? void 0 : (_buyHealthPolicy$addi35 = _buyHealthPolicy$addi34.status) === null || _buyHealthPolicy$addi35 === void 0 ? void 0 : (_buyHealthPolicy$addi36 = _buyHealthPolicy$addi35.toString()) === null || _buyHealthPolicy$addi36 === void 0 ? void 0 : _buyHealthPolicy$addi36.toLowerCase()) === 'quote saved' || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi37 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi37 === void 0 ? void 0 : (_buyHealthPolicy$addi38 = _buyHealthPolicy$addi37.status) === null || _buyHealthPolicy$addi38 === void 0 ? void 0 : (_buyHealthPolicy$addi39 = _buyHealthPolicy$addi38.toString()) === null || _buyHealthPolicy$addi39 === void 0 ? void 0 : _buyHealthPolicy$addi39.toLowerCase()) === 'pending uw approval' || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi40 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi40 === void 0 ? void 0 : (_buyHealthPolicy$addi41 = _buyHealthPolicy$addi40.status) === null || _buyHealthPolicy$addi41 === void 0 ? void 0 : (_buyHealthPolicy$addi42 = _buyHealthPolicy$addi41.toString()) === null || _buyHealthPolicy$addi42 === void 0 ? void 0 : _buyHealthPolicy$addi42.toLowerCase()) === 'underwriter rejected' || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi43 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi43 === void 0 ? void 0 : (_buyHealthPolicy$addi44 = _buyHealthPolicy$addi43.status) === null || _buyHealthPolicy$addi44 === void 0 ? void 0 : (_buyHealthPolicy$addi45 = _buyHealthPolicy$addi44.toString()) === null || _buyHealthPolicy$addi45 === void 0 ? void 0 : _buyHealthPolicy$addi45.toLowerCase()) === 'underwriter approved' || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$addi46 = buyHealthPolicy.additionalTabDetails) === null || _buyHealthPolicy$addi46 === void 0 ? void 0 : (_buyHealthPolicy$addi47 = _buyHealthPolicy$addi46.status) === null || _buyHealthPolicy$addi47 === void 0 ? void 0 : (_buyHealthPolicy$addi48 = _buyHealthPolicy$addi47.toString()) === null || _buyHealthPolicy$addi48 === void 0 ? void 0 : _buyHealthPolicy$addi48.toLowerCase()) === 'converted to proposal',
            onClick: function onClick(_) {
              setFieldValue('documentDetails', [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.documentDetails), [{
                documentDescription: '',
                documentName: '',
                documentNameValue: '',
                documentFileName: '',
                documentFileNameWithExtension: '',
                documentExtension: '',
                documentSize: null,
                documentSizeinKB: '',
                dragging: false,
                dragCounter: 0,
                documentBase64String: ''
              }]));
            }
          }, "Add More Document")));
        }
      }])
    } : null].filter(function (d) {
      return d;
    });
    var other_props = {
      flow: 'cols',
      repeat: repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true
    };
    var uploadDocumentsDataProps = {
      flow: 'cols',
      repeat: repeat,
      gapX: 4,
      gapY: 4,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info'
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaForm, {
      className: "-space-y-2 mt-3"
    }, /*#__PURE__*/React.createElement(InputGridGroup, _objectSpread2({
      data: data
    }, other_props)), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col space-y-4"
    }, /*#__PURE__*/React.createElement(Text, {
      severity: "info",
      type: "title",
      className: "mt-6"
    }, "Previous Insurance Details"), /*#__PURE__*/React.createElement(InputGridGroup, _objectSpread2({
      data: prevInsuredDetailsData
    }, other_props))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col space-y-4"
    }, /*#__PURE__*/React.createElement(Text, {
      severity: "info",
      type: "title",
      className: "mt-6"
    }, productCode.toString() !== '2885' ? 'Renew Mandate Details' : null), /*#__PURE__*/React.createElement(InputGridGroup, _objectSpread2({
      data: renewalMandateDetails
    }, other_props))), /*#__PURE__*/React.createElement(InputGridGroup, _objectSpread2({
      data: healthDeclarationData
    }, otherPropsWithoutExpanded)), /*#__PURE__*/React.createElement(Button, {
      type: "button",
      disabled: values.isHealthDeclarationSelected === 'No',
      flat: true,
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faFileMedical,
        className: values.isHealthDeclarationSelected === 'No' ? 'mr-1' : 'ml-2 mr-1'
      }),
      onClick: function onClick(_) {
        return setMedicalQuestionaireDisplay(true);
      }
    }, ' ', "Medical Questionaire"), /*#__PURE__*/React.createElement(React.Fragment, null, productCode.toString() === '2883' && !(buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.proposalNumber) && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col space-y-4"
    }, /*#__PURE__*/React.createElement(Text, {
      severity: "info",
      type: "title",
      className: "mt-6"
    }, "Upload Documents"), /*#__PURE__*/React.createElement(InputGridGroup, _objectSpread2({
      data: uploadDocumentsData
    }, uploadDocumentsDataProps)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NotificationList, {
      items: alerts
    }))), customWarningMsg && /*#__PURE__*/React.createElement("div", {
      className: "mt-6"
    }, /*#__PURE__*/React.createElement(Text, {
      severity: 'error',
      className: 'flex space-x-2 items-center my-2 '
    }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faExclamationTriangle
    })), /*#__PURE__*/React.createElement(Text, null, customWarningMsg))), /*#__PURE__*/React.createElement(SearchResultsModal, {
      modalDisplay: ifscModalDisplay,
      searchInput: searchInput,
      searchResults: searchResults,
      paginationInput: paginationInput,
      title: 'Search IFSC Code',
      onClose: onClose,
      onDataUpdate: onDataUpdate,
      onNoResultsFound: onNoResultsFound,
      onMessage: onMessage,
      selectOnRowClick: true,
      firstRowClickRequired: false
    }));
  };

  var submitNomineeArr = function submitNomineeArr(values) {
    var submitArr = [];
    var prevInsuredArr = [];
    Object.keys(values).forEach(function (m) {
      if (_typeof(values[m]) === 'object') {
        var _values$m = values[m],
            _prevInsuranceDetails2 = _values$m.prevInsuranceDetails,
            restValues = _objectWithoutProperties(_values$m, _excluded3$1);

        if (m === 'documentDetails') ; else {
          submitArr.push(_objectSpread2({
            relationship: m
          }, restValues));
        }

        prevInsuredArr.push(_prevInsuranceDetails2);
      }
    });
    return {
      nomineeDetails: submitArr,
      prevInsuranceDetails: prevInsuredArr,
      sameNomineeForAllInsured: values.sameNomineeForAllInsured,
      isHealthDeclarationSelected: values.isHealthDeclarationSelected,
      renewalMandateDetails: {
        renewalPaymentMandate: productCode.toString() === '2885' ? false : values === null || values === void 0 ? void 0 : values.renewalPaymentMandate,
        renewalPaymentMandateTakenInNameOf: values.renewalPaymentMandateTakenInNameOf,
        termForMandateOpted: values.termForMandateOpted,
        typeOfDebit: values.typeOfDebit,
        accountNumber: values.accountNumber,
        destinationBankName: values.destinationBankName,
        destinationIfscCode: values.destinationIfscCode,
        destinationMicrCode: values.destinationMicrCode,
        destinationBranchName: values.destinationBranchName,
        mandateAmount: renew_man_amount,
        finalCollectionDate: values.finalCollectionDate,
        destinationBankAccountType: values.destinationBankAccountType
      }
    };
  };

  var calculatePremiumForProposalVariables = function calculatePremiumForProposalVariables(buyHealthPolicyData, getDateTimeData, values) {
    var _buyHealthPolicyData$3, _buyHealthPolicyData$4, _buyHealthPolicyData$5, _values$isHealthDecla, _buyHealthPolicyData$6, _buyHealthPolicyData$7, _buyHealthPolicyData$8, _buyHealthPolicyData$9, _buyHealthPolicyData$10, _buyHealthPolicyData$11, _buyHealthPolicyData$12, _buyHealthPolicyData$13, _buyHealthPolicyData$14, _getDateTimeData$date, _buyHealthPolicyData$15, _buyHealthPolicyData$16, _buyHealthPolicyData$17, _buyHealthPolicyData$18, _values$isHealthDecla2, _buyHealthPolicy$quot6, _buyHealthPolicy$quot7, _buyHealthPolicyData$19, _buyHealthPolicyData$20, _buyHealthPolicyData$21;

    var getInsuredDetailsObj = function getInsuredDetailsObj(insuredDetails, medicalQuestionaire, planData, isHealthDeclarationSelected) {
      var _insuredDetailsRespon, _insuredDetailsRespon2;

      var _submitNomineeArr = submitNomineeArr(values),
          nomineeDetails = _submitNomineeArr.nomineeDetails;

      var insuredDetailsResponseArr = [];
      insuredDetails.forEach(function (insured) {
        var _values$insured$relat, _prevInsuranceInput$p, _medicalQuestionaireO, _medicalQuestionaireO2, _plans$find2, _plans$find2$packs;

        insured.ppcTestLevel;
            insured.memberID;
            insured.memberStatus;
            var restInsured = _objectWithoutProperties(insured, _excluded4);

        var insuredObj = _objectSpread2({}, restInsured);

        var nomineeObj = nomineeDetails === null || nomineeDetails === void 0 ? void 0 : nomineeDetails.find(function (nominee) {
          var _nominee$relationship8, _insured$relationship;

          return (nominee === null || nominee === void 0 ? void 0 : (_nominee$relationship8 = nominee.relationship) === null || _nominee$relationship8 === void 0 ? void 0 : _nominee$relationship8.toLowerCase()) === (insured === null || insured === void 0 ? void 0 : (_insured$relationship = insured.relationship) === null || _insured$relationship === void 0 ? void 0 : _insured$relationship.toLowerCase());
        });

        var relationship = nomineeObj.relationship,
            restNomineeObj = _objectWithoutProperties(nomineeObj, _excluded5);

        insuredObj.nomineeDetails = _objectSpread2(_objectSpread2({}, restNomineeObj), {}, {
          insuredRelationship: relationship
        });
        var prevInsuranceInput = (_values$insured$relat = values[insured === null || insured === void 0 ? void 0 : insured.relationship]) === null || _values$insured$relat === void 0 ? void 0 : _values$insured$relat.prevInsuranceDetails;
        insuredObj.prevInsuranceInput = {
          prevInsurerName: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevInsurerName,
          prevPolicyNo: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicyNo,
          prevPolicySI: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicySI,
          prevClaimLodged: (prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : (_prevInsuranceInput$p = prevInsuranceInput.prevClaimLodged) === null || _prevInsuranceInput$p === void 0 ? void 0 : _prevInsuranceInput$p.toLowerCase()) === 'yes' ? true : false,
          claimAmount: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.claimAmount,
          prevPolicyStartDate: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicyStartDate,
          prevPolicyEndDate: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicyEndDate,
          cbAmount: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.cbAmount
        };
        var medicalQuestionaireObj = isHealthDeclarationSelected ? medicalQuestionaire === null || medicalQuestionaire === void 0 ? void 0 : medicalQuestionaire.find(function (m) {
          var _m$relationship6, _insured$relationship2;

          return (m === null || m === void 0 ? void 0 : (_m$relationship6 = m.relationship) === null || _m$relationship6 === void 0 ? void 0 : _m$relationship6.toLowerCase()) === (insured === null || insured === void 0 ? void 0 : (_insured$relationship2 = insured.relationship) === null || _insured$relationship2 === void 0 ? void 0 : _insured$relationship2.toLowerCase());
        }) : {
          relationship: insured === null || insured === void 0 ? void 0 : insured.relationship,
          questions: []
        };

        if (medicalQuestionaireObj && ((_medicalQuestionaireO = medicalQuestionaireObj) === null || _medicalQuestionaireO === void 0 ? void 0 : (_medicalQuestionaireO2 = _medicalQuestionaireO.questions) === null || _medicalQuestionaireO2 === void 0 ? void 0 : _medicalQuestionaireO2.length) > 0) {
          var _medicalQuestionaireO3, _medicalQuestionaireO4, _medicalQuestionaireO5, _medicalQuestionaireO6, _medicalQuestionaireO7, _medicalQuestionaireO8, _medicalQuestionaireO9, _medicalQuestionaireO10;

          medicalQuestionaireObj = _objectSpread2(_objectSpread2({}, medicalQuestionaireObj), {}, {
            questions: (_medicalQuestionaireO3 = medicalQuestionaireObj) === null || _medicalQuestionaireO3 === void 0 ? void 0 : (_medicalQuestionaireO4 = _medicalQuestionaireO3.questions) === null || _medicalQuestionaireO4 === void 0 ? void 0 : _medicalQuestionaireO4.map(function (question) {
              var _question$answer;

              return {
                srNo: question === null || question === void 0 ? void 0 : question.srNo,
                answer: question === null || question === void 0 ? void 0 : (_question$answer = question.answer) === null || _question$answer === void 0 ? void 0 : _question$answer.answerText
              };
            })
          });
          medicalQuestionaireObj = _objectSpread2(_objectSpread2({}, medicalQuestionaireObj), {}, {
            questions: ((_medicalQuestionaireO5 = medicalQuestionaireObj) === null || _medicalQuestionaireO5 === void 0 ? void 0 : (_medicalQuestionaireO6 = _medicalQuestionaireO5.questions) === null || _medicalQuestionaireO6 === void 0 ? void 0 : (_medicalQuestionaireO7 = _medicalQuestionaireO6.find(function (q) {
              var _q$srNo;

              return (q === null || q === void 0 ? void 0 : (_q$srNo = q.srNo) === null || _q$srNo === void 0 ? void 0 : _q$srNo.toLowerCase()) === 'master';
            })) === null || _medicalQuestionaireO7 === void 0 ? void 0 : (_medicalQuestionaireO8 = _medicalQuestionaireO7.answer) === null || _medicalQuestionaireO8 === void 0 ? void 0 : _medicalQuestionaireO8.toLowerCase()) !== 'ye' ? (_medicalQuestionaireO9 = medicalQuestionaireObj) === null || _medicalQuestionaireO9 === void 0 ? void 0 : (_medicalQuestionaireO10 = _medicalQuestionaireO9.questions) === null || _medicalQuestionaireO10 === void 0 ? void 0 : _medicalQuestionaireO10.filter(function (q) {
              var _q$srNo2;

              return (q === null || q === void 0 ? void 0 : (_q$srNo2 = q.srNo) === null || _q$srNo2 === void 0 ? void 0 : _q$srNo2.toLowerCase()) !== '';
            }) : []
          });
        }

        insuredObj.medicalQuestionaire = medicalQuestionaireObj ? medicalQuestionaireObj : {
          relationship: insured === null || insured === void 0 ? void 0 : insured.relationship,
          questions: []
        };
        var plans = planData.plans;
        insuredObj.addOnCovers = plans === null || plans === void 0 ? void 0 : (_plans$find2 = plans.find(function (p) {
          var _p$name;

          return (p === null || p === void 0 ? void 0 : (_p$name = p.name) === null || _p$name === void 0 ? void 0 : _p$name.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
        })) === null || _plans$find2 === void 0 ? void 0 : (_plans$find2$packs = _plans$find2.packs) === null || _plans$find2$packs === void 0 ? void 0 : _plans$find2$packs.filter(function (pack) {
          var _pack$index;

          return pack === null || pack === void 0 ? void 0 : (_pack$index = pack.index) === null || _pack$index === void 0 ? void 0 : _pack$index.includes(insured === null || insured === void 0 ? void 0 : insured.relationship);
        }).flatMap(function (pack) {
          return pack.addOnCovers.filter(function (addOnCover) {
            return addOnCover.selected;
          });
        });

        if (!insuredObj.addOnCovers) {
          insuredObj.addOnCovers = [];
        }

        insuredDetailsResponseArr.push(insuredObj);
      });
      var enddatevalue = (_insuredDetailsRespon = insuredDetailsResponseArr[0]) === null || _insuredDetailsRespon === void 0 ? void 0 : (_insuredDetailsRespon2 = _insuredDetailsRespon.prevInsuranceInput) === null || _insuredDetailsRespon2 === void 0 ? void 0 : _insuredDetailsRespon2.prevPolicyEndDate;

      for (var i = 0; i <= insuredDetailsResponseArr.length; i++) {
        var _insuredDetailsRespon3, _insuredDetailsRespon4;

        if (moment(enddatevalue, 'DD/MM/YYYY').isAfter(moment((_insuredDetailsRespon3 = insuredDetailsResponseArr[i]) === null || _insuredDetailsRespon3 === void 0 ? void 0 : (_insuredDetailsRespon4 = _insuredDetailsRespon3.prevInsuranceInput) === null || _insuredDetailsRespon4 === void 0 ? void 0 : _insuredDetailsRespon4.prevPolicyEndDate, 'DD/MM/YYYY'), 'dates')) {
          var _insuredDetailsRespon5, _insuredDetailsRespon6;

          enddatevalue = (_insuredDetailsRespon5 = insuredDetailsResponseArr[i]) === null || _insuredDetailsRespon5 === void 0 ? void 0 : (_insuredDetailsRespon6 = _insuredDetailsRespon5.prevInsuranceInput) === null || _insuredDetailsRespon6 === void 0 ? void 0 : _insuredDetailsRespon6.prevPolicyEndDate;
        } else if (!enddatevalue) {
          var _insuredDetailsRespon7, _insuredDetailsRespon8;

          // console.log("inside else");
          enddatevalue = (_insuredDetailsRespon7 = insuredDetailsResponseArr[i]) === null || _insuredDetailsRespon7 === void 0 ? void 0 : (_insuredDetailsRespon8 = _insuredDetailsRespon7.prevInsuranceInput) === null || _insuredDetailsRespon8 === void 0 ? void 0 : _insuredDetailsRespon8.prevPolicyEndDate;
        }
      }

      enddatevalue = moment(enddatevalue, "DD/MM/YYYY").add(1, 'days').format('DD/MM/YYYY');
      policy_Start_Date_min = enddatevalue;
      return insuredDetailsResponseArr;
    };

    var _buyHealthPolicyData$ = buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.proposerDetailsMeta;
        _buyHealthPolicyData$.isNewCustomer;
        var isCRNVerified = _buyHealthPolicyData$.isCRNVerified,
        restProposerMetaData = _objectWithoutProperties(_buyHealthPolicyData$, _excluded6);

    var _buyHealthPolicyData$2 = buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$3 = buyHealthPolicyData.planData) === null || _buyHealthPolicyData$3 === void 0 ? void 0 : (_buyHealthPolicyData$4 = _buyHealthPolicyData$3.plans) === null || _buyHealthPolicyData$4 === void 0 ? void 0 : (_buyHealthPolicyData$5 = _buyHealthPolicyData$4.find(function (plan) {
      var _plan$name;

      return (plan === null || plan === void 0 ? void 0 : (_plan$name = plan.name) === null || _plan$name === void 0 ? void 0 : _plan$name.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
    })) === null || _buyHealthPolicyData$5 === void 0 ? void 0 : _buyHealthPolicyData$5.premium;
        _buyHealthPolicyData$2.warningMsg;
        var restPremium = _objectWithoutProperties(_buyHealthPolicyData$2, _excluded7);

    return {
      input: {
        proposerDetails: _objectSpread2(_objectSpread2(_objectSpread2({}, restProposerMetaData), buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.proposerDetails), {}, {
          isThinCustomer: false,
          isCRNVerified: isCRNVerified === null ? false : isCRNVerified === "" ? false : isCRNVerified
        }),
        insuredDetails: getInsuredDetailsObj(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.insuredDetails, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.medicalQuestionaire, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.planData, (values === null || values === void 0 ? void 0 : (_values$isHealthDecla = values.isHealthDeclarationSelected) === null || _values$isHealthDecla === void 0 ? void 0 : _values$isHealthDecla.toLowerCase()) !== 'ye'),
        plan: {
          name: planName,
          code: planCode,
          premium: restPremium
        },
        intermediary: {
          intermediaryCode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$6 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$6 === void 0 ? void 0 : _buyHealthPolicyData$6.code,
          locationCode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$7 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$7 === void 0 ? void 0 : _buyHealthPolicyData$7.location,
          fieldUserCode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$8 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$8 === void 0 ? void 0 : _buyHealthPolicyData$8.fieldUserCode
        },
        zone: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$9 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$9 === void 0 ? void 0 : (_buyHealthPolicyData$10 = _buyHealthPolicyData$9.location) === null || _buyHealthPolicyData$10 === void 0 ? void 0 : (_buyHealthPolicyData$11 = _buyHealthPolicyData$10.zone) === null || _buyHealthPolicyData$11 === void 0 ? void 0 : _buyHealthPolicyData$11.trim(),
        quotationType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.quotationType,
        sumInsured: parseFloat(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$12 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$12 === void 0 ? void 0 : (_buyHealthPolicyData$13 = _buyHealthPolicyData$12.cover) === null || _buyHealthPolicyData$13 === void 0 ? void 0 : _buyHealthPolicyData$13.sum_insured),
        startDate: (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$14 = buyHealthPolicyData.quotationType) === null || _buyHealthPolicyData$14 === void 0 ? void 0 : _buyHealthPolicyData$14.toLowerCase()) === 'roll over' ? policy_Start_Date_min // buyHealthPolicy?.policy?.startDate
        : getDateTimeData === null || getDateTimeData === void 0 ? void 0 : (_getDateTimeData$date = getDateTimeData.datetimeValue) === null || _getDateTimeData$date === void 0 ? void 0 : _getDateTimeData$date.date,
        startTime: '00:00',
        tenure: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$15 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$15 === void 0 ? void 0 : (_buyHealthPolicyData$16 = _buyHealthPolicyData$15.cover) === null || _buyHealthPolicyData$16 === void 0 ? void 0 : _buyHealthPolicyData$16.tenure,
        coverType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$17 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$17 === void 0 ? void 0 : (_buyHealthPolicyData$18 = _buyHealthPolicyData$17.cover) === null || _buyHealthPolicyData$18 === void 0 ? void 0 : _buyHealthPolicyData$18.type,
        isHealthDeclarationSelected: (values === null || values === void 0 ? void 0 : (_values$isHealthDecla2 = values.isHealthDeclarationSelected) === null || _values$isHealthDecla2 === void 0 ? void 0 : _values$isHealthDecla2.toLowerCase()) === 'yes',
        productCode: productCode,
        isExistingEmployee: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$quot6 = buyHealthPolicy.quoteData) === null || _buyHealthPolicy$quot6 === void 0 ? void 0 : (_buyHealthPolicy$quot7 = _buyHealthPolicy$quot6.isExistingEmployee) === null || _buyHealthPolicy$quot7 === void 0 ? void 0 : _buyHealthPolicy$quot7.toLowerCase()) === 'yes' ? true : false,
        existingPolicyNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.existingPolicyNumber,
        employeeNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$19 = buyHealthPolicyData.proposerDetails) === null || _buyHealthPolicyData$19 === void 0 ? void 0 : _buyHealthPolicyData$19.employeeNumber,
        proposerPincode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$20 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$20 === void 0 ? void 0 : (_buyHealthPolicyData$21 = _buyHealthPolicyData$20.location) === null || _buyHealthPolicyData$21 === void 0 ? void 0 : _buyHealthPolicyData$21.pincode,
        renewalMandateDetails: {
          renewalPaymentMandate: productCode.toString() === '2885' ? false : values === null || values === void 0 ? void 0 : values.renewalPaymentMandate,
          renewalPaymentMandateTakenInNameOf: values === null || values === void 0 ? void 0 : values.renewalPaymentMandateTakenInNameOf,
          termForMandateOpted: values === null || values === void 0 ? void 0 : values.termForMandateOpted,
          typeOfDebit: values === null || values === void 0 ? void 0 : values.typeOfDebit,
          accountNumber: values === null || values === void 0 ? void 0 : values.accountNumber,
          destinationBankName: values === null || values === void 0 ? void 0 : values.destinationBankName,
          destinationIfscCode: values === null || values === void 0 ? void 0 : values.destinationIfscCode,
          destinationMicrCode: values === null || values === void 0 ? void 0 : values.destinationMicrCode,
          destinationBranchName: values === null || values === void 0 ? void 0 : values.destinationBranchName,
          mandateAmount: parseFloat(renew_man_amount),
          finalCollectionDate: values === null || values === void 0 ? void 0 : values.finalCollectionDate,
          destinationBankAccountType: values === null || values === void 0 ? void 0 : values.destinationBankAccountType
        }
      }
    };
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(values) {
      var _buyHealthPolicy$prop13, _data$calculatePremiu, _buyHealthPolicy$insu, _values$documentDetai71, _values$documentDetai72, _values$documentDetai73, _buyHealthPolicy$quot8, getDateTime, _yield$getDateTime, getDateTimeData, calculatePremiumForProposal, _yield$calculatePremi, data, _buyHealthPolicy$plan, _buyHealthPolicy$plan2, _buyHealthPolicy$plan3, _buyHealthPolicy$plan4, _buyHealthPolicy$plan5, _data$calculatePremiu2, _data$calculatePremiu3, _data$calculatePremiu4, _data$calculatePremiu5, _buyHealthPolicy$plan6, _buyHealthPolicy$plan7, _buyHealthPolicy$plan8, _buyHealthPolicy$plan9, _buyHealthPolicy$plan10, _data$calculatePremiu6, _data$calculatePremiu7, _data$calculatePremiu11, rest, _values$documentDetai74, _values$documentDetai75, _values$documentDetai76;

      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(Object.values(validate(values)).length === 0)) {
                _context6.next = 35;
                break;
              }

              if (!((buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop13 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop13 === void 0 ? void 0 : _buyHealthPolicy$prop13.length) > 0)) {
                _context6.next = 4;
                break;
              }

              setProceedToNextStep([].concat(_toConsumableArray(proceedToNextStep.slice(0, 2)), [true], _toConsumableArray(proceedToNextStep.slice(3))));
              return _context6.abrupt("return", true);

            case 4:
              _context6.prev = 4;
              setParentAlerts([]);
              getDateTime = fetchQuery({
                query: GET_DATE_TIME
              });
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
              setCustomLoadingMessage('Calculating Premium');
              setLoadingStep(true);
              _context6.next = 12;
              return getDateTime;

            case 12:
              _yield$getDateTime = _context6.sent;
              getDateTimeData = _yield$getDateTime.data;
              calculatePremiumForProposal = fetchQuery({
                query: CALCULATE_PREMIUM_FOR_PROPOSAL,
                variables: calculatePremiumForProposalVariables(buyHealthPolicy, getDateTimeData, values)
              });
              _context6.next = 17;
              return calculatePremiumForProposal;

            case 17:
              _yield$calculatePremi = _context6.sent;
              data = _yield$calculatePremi.data;
              setLoadingStep(false);
              setCustomLoadingMessage(null);

              if (data !== null && data !== void 0 && (_data$calculatePremiu = data.calculatePremiumForProposal) !== null && _data$calculatePremiu !== void 0 && _data$calculatePremiu.warningMsg) {
                if ((buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$plan = buyHealthPolicy.planData) === null || _buyHealthPolicy$plan === void 0 ? void 0 : (_buyHealthPolicy$plan2 = _buyHealthPolicy$plan.plans) === null || _buyHealthPolicy$plan2 === void 0 ? void 0 : (_buyHealthPolicy$plan3 = _buyHealthPolicy$plan2.find(function (p) {
                  return p.name === planName;
                })) === null || _buyHealthPolicy$plan3 === void 0 ? void 0 : (_buyHealthPolicy$plan4 = _buyHealthPolicy$plan3.premium) === null || _buyHealthPolicy$plan4 === void 0 ? void 0 : (_buyHealthPolicy$plan5 = _buyHealthPolicy$plan4.totalPremium) === null || _buyHealthPolicy$plan5 === void 0 ? void 0 : _buyHealthPolicy$plan5.toString()) !== (data === null || data === void 0 ? void 0 : (_data$calculatePremiu2 = data.calculatePremiumForProposal) === null || _data$calculatePremiu2 === void 0 ? void 0 : (_data$calculatePremiu3 = _data$calculatePremiu2.totalPremium) === null || _data$calculatePremiu3 === void 0 ? void 0 : _data$calculatePremiu3.toString())) {
                  setParentAlerts([{
                    id: 1,
                    content: /*#__PURE__*/React.createElement("div", {
                      className: "flex flex-col w-full h-full"
                    }, /*#__PURE__*/React.createElement(Text, {
                      type: "normal"
                    }, "Your premium has been updated successfully")),
                    type: 'info',
                    timeout: null,
                    disableClose: false
                  }, {
                    id: 2,
                    content: /*#__PURE__*/React.createElement("div", {
                      className: "flex flex-col w-full h-full"
                    }, /*#__PURE__*/React.createElement(Text, {
                      type: "normal"
                    }, data === null || data === void 0 ? void 0 : (_data$calculatePremiu4 = data.calculatePremiumForProposal) === null || _data$calculatePremiu4 === void 0 ? void 0 : _data$calculatePremiu4.warningMsg)),
                    type: 'warning',
                    timeout: null,
                    disableClose: false
                  }]);
                } else {
                  setParentAlerts([{
                    id: Date.now(),
                    content: /*#__PURE__*/React.createElement("div", {
                      className: "flex flex-col w-full h-full"
                    }, /*#__PURE__*/React.createElement(Text, {
                      type: "normal"
                    }, data === null || data === void 0 ? void 0 : (_data$calculatePremiu5 = data.calculatePremiumForProposal) === null || _data$calculatePremiu5 === void 0 ? void 0 : _data$calculatePremiu5.warningMsg)),
                    type: 'warning',
                    timeout: null,
                    disableClose: false
                  }]);
                }
              } else {
                if ((buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$plan6 = buyHealthPolicy.planData) === null || _buyHealthPolicy$plan6 === void 0 ? void 0 : (_buyHealthPolicy$plan7 = _buyHealthPolicy$plan6.plans) === null || _buyHealthPolicy$plan7 === void 0 ? void 0 : (_buyHealthPolicy$plan8 = _buyHealthPolicy$plan7.find(function (p) {
                  return p.name === planName;
                })) === null || _buyHealthPolicy$plan8 === void 0 ? void 0 : (_buyHealthPolicy$plan9 = _buyHealthPolicy$plan8.premium) === null || _buyHealthPolicy$plan9 === void 0 ? void 0 : (_buyHealthPolicy$plan10 = _buyHealthPolicy$plan9.totalPremium) === null || _buyHealthPolicy$plan10 === void 0 ? void 0 : _buyHealthPolicy$plan10.toString()) !== (data === null || data === void 0 ? void 0 : (_data$calculatePremiu6 = data.calculatePremiumForProposal) === null || _data$calculatePremiu6 === void 0 ? void 0 : (_data$calculatePremiu7 = _data$calculatePremiu6.totalPremium) === null || _data$calculatePremiu7 === void 0 ? void 0 : _data$calculatePremiu7.toString())) {
                  setParentAlerts([{
                    id: Date.now(),
                    content: /*#__PURE__*/React.createElement("div", {
                      className: "flex flex-col w-full h-full"
                    }, /*#__PURE__*/React.createElement(Text, {
                      type: "normal"
                    }, "Your premium has been updated successfully")),
                    type: 'info',
                    timeout: null,
                    disableClose: false
                  }]);
                } else {
                  setParentAlerts([]);
                }
              }

              updateBuyHealthPolicy(_objectSpread2(_objectSpread2({}, submitNomineeArr(values)), {}, {
                insuredDetails: buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$insu = buyHealthPolicy.insuredDetails) === null || _buyHealthPolicy$insu === void 0 ? void 0 : _buyHealthPolicy$insu.map(function (member) {
                  var _data$calculatePremiu8, _data$calculatePremiu9, _data$calculatePremiu10;

                  return _objectSpread2(_objectSpread2({}, member), {}, {
                    ppcTestLevel: data === null || data === void 0 ? void 0 : (_data$calculatePremiu8 = data.calculatePremiumForProposal) === null || _data$calculatePremiu8 === void 0 ? void 0 : (_data$calculatePremiu9 = _data$calculatePremiu8.breakup) === null || _data$calculatePremiu9 === void 0 ? void 0 : (_data$calculatePremiu10 = _data$calculatePremiu9.find(function (b) {
                      var _b$relationship, _member$relationship;

                      return (b === null || b === void 0 ? void 0 : (_b$relationship = b.relationship) === null || _b$relationship === void 0 ? void 0 : _b$relationship.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship = member.relationship) === null || _member$relationship === void 0 ? void 0 : _member$relationship.toLowerCase());
                    })) === null || _data$calculatePremiu10 === void 0 ? void 0 : _data$calculatePremiu10.ppcTestLevel
                  });
                }),
                documentDetails: values !== null && values !== void 0 && values.documentDetails && (values === null || values === void 0 ? void 0 : (_values$documentDetai71 = values.documentDetails) === null || _values$documentDetai71 === void 0 ? void 0 : _values$documentDetai71.length) > 0 && values !== null && values !== void 0 && (_values$documentDetai72 = values.documentDetails[0]) !== null && _values$documentDetai72 !== void 0 && _values$documentDetai72.documentBase64String ? values === null || values === void 0 ? void 0 : (_values$documentDetai73 = values.documentDetails) === null || _values$documentDetai73 === void 0 ? void 0 : _values$documentDetai73.map(function (e) {
                  return {
                    documentDescription: e === null || e === void 0 ? void 0 : e.documentDescription,
                    documentName: e === null || e === void 0 ? void 0 : e.documentName,
                    documentFileName: e === null || e === void 0 ? void 0 : e.documentFileName,
                    documentExtension: e === null || e === void 0 ? void 0 : e.documentExtension,
                    documentSize: e === null || e === void 0 ? void 0 : e.documentSize,
                    documentBase64String: e === null || e === void 0 ? void 0 : e.documentBase64String
                  };
                }) : [],
                policy: {
                  startDate: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$quot8 = buyHealthPolicy.quotationType) === null || _buyHealthPolicy$quot8 === void 0 ? void 0 : _buyHealthPolicy$quot8.toLowerCase()) === 'roll over' ? policy_Start_Date_min : "",
                  endDate: '',
                  time: ''
                }
              }));
              _data$calculatePremiu11 = data.calculatePremiumForProposal, rest = _objectWithoutProperties(_data$calculatePremiu11, _excluded8);
              updatePlanPremium(planName, rest);
              setProceedToNextStep([].concat(_toConsumableArray(proceedToNextStep.slice(0, 2)), [true], _toConsumableArray(proceedToNextStep.slice(3))));
              return _context6.abrupt("return", true);

            case 29:
              _context6.prev = 29;
              _context6.t0 = _context6["catch"](4);
              updateBuyHealthPolicy(_objectSpread2(_objectSpread2({}, submitNomineeArr(values)), {}, {
                documentDetails: values !== null && values !== void 0 && values.documentDetails && (values === null || values === void 0 ? void 0 : (_values$documentDetai74 = values.documentDetails) === null || _values$documentDetai74 === void 0 ? void 0 : _values$documentDetai74.length) > 0 && values !== null && values !== void 0 && (_values$documentDetai75 = values.documentDetails[0]) !== null && _values$documentDetai75 !== void 0 && _values$documentDetai75.documentBase64String ? values === null || values === void 0 ? void 0 : (_values$documentDetai76 = values.documentDetails) === null || _values$documentDetai76 === void 0 ? void 0 : _values$documentDetai76.map(function (e) {
                  return {
                    documentDescription: e === null || e === void 0 ? void 0 : e.documentDescription,
                    documentName: e === null || e === void 0 ? void 0 : e.documentName,
                    documentFileName: e === null || e === void 0 ? void 0 : e.documentFileName,
                    documentExtension: e === null || e === void 0 ? void 0 : e.documentExtension,
                    documentSize: e === null || e === void 0 ? void 0 : e.documentSize,
                    documentBase64String: e === null || e === void 0 ? void 0 : e.documentBase64String
                  };
                }) : []
              }));
              setParentAlerts([{
                header: 'Error',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, _context6.t0.message),
                type: 'error',
                timeout: null,
                disableClose: false
              }]);
              setLoadingStep(false);
              return _context6.abrupt("return", false);

            case 35:
              return _context6.abrupt("return", false);

            case 36:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[4, 29]]);
    }));

    return function onSubmit(_x10) {
      return _ref6.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    severity: "info",
    type: "title"
  }, "Nominee Details"), /*#__PURE__*/React.createElement(QuantaFormik, {
    innerRef: props.forwardedRef,
    enableReinitialize: true,
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit,
    validator: function validator() {
      return {};
    }
  }, /*#__PURE__*/React.createElement(NomineeForm, {
    validate: validate,
    medicalQuestionaireDisplay: medicalQuestionaireDisplay,
    setMedicalQuestionaireDisplay: setMedicalQuestionaireDisplay
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalMedicalQuestionaire, {
    productCode: productCode,
    medicalQuestionaireDisplay: medicalQuestionaireDisplay,
    setMedicalQuestionaireDisplay: setMedicalQuestionaireDisplay,
    questions: productQuestionList,
    readOnlyMode: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop14 = buyHealthPolicy.proposalNumber) === null || _buyHealthPolicy$prop14 === void 0 ? void 0 : _buyHealthPolicy$prop14.length) > 0
  })));
}

var _excluded$2 = ["goToStep", "proceedToNextStep", "setProceedToNextStep", "setParentAlerts", "lobCode", "lobName", "productName", "productCode", "planName", "planCode", "proposalNumber", "renderExpandedCards"];
function InsuredMembers(_ref) {
  _ref.goToStep;
      var proceedToNextStep = _ref.proceedToNextStep,
      setProceedToNextStep = _ref.setProceedToNextStep,
      setParentAlerts = _ref.setParentAlerts;
      _ref.lobCode;
      _ref.lobName;
      _ref.productName;
      var productCode = _ref.productCode,
      planName = _ref.planName;
      _ref.planCode;
      _ref.proposalNumber;
      var renderExpandedCards = _ref.renderExpandedCards,
      props = _objectWithoutProperties(_ref, _excluded$2);

  var repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3
  });

  var getDomainData = function getDomainData(domainArr, searchText, searchType, returnType) {
    return domainArr.find(function (d) {
      var _d$, _d$$toString, _searchText$toString;

      return ((_d$ = d["".concat(searchType)]) === null || _d$ === void 0 ? void 0 : (_d$$toString = _d$.toString()) === null || _d$$toString === void 0 ? void 0 : _d$$toString.toLowerCase()) === (searchText === null || searchText === void 0 ? void 0 : (_searchText$toString = searchText.toString()) === null || _searchText$toString === void 0 ? void 0 : _searchText$toString.toLowerCase());
    }) ? domainArr.find(function (d) {
      var _d$2, _d$2$toString, _searchText$toString2;

      return ((_d$2 = d["".concat(searchType)]) === null || _d$2 === void 0 ? void 0 : (_d$2$toString = _d$2.toString()) === null || _d$2$toString === void 0 ? void 0 : _d$2$toString.toLowerCase()) === (searchText === null || searchText === void 0 ? void 0 : (_searchText$toString2 = searchText.toString()) === null || _searchText$toString2 === void 0 ? void 0 : _searchText$toString2.toLowerCase());
    })["".concat(returnType)] : '';
  };

  var _useQuery = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS),
      loadingBuyPolicy = _useQuery.loading,
      errorBuyPolicy = _useQuery.error,
      dataBuyPolicy = _useQuery.data;

  var _useQuery2 = useQuery(CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first'
  }),
      loading = _useQuery2.loading,
      dropDownDetails = _useQuery2.data;

  var _useQuery3 = useQuery(PROPOSER_DROPDOWN_DETAIL, {
    variables: {
      productCode: productCode
    },
    fetchPolicy: 'cache-first'
  }),
      loadingProposerDetail = _useQuery3.loading,
      errorProposerDetail = _useQuery3.error,
      dataProposerDetail = _useQuery3.data;

  var _useQuery4 = useQuery(GET_BUSINESS_TYPE),
      loadingBusinessType = _useQuery4.loading,
      errorBusinessType = _useQuery4.error,
      dataBusinessType = _useQuery4.data;

  var _useQuery5 = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loadingNameLimit = _useQuery5.loading,
      errorNameLimit = _useQuery5.error,
      dataNameLimit = _useQuery5.data;

  var _useQuery6 = useQuery(RELATIONSHIP_WITH_PROPOSER, {
    fetchPolicy: 'cache-first'
  }),
      loadingrelationshipwithproposer = _useQuery6.loading,
      errorrelationshipwithproposer = _useQuery6.error,
      datarelationshipwithproposer = _useQuery6.data;

  useEffect(function () {
    var _renderExpandedCards$;

    if (dataBuyPolicy && dataBuyPolicy !== null && dataBuyPolicy !== void 0 && dataBuyPolicy.buyHealthPolicy && (renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$ = renderExpandedCards.current) === null || _renderExpandedCards$ === void 0 ? void 0 : _renderExpandedCards$.length) === 8) {
      var _dataBuyPolicy$buyHea, _dataBuyPolicy$buyHea2;

      renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : renderExpandedCards.current), _toConsumableArray(dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : (_dataBuyPolicy$buyHea = dataBuyPolicy.buyHealthPolicy) === null || _dataBuyPolicy$buyHea === void 0 ? void 0 : (_dataBuyPolicy$buyHea2 = _dataBuyPolicy$buyHea.insuredDetails) === null || _dataBuyPolicy$buyHea2 === void 0 ? void 0 : _dataBuyPolicy$buyHea2.flatMap(function (insured) {
        return [{
          cardName: insured === null || insured === void 0 ? void 0 : insured.relationship,
          flag: false
        }, {
          cardName: "".concat(insured === null || insured === void 0 ? void 0 : insured.relationship, " nominee"),
          flag: false
        }, {
          cardName: "".concat(insured === null || insured === void 0 ? void 0 : insured.relationship, " prev insured"),
          flag: false
        }];
      })), [{
        cardName: 'renewal mandate',
        flag: false
      }]);
    }
  }, [dataBuyPolicy]);

  if (loadingBuyPolicy || loading || loadingProposerDetail || loadingBusinessType || loadingNameLimit || loadingrelationshipwithproposer) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Loading, {
      customMessage: 'Fetching members'
    }));
  }

  if (errorBuyPolicy || errorProposerDetail || errorBusinessType || errorNameLimit) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Error, {
      error: errorBuyPolicy || errorProposerDetail || errorBusinessType || errorNameLimit || errorrelationshipwithproposer
    }));
  }

  var buyHealthPolicy = dataBuyPolicy.buyHealthPolicy;
  var insuredDetails = buyHealthPolicy.insuredDetails;
  var salutationList = dropDownDetails.salutationList,
      genderList = dropDownDetails.genderList,
      maritalStatusList = dropDownDetails.maritalStatusList,
      occupationList = dropDownDetails.occupationList;
  var PRD_PreExistDiseaseWaitPeriod = dataProposerDetail.PRD_PreExistDiseaseWaitPeriod,
      PRD_OccupationList = dataProposerDetail.PRD_OccupationList,
      PRD_CumulativeBonus = dataProposerDetail.PRD_CumulativeBonus;
  var businessTypeList = dataBusinessType.businessTypeList;
  var characterLimitList = dataNameLimit.characterLimitList;
  var relationshipwithproposer = datarelationshipwithproposer.relationshipwithproposer;

  var getInitObject = function getInitObject() {
    var initObj = {};
    insuredDetails.forEach(function (insured) {
      var _occupationList$find, _buyHealthPolicy$prop2;

      initObj[insured.relationship] = {
        title: insured.title ? insured.title : insured.relationship.toLowerCase() === 'self' ? buyHealthPolicy.proposerDetails.title : '',
        gender: insured.gender ? insured.gender : insured.relationship.toLowerCase() === 'self' ? buyHealthPolicy.proposerDetails.gender ? buyHealthPolicy.proposerDetails.gender : buyHealthPolicy.quoteData.members.find(function (m) {
          return m.relationship === insured.relationship;
        }).gender : buyHealthPolicy.quoteData.members.find(function (m) {
          return m.relationship === insured.relationship;
        }).gender,
        dob: insured.dob ? insured.dob : insured.relationship.toLowerCase() === 'self' ? buyHealthPolicy.proposerDetails.proposerDOB ? buyHealthPolicy.proposerDetails.proposerDOB : buyHealthPolicy.quoteData.members.find(function (m) {
          return m.relationship === insured.relationship;
        }).dob : buyHealthPolicy.quoteData.members.find(function (m) {
          return m.relationship === insured.relationship;
        }).dob,
        firstName: insured.firstName ? insured.firstName : insured.relationship.toLowerCase() === 'self' ? buyHealthPolicy.proposerDetails.firstName : '',
        middleName: insured.middleName ? insured.middleName : insured.relationship.toLowerCase() === 'self' ? buyHealthPolicy.proposerDetails.middleName : '',
        lastName: insured.lastName ? insured.lastName : insured.relationship.toLowerCase() === 'self' ? buyHealthPolicy.proposerDetails.lastName : '',
        maritalStatus: insured.maritalStatus ? insured.maritalStatus : insured.relationship.toLowerCase() === 'self' ? buyHealthPolicy.proposerDetails.maritalStatus : '',
        height: insured.height ? insured.height : '',
        weight: insured.weight ? insured.weight : '',
        occupation: insured.occupation ? insured.occupation.value : insured.relationship.toLowerCase() === 'self' //?buyHealthPolicy?.proposerDetails?.occupation
        ? occupationList === null || occupationList === void 0 ? void 0 : (_occupationList$find = occupationList.find(function (e) {
          var _buyHealthPolicy$prop;

          return e.code == (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop === void 0 ? void 0 : _buyHealthPolicy$prop.occupation);
        })) === null || _occupationList$find === void 0 ? void 0 : _occupationList$find.value : '',
        // buyHealthPolicy.proposerDetails.occupation  
        // //  ? insured.occupation 
        // //  : ''
        //  ?buyHealthPolicy.proposerDetails.occupation 
        //  :'',
        otherOccupation: insured.otherOccupation ? insured.otherOccupation : insured.relationship.toLowerCase() === 'self' ? buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop2 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop2 === void 0 ? void 0 : _buyHealthPolicy$prop2.otherOccupation : '',

        /*SU Divya - P2_202 : For HP prodcut only default PED waiting period changes in the product*/
        pedWaitingPeriod: insured.pedWaitingPeriod ? insured.pedWaitingPeriod : (productCode === null || productCode === void 0 ? void 0 : productCode.toString()) === '2883' && ((planName === null || planName === void 0 ? void 0 : planName.toLowerCase()) === "total" || (planName === null || planName === void 0 ? void 0 : planName.toLowerCase()) === "edge") ? "36 Months" : (planName === null || planName === void 0 ? void 0 : planName.toLowerCase()) === "absolute" || planName.toLowerCase() === "elite" ? "36 Months" : '48 Months',

        /*EUA Divya */
        insuredrelationshipwithproposer: insured.insuredrelationshipwithproposer ? insured.insuredrelationshipwithproposer : "",
        maternitySelected: buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.quoteData.members ? buyHealthPolicy.quoteData.members.find(function (m) {
          return m.relationship === insured.relationship;
        }).maternitySelected : false,
        isPortabilityRequired: insured.isPortabilityRequired ? insured.isPortabilityRequired : false,
        cbBonusPct: insured.cbBonusPct ? insured.cbBonusPct : '',
        ppcTestLevel: insured.ppcTestLevel ? insured.ppcTestLevel : '',
        memberStatus: insured.memberStatus ? insured.memberStatus : '',
        memberID: insured.memberID ? insured.memberID : ''
      };
    });
    return initObj;
  };

  var initialValues = getInitObject();

  var validate = function validate(values) {
    var errors = {};
    var Pcount = 0;
    var Truecount = 0;
    insuredDetails.forEach(function (insured) {
      var _values$$title, _getDomainData, _getDomainData2, _values$, _values$$gender, _getDomainData3, _getDomainData4, _getDomainData5, _values$2;

      errors["".concat(insured.relationship)] = {};

      if (!values["".concat(insured.relationship)].title) {
        errors["".concat(insured.relationship)].title = '* Required';
      }

      if (((_values$$title = values["".concat(insured.relationship)].title) === null || _values$$title === void 0 ? void 0 : _values$$title.toLowerCase()) !== ((_getDomainData = getDomainData(salutationList, values["".concat(insured.relationship)].title, 'code', 'code')) === null || _getDomainData === void 0 ? void 0 : _getDomainData.toLowerCase())) {
        errors["".concat(insured.relationship)].title = '* Enter valid title';
      } else if ((_getDomainData2 = getDomainData(salutationList, values["".concat(insured.relationship)].title, 'code', 'gender')) !== null && _getDomainData2 !== void 0 && _getDomainData2.toLowerCase() && ((_values$ = values["".concat(insured.relationship)]) === null || _values$ === void 0 ? void 0 : (_values$$gender = _values$.gender) === null || _values$$gender === void 0 ? void 0 : _values$$gender.toLowerCase()) !== ((_getDomainData3 = getDomainData(salutationList, values["".concat(insured.relationship)].title, 'code', 'gender')) === null || _getDomainData3 === void 0 ? void 0 : _getDomainData3.toLowerCase()) && (((_getDomainData4 = getDomainData(genderList, values["".concat(insured.relationship)].gender, 'code', 'value')) === null || _getDomainData4 === void 0 ? void 0 : _getDomainData4.toLowerCase()) === 'male' || ((_getDomainData5 = getDomainData(genderList, values["".concat(insured.relationship)].gender, 'code', 'value')) === null || _getDomainData5 === void 0 ? void 0 : _getDomainData5.toLowerCase()) === 'female')) {
        errors["".concat(insured.relationship)].title = '* Title mismatch with gender';
      }

      if (!values["".concat(insured.relationship)].height) {
        errors["".concat(insured.relationship)].height = '* Required';
      }

      if (!values["".concat(insured.relationship)].weight) {
        errors["".concat(insured.relationship)].weight = '* Required';
      }

      if (!values["".concat(insured.relationship)].gender) {
        errors["".concat(insured.relationship)].gender = '* Required';
      }

      if (!values["".concat(insured.relationship)].dob) {
        errors["".concat(insured.relationship)].dob = '* Required';
      }

      if (!((_values$2 = values["".concat(insured.relationship)]) !== null && _values$2 !== void 0 && _values$2.insuredrelationshipwithproposer) && insured.relationship === 'Co-applicant') {
        errors["".concat(insured.relationship)].insuredrelationshipwithproposer = '* Required';
      }

      if (values["".concat(insured.relationship)].dob) {
        if (moment(values["".concat(insured.relationship)].dob, 'DD/MM/YYYY').isAfter()) {
          errors["".concat(insured.relationship)].dob = '* Date of Birth cannot be a future date';
        }
      }
      /*SA Divya - P2_202 : default PED waiting period changes in the product*/


      if ((productCode === null || productCode === void 0 ? void 0 : productCode.toString()) === '2883' && ((planName === null || planName === void 0 ? void 0 : planName.toLowerCase()) === "total" || (planName === null || planName === void 0 ? void 0 : planName.toLowerCase()) === "edge")) {
        if (values["".concat(insured.relationship)].pedWaitingPeriod === '48 Months') {
          errors["".concat(insured.relationship)].pedWaitingPeriod = '*48 Months is not allowed for Total/Edge Plan';
        }
      }
      /*EA Divya */


      var firstNameValue = characterLimitList === null || characterLimitList === void 0 ? void 0 : characterLimitList.find(function (characterLimit) {
        return characterLimit.code.toLowerCase() === 'first name';
      });
      var middleNameValue = characterLimitList === null || characterLimitList === void 0 ? void 0 : characterLimitList.find(function (characterLimit) {
        return characterLimit.code.toLowerCase() === 'middle name';
      });
      var lastNameValue = characterLimitList === null || characterLimitList === void 0 ? void 0 : characterLimitList.find(function (characterLimit) {
        return characterLimit.code.toLowerCase() === 'last name';
      });

      if (!values["".concat(insured.relationship)].firstName) {
        errors["".concat(insured.relationship)].firstName = '* Required';
      } else if (values["".concat(insured.relationship)].firstName && !values["".concat(insured.relationship)].firstName.match(/^[a-zA-Z ]*$/)) {
        errors["".concat(insured.relationship)].firstName = '* First Name can contain alphabets only';
      } else if (values["".concat(insured.relationship)].firstName.length > firstNameValue.value) {
        errors["".concat(insured.relationship)].firstName = "* First Name cannot be greater than ".concat(firstNameValue.value, " characters");
      }

      if (values["".concat(insured.relationship)].middleName && !values["".concat(insured.relationship)].middleName.match(/^[a-zA-Z ]*$/)) {
        errors["".concat(insured.relationship)].middleName = '* Middle Name can contain alphabets only';
      } else if (values["".concat(insured.relationship)].middleName.length > middleNameValue.value) {
        errors["".concat(insured.relationship)].middleName = "* Middle Name cannot be greater than ".concat(middleNameValue.value, " characters");
      }

      if (!values["".concat(insured.relationship)].lastName) {
        errors["".concat(insured.relationship)].lastName = '* Required';
      } else if (values["".concat(insured.relationship)].lastName && !values["".concat(insured.relationship)].lastName.match(/^[a-zA-Z. ]*$/)) {
        errors["".concat(insured.relationship)].lastName = '* Last Name can contain alphabets only';
      } else if (values["".concat(insured.relationship)].lastName.length > lastNameValue.value) {
        errors["".concat(insured.relationship)].lastName = "* Last Name cannot be greater than ".concat(lastNameValue.value, " characters");
      }

      if (!values["".concat(insured.relationship)].maritalStatus) {
        errors["".concat(insured.relationship)].maritalStatus = '* Required';
      }

      if (!values["".concat(insured.relationship)].occupation) {
        errors["".concat(insured.relationship)].occupation = '* Required';
      } // if (
      //   values[`${insured.relationship}`].occupation &&
      //   getDomainData(
      //     PRD_OccupationList,
      //     values[`${insured.relationship}`].occupation,
      //     'code',
      //     'value',
      //   )?.toLowerCase() === 'others' &&
      //   !values[`${insured.relationship}`].otherOccupation
      // ) {
      //   errors[`${insured.relationship}`].otherOccupation =
      //     '* Required';
      // }


      if (values["".concat(insured.relationship)].isPortabilityRequired.toString() === 'true') {
        Truecount = Truecount + 1;
      }

      Pcount = Pcount + 1;
    });

    if (buyHealthPolicy.quotationType.toString() === 'Roll Over') {
      if (Pcount > 0) {
        if (Truecount <= 0) {
          insuredDetails.forEach(function (insured) {
            errors["".concat(insured.relationship)].isPortabilityRequired = '* For Roll Over atleast 1 Portability is Required';
          });
        }
      }
    }

    var error_count = 0;
    insuredDetails.forEach(function (insured) {
      error_count += Object.keys(errors["".concat(insured.relationship)]).length;
    });

    if (error_count === 0) {
      errors = {};
    }

    return errors;
  };

  var InsuredMemberForm = function InsuredMemberForm(_ref2) {
    _ref2.validate;

    var _useQuantaFormikConte = useQuantaFormikContext(),
        values = _useQuantaFormikConte.values;
        _useQuantaFormikConte.setFieldValue;

    var insuredcount = 0;
    var data = insuredDetails ? insuredDetails.map(function (m) {
      var _renderExpandedCards$2, _renderExpandedCards$3, _salutationList$filte, _salutationList$filte2, _buyHealthPolicy$quot, _buyHealthPolicy$quot2, _buyHealthPolicy$quot3, _buyHealthPolicy$prop3, _buyHealthPolicy$prop4, _buyHealthPolicy$prop5, _buyHealthPolicy$prop6, _buyHealthPolicy$prop7, _buyHealthPolicy$prop8, _buyHealthPolicy$prop9, _buyHealthPolicy$prop10, _buyHealthPolicy$prop11, _buyHealthPolicy$prop12, _buyHealthPolicy$prop13, _buyHealthPolicy$prop14, _ref3, _getDomainData6;

      insuredcount = insuredcount + 1;
      return {
        title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
          severity: "info",
          type: "large"
        }, m.relationship, ' '), /*#__PURE__*/React.createElement(Text, {
          severity: "error",
          type: "title"
        }, "*")),
        size: 'medium',
        expanded: renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$2 = renderExpandedCards.current) === null || _renderExpandedCards$2 === void 0 ? void 0 : (_renderExpandedCards$3 = _renderExpandedCards$2.find(function (card) {
          var _card$cardName, _card$cardName$toStri, _m$relationship, _m$relationship$toStr;

          return (card === null || card === void 0 ? void 0 : (_card$cardName = card.cardName) === null || _card$cardName === void 0 ? void 0 : (_card$cardName$toStri = _card$cardName.toString()) === null || _card$cardName$toStri === void 0 ? void 0 : _card$cardName$toStri.toLowerCase()) === "".concat(m === null || m === void 0 ? void 0 : (_m$relationship = m.relationship) === null || _m$relationship === void 0 ? void 0 : (_m$relationship$toStr = _m$relationship.toString()) === null || _m$relationship$toStr === void 0 ? void 0 : _m$relationship$toStr.toLowerCase());
        })) === null || _renderExpandedCards$3 === void 0 ? void 0 : _renderExpandedCards$3.flag,
        isToggleEnabled: true,
        setExpandedCards: function setExpandedCards(expanded) {
          var _renderExpandedCards$4, _renderExpandedCards$5;

          renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$4 = renderExpandedCards.current) === null || _renderExpandedCards$4 === void 0 ? void 0 : _renderExpandedCards$4.filter(function (card) {
            var _card$cardName2, _card$cardName2$toStr, _m$relationship2, _m$relationship2$toSt;

            return (card === null || card === void 0 ? void 0 : (_card$cardName2 = card.cardName) === null || _card$cardName2 === void 0 ? void 0 : (_card$cardName2$toStr = _card$cardName2.toString()) === null || _card$cardName2$toStr === void 0 ? void 0 : _card$cardName2$toStr.toLowerCase()) !== "".concat(m === null || m === void 0 ? void 0 : (_m$relationship2 = m.relationship) === null || _m$relationship2 === void 0 ? void 0 : (_m$relationship2$toSt = _m$relationship2.toString()) === null || _m$relationship2$toSt === void 0 ? void 0 : _m$relationship2$toSt.toLowerCase());
          })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$5 = renderExpandedCards.current) === null || _renderExpandedCards$5 === void 0 ? void 0 : _renderExpandedCards$5.find(function (card) {
            var _card$cardName3, _card$cardName3$toStr, _m$relationship3, _m$relationship3$toSt;

            return (card === null || card === void 0 ? void 0 : (_card$cardName3 = card.cardName) === null || _card$cardName3 === void 0 ? void 0 : (_card$cardName3$toStr = _card$cardName3.toString()) === null || _card$cardName3$toStr === void 0 ? void 0 : _card$cardName3$toStr.toLowerCase()) === "".concat(m === null || m === void 0 ? void 0 : (_m$relationship3 = m.relationship) === null || _m$relationship3 === void 0 ? void 0 : (_m$relationship3$toSt = _m$relationship3.toString()) === null || _m$relationship3$toSt === void 0 ? void 0 : _m$relationship3$toSt.toLowerCase());
          })), {}, {
            flag: expanded
          })]);
        },
        grid_data: [{
          type: 'select',
          label: /*#__PURE__*/React.createElement("div", null, "Title ", /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")),
          searchable: true,
          data: salutationList && (salutationList === null || salutationList === void 0 ? void 0 : salutationList.length) > 0 ? (salutationList === null || salutationList === void 0 ? void 0 : (_salutationList$filte = salutationList.filter(function (salutation) {
            var _salutation$gender, _values$$gender2;

            return (salutation === null || salutation === void 0 ? void 0 : (_salutation$gender = salutation.gender) === null || _salutation$gender === void 0 ? void 0 : _salutation$gender.toLowerCase()) === ((_values$$gender2 = values["".concat(m.relationship)].gender) === null || _values$$gender2 === void 0 ? void 0 : _values$$gender2.toLowerCase());
          })) === null || _salutationList$filte === void 0 ? void 0 : _salutationList$filte.length) === 0 ? salutationList === null || salutationList === void 0 ? void 0 : salutationList.map(function (salutation) {
            return {
              label: salutation !== null && salutation !== void 0 && salutation.value ? salutation === null || salutation === void 0 ? void 0 : salutation.value : '',
              value: salutation !== null && salutation !== void 0 && salutation.code ? salutation === null || salutation === void 0 ? void 0 : salutation.code : ''
            };
          }) : salutationList === null || salutationList === void 0 ? void 0 : (_salutationList$filte2 = salutationList.filter(function (salutation) {
            var _salutation$gender2, _values$$gender3;

            return (salutation === null || salutation === void 0 ? void 0 : (_salutation$gender2 = salutation.gender) === null || _salutation$gender2 === void 0 ? void 0 : _salutation$gender2.toLowerCase()) === ((_values$$gender3 = values["".concat(m.relationship)].gender) === null || _values$$gender3 === void 0 ? void 0 : _values$$gender3.toLowerCase()) || !(salutation !== null && salutation !== void 0 && salutation.gender);
          })) === null || _salutationList$filte2 === void 0 ? void 0 : _salutationList$filte2.map(function (salutation) {
            return {
              label: salutation !== null && salutation !== void 0 && salutation.value ? salutation === null || salutation === void 0 ? void 0 : salutation.value : '',
              value: salutation !== null && salutation !== void 0 && salutation.code ? salutation === null || salutation === void 0 ? void 0 : salutation.code : ''
            };
          }) : [],
          name: "".concat(m.relationship, ".title"),
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0,
          onDataChange: function onDataChange(val, setFieldValue) {
            if (getDomainData(salutationList, val, 'value', 'code')) {
              setFieldValue("".concat(m.relationship, ".title"), getDomainData(salutationList, val, 'value', 'code'));
            }
          }
        }, {
          type: 'select',
          label: /*#__PURE__*/React.createElement("div", null, "Gender ", /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")),
          data: genderList ? _toConsumableArray(genderList.map(function (gender) {
            return {
              label: gender.value ? gender.value : '',
              value: gender.code ? gender.code : ''
            };
          })) : [],
          name: "".concat(m.relationship, ".gender"),
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0
        }, {
          type: 'date',
          label: /*#__PURE__*/React.createElement("div", {
            className: "space-x-2"
          }, /*#__PURE__*/React.createElement("span", null, "Date of Birth ", /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")), (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$quot = buyHealthPolicy.quoteData) === null || _buyHealthPolicy$quot === void 0 ? void 0 : (_buyHealthPolicy$quot2 = _buyHealthPolicy$quot.members) === null || _buyHealthPolicy$quot2 === void 0 ? void 0 : (_buyHealthPolicy$quot3 = _buyHealthPolicy$quot2.find(function (member) {
            return member.relationship === m.relationship;
          })) === null || _buyHealthPolicy$quot3 === void 0 ? void 0 : _buyHealthPolicy$quot3.dob) !== values["".concat(m.relationship)].dob && /*#__PURE__*/React.createElement(Text, {
            severity: "warning"
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faInfoCircle,
            title: "DOB changes might affect proposal premium.",
            className: "cursor-pointer"
          }))),
          name: "".concat(m.relationship, ".dob"),
          // disabled: buyHealthPolicy?.proposalNumber.length > 0,
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop3 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop3 === void 0 ? void 0 : _buyHealthPolicy$prop3.id) !== null && (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop4 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop4 === void 0 ? void 0 : _buyHealthPolicy$prop4.id.length) > 0 && m.relationship.toLowerCase() === 'self' && (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop5 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop5 === void 0 ? void 0 : _buyHealthPolicy$prop5.customerType) === 'Individual'
        }, {
          type: 'text',
          label: /*#__PURE__*/React.createElement("div", null, "First Name ", /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")),
          //disabled: buyHealthPolicy?.proposalNumber.length > 0,
          // disabled: buyHealthPolicy?.proposalNumber.length > 0 || ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0 && buyHealthPolicy?.proposerDetails?.id==='Individual') && (m.relationship.toLowerCase() === 'self'),
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop6 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop6 === void 0 ? void 0 : _buyHealthPolicy$prop6.id) !== null && (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop7 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop7 === void 0 ? void 0 : _buyHealthPolicy$prop7.id.length) > 0 && m.relationship.toLowerCase() === 'self' && (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop8 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop8 === void 0 ? void 0 : _buyHealthPolicy$prop8.customerType) === 'Individual',
          name: "".concat(m.relationship, ".firstName"),
          onKeyDown: function onKeyDown(evt) {
            var _evt$target, _evt$target$value, _evt$target$value$toS, _evt$target2, _evt$target2$value, _evt$target2$value$to;

            if (evt !== null && evt !== void 0 && (_evt$target = evt.target) !== null && _evt$target !== void 0 && (_evt$target$value = _evt$target.value) !== null && _evt$target$value !== void 0 && (_evt$target$value$toS = _evt$target$value.toString()) !== null && _evt$target$value$toS !== void 0 && _evt$target$value$toS.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target2 = evt.target) === null || _evt$target2 === void 0 ? void 0 : (_evt$target2$value = _evt$target2.value) === null || _evt$target2$value === void 0 ? void 0 : (_evt$target2$value$to = _evt$target2$value.toString()) === null || _evt$target2$value$to === void 0 ? void 0 : _evt$target2$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
              evt.preventDefault();
            }
          }
        }, {
          type: 'text',
          label: /*#__PURE__*/React.createElement("div", null, "Middle Name ", /*#__PURE__*/React.createElement(Text, null)),
          name: "".concat(m.relationship, ".middleName"),
          onKeyDown: function onKeyDown(evt) {
            var _evt$target3, _evt$target3$value, _evt$target3$value$to, _evt$target4, _evt$target4$value, _evt$target4$value$to;

            if (evt !== null && evt !== void 0 && (_evt$target3 = evt.target) !== null && _evt$target3 !== void 0 && (_evt$target3$value = _evt$target3.value) !== null && _evt$target3$value !== void 0 && (_evt$target3$value$to = _evt$target3$value.toString()) !== null && _evt$target3$value$to !== void 0 && _evt$target3$value$to.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target4 = evt.target) === null || _evt$target4 === void 0 ? void 0 : (_evt$target4$value = _evt$target4.value) === null || _evt$target4$value === void 0 ? void 0 : (_evt$target4$value$to = _evt$target4$value.toString()) === null || _evt$target4$value$to === void 0 ? void 0 : _evt$target4$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
              evt.preventDefault();
            }
          },
          // disabled: buyHealthPolicy?.proposalNumber.length > 0,
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop9 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop9 === void 0 ? void 0 : _buyHealthPolicy$prop9.id) !== null && (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop10 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop10 === void 0 ? void 0 : _buyHealthPolicy$prop10.id.length) > 0 && m.relationship.toLowerCase() === 'self' && (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop11 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop11 === void 0 ? void 0 : _buyHealthPolicy$prop11.customerType) === 'Individual'
        }, {
          type: 'text',
          label: /*#__PURE__*/React.createElement("div", null, "Last Name ", /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")),
          name: "".concat(m.relationship, ".lastName"),
          onKeyDown: function onKeyDown(evt) {
            var _evt$target5, _evt$target5$value, _evt$target5$value$to, _evt$target6, _evt$target6$value, _evt$target6$value$to;

            if (evt !== null && evt !== void 0 && (_evt$target5 = evt.target) !== null && _evt$target5 !== void 0 && (_evt$target5$value = _evt$target5.value) !== null && _evt$target5$value !== void 0 && (_evt$target5$value$to = _evt$target5$value.toString()) !== null && _evt$target5$value$to !== void 0 && _evt$target5$value$to.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target6 = evt.target) === null || _evt$target6 === void 0 ? void 0 : (_evt$target6$value = _evt$target6.value) === null || _evt$target6$value === void 0 ? void 0 : (_evt$target6$value$to = _evt$target6$value.toString()) === null || _evt$target6$value$to === void 0 ? void 0 : _evt$target6$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
              evt.preventDefault();
            }
          },
          // disabled: buyHealthPolicy?.proposalNumber.length > 0,
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop12 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop12 === void 0 ? void 0 : _buyHealthPolicy$prop12.id) !== null && (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop13 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop13 === void 0 ? void 0 : _buyHealthPolicy$prop13.id.length) > 0 && m.relationship.toLowerCase() === 'self' && (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : (_buyHealthPolicy$prop14 = buyHealthPolicy.proposerDetails) === null || _buyHealthPolicy$prop14 === void 0 ? void 0 : _buyHealthPolicy$prop14.customerType) === 'Individual'
        }, {
          type: 'select',
          label: /*#__PURE__*/React.createElement("div", null, "Marital Status ", /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")),
          data: maritalStatusList ? _toConsumableArray(maritalStatusList.map(function (maritalStatus) {
            return {
              label: maritalStatus.value ? maritalStatus.value : '',
              value: maritalStatus.code ? maritalStatus.code : ''
            };
          })) : [],
          name: "".concat(m.relationship, ".maritalStatus"),
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0
        }, {
          type: 'number',
          min: 0,
          label: /*#__PURE__*/React.createElement("div", null, "Height ", /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")),
          iconPost: 'cms',
          name: "".concat(m.relationship, ".height"),
          className: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 ? "border-neutral-dark" : "",
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0
        }, {
          type: 'number',
          min: 0,
          label: /*#__PURE__*/React.createElement("div", null, "Weight ", /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")),
          iconPost: 'Kgs',
          name: "".concat(m.relationship, ".weight"),
          className: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 ? "border-neutral-dark" : "",
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0
        }, {
          type: 'select',
          label: /*#__PURE__*/React.createElement("div", null, "Occupation ", /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")),
          data: PRD_OccupationList ? _toConsumableArray(PRD_OccupationList.map(function (occupation) {
            return {
              label: occupation.value ? occupation.value : '',
              value: occupation.code ? occupation.code : ''
            };
          })) : [],
          name: "".concat(m.relationship, ".occupation"),
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0,
          onDataChange: function onDataChange(val, setFieldValue) {
            setFieldValue("".concat(m.relationship, ".otherOccupation"), '');
          }
        }, {
          type: 'text',
          maxLength: 100,
          disabled: values["".concat(m.relationship)].occupation !== getDomainData(PRD_OccupationList, 'Others', 'value', 'code') || (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0,
          label: /*#__PURE__*/React.createElement("div", null, "If Others Occupation, please specify"),
          name: "".concat(m.relationship, ".otherOccupation")
        }, productCode !== '2877' ? productCode !== '2885' ? {
          type: 'select',
          label: /*#__PURE__*/React.createElement("div", null, "Pre-Existing Disease waiting period", /*#__PURE__*/React.createElement(Text, null)),
          data: PRD_PreExistDiseaseWaitPeriod ? _toConsumableArray(PRD_PreExistDiseaseWaitPeriod.map(function (pedWaitingPeriod) {
            return {
              label: pedWaitingPeriod.value ? pedWaitingPeriod.value : '',
              value: pedWaitingPeriod.code ? pedWaitingPeriod.code : ''
            };
          })) : [],
          name: "".concat(m.relationship, ".pedWaitingPeriod"),
          disabled: insuredcount === 1 ? false : true,
          onDataChange: function onDataChange(val, setFieldValue) {
            insuredDetails.map(function (m) {
              setFieldValue("".concat(m.relationship, ".pedWaitingPeriod"), val);
            });
          }
        } : '' : {
          type: 'select',
          label: /*#__PURE__*/React.createElement("div", null, "Pre-Existing Disease", /*#__PURE__*/React.createElement(Text, null)),
          data: PRD_PreExistDiseaseWaitPeriod ? _toConsumableArray(PRD_PreExistDiseaseWaitPeriod.map(function (pedWaitingPeriod) {
            return {
              label: pedWaitingPeriod.value ? pedWaitingPeriod.value : '',
              value: pedWaitingPeriod.code ? pedWaitingPeriod.code : ''
            };
          })) : [],
          name: "".concat(m.relationship, ".pedWaitingPeriod"),
          disabled: (buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber.length) > 0 || productCode.toString() === '2885' || productCode.toString() === '2880'
        }, productCode === '2877' && ((_ref3 = "".concat(m.relationship)) === null || _ref3 === void 0 ? void 0 : _ref3.toLowerCase()) === 'co-applicant' ? {
          type: 'select',
          label: /*#__PURE__*/React.createElement("div", null, "Insured Relationship with Proposer", /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*")),
          data: relationshipwithproposer ? _toConsumableArray(relationshipwithproposer.map(function (relationshipwithproposer) {
            return {
              label: relationshipwithproposer.value ? relationshipwithproposer.value : '',
              value: relationshipwithproposer.code ? relationshipwithproposer.code : ''
            };
          })) : [],
          name: "".concat(m.relationship, ".insuredrelationshipwithproposer")
        } : [], ((_getDomainData6 = getDomainData(businessTypeList, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quotationType, 'code', 'value')) === null || _getDomainData6 === void 0 ? void 0 : _getDomainData6.toLowerCase()) === 'roll ove' ? {
          type: 'select',
          label: /*#__PURE__*/React.createElement("div", null, "Cumulative Bonus (in %) ", /*#__PURE__*/React.createElement(Text, null)),
          data: PRD_CumulativeBonus ? _toConsumableArray(PRD_CumulativeBonus.map(function (cumulativeBonus) {
            var _cumulativeBonus$valu, _cumulativeBonus$code;

            return {
              label: cumulativeBonus.value ? cumulativeBonus === null || cumulativeBonus === void 0 ? void 0 : (_cumulativeBonus$valu = cumulativeBonus.value) === null || _cumulativeBonus$valu === void 0 ? void 0 : _cumulativeBonus$valu.toString() : '',
              value: cumulativeBonus.code ? cumulativeBonus === null || cumulativeBonus === void 0 ? void 0 : (_cumulativeBonus$code = cumulativeBonus.code) === null || _cumulativeBonus$code === void 0 ? void 0 : _cumulativeBonus$code.toString() : ''
            };
          })) : [],
          name: "".concat(m.relationship, ".cbBonusPct")
        } : null, m !== null && m !== void 0 && m.ppcTestLevel ? {
          type: 'render',
          component: function component() {
            return /*#__PURE__*/React.createElement("div", {
              className: "flex flex-col"
            }, /*#__PURE__*/React.createElement(Text, {
              type: "label",
              severity: "info"
            }, "PPC Test Level"), /*#__PURE__*/React.createElement(Text, null, m !== null && m !== void 0 && m.ppcTestLevel ? m === null || m === void 0 ? void 0 : m.ppcTestLevel : /*#__PURE__*/React.createElement(Text, {
              className: "opacity-40"
            }, "Not Captured")));
          }
        } : null, m !== null && m !== void 0 && m.memberStatus ? {
          type: 'render',
          component: function component() {
            return /*#__PURE__*/React.createElement("div", {
              className: "flex flex-col"
            }, /*#__PURE__*/React.createElement(Text, {
              type: "label",
              severity: "info"
            }, "Member Status"), /*#__PURE__*/React.createElement(Text, null, m !== null && m !== void 0 && m.memberStatus ? m === null || m === void 0 ? void 0 : m.memberStatus : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
              className: "opacity-40"
            }, "Not Captured"), /*#__PURE__*/React.createElement("br", null))));
          }
        } : null, {
          type: 'checkbox',
          name: "".concat(m.relationship, ".isPortabilityRequired"),
          label: /*#__PURE__*/React.createElement(Text, null, "Do you want to port this member from another insurer?"),
          colSpan: repeat
        }].filter(function (d) {
          return d;
        })
      };
    }) : [];
    var other_props = {
      flow: 'cols',
      repeat: repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaForm, {
      className: "space-y-4 mt-3"
    }, /*#__PURE__*/React.createElement(InputGridGroup, _objectSpread2({
      data: data
    }, other_props))));
  };

  var submitInsuredArr = function submitInsuredArr(values) {
    var submitArr = [];
    Object.keys(values).forEach(function (m) {
      var _values$m, _values$m2, _values$m3, _values$m4;

      submitArr.push(_objectSpread2(_objectSpread2({
        relationship: m
      }, values[m]), {}, {
        cbBonusPct: ((_values$m = values[m]) === null || _values$m === void 0 ? void 0 : _values$m.cbBonusPct) !== '' && ((_values$m2 = values[m]) === null || _values$m2 === void 0 ? void 0 : _values$m2.cbBonusPct) !== null && ((_values$m3 = values[m]) === null || _values$m3 === void 0 ? void 0 : _values$m3.cbBonusPct) !== undefined ? parseFloat((_values$m4 = values[m]) === null || _values$m4 === void 0 ? void 0 : _values$m4.cbBonusPct) : null
      }));
    });
    return {
      insuredDetails: submitArr
    };
  };

  var onSubmit = function onSubmit(values) {
    if (Object.values(validate(values)).length === 0) {
      setParentAlerts([]);
      setProceedToNextStep([proceedToNextStep[0], true].concat(_toConsumableArray(proceedToNextStep.slice(2))));
      updateBuyHealthPolicy(submitInsuredArr(values));
      return true;
    }

    return false;
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuantaFormik, {
    innerRef: props.forwardedRef,
    enableReinitialize: true,
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit,
    validator: function validator() {
      return {};
    }
  }, /*#__PURE__*/React.createElement(InsuredMemberForm, {
    validate: validate
  })));
}

var _excluded$1 = ["prevInsuranceDetails"];
function WizardPanel(_ref) {
  var startStep = _ref.startStep,
      isProposalNumberGenerated = _ref.isProposalNumberGenerated;
      _ref.customerID;
      var lobCode = _ref.lobCode,
      lobName = _ref.lobName,
      productName = _ref.productName,
      productCode = _ref.productCode,
      planName = _ref.planName,
      planCode = _ref.planCode,
      proposalNumber = _ref.proposalNumber,
      stepsDisabled = _ref.stepsDisabled;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      successMsg = _useState2[0],
      showSuccessMsg = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      alerts = _useState4[0],
      setAlerts = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loadingStep = _useState6[0],
      setLoadingStep = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      showWizardButtonPanel = _useState8[0],
      setShowWizardButtonPanel = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      customLoadingMessage = _useState10[0],
      setCustomLoadingMessage = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      disableProceed = _useState12[0],
      setDisableProcced = _useState12[1];

  var _useState13 = useState([false, false, false, false, false]),
      _useState14 = _slicedToArray(_useState13, 2),
      proceedToNextStep = _useState14[0],
      setProceedToNextStep = _useState14[1];

  var _useState15 = useState([null, null, null, null, null]),
      _useState16 = _slicedToArray(_useState15, 2),
      currentStepFunctions = _useState16[0],
      setCurrentStepFunctions = _useState16[1];

  var proposerFormRef = useRef();
  var insuredFormRef = useRef();
  var nomineeFormRef = useRef();
  var reviewAndConfirmRef = useRef();
  var payAndPremiumRef = useRef();
  var renderExpandedCards = useRef([{
    cardName: 'proposer customer',
    flag: false
  }, {
    cardName: 'insured members details',
    flag: false
  }, {
    cardName: 'nominee details',
    flag: false
  }, {
    cardName: 'previous insurance details',
    flag: false
  }, {
    cardName: 'underwriting assessment',
    flag: false
  }, {
    cardName: 'renewal mandate details',
    flag: false
  }, {
    cardName: 'uploaded document',
    flag: false
  }, {
    cardName: 'cheque 1',
    flag: true
  }, {
    cardName: 'dd 1',
    flag: true
  }]);
  var steps = [{
    label: 'Proposer',
    proceedLabel: function proceedLabel() {
      return 'Proceed';
    },
    disableStep: stepsDisabled && stepsDisabled[0] ? true : false,
    submitForm: function () {
      var _submitForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!proposerFormRef.current) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return proposerFormRef.current.submitForm();

              case 3:
                res = _context.sent;
                return _context.abrupt("return", res);

              case 5:
                return _context.abrupt("return", false);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function submitForm() {
        return _submitForm.apply(this, arguments);
      }

      return submitForm;
    }(),
    component: function component(_ref2) {
      var expanded = _ref2.expanded,
          goToStep = _ref2.goToStep;
      return expanded ? loadingStep ? /*#__PURE__*/React.createElement("div", {
        className: "min-h-screen"
      }, /*#__PURE__*/React.createElement(Loading, {
        customMessage: customLoadingMessage
      })) : /*#__PURE__*/React.createElement(ProposerDetailsHealth, {
        forwardedRef: proposerFormRef,
        goToStep: goToStep,
        proceedToNextStep: proceedToNextStep,
        setProceedToNextStep: setProceedToNextStep,
        setParentAlerts: setAlerts,
        setLoadingStep: setLoadingStep,
        setCustomLoadingMessage: setCustomLoadingMessage,
        lobCode: lobCode,
        lobName: lobName,
        productName: productName,
        productCode: productCode,
        planName: planName,
        planCode: planCode,
        proposalNumber: proposalNumber
      }) : null;
    },
    stepNotCompleteAlert: function stepNotCompleteAlert() {
      var _proposerFormRef$curr, _proposerFormRef$curr2, _proposerFormRef$curr3, _proposerFormRef$curr4, _proposerFormRef$curr5, _proposerFormRef$curr6, _proposerFormRef$curr7, _proposerFormRef$curr8, _proposerFormRef$curr9, _proposerFormRef$curr10;

      setAlerts([{
        header: 'Unable to proceed',
        id: Date.now(),
        content: /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row flex-wrap space-y-2 w-full h-full"
        }, /*#__PURE__*/React.createElement("span", null, proposerFormRef !== null && proposerFormRef !== void 0 && (_proposerFormRef$curr = proposerFormRef.current.errors) !== null && _proposerFormRef$curr !== void 0 && (_proposerFormRef$curr2 = _proposerFormRef$curr.proposerDetailsMeta) !== null && _proposerFormRef$curr2 !== void 0 && _proposerFormRef$curr2.isCRNVerified ? proposerFormRef === null || proposerFormRef === void 0 ? void 0 : (_proposerFormRef$curr3 = proposerFormRef.current.errors) === null || _proposerFormRef$curr3 === void 0 ? void 0 : (_proposerFormRef$curr4 = _proposerFormRef$curr3.proposerDetailsMeta) === null || _proposerFormRef$curr4 === void 0 ? void 0 : _proposerFormRef$curr4.isCRNVerified : (_proposerFormRef$curr5 = proposerFormRef.current) !== null && _proposerFormRef$curr5 !== void 0 && (_proposerFormRef$curr6 = _proposerFormRef$curr5.errors) !== null && _proposerFormRef$curr6 !== void 0 && (_proposerFormRef$curr7 = _proposerFormRef$curr6.proposerDetailsMeta) !== null && _proposerFormRef$curr7 !== void 0 && _proposerFormRef$curr7.isConfigIMD ? (_proposerFormRef$curr8 = proposerFormRef.current) === null || _proposerFormRef$curr8 === void 0 ? void 0 : (_proposerFormRef$curr9 = _proposerFormRef$curr8.errors) === null || _proposerFormRef$curr9 === void 0 ? void 0 : (_proposerFormRef$curr10 = _proposerFormRef$curr9.proposerDetailsMeta) === null || _proposerFormRef$curr10 === void 0 ? void 0 : _proposerFormRef$curr10.isConfigIMD : "Please fill the mandatory fields before proceeding.")),
        type: 'warning',
        timeout: null,
        disableClose: false
      }]);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, {
    label: 'Members',
    proceedLabel: function proceedLabel() {
      return 'Proceed';
    },
    disableStep: stepsDisabled && stepsDisabled[1] ? true : false,
    submitForm: function () {
      var _submitForm2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!insuredFormRef.current) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return insuredFormRef.current.submitForm();

              case 3:
                res = _context2.sent;
                return _context2.abrupt("return", res);

              case 5:
                return _context2.abrupt("return", false);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function submitForm() {
        return _submitForm2.apply(this, arguments);
      }

      return submitForm;
    }(),
    onPreviousStep: function onPreviousStep() {
      if (insuredFormRef.current) {
        var _insuredFormRef$curre;

        var submitArr = [];
        Object.keys(insuredFormRef === null || insuredFormRef === void 0 ? void 0 : (_insuredFormRef$curre = insuredFormRef.current) === null || _insuredFormRef$curre === void 0 ? void 0 : _insuredFormRef$curre.values).forEach(function (m) {
          var _insuredFormRef$curre2;

          submitArr.push(_objectSpread2({
            relationship: m
          }, insuredFormRef === null || insuredFormRef === void 0 ? void 0 : (_insuredFormRef$curre2 = insuredFormRef.current) === null || _insuredFormRef$curre2 === void 0 ? void 0 : _insuredFormRef$curre2.values[m]));
        });
        updateBuyHealthPolicy({
          insuredDetails: submitArr
        });
      }
    },
    component: function component(_ref3) {
      var expanded = _ref3.expanded,
          goToStep = _ref3.goToStep;
      return expanded ? loadingStep ? /*#__PURE__*/React.createElement(Loading, {
        customMessage: customLoadingMessage
      }) : /*#__PURE__*/React.createElement(InsuredMembers, {
        forwardedRef: insuredFormRef,
        goToStep: goToStep,
        proceedToNextStep: proceedToNextStep,
        setProceedToNextStep: setProceedToNextStep,
        setParentAlerts: setAlerts,
        lobCode: lobCode,
        lobName: lobName,
        productName: productName,
        productCode: productCode,
        planName: planName,
        planCode: planCode,
        proposalNumber: proposalNumber,
        renderExpandedCards: renderExpandedCards
      }) : null;
    },
    stepNotCompleteAlert: function stepNotCompleteAlert() {
      setAlerts([{
        header: 'Unable to proceed',
        id: Date.now(),
        content: /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row flex-wrap space-y-2 w-full h-full"
        }, /*#__PURE__*/React.createElement("span", null, "Please fill the mandatory fields before proceeding.")),
        type: 'warning',
        timeout: null,
        disableClose: false
      }]);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, {
    label: 'Additional Details',
    proceedLabel: function proceedLabel() {
      return 'Calculate and Proceed';
    },
    disabledLabel: disableProceed,
    disableStep: stepsDisabled && stepsDisabled[2] ? true : false,
    submitForm: function () {
      var _submitForm3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!nomineeFormRef.current) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 3;
                return nomineeFormRef.current.submitForm();

              case 3:
                res = _context3.sent;
                return _context3.abrupt("return", res);

              case 5:
                return _context3.abrupt("return", false);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function submitForm() {
        return _submitForm3.apply(this, arguments);
      }

      return submitForm;
    }(),
    onPreviousStep: function onPreviousStep() {
      if (nomineeFormRef.current) {
        var _nomineeFormRef$curre, _nomineeFormRef$curre5, _nomineeFormRef$curre6, _nomineeFormRef$curre7, _nomineeFormRef$curre8, _nomineeFormRef$curre9, _nomineeFormRef$curre10, _nomineeFormRef$curre11, _nomineeFormRef$curre12, _nomineeFormRef$curre13, _nomineeFormRef$curre14, _nomineeFormRef$curre15, _nomineeFormRef$curre16, _nomineeFormRef$curre17, _nomineeFormRef$curre18, _nomineeFormRef$curre19, _nomineeFormRef$curre20, _nomineeFormRef$curre21, _nomineeFormRef$curre22, _nomineeFormRef$curre23, _nomineeFormRef$curre24, _nomineeFormRef$curre25, _nomineeFormRef$curre26, _nomineeFormRef$curre27, _nomineeFormRef$curre28, _nomineeFormRef$curre29, _nomineeFormRef$curre30, _nomineeFormRef$curre31, _nomineeFormRef$curre32;

        var submitArr = [];
        var prevInsuredArr = [];
        Object.keys(nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre = nomineeFormRef.current) === null || _nomineeFormRef$curre === void 0 ? void 0 : _nomineeFormRef$curre.values).forEach(function (m) {
          var _nomineeFormRef$curre2;

          if (_typeof(nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre2 = nomineeFormRef.current) === null || _nomineeFormRef$curre2 === void 0 ? void 0 : _nomineeFormRef$curre2.values[m]) === 'object' && (m === null || m === void 0 ? void 0 : m.toLowerCase()) !== 'renewalmandatedetails') {
            var _nomineeFormRef$curre4;

            var _nomineeFormRef$curre3 = nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre4 = nomineeFormRef.current) === null || _nomineeFormRef$curre4 === void 0 ? void 0 : _nomineeFormRef$curre4.values[m],
                prevInsuranceDetails = _nomineeFormRef$curre3.prevInsuranceDetails,
                restValues = _objectWithoutProperties(_nomineeFormRef$curre3, _excluded$1);

            submitArr.push(_objectSpread2({
              relationship: m
            }, restValues));
            prevInsuredArr.push(prevInsuranceDetails);
          }
        });
        updateBuyHealthPolicy({
          nomineeDetails: submitArr,
          prevInsuranceDetails: prevInsuredArr,
          sameNomineeForAllInsured: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre5 = nomineeFormRef.current) === null || _nomineeFormRef$curre5 === void 0 ? void 0 : (_nomineeFormRef$curre6 = _nomineeFormRef$curre5.values) === null || _nomineeFormRef$curre6 === void 0 ? void 0 : _nomineeFormRef$curre6.sameNomineeForAllInsured,
          isHealthDeclarationSelected: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre7 = nomineeFormRef.current) === null || _nomineeFormRef$curre7 === void 0 ? void 0 : (_nomineeFormRef$curre8 = _nomineeFormRef$curre7.values) === null || _nomineeFormRef$curre8 === void 0 ? void 0 : _nomineeFormRef$curre8.isHealthDeclarationSelected,
          renewalMandateDetails: {
            renewalPaymentMandate: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre9 = nomineeFormRef.current) === null || _nomineeFormRef$curre9 === void 0 ? void 0 : (_nomineeFormRef$curre10 = _nomineeFormRef$curre9.values) === null || _nomineeFormRef$curre10 === void 0 ? void 0 : _nomineeFormRef$curre10.renewalPaymentMandate,
            renewalPaymentMandateTakenInNameOf: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre11 = nomineeFormRef.current) === null || _nomineeFormRef$curre11 === void 0 ? void 0 : (_nomineeFormRef$curre12 = _nomineeFormRef$curre11.values) === null || _nomineeFormRef$curre12 === void 0 ? void 0 : _nomineeFormRef$curre12.renewalPaymentMandateTakenInNameOf,
            termForMandateOpted: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre13 = nomineeFormRef.current) === null || _nomineeFormRef$curre13 === void 0 ? void 0 : (_nomineeFormRef$curre14 = _nomineeFormRef$curre13.values) === null || _nomineeFormRef$curre14 === void 0 ? void 0 : _nomineeFormRef$curre14.termForMandateOpted,
            typeOfDebit: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre15 = nomineeFormRef.current) === null || _nomineeFormRef$curre15 === void 0 ? void 0 : (_nomineeFormRef$curre16 = _nomineeFormRef$curre15.values) === null || _nomineeFormRef$curre16 === void 0 ? void 0 : _nomineeFormRef$curre16.typeOfDebit,
            accountNumber: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre17 = nomineeFormRef.current) === null || _nomineeFormRef$curre17 === void 0 ? void 0 : (_nomineeFormRef$curre18 = _nomineeFormRef$curre17.values) === null || _nomineeFormRef$curre18 === void 0 ? void 0 : _nomineeFormRef$curre18.accountNumber,
            destinationBankName: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre19 = nomineeFormRef.current) === null || _nomineeFormRef$curre19 === void 0 ? void 0 : (_nomineeFormRef$curre20 = _nomineeFormRef$curre19.values) === null || _nomineeFormRef$curre20 === void 0 ? void 0 : _nomineeFormRef$curre20.destinationBankName,
            destinationIfscCode: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre21 = nomineeFormRef.current) === null || _nomineeFormRef$curre21 === void 0 ? void 0 : (_nomineeFormRef$curre22 = _nomineeFormRef$curre21.values) === null || _nomineeFormRef$curre22 === void 0 ? void 0 : _nomineeFormRef$curre22.destinationIfscCode,
            destinationMicrCode: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre23 = nomineeFormRef.current) === null || _nomineeFormRef$curre23 === void 0 ? void 0 : (_nomineeFormRef$curre24 = _nomineeFormRef$curre23.values) === null || _nomineeFormRef$curre24 === void 0 ? void 0 : _nomineeFormRef$curre24.destinationMicrCode,
            destinationBranchName: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre25 = nomineeFormRef.current) === null || _nomineeFormRef$curre25 === void 0 ? void 0 : (_nomineeFormRef$curre26 = _nomineeFormRef$curre25.values) === null || _nomineeFormRef$curre26 === void 0 ? void 0 : _nomineeFormRef$curre26.destinationBranchName,
            mandateAmount: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre27 = nomineeFormRef.current) === null || _nomineeFormRef$curre27 === void 0 ? void 0 : (_nomineeFormRef$curre28 = _nomineeFormRef$curre27.values) === null || _nomineeFormRef$curre28 === void 0 ? void 0 : _nomineeFormRef$curre28.mandateAmount,
            finalCollectionDate: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre29 = nomineeFormRef.current) === null || _nomineeFormRef$curre29 === void 0 ? void 0 : (_nomineeFormRef$curre30 = _nomineeFormRef$curre29.values) === null || _nomineeFormRef$curre30 === void 0 ? void 0 : _nomineeFormRef$curre30.finalCollectionDate,
            destinationBankAccountType: nomineeFormRef === null || nomineeFormRef === void 0 ? void 0 : (_nomineeFormRef$curre31 = nomineeFormRef.current) === null || _nomineeFormRef$curre31 === void 0 ? void 0 : (_nomineeFormRef$curre32 = _nomineeFormRef$curre31.values) === null || _nomineeFormRef$curre32 === void 0 ? void 0 : _nomineeFormRef$curre32.destinationBankAccountType
          }
        });
      }
    },
    component: function component(_ref4) {
      var expanded = _ref4.expanded;
      return expanded ? loadingStep ? /*#__PURE__*/React.createElement("div", {
        className: "min-h-screen"
      }, /*#__PURE__*/React.createElement(Loading, {
        customMessage: customLoadingMessage
      })) : /*#__PURE__*/React.createElement(NomineeDetails, {
        forwardedRef: nomineeFormRef,
        proceedToNextStep: proceedToNextStep,
        setProceedToNextStep: setProceedToNextStep,
        setParentAlerts: setAlerts,
        setCustomLoadingMessage: setCustomLoadingMessage,
        setLoadingStep: setLoadingStep,
        setDisableProcced: setDisableProcced,
        lobCode: lobCode,
        lobName: lobName,
        productName: productName,
        productCode: productCode,
        planName: planName,
        planCode: planCode,
        proposalNumber: proposalNumber,
        renderExpandedCards: renderExpandedCards
      }) : null;
    },
    stepNotCompleteAlert: function stepNotCompleteAlert() {
      setAlerts([{
        header: 'Unable to proceed',
        id: Date.now(),
        content: /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row flex-wrap space-y-2 w-full h-full"
        }, /*#__PURE__*/React.createElement("span", null, "Please fill the mandatory fields before proceeding.")),
        type: 'warning',
        timeout: null,
        disableClose: false
      }]);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, {
    label: 'Review & Confirm',
    proceedLabel: function proceedLabel() {
      return isProposalNumberGenerated ? 'Proceed to Buy' : 'Create Proposal';
    },
    disableStep: stepsDisabled && stepsDisabled[3] ? true : false,
    submitForm: function () {
      var _submitForm4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!reviewAndConfirmRef.current) {
                  _context4.next = 6;
                  break;
                }

                setAlerts([]);
                _context4.next = 4;
                return reviewAndConfirmRef.current.submitForm();

              case 4:
                res = _context4.sent;
                return _context4.abrupt("return", res);

              case 6:
                return _context4.abrupt("return", false);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function submitForm() {
        return _submitForm4.apply(this, arguments);
      }

      return submitForm;
    }(),
    onPreviousStep: function onPreviousStep() {
      if (reviewAndConfirmRef.current) {
        var _reviewAndConfirmRef$, _reviewAndConfirmRef$2;

        updateBuyHealthPolicy({
          proposalPaymentType: reviewAndConfirmRef === null || reviewAndConfirmRef === void 0 ? void 0 : (_reviewAndConfirmRef$ = reviewAndConfirmRef.current) === null || _reviewAndConfirmRef$ === void 0 ? void 0 : (_reviewAndConfirmRef$2 = _reviewAndConfirmRef$.values) === null || _reviewAndConfirmRef$2 === void 0 ? void 0 : _reviewAndConfirmRef$2.proposalPaymentType
        });
      }
    },
    component: function component(_ref5) {
      var expanded = _ref5.expanded,
          goToStep = _ref5.goToStep;
      return expanded ? loadingStep ? /*#__PURE__*/React.createElement("div", {
        className: "min-h-screen"
      }, /*#__PURE__*/React.createElement(Loading, {
        customMessage: customLoadingMessage
      })) : /*#__PURE__*/React.createElement(ReviewConfirmDetails, {
        forwardedRef: reviewAndConfirmRef,
        goToStep: goToStep,
        proceedToNextStep: proceedToNextStep,
        setProceedToNextStep: setProceedToNextStep,
        currentStepFunctions: currentStepFunctions,
        setCurrentStepFunctions: setCurrentStepFunctions,
        setParentAlerts: setAlerts,
        setLoadingStep: setLoadingStep,
        setCustomLoadingMessage: setCustomLoadingMessage,
        lobCode: lobCode,
        lobName: lobName,
        productName: productName,
        productCode: productCode,
        planName: planName,
        planCode: planCode,
        proposalNumber: proposalNumber,
        renderExpandedCards: renderExpandedCards,
        alerts: alerts
      }) : null;
    }
  }, {
    label: 'Pay Premium',
    proceedLabel: function proceedLabel() {
      return 'Submit';
    },
    disableStep: stepsDisabled && stepsDisabled[4] ? true : false,
    submitForm: function () {
      var _submitForm5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                setAlerts([]);

                if (!payAndPremiumRef.current) {
                  _context5.next = 6;
                  break;
                }

                _context5.next = 4;
                return payAndPremiumRef.current.submitForm();

              case 4:
                res = _context5.sent;
                return _context5.abrupt("return", res);

              case 6:
                return _context5.abrupt("return", false);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function submitForm() {
        return _submitForm5.apply(this, arguments);
      }

      return submitForm;
    }(),
    onPreviousStep: function onPreviousStep() {
      if (payAndPremiumRef.current) {
        var _payAndPremiumRef$cur;

        updateBuyHealthPolicy({
          premiumDetails: payAndPremiumRef === null || payAndPremiumRef === void 0 ? void 0 : (_payAndPremiumRef$cur = payAndPremiumRef.current) === null || _payAndPremiumRef$cur === void 0 ? void 0 : _payAndPremiumRef$cur.values
        });
      }
    },
    component: function component(_ref6) {
      var expanded = _ref6.expanded;
      return expanded ? loadingStep ? /*#__PURE__*/React.createElement("div", {
        className: "min-h-screen"
      }, /*#__PURE__*/React.createElement(Loading, {
        customMessage: customLoadingMessage
      })) : GET_BUY_HEALTH_POLICY_VAR_DETAILS ? /*#__PURE__*/React.createElement(PayPremium, {
        forwardedRef: payAndPremiumRef,
        setLoadingStep: setLoadingStep,
        setCustomLoadingMessage: setCustomLoadingMessage,
        showSuccessMsg: showSuccessMsg,
        setParentAlerts: setAlerts,
        setShowWizardButtonPanel: setShowWizardButtonPanel,
        lobCode: lobCode,
        lobName: lobName,
        productName: productName,
        productCode: productCode,
        planName: planName,
        planCode: planCode,
        proposalNumber: proposalNumber,
        REACTIVE_VAR_QUERY: GET_BUY_HEALTH_POLICY_VAR_DETAILS,
        reactiveVarName: 'buyHealthPolicy',
        updateReactiveVar: updateBuyHealthPolicy,
        renderExpandedCards: renderExpandedCards
      }) : null : null;
    },
    stepNotCompleteAlert: function stepNotCompleteAlert() {
      var _payAndPremiumRef$cur2, _payAndPremiumRef$cur3, _payAndPremiumRef$cur4, _payAndPremiumRef$cur5, _payAndPremiumRef$cur6, _payAndPremiumRef$cur7, _payAndPremiumRef$cur8, _payAndPremiumRef$cur9, _payAndPremiumRef$cur10, _payAndPremiumRef$cur11, _payAndPremiumRef$cur12, _payAndPremiumRef$cur13, _payAndPremiumRef$cur14, _payAndPremiumRef$cur15, _payAndPremiumRef$cur16;

      setAlerts([{
        header: 'Unable to proceed',
        id: Date.now(),
        content: /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row flex-wrap space-y-2 w-full h-full"
        }, /*#__PURE__*/React.createElement("span", null, (_payAndPremiumRef$cur2 = payAndPremiumRef.current.errors) !== null && _payAndPremiumRef$cur2 !== void 0 && _payAndPremiumRef$cur2.totalPaymentAmount ? (_payAndPremiumRef$cur3 = payAndPremiumRef.current.errors) === null || _payAndPremiumRef$cur3 === void 0 ? void 0 : _payAndPremiumRef$cur3.totalPaymentAmount : (_payAndPremiumRef$cur4 = payAndPremiumRef.current.errors) !== null && _payAndPremiumRef$cur4 !== void 0 && _payAndPremiumRef$cur4.payerName ? (_payAndPremiumRef$cur5 = payAndPremiumRef.current.errors) === null || _payAndPremiumRef$cur5 === void 0 ? void 0 : _payAndPremiumRef$cur5.payerName : (_payAndPremiumRef$cur6 = payAndPremiumRef.current.errors) !== null && _payAndPremiumRef$cur6 !== void 0 && (_payAndPremiumRef$cur7 = _payAndPremiumRef$cur6.onlinePayment) !== null && _payAndPremiumRef$cur7 !== void 0 && _payAndPremiumRef$cur7.isTransactionIdVerified ? (_payAndPremiumRef$cur8 = payAndPremiumRef.current.errors) === null || _payAndPremiumRef$cur8 === void 0 ? void 0 : (_payAndPremiumRef$cur9 = _payAndPremiumRef$cur8.onlinePayment) === null || _payAndPremiumRef$cur9 === void 0 ? void 0 : _payAndPremiumRef$cur9.isTransactionIdVerified : payAndPremiumRef !== null && payAndPremiumRef !== void 0 && (_payAndPremiumRef$cur10 = payAndPremiumRef.current) !== null && _payAndPremiumRef$cur10 !== void 0 && (_payAndPremiumRef$cur11 = _payAndPremiumRef$cur10.errors) !== null && _payAndPremiumRef$cur11 !== void 0 && (_payAndPremiumRef$cur12 = _payAndPremiumRef$cur11.cdWallet) !== null && _payAndPremiumRef$cur12 !== void 0 && _payAndPremiumRef$cur12.cdAccountCount ? payAndPremiumRef === null || payAndPremiumRef === void 0 ? void 0 : (_payAndPremiumRef$cur13 = payAndPremiumRef.current) === null || _payAndPremiumRef$cur13 === void 0 ? void 0 : (_payAndPremiumRef$cur14 = _payAndPremiumRef$cur13.errors) === null || _payAndPremiumRef$cur14 === void 0 ? void 0 : (_payAndPremiumRef$cur15 = _payAndPremiumRef$cur14.cdWallet) === null || _payAndPremiumRef$cur15 === void 0 ? void 0 : _payAndPremiumRef$cur15.cdAccountCount : (_payAndPremiumRef$cur16 = payAndPremiumRef.current.values) !== null && _payAndPremiumRef$cur16 !== void 0 && _payAndPremiumRef$cur16.termsAndConditions ? "Please fill the mandatory fields before proceeding" : 'Please fill the mandatory fields and accept terms and conditions before proceeding.')),
        type: 'warning',
        timeout: null,
        disableClose: false
      }]);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }];
  return /*#__PURE__*/React.createElement(Card, {
    className: "min-h-full",
    severity: "".concat(successMsg ? 'success' : 'info')
  }, successMsg ? /*#__PURE__*/React.createElement(SuccessPage, {
    lobCode: lobCode,
    lobName: lobName,
    productName: productName,
    productCode: productCode,
    planName: planName,
    planCode: planCode,
    proposalNumber: proposalNumber,
    REACTIVE_VAR_QUERY: GET_BUY_HEALTH_POLICY_VAR_DETAILS,
    reactiveVarName: 'buyHealthPolicy'
  }) : /*#__PURE__*/React.createElement(Wizard, {
    steps: steps,
    startStep: startStep ? startStep : 0,
    tabStyle: true,
    showButtonPanel: showWizardButtonPanel !== null ? showWizardButtonPanel : !loadingStep
  }), /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts,
    resetAlerts: function resetAlerts(idx) {
      var alertToBeRemovedPos = alerts.findIndex(function (a) {
        return a.id === idx;
      });
      setAlerts([].concat(_toConsumableArray(alerts.slice(0, alertToBeRemovedPos)), _toConsumableArray(alerts.slice(alertToBeRemovedPos + 1, alerts.length))));
    }
  }));
}

var _excluded = ["ppcTestLevel", "memberID", "memberStatus"],
    _excluded2 = ["relationship"],
    _excluded3 = ["crn", "isNewCustomer"];
function QuoteSummary(_ref) {
  var _screenSize$toString, _plans$find2, _plans$find2$premium, _screenSize$toString2, _dataBuyHealthPolicy$;

  _ref.lobCode;
      _ref.lobName;
      var productName = _ref.productName,
      productCode = _ref.productCode,
      planName = _ref.planName,
      planCode = _ref.planCode;
      _ref.proposalNumber;

  var _useQuery = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS),
      loading = _useQuery.loading,
      error = _useQuery.error,
      dataBuyHealthPolicy = _useQuery.data;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showViewBreakup = _useState2[0],
      setShowViewBreakup = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loadingDownload = _useState4[0],
      setLoadingDownload = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      alerts = _useState6[0],
      setAlerts = _useState6[1];

  var fetchQuery = useFetchQuery();
  var mutateQuery = useMutationQuery();

  var _useQuery2 = useQuery(GET_GENDER_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loadingGenderList = _useQuery2.loading,
      errorGenderList = _useQuery2.error,
      dataGenderList = _useQuery2.data;

  if (dataBuyHealthPolicy) {
    var buyHealthPolicy = dataBuyHealthPolicy === null || dataBuyHealthPolicy === void 0 ? void 0 : dataBuyHealthPolicy.buyHealthPolicy;
    var planData = buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.planData;
    var plans = planData === null || planData === void 0 ? void 0 : planData.plans;
  }

  if (dataGenderList) {
    var genderList = dataGenderList.genderList;
  }

  var screenSize = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
    for_iPad: 'iPad'
  });
  var repeat = useResponsiveParams({
    for_mobile: 2,
    for_iPad: 4
  });

  var getBase64Var = function getBase64Var(buyHealthPolicyData, getDateTimeData) {
    var _buyHealthPolicyData$2, _buyHealthPolicyData$3, _buyHealthPolicyData$4, _buyHealthPolicyData$5, _buyHealthPolicyData$6, _buyHealthPolicyData$7, _buyHealthPolicyData$8, _buyHealthPolicyData$9, _buyHealthPolicyData$10, _buyHealthPolicyData$11, _buyHealthPolicyData$12, _buyHealthPolicyData$13, _buyHealthPolicyData$14, _buyHealthPolicyData$15, _buyHealthPolicyData$16, _buyHealthPolicyData$17, _buyHealthPolicyData$18, _buyHealthPolicyData$19, _buyHealthPolicyData$20, _buyHealthPolicyData$21, _buyHealthPolicyData$22, _buyHealthPolicyData$23, _buyHealthPolicyData$24, _buyHealthPolicyData$25, _buyHealthPolicyData$26, _buyHealthPolicyData$27, _buyHealthPolicyData$28, _buyHealthPolicyData$29, _buyHealthPolicyData$30, _getDateTimeData$date, _buyHealthPolicyData$31, _buyHealthPolicyData$32, _buyHealthPolicyData$33, _buyHealthPolicyData$34, _buyHealthPolicyData$35, _buyHealthPolicyData$36, _buyHealthPolicyData$37, _buyHealthPolicyData$38, _buyHealthPolicyData$39, _buyHealthPolicyData$40, _buyHealthPolicyData$41, _buyHealthPolicyData$42, _buyHealthPolicyData$43, _buyHealthPolicyData$44, _buyHealthPolicyData$45, _buyHealthPolicyData$46, _buyHealthPolicyData$47, _buyHealthPolicyData$48, _buyHealthPolicyData$49, _buyHealthPolicyData$50, _buyHealthPolicyData$51;

    var getInsuredDetailsObj = function getInsuredDetailsObj(insuredDetails, nomineeDetails, prevInsuranceDetails, medicalQuestionaire, planData, isHealthDeclarationSelected) {
      var insuredDetailsResponseArr = [];
      insuredDetails.forEach(function (insured) {
        var _prevInsuranceInput$p, _medicalQuestionaireO, _medicalQuestionaireO2, _plans$find, _plans$find$packs;

        insured.ppcTestLevel;
            insured.memberID;
            insured.memberStatus;
            var restInsured = _objectWithoutProperties(insured, _excluded);

        var insuredObj = _objectSpread2({}, restInsured);

        var nomineeObj = nomineeDetails === null || nomineeDetails === void 0 ? void 0 : nomineeDetails.find(function (nominee) {
          var _nominee$relationship, _insured$relationship;

          return (nominee === null || nominee === void 0 ? void 0 : (_nominee$relationship = nominee.relationship) === null || _nominee$relationship === void 0 ? void 0 : _nominee$relationship.toLowerCase()) === (insured === null || insured === void 0 ? void 0 : (_insured$relationship = insured.relationship) === null || _insured$relationship === void 0 ? void 0 : _insured$relationship.toLowerCase());
        });

        var relationship = nomineeObj.relationship,
            restNomineeObj = _objectWithoutProperties(nomineeObj, _excluded2);

        insuredObj.nomineeDetails = _objectSpread2(_objectSpread2({}, restNomineeObj), {}, {
          insuredRelationship: relationship
        });
        var prevInsuranceInput = prevInsuranceDetails === null || prevInsuranceDetails === void 0 ? void 0 : prevInsuranceDetails.find(function (prevInsured) {
          var _prevInsured$insuredR, _insured$relationship2;

          return (prevInsured === null || prevInsured === void 0 ? void 0 : (_prevInsured$insuredR = prevInsured.insuredRelationship) === null || _prevInsured$insuredR === void 0 ? void 0 : _prevInsured$insuredR.toLowerCase()) === (insured === null || insured === void 0 ? void 0 : (_insured$relationship2 = insured.relationship) === null || _insured$relationship2 === void 0 ? void 0 : _insured$relationship2.toLowerCase());
        });
        insuredObj.prevInsuranceInput = {
          prevInsurerName: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevInsurerName,
          prevPolicyNo: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicyNo,
          prevPolicySI: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicySI,
          prevClaimLodged: (prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : (_prevInsuranceInput$p = prevInsuranceInput.prevClaimLodged) === null || _prevInsuranceInput$p === void 0 ? void 0 : _prevInsuranceInput$p.toLowerCase()) === 'yes' ? true : false,
          claimAmount: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.claimAmount,
          prevPolicyStartDate: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicyStartDate,
          prevPolicyEndDate: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.prevPolicyEndDate,
          cbAmount: prevInsuranceInput === null || prevInsuranceInput === void 0 ? void 0 : prevInsuranceInput.cbAmount
        };
        var medicalQuestionaireObj = isHealthDeclarationSelected ? medicalQuestionaire === null || medicalQuestionaire === void 0 ? void 0 : medicalQuestionaire.find(function (m) {
          var _m$relationship, _insured$relationship3;

          return (m === null || m === void 0 ? void 0 : (_m$relationship = m.relationship) === null || _m$relationship === void 0 ? void 0 : _m$relationship.toLowerCase()) === (insured === null || insured === void 0 ? void 0 : (_insured$relationship3 = insured.relationship) === null || _insured$relationship3 === void 0 ? void 0 : _insured$relationship3.toLowerCase());
        }) : {
          relationship: insured === null || insured === void 0 ? void 0 : insured.relationship,
          questions: []
        };

        if (medicalQuestionaireObj && ((_medicalQuestionaireO = medicalQuestionaireObj) === null || _medicalQuestionaireO === void 0 ? void 0 : (_medicalQuestionaireO2 = _medicalQuestionaireO.questions) === null || _medicalQuestionaireO2 === void 0 ? void 0 : _medicalQuestionaireO2.length) > 0) {
          var _medicalQuestionaireO3, _medicalQuestionaireO4, _medicalQuestionaireO5, _medicalQuestionaireO6, _medicalQuestionaireO7, _medicalQuestionaireO8, _medicalQuestionaireO9, _medicalQuestionaireO10;

          medicalQuestionaireObj = _objectSpread2(_objectSpread2({}, medicalQuestionaireObj), {}, {
            questions: (_medicalQuestionaireO3 = medicalQuestionaireObj) === null || _medicalQuestionaireO3 === void 0 ? void 0 : (_medicalQuestionaireO4 = _medicalQuestionaireO3.questions) === null || _medicalQuestionaireO4 === void 0 ? void 0 : _medicalQuestionaireO4.map(function (question) {
              var _question$answer;

              return {
                srNo: question === null || question === void 0 ? void 0 : question.srNo,
                answer: question === null || question === void 0 ? void 0 : (_question$answer = question.answer) === null || _question$answer === void 0 ? void 0 : _question$answer.answerText
              };
            })
          });
          medicalQuestionaireObj = _objectSpread2(_objectSpread2({}, medicalQuestionaireObj), {}, {
            questions: ((_medicalQuestionaireO5 = medicalQuestionaireObj) === null || _medicalQuestionaireO5 === void 0 ? void 0 : (_medicalQuestionaireO6 = _medicalQuestionaireO5.questions) === null || _medicalQuestionaireO6 === void 0 ? void 0 : (_medicalQuestionaireO7 = _medicalQuestionaireO6.find(function (q) {
              var _q$srNo;

              return (q === null || q === void 0 ? void 0 : (_q$srNo = q.srNo) === null || _q$srNo === void 0 ? void 0 : _q$srNo.toLowerCase()) === 'master';
            })) === null || _medicalQuestionaireO7 === void 0 ? void 0 : (_medicalQuestionaireO8 = _medicalQuestionaireO7.answer) === null || _medicalQuestionaireO8 === void 0 ? void 0 : _medicalQuestionaireO8.toLowerCase()) === 'no' ? (_medicalQuestionaireO9 = medicalQuestionaireObj) === null || _medicalQuestionaireO9 === void 0 ? void 0 : (_medicalQuestionaireO10 = _medicalQuestionaireO9.questions) === null || _medicalQuestionaireO10 === void 0 ? void 0 : _medicalQuestionaireO10.filter(function (q) {
              var _q$srNo2;

              return (q === null || q === void 0 ? void 0 : (_q$srNo2 = q.srNo) === null || _q$srNo2 === void 0 ? void 0 : _q$srNo2.toLowerCase()) !== 'master';
            }) : []
          });
        }

        insuredObj.medicalQuestionaire = medicalQuestionaireObj ? medicalQuestionaireObj : {
          relationship: insured === null || insured === void 0 ? void 0 : insured.relationship,
          questions: []
        };
        var plans = planData.plans;
        insuredObj.addOnCovers = plans === null || plans === void 0 ? void 0 : (_plans$find = plans.find(function (p) {
          var _p$name;

          return (p === null || p === void 0 ? void 0 : (_p$name = p.name) === null || _p$name === void 0 ? void 0 : _p$name.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
        })) === null || _plans$find === void 0 ? void 0 : (_plans$find$packs = _plans$find.packs) === null || _plans$find$packs === void 0 ? void 0 : _plans$find$packs.filter(function (pack) {
          var _pack$index;

          return pack === null || pack === void 0 ? void 0 : (_pack$index = pack.index) === null || _pack$index === void 0 ? void 0 : _pack$index.includes(insured === null || insured === void 0 ? void 0 : insured.relationship);
        }).flatMap(function (pack) {
          return pack.addOnCovers.filter(function (addOnCover) {
            return addOnCover.selected;
          });
        });

        if (!insuredObj.addOnCovers) {
          insuredObj.addOnCovers = [];
        }

        insuredDetailsResponseArr.push(insuredObj);
      });
      return insuredDetailsResponseArr;
    };

    var _buyHealthPolicyData$ = buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.proposerDetailsMeta;
        _buyHealthPolicyData$.crn;
        _buyHealthPolicyData$.isNewCustomer;
        var restProposerMetaData = _objectWithoutProperties(_buyHealthPolicyData$, _excluded3);

    return {
      input: {
        proposerDetails: _objectSpread2(_objectSpread2(_objectSpread2({}, restProposerMetaData), buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.proposerDetails), {}, {
          isThinCustomer: false
        }),
        insuredDetails: getInsuredDetailsObj(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.insuredDetails, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.nomineeDetails, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.prevInsuranceDetails, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.medicalQuestionaire, buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.planData, (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$2 = buyHealthPolicyData.isHealthDeclarationSelected) === null || _buyHealthPolicyData$2 === void 0 ? void 0 : _buyHealthPolicyData$2.toLowerCase()) === 'yes'),
        plan: {
          name: planName,
          code: planCode,
          covers: (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$3 = buyHealthPolicyData.planData) === null || _buyHealthPolicyData$3 === void 0 ? void 0 : (_buyHealthPolicyData$4 = _buyHealthPolicyData$3.plans) === null || _buyHealthPolicyData$4 === void 0 ? void 0 : (_buyHealthPolicyData$5 = _buyHealthPolicyData$4.find(function (plan) {
            var _plan$name;

            return (plan === null || plan === void 0 ? void 0 : (_plan$name = plan.name) === null || _plan$name === void 0 ? void 0 : _plan$name.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          })) === null || _buyHealthPolicyData$5 === void 0 ? void 0 : (_buyHealthPolicyData$6 = _buyHealthPolicyData$5.covers) === null || _buyHealthPolicyData$6 === void 0 ? void 0 : _buyHealthPolicyData$6.length) > 0 ? buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$7 = buyHealthPolicyData.planData) === null || _buyHealthPolicyData$7 === void 0 ? void 0 : (_buyHealthPolicyData$8 = _buyHealthPolicyData$7.plans) === null || _buyHealthPolicyData$8 === void 0 ? void 0 : (_buyHealthPolicyData$9 = _buyHealthPolicyData$8.find(function (plan) {
            var _plan$name2;

            return (plan === null || plan === void 0 ? void 0 : (_plan$name2 = plan.name) === null || _plan$name2 === void 0 ? void 0 : _plan$name2.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          })) === null || _buyHealthPolicyData$9 === void 0 ? void 0 : _buyHealthPolicyData$9.covers : [],
          packs: (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$10 = buyHealthPolicyData.planData) === null || _buyHealthPolicyData$10 === void 0 ? void 0 : (_buyHealthPolicyData$11 = _buyHealthPolicyData$10.plans) === null || _buyHealthPolicyData$11 === void 0 ? void 0 : (_buyHealthPolicyData$12 = _buyHealthPolicyData$11.find(function (plan) {
            var _plan$name3;

            return (plan === null || plan === void 0 ? void 0 : (_plan$name3 = plan.name) === null || _plan$name3 === void 0 ? void 0 : _plan$name3.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          })) === null || _buyHealthPolicyData$12 === void 0 ? void 0 : (_buyHealthPolicyData$13 = _buyHealthPolicyData$12.packs) === null || _buyHealthPolicyData$13 === void 0 ? void 0 : _buyHealthPolicyData$13.length) > 0 ? buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$14 = buyHealthPolicyData.planData) === null || _buyHealthPolicyData$14 === void 0 ? void 0 : (_buyHealthPolicyData$15 = _buyHealthPolicyData$14.plans) === null || _buyHealthPolicyData$15 === void 0 ? void 0 : (_buyHealthPolicyData$16 = _buyHealthPolicyData$15.find(function (plan) {
            var _plan$name4;

            return (plan === null || plan === void 0 ? void 0 : (_plan$name4 = plan.name) === null || _plan$name4 === void 0 ? void 0 : _plan$name4.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          })) === null || _buyHealthPolicyData$16 === void 0 ? void 0 : _buyHealthPolicyData$16.packs : [],
          premium: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$17 = buyHealthPolicyData.planData) === null || _buyHealthPolicyData$17 === void 0 ? void 0 : (_buyHealthPolicyData$18 = _buyHealthPolicyData$17.plans) === null || _buyHealthPolicyData$18 === void 0 ? void 0 : (_buyHealthPolicyData$19 = _buyHealthPolicyData$18.find(function (plan) {
            var _plan$name5;

            return (plan === null || plan === void 0 ? void 0 : (_plan$name5 = plan.name) === null || _plan$name5 === void 0 ? void 0 : _plan$name5.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          })) === null || _buyHealthPolicyData$19 === void 0 ? void 0 : _buyHealthPolicyData$19.premium
        },
        intermediary: {
          intermediaryCode: buyHealthPolicyData !== null && buyHealthPolicyData !== void 0 && (_buyHealthPolicyData$20 = buyHealthPolicyData.intermediaryDetails) !== null && _buyHealthPolicyData$20 !== void 0 && _buyHealthPolicyData$20.code ? "".concat(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$21 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$21 === void 0 ? void 0 : _buyHealthPolicyData$21.code) : '',
          locationCode: buyHealthPolicyData !== null && buyHealthPolicyData !== void 0 && (_buyHealthPolicyData$22 = buyHealthPolicyData.intermediaryDetails) !== null && _buyHealthPolicyData$22 !== void 0 && _buyHealthPolicyData$22.location ? "".concat(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$23 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$23 === void 0 ? void 0 : _buyHealthPolicyData$23.location) : '',
          fieldUserCode: buyHealthPolicyData !== null && buyHealthPolicyData !== void 0 && (_buyHealthPolicyData$24 = buyHealthPolicyData.intermediaryDetails) !== null && _buyHealthPolicyData$24 !== void 0 && _buyHealthPolicyData$24.fieldUserCode ? "".concat(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$25 = buyHealthPolicyData.intermediaryDetails) === null || _buyHealthPolicyData$25 === void 0 ? void 0 : _buyHealthPolicyData$25.fieldUserCode) : ''
        },
        zone: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$26 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$26 === void 0 ? void 0 : (_buyHealthPolicyData$27 = _buyHealthPolicyData$26.location) === null || _buyHealthPolicyData$27 === void 0 ? void 0 : (_buyHealthPolicyData$28 = _buyHealthPolicyData$27.zone) === null || _buyHealthPolicyData$28 === void 0 ? void 0 : _buyHealthPolicyData$28.trim(),
        quotationType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.quotationType,
        sumInsured: parseFloat(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$29 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$29 === void 0 ? void 0 : (_buyHealthPolicyData$30 = _buyHealthPolicyData$29.cover) === null || _buyHealthPolicyData$30 === void 0 ? void 0 : _buyHealthPolicyData$30.sum_insured),
        startDate: getDateTimeData === null || getDateTimeData === void 0 ? void 0 : (_getDateTimeData$date = getDateTimeData.datetimeValue) === null || _getDateTimeData$date === void 0 ? void 0 : _getDateTimeData$date.date,
        startTime: '00:00',
        coverType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$31 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$31 === void 0 ? void 0 : (_buyHealthPolicyData$32 = _buyHealthPolicyData$31.cover) === null || _buyHealthPolicyData$32 === void 0 ? void 0 : _buyHealthPolicyData$32.type,
        tenure: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$33 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$33 === void 0 ? void 0 : (_buyHealthPolicyData$34 = _buyHealthPolicyData$33.cover) === null || _buyHealthPolicyData$34 === void 0 ? void 0 : _buyHealthPolicyData$34.tenure,
        proposalPaymentType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.proposalPaymentType,
        isHealthDeclarationSelected: (buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$35 = buyHealthPolicyData.isHealthDeclarationSelected) === null || _buyHealthPolicyData$35 === void 0 ? void 0 : _buyHealthPolicyData$35.toLowerCase()) === 'yes',
        quoteNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.quoteNumber,
        productCode: productCode,
        policyNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$36 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$36 === void 0 ? void 0 : _buyHealthPolicyData$36.policyNumber,
        employeeNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$37 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$37 === void 0 ? void 0 : _buyHealthPolicyData$37.employeeNumber,
        proposerPincode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$38 = buyHealthPolicyData.quoteData) === null || _buyHealthPolicyData$38 === void 0 ? void 0 : (_buyHealthPolicyData$39 = _buyHealthPolicyData$38.location) === null || _buyHealthPolicyData$39 === void 0 ? void 0 : _buyHealthPolicyData$39.pincode,

        /* Renew mandate */
        renewalMandateDetails: {
          renewalPaymentMandate: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$40 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$40 === void 0 ? void 0 : _buyHealthPolicyData$40.renewalPaymentMandate,
          renewalPaymentMandateTakenInNameOf: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$41 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$41 === void 0 ? void 0 : _buyHealthPolicyData$41.renewalPaymentMandateTakenInNameOf,
          termForMandateOpted: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$42 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$42 === void 0 ? void 0 : _buyHealthPolicyData$42.termForMandateOpted,
          typeOfDebit: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$43 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$43 === void 0 ? void 0 : _buyHealthPolicyData$43.typeOfDebit,
          accountNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$44 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$44 === void 0 ? void 0 : _buyHealthPolicyData$44.accountNumber,
          destinationBankName: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$45 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$45 === void 0 ? void 0 : _buyHealthPolicyData$45.destinationBankName,
          destinationIfscCode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$46 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$46 === void 0 ? void 0 : _buyHealthPolicyData$46.destinationIfscCode,
          destinationMicrCode: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$47 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$47 === void 0 ? void 0 : _buyHealthPolicyData$47.destinationMicrCode,
          destinationBranchName: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$48 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$48 === void 0 ? void 0 : _buyHealthPolicyData$48.destinationBranchName,
          mandateAmount: parseFloat(buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$49 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$49 === void 0 ? void 0 : _buyHealthPolicyData$49.mandateAmount),
          finalCollectionDate: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$50 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$50 === void 0 ? void 0 : _buyHealthPolicyData$50.finalCollectionDate,
          destinationBankAccountType: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : (_buyHealthPolicyData$51 = buyHealthPolicyData.renewalMandateDetails) === null || _buyHealthPolicyData$51 === void 0 ? void 0 : _buyHealthPolicyData$51.destinationBankAccountType
        }
      },
      proposalNumber: buyHealthPolicyData === null || buyHealthPolicyData === void 0 ? void 0 : buyHealthPolicyData.proposalNumber
    };
  };

  var data = [planName ? {
    label: /*#__PURE__*/React.createElement(Text, {
      severity: 'info',
      className: "ml-1"
    }, "Plan Name"),
    text: /*#__PURE__*/React.createElement(Text, {
      className: "ml-1"
    }, planName)
  } : null, {
    label: /*#__PURE__*/React.createElement(Text, {
      severity: 'info',
      className: ""
    }, "Annual Premium"),
    className: (screenSize === null || screenSize === void 0 ? void 0 : (_screenSize$toString = screenSize.toString()) === null || _screenSize$toString === void 0 ? void 0 : _screenSize$toString.toLowerCase()) === 'ipad' ? '' : '',
    text: /*#__PURE__*/React.createElement("div", {
      className: "space-x-2 flex items-center"
    }, /*#__PURE__*/React.createElement(Text, {
      type: "larger",
      severity: "info"
    }, Parse(plans === null || plans === void 0 ? void 0 : (_plans$find2 = plans.find(function (p) {
      return p.name === planName;
    })) === null || _plans$find2 === void 0 ? void 0 : (_plans$find2$premium = _plans$find2.premium) === null || _plans$find2$premium === void 0 ? void 0 : _plans$find2$premium.totalPremium)), /*#__PURE__*/React.createElement(Text, {
      severity: "info",
      onClick: function onClick(_) {
        setShowViewBreakup(true);
      },
      className: "cursor-pointer mt-1"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faInfoCircle
    })))
  }, {
    label: /*#__PURE__*/React.createElement(Text, {
      severity: "info",
      className: "ml-1"
    }, "Proposal Number"),
    text: buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.proposalNumber ? /*#__PURE__*/React.createElement(Text, {
      className: "ml-1"
    }, buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.proposalNumber) : /*#__PURE__*/React.createElement(Text, {
      severity: "neutral-darker",
      className: "ml-1"
    }, "Not Captured")
  }, {
    className: (screenSize === null || screenSize === void 0 ? void 0 : (_screenSize$toString2 = screenSize.toString()) === null || _screenSize$toString2 === void 0 ? void 0 : _screenSize$toString2.toLowerCase()) === 'ipad' ? '' : '',
    text: /*#__PURE__*/React.createElement(Text, {
      className: "mt-1 mb-1 flex items-center h-full"
    }, /*#__PURE__*/React.createElement(Button, {
      size: screenSize === 'iPad' ? 'medium' : 'small',
      flat: true,
      className: "h-8 ".concat(screenSize === 'mobile' ? '' : 'border-none', " ").concat(!(dataBuyHealthPolicy !== null && dataBuyHealthPolicy !== void 0 && (_dataBuyHealthPolicy$ = dataBuyHealthPolicy.buyHealthPolicy) !== null && _dataBuyHealthPolicy$ !== void 0 && _dataBuyHealthPolicy$.proposalNumber.length) > 0 || loadingDownload ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none' : ''),
      onClick: /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_) {
          var _dataBuyHealthPolicy$2, _dataBuyHealthPolicy$3;

          var getDateTime, _yield$getDateTime, getDateTimeData, proposalPDFBase64String, _yield$proposalPDFBas, dataBase64String, sendProposalPDF, downloadBase64String, byteCharacters, byteNumbers, i, byteArray, file, fileURL;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!((dataBuyHealthPolicy === null || dataBuyHealthPolicy === void 0 ? void 0 : (_dataBuyHealthPolicy$2 = dataBuyHealthPolicy.buyHealthPolicy) === null || _dataBuyHealthPolicy$2 === void 0 ? void 0 : (_dataBuyHealthPolicy$3 = _dataBuyHealthPolicy$2.proposalNumber) === null || _dataBuyHealthPolicy$3 === void 0 ? void 0 : _dataBuyHealthPolicy$3.length) > 0 && !loadingDownload)) {
                    _context.next = 31;
                    break;
                  }

                  _context.prev = 1;
                  getDateTime = fetchQuery({
                    query: GET_DATE_TIME
                  });
                  setAlerts([]);
                  setLoadingDownload(true);
                  _context.next = 7;
                  return getDateTime;

                case 7:
                  _yield$getDateTime = _context.sent;
                  getDateTimeData = _yield$getDateTime.data;
                  proposalPDFBase64String = mutateQuery({
                    mutation: SEND_PROPOSAL_PDF,
                    variables: getBase64Var(buyHealthPolicy, getDateTimeData)
                  });
                  _context.next = 12;
                  return proposalPDFBase64String;

                case 12:
                  _yield$proposalPDFBas = _context.sent;
                  dataBase64String = _yield$proposalPDFBas.data;
                  sendProposalPDF = dataBase64String.sendProposalPDF;
                  downloadBase64String = sendProposalPDF.base64Pdf;
                  setLoadingDownload(false);
                  byteCharacters = atob(downloadBase64String.toString());
                  byteNumbers = new Array(byteCharacters.length);

                  for (i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                  }

                  byteArray = new Uint8Array(byteNumbers);
                  file = new Blob([byteArray], {
                    type: 'application/pdf;base64'
                  });
                  fileURL = URL.createObjectURL(file);
                  window.open(fileURL);
                  _context.next = 31;
                  break;

                case 26:
                  _context.prev = 26;
                  _context.t0 = _context["catch"](1);
                  setAlerts([{
                    id: Date.now(),
                    content: /*#__PURE__*/React.createElement("div", {
                      className: "flex flex-col w-full h-full"
                    }, /*#__PURE__*/React.createElement(Text, {
                      type: "normal"
                    }, _context.t0.message)),
                    type: 'error',
                    timeout: null,
                    disableClose: false
                  }]);
                  setLoadingDownload(false);
                  window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                  });

                case 31:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 26]]);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: loadingDownload ? faSpinner : faDownload,
      className: "mr-1.5",
      spin: loadingDownload,
      size: "lg"
    }), loadingDownload ? 'Downloading...' : 'Download Form'))
  }].filter(function (d) {
    return d;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading || loadingGenderList ? /*#__PURE__*/React.createElement(Loading, null) : error || errorGenderList ? /*#__PURE__*/React.createElement(Error$1, {
    error: error || errorGenderList
  }) : !(buyHealthPolicy !== null && buyHealthPolicy !== void 0 && buyHealthPolicy.isPolicyIssued) ? screenSize !== 'desktop' ? /*#__PURE__*/React.createElement("div", {
    className: "bg-neutral sticky bottom-0 pt-1 -mx-4 mt-2 -mb-4 z-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-2 pb-3"
  }, /*#__PURE__*/React.createElement(DataGrid, {
    textType: "normal",
    data: data,
    repeat: repeat,
    gapX: 20,
    nullData: function nullData() {
      return /*#__PURE__*/React.createElement(Text, {
        severity: "neutral"
      }, "Not Captured");
    }
  }), /*#__PURE__*/React.createElement(ModalViewBreakup, {
    showViewBreakup: showViewBreakup,
    setShowViewBreakup: setShowViewBreakup,
    selectedPlanTypeView: planName,
    productName: productName,
    genderList: genderList,
    reactive_var_quote: buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.quoteData,
    reactive_var_plan: buyHealthPolicy === null || buyHealthPolicy === void 0 ? void 0 : buyHealthPolicy.planData,
    title: 'Premium Breakup for Proposal'
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null) : null);
}

function NewHealthPolicyIssuance(_ref) {
  var startStep = _ref.startStep,
      isProposalNumberGenerated = _ref.isProposalNumberGenerated,
      customerID = _ref.customerID,
      lobCode = _ref.lobCode,
      lobName = _ref.lobName,
      productName = _ref.productName,
      planName = _ref.planName,
      planCode = _ref.planCode,
      productCode = _ref.productCode,
      proposalNumber = _ref.proposalNumber,
      stepsDisabled = _ref.stepsDisabled,
      breadcrumbNav = _ref.breadcrumbNav;
  var nav = ['Quote', 'Buy Policy'];
  var params = useParams();
  var product_name = productName ? productName : params === null || params === void 0 ? void 0 : params.product_name;
  var lob_code = lobCode ? lobCode : params === null || params === void 0 ? void 0 : params.lob_code;
  var lob_name = lobName ? lobName : params === null || params === void 0 ? void 0 : params.lob_name;
  var plan_name = planName ? planName : params === null || params === void 0 ? void 0 : params.plan_name;
  var plan_code = planCode ? planCode : params === null || params === void 0 ? void 0 : params.plan_code;
  var product_code = productCode ? productCode : params === null || params === void 0 ? void 0 : params.product_code;
  var proposal_number = proposalNumber ? proposalNumber : params === null || params === void 0 ? void 0 : params.proposal_number;
  return /*#__PURE__*/React.createElement(Layout, {
    nav: breadcrumbNav ? breadcrumbNav : nav,
    service_type: ClientService,
    title: "Your ".concat(product_name, " Proposal")
  }, /*#__PURE__*/React.createElement(SummaryLayout, {
    summary: /*#__PURE__*/React.createElement(SummaryPanel, {
      lobCode: lob_code,
      lobName: lob_name,
      customerID: customerID,
      productName: product_name,
      productCode: product_code,
      planName: plan_name,
      planCode: plan_code,
      proposalNumber: proposal_number
    }),
    showFloatingSummary: true,
    summaryIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faFileAlt,
      size: "2x"
    })
  }, /*#__PURE__*/React.createElement(WizardPanel, {
    startStep: startStep,
    isProposalNumberGenerated: isProposalNumberGenerated,
    lobCode: lob_code,
    lobName: lob_name,
    customerID: customerID,
    productName: product_name,
    productCode: product_code,
    planName: plan_name,
    planCode: plan_code,
    proposalNumber: proposal_number,
    stepsDisabled: stepsDisabled
  })), /*#__PURE__*/React.createElement(HideOnTablet, {
    className: "mt-8"
  }, /*#__PURE__*/React.createElement(SlideablePaper, {
    className: "fixed bottom-0",
    height: 24,
    minimized: /*#__PURE__*/React.createElement(InsuranceSummaryMinimized, {
      lobCode: lob_code,
      lobName: lob_name,
      customerID: customerID,
      productName: product_name,
      productCode: product_code,
      planName: plan_name,
      planCode: plan_code,
      proposalNumber: proposal_number
    })
  }, /*#__PURE__*/React.createElement(Paper, {
    className: "bg-neutral shadow-2xl drop-shadow-2xl"
  }, /*#__PURE__*/React.createElement(InsuranceSummary, {
    lobCode: lob_code,
    lobName: lob_name,
    customerID: customerID,
    productName: product_name,
    productCode: product_code,
    planName: plan_name,
    planCode: plan_code,
    proposalNumber: proposal_number
  })))), /*#__PURE__*/React.createElement(QuoteSummary, {
    lobCode: lob_code,
    lobName: lob_name,
    customerID: customerID,
    productName: product_name,
    productCode: product_code,
    planName: plan_name,
    planCode: plan_code,
    proposalNumber: proposal_number
  }));
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': NewHealthPolicyIssuance
});

export { InsuredMembers as I, ModalMedicalQuestionaire as M, NewHealthPolicyIssuance as N, ProposalSummary as P, QuoteSummary as Q, ReviewConfirmDetails as R, SummaryPanel as S, WizardPanel as W, NomineeDetails as a, InsuranceSummary as b, InsuranceData as c, InsuranceSummaryMinimized as d, index as i };
